import React, { Component } from 'react';
// import { formDataSchema } from '../../../schema/add-user';
import { basicDetailsSchema, medicationDetailsSchema, estimateBreakupFormatSchema, addonSchema, roomtypeSchema, additionalPackageSchema, additionalProcedureSchema, signatureSchema } from './../../../schema/new-estimation-charges-cash.js';
import {includesSchema, excludesSchema} from './../../../schema/new-estimate-charges-cash.js';
import Formcomponent from '../../../components/version2form_component';
import Tableantd from '../../../components/version2form_component/table/antdNew.js';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { Modal, Spin, Button, Carousel, Icon, Input, Radio, Tooltip, Collapse } from 'antd';
import Storage from '../../../services/local-store';
import hideInEXStore from './../../../reduxStore/dataEvent';
import moment from 'moment';
// import {excludes_schema} from './sideFeilds';
import { optionsStore, excludesTableStore, excludesUpdateTableStore } from './../../../selectStore.jsx'
import { F } from 'ramda';
import { ConsoleSqlOutlined } from '@ant-design/icons';
import Cash_preview from './cash_preview';
import userTrackService from '../../../services/usertrack-service';
import html2PDF from 'jspdf-html2canvas';
import formDataPostService from '../../../services/httpformData';
import PatientCheckList_preview from './patientCheckln_preview';
import bcrypt from 'bcryptjs';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { stubTrue } from 'lodash';
import {serviceTypes} from '../../../constants/app-constants.jsx';
const { base_url, getDigitalSignInfoByToken, sendDigitalSignLink, getPatientWilling} = networkList;

const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};

const $ = require('jquery');
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2];
let dollarIndianLocale = Intl.NumberFormat('en-IN');
class New_add_cash_form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'exculude_options': [],
            'loadding': false,
            visible: false,
            'basicDetailsSchema': basicDetailsSchema['feilds'],
            'medicationDetailsSchema': JSON.parse(JSON.stringify(medicationDetailsSchema['feilds'])),
            'estimateBreakupFormatSchema': JSON.parse(JSON.stringify(estimateBreakupFormatSchema['feilds'])),
            'addonSchema': addonSchema['feilds'],
            roomtypeSchema: roomtypeSchema['feilds'],
            includesSchema: includesSchema['feilds'],
            excludesSchema: excludesSchema['feilds'],
            'additionalPackageSchema': additionalPackageSchema['feilds'],
            'additionalProcedureSchema': additionalProcedureSchema['feilds'],
            signatureSchema: signatureSchema['feilds'],
            form_openn: 'cash',
            addText: '',
            pre_link: '',
            modal1Visible: false, // includes
            modal2Visible: false, // Excludes
            modal3Visible: false, // Rooms
            img: false,
            img2: false,
            payment_mode: null,
            total_estimate_amount: 0,
            // new Feilds later Remove
            active_tab: 0,
            wizard_items: [{
                'id': 1,
                'title': 'Basic Info',
                'key': 'basic_info'
            }, {
                'id': 2,
                'title': 'Financial Form',
                'key': 'fc_form'
            }, {
                'id': 3,
                'title': 'Confirmation/Print',
                'key': 'confirmation_print'
            }],
            view_mode: false,
            view_details: false,
            counselling_details: '',
            inc_excludes_pack_id: [],
            inc_excludes_packages_ids: [],
            MasterRoutineEstimates: {},
            preserve_medicationDetailsSchema: medicationDetailsSchema,
            preserve_estimateBreakupFormatSchema: estimateBreakupFormatSchema,
            preserve_addonSchema: JSON.parse(JSON.stringify(addonSchema)),
            error_view: false,
            error_message: '',
            includes_data: [],
            excludes_datarecounselling: [],
            hideing_estimatetable: 0,
            configuration: [],
            includearrya: [],
            packages_IN_EX:[],
            exclude_total_amount:0,
            medicationDetailserrors:[],
            preview_data: {},
            preview_modal: false,
            preview_PatientCheckin_model:false,
            preview_PatientCheckin_model:false,
            fc1_total_estimate_amount:0,
            estimateBreakupFormaterror:[],
            finalSubmit:false,
            exclude_slug_fordropdown:'',
            consutations:[],
            signatureModal: false,
            generatedLink: null,
            isPreviewAttachments:false,
            previewFile: null,
            isGenerateSign: null,
            digital_sig_imgpath: null,
            tableData:[],
            data: {},
            tableData:[],
            data: {},
            patient_digsign_willing: null,
            enableCheckBox: false,
            otp: Array(this.props.length).fill(''),
            showSuccessModal: false,
            errorMessage: '',
            showButtons: false,
            showInputFeilds: false,
            showLinks: false,
            otpLink: false,
            loading: false,
            otpSent: false,
            patient_validate: false,
            checkboxDisabled: false,
            procedureValue: '',
            procedureText: '',
            procedureCode:'',
            EstimateValue: '',
            collapsedSections: this.initializeCollapsedState(),
            hideing_estimatetable_break_down: true,
            activeKey: ['1'],
            activeKey2: [],
            activeKey3: [],
            activeKey4:[],
            activeKey5:[],
            doctorCode: null,
            activeKey6: [],
            HeaderAmounts: null,
            careManagementValue:null,
            PackageSchema:[],
            showEstimationBreakdown: false,
            showOtherDetails: false 
        }
        this.timeoutId = null;
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.carousel = React.createRef();

        excludesTableStore.subscribe(() => {
            this.total_suming();
        })
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }

    // Method to toggle collapse for a specific section
    // toggleCollapse = (key) => {
    //     this.setState(prevState => ({
    //         collapsedSections: {
    //             ...prevState.collapsedSections,
    //             [key]: !prevState.collapsedSections[key]
    //         }
    //     }));
    // }

// Helper method to set all sections as collapsed initially
initializeCollapsedState() {
    const collapsedState = {};
    // Check if addonSchema exists and is an array
    if (Array.isArray(addonSchema)) {
        addonSchema.forEach((feild, key) => {
            collapsedState[key] = true; // Set all sections collapsed (table hidden initially)
        });
    } else {
        console.error("addonSchema is not an array.");
    }
    return collapsedState;
}

// Method to toggle collapse for a specific section
toggleCollapse = (key) => {
    this.setState(prevState => ({
        collapsedSections: {
            ...prevState.collapsedSections,
            [key]: !prevState.collapsedSections[key] // Toggle collapse state
        }
    }));
}

    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible });
    }

    setModal2Visible(modal2Visible) {
        this.setState({ modal2Visible });
    }

    setModal3Visible(modal3Visible) {
        this.setState({ modal3Visible });
    }

    signModal(signModalVisible) {
        this.setState({ signModalVisible });
    }
    signsuccess() {
        this.signModal(false);
        this.setState({ img: true })
    }
    sign2Modal(signModal2Visible) {
        this.setState({ signModal2Visible });
    }
    sign2success() {
        this.sign2Modal(false);
        this.setState({ img2: true })
    }

    async componentDidMount () {
        // let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema } = this.state;
        let { counselling_details, basic_info, } = this.props;
        // let { estimation, additional_packages } = counselling_details
        let { slug } = this.props.match.params;
        // let disabled = false;
        // const params = new URLSearchParams(this.props.location);
        excludesTableStore.subscribe(() => {
            this.total_suming();
            const exludesider = excludesTableStore.getState();
            this.setState((state) => ({ exludesiders: exludesider.data }),
                () => {
                    this.total_suming();
                })

        });
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const cd = params.get('cd');

        this.setState({ error_message: '', error_view: false });

        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
            // if( cd != '' && cd !== undefined && cd !== null && !isNaN(cd)){
            //     disabled = true;
            // }
            if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE'])){
           console.log('teet', counselling_details)
            }else{
                slug = 'finanical-counselling'; 
            }
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }

        await this.setState((state) => ({ exclude_slug_fordropdown:slug }),
        () => {
            this.setState({exclude_slug_fordropdown:slug})
        })
        const locst = this.props.history.location.state;
        console.log('locst::::', locst);
        const est_date_of_admis = (locst && locst['est_admis_date']) ? locst['est_admis_date'] : null;
         const est_admis_date = localStorage.getItem('est_admis_date');
        console.log('est_date_of_admis:',est_date_of_admis);
        let careManagementValue;
        switch (slug) {
            case 'view-finanical-counselling': {
                let { counselling_details } = this.props;
                let { estimation, additional_packages, additional_procedures } = counselling_details;
                Storage.remove('fc_checklist_verified');
                this.setState({ view_details: false });
                // let counselling_details = this.props.counselling_details;
                // let { estimation, additional_packages } = counselling_details
                let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, excludes_schema } = this.state;
                medicationDetailsSchema.map((feild, key) => {
                    feild.value = null;
                    if (feild.name === 'estimated_admission_date') {
                        feild.disable = false;
                    }
                    if (feild.name === 'actual_admission_date') {

                    }
                    if (feild.name === 'diagnosis') {
                        feild.disable = false;
                    }
                    if (feild.name === 'care_management') {
                        feild.disable = false;
                    }
                    if (feild.name === 'estimate_type') {
                        feild.visible = false;
                    }
                    if (feild.name === 'package_name') {
                        feild.visible = true;
                    }
                    if (feild.name === 'length_of_stay') {

                    }
                    if (feild.name === 'icu_stay') {

                    }
                    if (feild.name === 'room_stay') {

                    }
                    if (feild.name === 'room_opted') {

                    }
                    if (feild.name === 'room_upgrade') {

                    }
                    if (feild.name === 'room_upgrade_reason') {

                    }
                    if (feild.name === 'icu_opted') {
                        feild.visible = true;
                    }
                    if (feild.name === 'date_of_surgery') {

                    }
                    if (feild.name === 'surgery_procedure_name') {
                        feild.disable = false;
                    }
                    if (feild.name === 'surgery_procedure_amount') {

                    }
                })

                // Clear data starts
                estimateBreakupFormatSchema.map((feild, key) => {
                    feild.value = null;
                    feild.text = null;
                    if (feild.name === 'base_price') {

                    }
                    if (feild.name === 'advance_amount') {
                        feild.disable = true;
                    }
                    if (feild.name === 'excludes') {

                    }
                    if (feild.name === 'total_Estimate_amount') {

                    }
                    if (feild.name === 'name_of_the_fc') {
                        feild.disable = false;
                    }
                    if (feild.name === 'attendant_name') {
                        feild.disable = false;
                    }
                    if (feild.name === 'relation') {
                        feild.disable = false;
                    }
                })

                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            if (table_name === 'room_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            // if (table_name === 'ip_pharmacy_charges') {
                            //     if (feild.key_word === 'routine') {
                            //         if (sub_feild.name === 'routine_drugs_implants') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                            //         }
                            //         if (sub_feild.name === 'qty') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'rate') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'amount') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //     }
                            //     if (feild.key_word === 'highend') {
                            //         if (sub_feild.name === 'room_highend_drugs_implants') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'qty') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'rate') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //         if (sub_feild.name === 'amount') {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //         }
                            //     }
                            //     if (feild.key_word === 'add_more') {
                            //         addonSchema[key].Specification.table_body.splice(table_key, 1)
                            //     }
                            // }
                            if (table_name === 'icu_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'drug_admin_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                            }
                            if (table_name === 'general_equipment_charges') {
                                if (feild.key_word === 'routine') {
                                    // if (sub_feild.name === 'general_highend_equipments') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'hospital_services') {
                                if (feild.key_word === 'mrd') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'ward_consumables') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'room_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                            }
                            if (table_name === 'physiotherapy_diet_charges') {
                                if (feild.key_word === 'dietician') {
                                    if (sub_feild.name === 'dietician') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'surgeon') {
                                if (feild.key_word === 'surgeon') {
                                    if (sub_feild.name === 'surgeon') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            // if (table_name === 'surgical_charges') {
                            //     if (sub_feild.name === 'qty') {
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //     }
                            //     if (sub_feild.name === 'percentage') {
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //     }
                            //     if (sub_feild.name === 'amount') {
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            //     }
                            // }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })
                // this.previousDataAErasing()


                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    // additionalPackageSchema[key].Specification.table_body.length=1;
                })

                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    additionalProcedureSchema[key].Specification.table_body.length=0;
                })
                // Clear data ends

                medicationDetailsSchema.map((feild, key) => {
                    if (feild.name === 'estimated_admission_date') {
                        medicationDetailsSchema[key]['value'] = counselling_details['e_date_of_admission'];
                        medicationDetailsSchema[key]['text'] = counselling_details['e_date_of_admission'];
                        if (counselling_details['e_date_of_admission']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'diagnosis') {
                        medicationDetailsSchema[key]['value'] = counselling_details['diagnosis'];
                        medicationDetailsSchema[key]['text'] = counselling_details['diagnosis'];
                        if (counselling_details['diagnosis']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'care_management') {
                        medicationDetailsSchema[key]['value'] = counselling_details['care_management_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['care_management_name'];
                        if (counselling_details['care_management']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'estimate_type') {
                        medicationDetailsSchema[key]['value'] = counselling_details['estimate_type_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['estimate_type_name'];
                        if (counselling_details['estimate_type']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                        if (counselling_details['estimate_type'] === 2) {
                            hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                        } else {
                            hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
                        }
                    }
                    if (feild.name === 'package_name') {
                        medicationDetailsSchema[key]['value'] = counselling_details['package_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['package_name'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['package_amt'];

                        if (counselling_details['package_id']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });

                            this.getExcludesIncludes(counselling_details['package_id'], counselling_details['package_name'],0);
                        }
                    }

                    if (feild.name === 'length_of_stay') {
                        medicationDetailsSchema[key]['value'] = counselling_details['length_of_stay'];
                        medicationDetailsSchema[key]['text'] = counselling_details['length_of_stay'];
                        if (counselling_details['length_of_stay']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'icu_stay') {
                        medicationDetailsSchema[key]['value'] = counselling_details['icu_stay'];
                        medicationDetailsSchema[key]['text'] = counselling_details['icu_stay'];
                        if (counselling_details['icu_stay']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_stay') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_stay'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_stay'];
                        if (counselling_details['room_stay']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'date_of_surgery') {
                        medicationDetailsSchema[key]['value'] = counselling_details['date_of_surgery'];
                        medicationDetailsSchema[key]['text'] = counselling_details['date_of_surgery'];

                    }

                    if (feild.name === 'surgery_procedure_name') {
                        medicationDetailsSchema[key]['value'] = counselling_details['procedure_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['procedure_name'];
                        if (counselling_details['surgery_procedure_id']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });

                            this.getExcludesIncludes(counselling_details['surgery_procedure_id'], counselling_details['procedure_name'],0);
                        }

                    }

                    if (feild.name === 'surgery_procedure_amount') {
                        medicationDetailsSchema[key]['value'] = parseInt(counselling_details['surgery_procedure_amt']);
                        medicationDetailsSchema[key]['text'] = parseInt(counselling_details['surgery_procedure_amt']);
                        if (counselling_details['surgery_procedure_amount']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'room_opted') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_opted_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_opted_name'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['room_opted_amount'];
                        medicationDetailsSchema[key]['room_id'] = counselling_details['room_opted'];
                        if (counselling_details['room_opted']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_upgrade') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_upgrade_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_upgrade_name'];
                        if (counselling_details['room_upgrade']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'icu_opted') {
                        medicationDetailsSchema[key]['value'] = counselling_details['icu_opted_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['icu_opted_name'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['icu_opted_amount'];
                        medicationDetailsSchema[key]['room_id'] = counselling_details['icu_opted'];

                        if (counselling_details['room_upgrade']) {
                            medicationDetailsSchema[key]['disable'] = false;
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'room_upgrade_reason') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_upgrade_reason_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_upgrade_reason_name'];
                        if (counselling_details['room_upgrade_reason']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }




                })

                additionalPackageSchema.map((subTable, key) => {
                    // subTable.Specification.table_body = Tablebody;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((subTable1, key1) => {
                        let row = subTable1.feilds;
                        let Package_name = this.props.counselling_details.procedure_name;
                        let Amount = this.props.counselling_details.room_opted_amount;
                        // console.log('total???????????????', total_estimate_amount, Amount)
                        row.map((subTable3, key2) => {
                            if(true){
                                // if(subTable3.name === 'qty'){
                                //         console.log('subTable3',procedureText);
                                //     subTable3.value = procedureText;
                                //     subTable3.text = procedureText;
                                // }
                                if (subTable3.name === 'qty') {
                                    subTable3.value = Package_name;
                                    subTable3.text = Package_name;
                                }
                                if(subTable3.name === 'rate'){
                                    subTable3.value = 'Package';
                                    subTable3.text = 'Package';
                                }
                                if(subTable3.name === 'package_amount'){
                                    
                                    subTable3.value = Amount;
                                    subTable3.text = Amount;
                                }
                            }
                        });
                    });
                });


                if (additional_procedures.length > 0) {
                    additionalProcedureSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalProcedureSchema[secKey].visible = true;
                            additional_procedures.map((procedures, procedures_key) => {
                                // if (procedures_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "additional_surgery_procedure_name") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['procedure_id']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['procedure_id']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['amount']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalProcedureSchema[secKey].Specification.table_body[additionalProcedureSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id
                                if (last_element === undefined) {
                                    last_id = procedures_key;
                                }
                                // } else {
                                //     last_id = last_element['id'];
                                // }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "additional_surgery_procedure_name") {
                                        obj['feilds'][key]['value'] = procedures['procedure_id'];
                                        obj['feilds'][key]['text'] = procedures['procedure_name'];
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = procedures['amount'];
                                        obj['feilds'][key]['text'] = procedures['amount'];
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }
                // if (true) {
                //     additionalPackageSchema.map((data, secKey) => {
                //         let table_body = data.Specification.table_body;
                //         table_body.map((suTable, keys) => {
                //             if(suTable.key_word === 'package_amount'){
                //                 let row = suTable.feilds;
                //                 row.map((feild, Key) => {
                //                     if(feild.name === 'qty'){
                //                         feild.value = counselling_details['procedure_name'];
                //                         feild.text = counselling_details['procedure_name'];
                //                         feild.disable = true;
                //                     }
                //                     if(feild.name === 'rate'){
                //                         feild.value = 'Package';
                //                         feild.text = 'Package';
                //                     }
                //                     if(feild.name === 'package_amount'){
                //                         feild.value = counselling_details['room_opted_amount'];
                //                     }
                //                 });
                //             }
                //         });
                //         if (secKey === 0) {
                //             additionalPackageSchema[secKey].visible = true;
                //             additional_packages.map((packages, packages_key) => {
                //                 // if (packages_key === 0) {
                //                 //     data['Specification']['table_body'].map((table_body, table_key) => {
                //                 //         table_body['feilds'].map((feilds, key) => {
                //                 //             if (feilds.name === "ins_additional_package_name") {
                //                 //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['package_id']
                //                 //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['package_name']
                //                 //             }
                //                 //             if (feilds.name === "amount") {
                //                 //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['amount']
                //                 //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['amount']
                //                 //             }
                //                 //         })
                //                 //     })
                //                 // }
                //                 // else {
                //                 let last_element = additionalPackageSchema[secKey].Specification.table_body[additionalPackageSchema[secKey].Specification.table_body.length - 1];
                //                 // let last_id = last_element['id'];
                //                 let last_id;
                //                 if (last_element === undefined) {
                //                     last_id = packages_key;
                //                 }

                //                 let obj = {
                //                     "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                //                     id: last_id,
                //                     input_feild: [],
                //                     text: "Highend",
                //                     'key_word': 'add_more',
                //                     type: "text"
                //                 }
                //                 obj['feilds'].map((feild, key) => {
                //                     obj['feilds'][key]['id'] = null;
                //                     obj['feilds'][key]['value'] = null;
                //                     obj['feilds'][key]['text'] = null;
                //                 })
                //                 obj['feilds'].map((feild, key) => {
                //                     obj['feilds'][key]['id'] = last_id + 1;
                //                     if (feild.name === "ins_additional_package_name") {
                //                         obj['feilds'][key]['value'] = packages['package_id'];
                //                         obj['feilds'][key]['text'] = packages['package_name'];
                //                         obj['feilds'][key]['disable'] = true;
                //                     }
                //                     if (feild.name === "is_package") {
                //                         obj['feilds'][key]['value'] ='Package';
                //                         obj['feilds'][key]['text'] = 'Package';
                //                     }
                //                     if (feild.name === "actualprice") {
                //                         obj['feilds'][key]['value'] = packages['actual_price'];
                //                         obj['feilds'][key]['text'] = packages['actual_price'];
                                        
                //                     }
                //                     if (feild.name === "percentage" ) {
                //                         obj['feilds'][key]['value'] = packages['package_percentage'];
                //                         obj['feilds'][key]['text'] = packages['package_percentage'];
                //                     }
                //                     if (feild.name === "amount") {
                //                         obj['feilds'][key]['value'] = packages['amount'];
                //                         obj['feilds'][key]['text'] = packages['amount'];
                //                     }
                //                     if (feild.name === "action") {
                //                         obj['feilds'][key]['element'] = 'text';
                //                     }
                //                 })
                //                 data['Specification']['table_body'].push(obj);
                //                 // alert('came');
                //                 this.getExcludesIncludes(parseInt(packages['package_id']), packages['package_name'], 1);

                //                 // }
                //             })
                //         }
                //     })
                // }
                else {
                    additional_procedures.map((data, secKey) => {
                        if (secKey === 0) {
                            additional_procedures[secKey].visible = false;
                        }
                    })
                }

                if (estimation) {
                    console.log('VIEW:::', estimation, addonSchema);
                    addonSchema.map((subTable, key) => {
                        console.log('subTable:::', subTable);
                        let service_ids = [];
                        let estimate_keys=[]
                            let table_body = subTable.Specification.table_body;
                            estimation.map((estimate, estimate_key) => {
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                if (estimate.header === subTable.header && feild.key_word === estimate.key_word && estimate.key_word !== 'add_more') {
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.name !== "action" && sub_feild.element!=='text') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['service']
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['service_name']
                                        }
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "rate") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                        }
                                        if (sub_feild.name === "percentage") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "amount") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                        }
                                    })
                                }
                                else if (estimate.header === subTable.header && estimate.key_word === 'add_more' && !estimate_keys.includes(estimate_key) ) {
                                    const i_key = (addonSchema[key].Specification.table_body).length + 1;
                                    service_ids.push(estimate.service);
                                    estimate_keys.push(estimate_key);
                                    let feildData;
                                    if(subTable['Specification']['add_more_feilds'] && subTable['Specification']['add_more_feilds'].find(f => f.sub_header === estimate.sub_header)){
                                        feildData = subTable['Specification']['add_more_feilds'];
                                    } else if(subTable['Specification']['add_more_feilds1'] && subTable['Specification']['add_more_feilds1'].find(f => f.sub_header === estimate.sub_header)){
                                        feildData = subTable['Specification']['add_more_feilds1'];
                                    } else if(subTable['Specification']['add_more_feilds2'] && subTable['Specification']['add_more_feilds2'].find(f => f.sub_header === estimate.sub_header)){
                                        feildData = subTable['Specification']['add_more_feilds2'];
                                    }
                                    console.log("subTable['Specification']['add_more_feilds1']",subTable['Specification'], estimate.sub_header);
                                    let obj = {
                                        "feilds": feildData ? JSON.parse(JSON.stringify(feildData)) : [],
                                        id: i_key,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    // let obj = {
                                    //     "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                    //     id: i_key,
                                    //     input_feild: [],
                                    //     text: "Highend",
                                    //     'key_word': 'add_more',
                                    //     type: "text"
                                    // }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = i_key;
                                        // if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action") {
                                        //     obj['feilds'][key]['value'] = estimate['service'];
                                        //     obj['feilds'][key]['text'] = estimate['service_name'];
                                        // }
                                        // if (feild.name === "qty") {
                                        //     obj['feilds'][key]['value'] = estimate['qty'];
                                        //     obj['feilds'][key]['text'] = estimate['qty'];
                                        // }
                                        // if (feild.name === "rate") {
                                        //     obj['feilds'][key]['value'] = estimate['rate'];
                                        //     obj['feilds'][key]['text'] = estimate['rate'];
                                        // }
                                        // if (feild.name === "percentage") {
                                        //     obj['feilds'][key]['value'] = estimate['qty'];
                                        //     obj['feilds'][key]['text'] = estimate['qty'];
                                        // }
                                        // if (feild.name === "amount") {
                                        //     obj['feilds'][key]['value'] = estimate['amount'];
                                        //     obj['feilds'][key]['text'] = estimate['amount'];
                                        // }
                                        // if (feild.name === "action") {
                                        //     obj['feilds'][key]['element'] = 'text';
                                        // }
                                        if(feild.rowgroup === 'surgeon_fees'){
                                            if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action" && feild.element!=='text') {
                                                obj['feilds'][key]['value'] = estimate['service'];
                                                obj['feilds'][key]['text'] = estimate['service_name'];
                                            }
                                            if (feild.name === "qty") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "rate") {
                                                obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                                obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                            if (feild.name === "percentage") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            // if (feild.name === "amount") {
                                            //     console.log("feild.name",feild.name);
                                            //     obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            //     obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            // }
                                        } else {
                                            if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action" && feild.element!=='text') {
                                                obj['feilds'][key]['value'] = estimate['service'];
                                                obj['feilds'][key]['text'] = estimate['service_name'];
                                            }
                                            if (feild.name === "qty") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "rate") {
                                                obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                                obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                            if (feild.name === "percentage") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "amount") {
                                                console.log("feild.name",feild.name);
                                                obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                                obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                        }
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                }
                            })
                        })
                        console.log('table_body', addonSchema[key].Specification.table_body);
                    })
                    addonSchema.map((subTable, key) => {
                        estimation.map((estimate, estimate_key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                })
                            })
                        })
                    })
                }

                if (counselling_details['care_management'] === 1) {     // 1 - mdeical, 2 - surgical
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === 'surgical_charges') {
                            addonSchema[key].visible = false;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                })
                            })
                        }
                        if (subTable.name === 'ot_cath_pharmacy') {
                            addonSchema[key].visible = false;
                        }
                        if (subTable.name === 'ot_charges') {
                            addonSchema[key].visible = false;
                        }
                        if (subTable.name === 'ot_equipment') {
                            addonSchema[key].visible = false;
                        }
                        if (subTable.name === 'medical_charges') {
                            addonSchema[key].visible = true;
                        }
                    })
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                }
                else {
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === 'medical_charges') {
                            addonSchema[key].visible = false;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                })
                            })
                        }
                        if (subTable.name === 'ot_cath_pharmacy') {
                            addonSchema[key].visible = true;
                        }
                        if (subTable.name === 'ot_charges') {
                            addonSchema[key].visible = true;
                        }
                        if (subTable.name === 'ot_equipment') {
                            addonSchema[key].visible = true;
                        }
                        if (subTable.name === 'surgical_charges') {
                            addonSchema[key].visible = true;
                        }
                    })
                }
                let { includesSchema } = this.state;

                if (counselling_details['includes_data'].length > 0) {

                    let includes_data = JSON.parse(JSON.stringify(counselling_details['includes_data']));
                    // let includes_data = [{
                    //     "package_id": "1",
                    //     "package_name": "CAG",
                    //     "services": [{
                    //         "service_id": 10,
                    //         "service_nam": "Room Rent & ICCU - 8 days"
                    //     }, {
                    //         "service_id": 11,
                    //         "service_nam": "OT Consumables"
                    //     }, {
                    //         "service_id": 12,
                    //         "service_nam": "Routine Drugs & Disposables"
                    //     }, {
                    //         "service_id": 13,
                    //         "service_nam": "Investigations Routine"
                    //     }, {
                    //         "service_id": 14,
                    //         "service_nam": "OT Charges"
                    //     }, {
                    //         "service_id": 15,
                    //         "service_nam": "Professional Fee for CT Team"
                    //     }, {
                    //         "service_id": 16,
                    //         "service_nam": "Anesthetist charges"
                    //     }]
                    // }, {
                    //     "package_id": 2,
                    //     "package_name": "PTCA",
                    //     "services": [{
                    //         "service_id": 17,
                    //         "service_nam": "Room Rent & ICCU - 8 days"
                    //     }, {
                    //         "service_id": 18,
                    //         "service_nam": "OT Consumables"
                    //     }, {
                    //         "service_id": 19,
                    //         "service_nam": "Routine Drugs & Disposables"
                    //     }, {
                    //         "service_id": 20,
                    //         "service_nam": "Investigations Routine"
                    //     }, {
                    //         "service_id": 21,
                    //         "service_nam": "OT Charges"
                    //     }]
                    // }];
                    // includesSchema.map((subTable, key) => {
                    //     subTable['title'] = '';
                    //     subTable['name'] = '';
                    //     if (includesSchema[key].id === 1) {
                    //         if (includesSchema[key].Specification.table_body.length > 0) {
                    //             includesSchema[key].Specification.table_body.length = 0;
                    //         }
                    //     } else {
                    //         includesSchema.splice(1, includesSchema.length)
                    //     }
                    // })
                    // this.setState({ includesSchema });

                    // let dopulicatearray = [];
                    // dopulicatearray = JSON.parse(JSON.stringify(includesSchema));
                    // dopulicatearray.map((subTable, key) => {
                    //     if (dopulicatearray[key].id === 1) {
                    //         if (dopulicatearray[key].Specification.table_body.length > 0) {
                    //             dopulicatearray[key].Specification.table_body.length = 0;
                    //         }
                    //     } else {
                    //         dopulicatearray.splice(1, dopulicatearray.length)
                    //     }
                    // })
                   
                    //     dopulicatearray.map((subTable, key) => {
                    //         includes_data.map((data,item)=>{
                    //         subTable['id'] = key+1;
                    //         subTable['header'] = data.package_id;
                    //         subTable['title'] = data.package_name;
                    //         subTable['name'] = data.package_name;
                           
                    //             let last_id = 1;
                    //             if (dopulicatearray[key].Specification.table_body.length > 0) {
                    //                 let last_element = dopulicatearray[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                    //                 last_id = last_element ? last_element['id'] : 0;
                    //             }
                    //             let obj = {
                    //                 "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                    //                 id: last_id + 1,
                    //                 input_feild: [],
                    //                 text: "Highend",
                    //                 'key_word': 'add_more',
                    //                 type: "text"
                    //             }
                    //             data.services.map((ex_data, ex_key) => {
                    //             obj['feilds'].map((feild, feild_key) => {
                    //                 obj['feilds'][feild_key]['id'] = last_id + 1;
    
                    //                 if (feild.name === 'item_service') {
                    //                     obj['feilds'][feild_key]['value'] = ex_data.id;
                    //                     obj['feilds'][feild_key]['title'] = ex_data.service;
                    //                 }
                    //             })
                    //             subTable['Specification']['table_body'].push(obj);
                    //         })
                    //         includesSchema.push(subTable);
                    //     })      
                        
                    // })
                    // console.log(includesSchema)
                    

                    includesSchema.map((subTable, key) => {
                        includes_data.map((ex_data, ex_key) => {
                            let last_id = 1;
                            if (includesSchema[key].Specification.table_body.length > 0) {
                                let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                last_id = last_element['id'];
                            }

                            let obj = {
                                "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                id: last_id + 1,
                                input_feild: [],
                                text: "Highend",
                                'key_word': 'add_more',
                                type: "text"
                            }
                            obj['feilds'].map((feild, feild_key) => {
                                obj['feilds'][feild_key]['id'] = last_id + 1;

                                if (feild.name === 'item_service') {
                                    obj['feilds'][feild_key]['value'] = ex_data.service_name;
                                    obj['feilds'][feild_key]['title'] = ex_data.service_name;
                                }
                            })
                            JSON.parse(JSON.stringify(subTable['Specification']['table_body'].push(obj)));
                        })
                    })
                }

                medicationDetailsSchema.map((feild, key) => {
                    medicationDetailsSchema[key]['disable'] = true;
                    // medicationDetailsSchema[key]['element'] = 'input';
                })

                let base_price = 0, excludes = 0, total_estimate_amount = 0;
                counselling_details['header_amount'].map((feild, key) => {
                    if (feild.base_price !== '' && feild.base_price !== null & feild.base_price !== undefined) {
                        base_price = feild.base_price;
                    }
                    if (feild.excludes !== '' && feild.excludes !== null & feild.excludes !== undefined) {
                        excludes = feild.excludes;
                                            }
                    if (feild.total_estimate_amount !== '' && feild.total_estimate_amount !== null & feild.total_estimate_amount !== undefined) {
                        total_estimate_amount = feild.total_estimate_amount;
                    }
                })

                if (counselling_details['estimate_type'] === 1) {
                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild.name === 'base_price') {
                            estimateBreakupFormatSchema[key]['value'] = parseFloat(base_price);
                            estimateBreakupFormatSchema[key]['text'] = parseFloat(base_price);
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        }
                        if (feild.name === 'excludes') {
                            const examount = parseFloat(counselling_details['header_amount'][0].length>0&&counselling_details['header_amount'][0].excludes)
                        estimateBreakupFormatSchema[key]['value'] = examount?examount:0;
                        estimateBreakupFormatSchema[key]['text'] = examount?examount:0;
                        this.setState({ exclude_total_amount: examount?examount:0 });
                        estimateBreakupFormatSchema[key]['visible'] = true;
                            // estimateBreakupFormatSchema[key]['value'] = parseFloat(excludes);
                            // estimateBreakupFormatSchema[key]['text'] = parseFloat(excludes);
                            // estimateBreakupFormatSchema[key]['visible'] = true;
                        }
                        if (feild.name === 'total_Estimate_amount') {
                            estimateBreakupFormatSchema[key]['value'] = parseFloat(total_estimate_amount);
                            estimateBreakupFormatSchema[key]['text'] = parseFloat(total_estimate_amount);
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        }
                    })
                }


                estimateBreakupFormatSchema.map((feild, key) => {
                    if (feild.name === 'name_of_the_fc') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['counseller_name'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['counseller_name'];
                    }
                    if (feild.name === 'attendant_name') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['attendant_name'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['attendant_name'];
                    }
                    if (feild.name === 'relation') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['patient_relation'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['patient_relation'];
                    }
                    if (feild.name === 'remarks') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['remarks'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['remarks'];
                    }
                    if (feild.name === 'advance_amount') {
                        estimateBreakupFormatSchema[key]['value'] = parseFloat(counselling_details['advance_amount']);
                        estimateBreakupFormatSchema[key]['text'] = parseFloat(counselling_details['advance_amount']);
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                    estimateBreakupFormatSchema[key]['disable'] = true;
                    estimateBreakupFormatSchema[key]['element'] = 'input';
                })

                medicationDetailsSchema.map((feild, key) => {
                    medicationDetailsSchema[key]['disable'] = true;
                })

                addonSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    addonSchema[key].Specification.add_more = false;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true
                            if (sub_feild.name === "action") {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["element"] = 'text'
                            }
                        })
                    })
                    if (subTable.name === 'surgical_charges') {
                        if (counselling_details['care_management'] === 1) {   // 1 - medical, 2 - surgical
                            addonSchema[key].visible = false;
                        }
                        else {
                            addonSchema[key].visible = true;
                        }
                    }
                    if (subTable.name === 'medical_charges') {
                        if (counselling_details['care_management'] === 1) {   // 1 - medical, 2 - surgical
                            addonSchema[key].visible = true;
                        }
                        else {
                            addonSchema[key].visible = false;
                        }
                    }
                })

                if (additional_packages.length > 0) {
                    additionalPackageSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalPackageSchema[secKey].visible = true;
                            additional_packages.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "additional_package_name") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['package_id']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['package_name']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['amount']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalPackageSchema[secKey].Specification.table_body[additionalPackageSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id
                                if (last_element === undefined) {
                                    last_id = packages_key;
                                }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "additional_package_name") {
                                        obj['feilds'][key]['value'] = packages['package_id'];
                                        obj['feilds'][key]['text'] = packages['package_name'];
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = packages['amount'];
                                        obj['feilds'][key]['text'] = packages['amount'];
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                this.getExcludesIncludes(packages['package_id'], packages['package_name'],1);

                                // }
                            })
                        }
                    })
                }
                else {
                    additionalPackageSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalPackageSchema[secKey].visible = false;
                        }
                    })
                }

                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = false;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true
                        })
                    })
                })
                
                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = false;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true
                        })
                    })
                })
                Storage.store('current_print', {
                    "counselling_id": counselling_details['counselling_id'],
                    "payment_type": counselling_details['payment_type_id'],
                    "care_management": counselling_details['care_management'],
                    "estimate_type": counselling_details['estimate_type']
                })
                // Storage.store('current_print', counselling_details)
                hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                this.setState({ 'counselling_details': counselling_details, view_mode: true, view_details: true, addonSchema: addonSchema, medicationDetailsSchema: medicationDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, excludes_schema, includesSchema: JSON.parse(JSON.stringify(includesSchema)), fc1_total_estimate_amount: total_estimate_amount }, () => {
                    if (counselling_details['excludes_data']) {
                        hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData: counselling_details['excludes_data'], page: 'view-finanical-counselling' } })
                    }
                    this.total_suming();
                })
            } break;

            case 'recounselling': {
                let { counselling_details } = this.props;
                excludesTableStore.dispatch({ type: 'options_data', 'data': [] });
                Storage.remove('fc_checklist_verified');
                if(counselling_details['payment_type']==="Insurance"){

                    let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, excludesSchema, includesSchema } = this.state

                    medicationDetailsSchema.map((feild, key) => {
                        feild.value = null;
                        if (feild.name === 'estimated_admission_date') {
                            // feild.disable = false;
                            // feild['value'] = est_date_of_admis ? moment(est_date_of_admis).format('YYYY-MM-DD') :est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):null;
                            // feild['disable'] = est_date_of_admis ? true : est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):false;
                        }
                        if (feild.name === 'actual_admission_date') {
    
                        }
                        if (feild.name === 'diagnosis') {
                            feild.disable = false;
                        }
                        if (feild.name === 'care_management') {
                            feild.disable = false;
                        }
                        if (feild.name === 'estimate_type') {
                            feild.visible = false;
                        }
                        if (feild.name === 'package_name') {
                            feild.visible = false;
                        }
                        if (feild.name === 'length_of_stay') {
    
                        }
                        if (feild.name === 'icu_stay') {
    
                        }
                        if (feild.name === 'room_stay') {
    
                        }
                        if (feild.name === 'room_opted') {
    
                        }
                        if (feild.name === 'room_upgrade') {
    
                        }
                        if (feild.name === 'room_upgrade_reason') {
    
                        }
                        if (feild.name === 'icu_opted') {
                            feild.visible = false;
                        }
                        if (feild.name === 'date_of_surgery') {
    
                        }
                        if (feild.name === 'surgery_procedure_name') {
                            feild.disable = false;
                        }
                        if (feild.name === 'surgery_procedure_amount') {
    
                        }
                    })
    
                    estimateBreakupFormatSchema.map((feild, key) => {
                        feild.value = null;
                        feild.text = null;
                        if (feild.name === 'base_price') {
    
                        }
                        if (feild.name === 'excludes') {
    
                        }
                        if (feild.name === 'total_Estimate_amount') {
    
                        }
                        if (feild.name === 'name_of_the_fc') {
                            estimateBreakupFormatSchema[key]['value'] = JSON.parse(Storage.get('user'));
                            estimateBreakupFormatSchema[key]['text'] = JSON.parse(Storage.get('user'));
                            feild.disable = true;
                        }
                        if (feild.name === 'attendant_name') {
                            feild.disable = false;
                        }
                        if (feild.name === 'relation') {
                            feild.disable = false;
                        }
                    })
    
                    addonSchema.map((subTable, key) => {
                        let table_name = subTable.name
                        addonSchema[key].header_amount = 0;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                // }
    
                                if (table_name === 'room_charges') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (table_name === 'room_investigation_charges') {
                                    addonSchema[key].Specification.add_more = true;
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'Routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'room_highend_investigations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'icu_investigation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'Routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_highend_investigations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ip_pharmacy_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'room_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'icu_pharmacy_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_cath_pharmacy') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'drug_admin_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                }
                                if (table_name === 'general_equipment_charges') {
                                    if (feild.key_word === 'routine') {
                                        // if (sub_feild.name === 'general_highend_equipments') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'general_highend_equipments') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_charges') {
    
                                    if (feild.key_word === 'ot_inst_disinfec') {
                                        if (sub_feild.name === 'ot_inst_disinfec') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
    
                                    }
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_hours') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'text';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_equipment') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_equipments') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'procedure_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'surgery_procedure_name') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'blood_bank_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'blood_components') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'cross_consultation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'dept_for_corss_consultations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'hospital_services') {
                                    if (feild.key_word === 'mrd') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'ward_consumables') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'seropositive') {
                                        if (sub_feild.name === 'seropositive') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'isolation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'room_isolation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_isolation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
    
                                    }
                                }
                                if (table_name === 'physiotherapy_diet_charges') {
                                    if (feild.key_word === 'dietician') {
                                        if (sub_feild.name === 'dietician') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'physiotherapys') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'surgical_charges') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'percentage') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (table_name === 'medical_charges') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'percentage') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                            })
                        })
                    })
    
                    additionalPackageSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        subTable.visible=false;
                        additionalPackageSchema[key].Specification.add_more = true;
                        // additionalPackageSchema[key].Specification.table_body.length=0
                    })
    
                    additionalProcedureSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        subTable.visible=false;
                        additionalProcedureSchema[key].Specification.add_more = true;
                        additionalProcedureSchema[key].Specification.table_body.length=0
                    })
    
                    includesSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        includesSchema[key].Specification.table_body.length=0;
                      
                    })
    
                    excludesSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        excludesSchema[key].Specification.table_body.length=0;
                    })
                    hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                    hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                    this.setState({ addonSchema: addonSchema, medicationDetailsSchema: medicationDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, includesSchema, excludesSchema }, () => {
                        console.log('additionalPackageSchema',additionalPackageSchema);
                        // this.updateDefaultEstimates()
                    });
                   
                }else{


                let { estimation,  additional_procedures } = counselling_details
                let { medicationDetailsSchema, addonSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema } = this.state;

                medicationDetailsSchema.map((feild, key) => {
                    // if (feild.name === 'estimated_admission_date') {
                    //     medicationDetailsSchema[key]['value'] = est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):counselling_details['e_date_of_admission'];
                    //     medicationDetailsSchema[key]['text'] = est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):counselling_details['e_date_of_admission'];
                    //     medicationDetailsSchema[key]['disable']=est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?true:false;
                    //     if (counselling_details['e_date_of_admission']) {
                    //         this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                    //     }
                    // }
                    if (feild.name === 'estimated_admission_date') {
                        medicationDetailsSchema[key]['value'] = counselling_details['e_date_of_admission'];
                        medicationDetailsSchema[key]['text'] = counselling_details['e_date_of_admission'];
                        medicationDetailsSchema[key]['disable'] = true;
                        if (counselling_details['e_date_of_admission']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'actual_admission_date') {
                        medicationDetailsSchema[key]['value'] = counselling_details['a_date_of_admission'];
                        medicationDetailsSchema[key]['text'] = counselling_details['a_date_of_admission'];
                        if (counselling_details['a_date_of_admission']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }


                    if (feild.name === 'diagnosis') {
                        medicationDetailsSchema[key]['value'] = counselling_details['diagnosis'];
                        medicationDetailsSchema[key]['text'] = counselling_details['diagnosis'];
                        if (counselling_details['diagnosis']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'care_management') {
                        medicationDetailsSchema[key]['value'] = counselling_details['care_management'];
                        medicationDetailsSchema[key]['text'] = counselling_details['care_management_name'];
                        if (counselling_details['care_management']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'estimate_type') {
                        medicationDetailsSchema[key]['value'] = counselling_details['estimate_type'];
                        medicationDetailsSchema[key]['text'] = counselling_details['estimate_type_name'];
                        if (counselling_details['estimate_type']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                    if (feild.name === 'package_name') {
                        medicationDetailsSchema[key]['value'] = counselling_details['package_id'];
                        medicationDetailsSchema[key]['text'] = counselling_details['package_name'];
                        medicationDetailsSchema[key]['length_of_stay'] = counselling_details['length_of_stay'];

                        if (counselling_details['surgery_procedure_id']) {
                            this.getExcludesIncludes((counselling_details['surgery_procedure_id']), counselling_details['procedure_name'],0);
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'length_of_stay') {
                        medicationDetailsSchema[key]['value'] = counselling_details['length_of_stay'];
                        medicationDetailsSchema[key]['text'] = counselling_details['length_of_stay'];
                        if (counselling_details['length_of_stay']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'icu_stay') {
                        medicationDetailsSchema[key]['value'] = counselling_details['icu_stay'];
                        medicationDetailsSchema[key]['text'] = counselling_details['icu_stay'];
                        if (counselling_details['icu_stay']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_stay') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_stay'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_stay'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['room_stay'];
                        if (counselling_details['room_stay']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'date_of_surgery') {
                        medicationDetailsSchema[key]['value'] = counselling_details['date_of_surgery'];
                        medicationDetailsSchema[key]['text'] = counselling_details['date_of_surgery'];

                    }

                    if (feild.name === 'surgery_procedure_name') {
                        // medicationDetailsSchema[key]['value'] = "RAT0004";
                        // medicationDetailsSchema[key]['text'] = "3DCRT";
                        medicationDetailsSchema[key]['value'] = counselling_details['procedure_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['procedure_name'];
                        if (counselling_details['surgery_procedure_id']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            // this.getExcludesIncludes((counselling_details['surgery_procedure_id']), counselling_details['procedure_name'],0);
                        }
                    }

                    if (feild.name === 'room_opted') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_opted_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_opted_name'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['room_opted_amount'];
                        medicationDetailsSchema[key]['room_id'] = counselling_details['room_opted'];

                        if (counselling_details['room_opted']) {
                            medicationDetailsSchema[key]['disable'] = false;
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_upgrade') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_upgrade_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_upgrade_name'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['room_upgrade_amount'];
                        medicationDetailsSchema[key]['room_id'] = counselling_details['room_upgrade'];

                        if (counselling_details['room_upgrade']) {
                            medicationDetailsSchema[key]['disable'] = false;
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'icu_opted') {
                        medicationDetailsSchema[key]['value'] = counselling_details['icu_opted_name'];
                        medicationDetailsSchema[key]['text'] = counselling_details['icu_opted_name'];
                        medicationDetailsSchema[key]['amount'] = counselling_details['icu_opted_amount'];
                        medicationDetailsSchema[key]['room_id'] = counselling_details['icu_opted'];

                        if (counselling_details['icu_opted']) {
                            medicationDetailsSchema[key]['disable'] = false;
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    if (feild.name === 'room_upgrade_reason') {
                        medicationDetailsSchema[key]['value'] = counselling_details['room_upgrade_reason'];
                        medicationDetailsSchema[key]['text'] = counselling_details['room_upgrade_reason_name'];

                        if (counselling_details['room_upgrade_reason']) {
                            medicationDetailsSchema[key]['disable'] = false;
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }
                })

                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            if (table_name === 'room_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details &&counselling_details['room_stay']?counselling_details['room_stay']: null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details &&counselling_details['room_stay']?counselling_details['room_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details &&counselling_details['icu_stay']?counselling_details['icu_stay']: null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details &&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ip_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details&&counselling_details['room_stay']?counselling_details['room_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details&&counselling_details['room_stay']?counselling_details['room_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details&&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details&&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'drug_admin_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                            }
                            if (table_name === 'general_equipment_charges') {
                                if (feild.key_word === 'routine') {
                                    // if (sub_feild.name === 'general_highend_equipments') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'text';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'hospital_services') {
                                if (feild.key_word === 'mrd') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'ward_consumables') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'room_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details && counselling_details['room_stay']?counselling_details['room_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details && counselling_details['room_stay']?counselling_details['room_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] =counselling_details&& counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details&&counselling_details['icu_stay']?counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }

                                }
                            }
                            if (table_name === 'physiotherapy_diet_charges') {
                                if (feild.key_word === 'dietician') {
                                    if (sub_feild.name === 'dietician') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = counselling_details && counselling_details['room_stay'] && counselling_details['icu_stay']?counselling_details['room_stay']+counselling_details['icu_stay']:null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = counselling_details && counselling_details['room_stay'] &&counselling_details['icu_stay']?counselling_details['room_stay']+counselling_details['icu_stay']:null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'surgical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount' && sub_feild.id!==1) {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })
                additionalPackageSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    // additionalPackageSchema[key].Specification.table_body.length=0
                })

                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    additionalProcedureSchema[key].Specification.table_body.length=0
                })



                // let { estimation, additional_packages } = counselling_details
             let  additional_packages =  this.props.counselling_details.additional_packages
                if (this.props.counselling_details.additional_packages.length>0) {
                    additionalPackageSchema.map((data, secKey) => {
                        additionalPackageSchema[secKey].visible = true;
                        additionalPackageSchema[secKey].Specification.add_more = true;
                        if (secKey === 0) {
                            this.props.counselling_details.additional_packages.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "additional_package_name") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['package_id']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['package_name']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['amount']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalPackageSchema[secKey].Specification.table_body[additionalPackageSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = (last_element && last_element['id']) ? last_element['id'] : 0;
                                let last_id=packages_key;
                                // if (last_element == undefined) {
                                //     last_id = packages_key;
                                // }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id+1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "additional_package_name") {
                                        obj['feilds'][key]['value'] = packages['package_id'];
                                        obj['feilds'][key]['text'] = packages['package_name'];
                                        obj['feilds'][key]['disable'] = true;
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = packages['amount'];
                                        obj['feilds'][key]['text'] = packages['amount'];
                                    }
                                })
                                data['Specification']['table_body'].push(obj);

                                this.getExcludesIncludes(packages['package_id'], packages['package_name'],1);
                                // }
                            })
                        }

                    })
                }

                if (additional_procedures.length > 0) {
                    additionalProcedureSchema.map((data, secKey) => {
                        if (secKey === 0) {
                            additionalProcedureSchema[secKey].visible = true;
                            additional_procedures.map((procedures, procedures_key) => {
                                // if (procedures_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "additional_surgery_procedure_name") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['procedure_id']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['procedure_id']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = procedures['amount']
                                //                 additionalProcedureSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = procedures['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                let last_element = additionalProcedureSchema[secKey].Specification.table_body[additionalProcedureSchema[secKey].Specification.table_body.length - 1];
                                // let last_id = last_element['id'];
                                let last_id=procedures_key;
                                // if (last_element === undefined) {
                                //     last_id = procedures_key;
                                // }
                                // } else {
                                //     last_id = last_element['id'];
                                // }

                                let obj = {
                                    "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                    id: last_id+1,
                                    input_feild: [],
                                    text: "Highend",
                                    'key_word': 'add_more',
                                    type: "text"
                                }
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = null;
                                    obj['feilds'][key]['value'] = null;
                                    obj['feilds'][key]['text'] = null;
                                })
                                obj['feilds'].map((feild, key) => {
                                    obj['feilds'][key]['id'] = last_id + 1;
                                    if (feild.name === "additional_surgery_procedure_name") {
                                        obj['feilds'][key]['value'] = procedures['procedure_id'];
                                        obj['feilds'][key]['text'] = procedures['procedure_name'];
                                    }
                                    if (feild.name === "amount") {
                                        obj['feilds'][key]['value'] = procedures['amount'];
                                        obj['feilds'][key]['text'] = procedures['amount'];
                                    }
                                    if (feild.name === "action") {
                                        obj['feilds'][key]['element'] = 'text';
                                    }
                                })
                                data['Specification']['table_body'].push(obj);
                                // }
                            })
                        }
                    })
                }
                else {
                    additional_procedures.map((data, secKey) => {
                        if (secKey === 0) {
                            additional_procedures[secKey].visible = false;
                        }
                    })
                }

                if (estimation) {
                    addonSchema.map((subTable, key) => {
                        console.log('subTable:::', subTable);
                        let service_ids = [];
                        let estimate_keys=[];
                        estimation.map((estimate, estimate_key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                if (estimate.header === subTable.header && feild.key_word === estimate.key_word && estimate.key_word !== 'add_more') {
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.name !== "action" && sub_feild.element!=='text') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['service']
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['service_name']
                                        }
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "rate") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                        }
                                        if (sub_feild.name === "percentage") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                        }
                                        if (sub_feild.name === "amount") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                        }
                                    })
                                }
                                else if (estimate.header === subTable.header && estimate.key_word === 'add_more' && !estimate_keys.includes(estimate_key)) {
                                    const i_key = (addonSchema[key].Specification.table_body).length + 1;
                                    service_ids.push(estimate.service);
                                    estimate_keys.push(estimate_key);
                                    let feildData;
                                    if(subTable['Specification']['add_more_feilds'] && subTable['Specification']['add_more_feilds'].find(f => f.sub_header === estimate.sub_header)){
                                        feildData = subTable['Specification']['add_more_feilds'];
                                    } else if(subTable['Specification']['add_more_feilds1'] && subTable['Specification']['add_more_feilds1'].find(f => f.sub_header === estimate.sub_header)){
                                        feildData = subTable['Specification']['add_more_feilds1'];
                                    } else if(subTable['Specification']['add_more_feilds2'] && subTable['Specification']['add_more_feilds2'].find(f => f.sub_header === estimate.sub_header)){
                                        feildData = subTable['Specification']['add_more_feilds2'];
                                    }
                                    console.log("subTable['Specification']['add_more_feilds1']",subTable['Specification'], estimate.sub_header);
                                    let obj = {
                                        "feilds": feildData ? JSON.parse(JSON.stringify(feildData)) : [],
                                        id: i_key,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    // let obj = {
                                    //     "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                    //     id: i_key,
                                    //     input_feild: [],
                                    //     text: "Highend",
                                    //     'key_word': 'add_more',
                                    //     type: "text"
                                    // }
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = null;
                                        obj['feilds'][key]['value'] = null;
                                        obj['feilds'][key]['text'] = null;
                                    })
                                    obj['feilds'].map((feild, key) => {
                                        obj['feilds'][key]['id'] = i_key;
                                        // if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action") {
                                        //     obj['feilds'][key]['value'] = estimate['service'];
                                        //     obj['feilds'][key]['text'] = estimate['service_name'];
                                        // }
                                        // if (feild.name === "qty") {
                                        //     obj['feilds'][key]['value'] = estimate['qty'];
                                        //     obj['feilds'][key]['text'] = estimate['qty'];
                                        // }
                                        // if (feild.name === "rate") {
                                        //     obj['feilds'][key]['value'] = estimate['rate'];
                                        //     obj['feilds'][key]['text'] = estimate['rate'];
                                        // }
                                        // if (feild.name === "percentage") {
                                        //     obj['feilds'][key]['value'] = estimate['qty'];
                                        //     obj['feilds'][key]['text'] = estimate['qty'];
                                        // }
                                        // if (feild.name === "amount") {
                                        //     obj['feilds'][key]['value'] = estimate['amount'];
                                        //     obj['feilds'][key]['text'] = estimate['amount'];
                                        // }
                                        if(feild.rowgroup === 'surgeon_fees'){
                                            if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action" && feild.element!=='text') {
                                                obj['feilds'][key]['value'] = estimate['service'];
                                                obj['feilds'][key]['text'] = estimate['service_name'];
                                            }
                                            if (feild.name === "qty") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "rate") {
                                                obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                                obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                            if (feild.name === "percentage") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            // if (feild.name === "amount") {
                                            //     console.log("feild.name",feild.name);
                                            //     obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            //     obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            // }
                                        } else {
                                            if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action" && feild.element!=='text') {
                                                obj['feilds'][key]['value'] = estimate['service'];
                                                obj['feilds'][key]['text'] = estimate['service_name'];
                                            }
                                            if (feild.name === "qty") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "rate") {
                                                obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                                obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                            if (feild.name === "percentage") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "amount") {
                                                console.log("feild.name",feild.name);
                                                obj['feilds'][key]['value'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                                obj['feilds'][key]['text'] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                        }
                                        
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                }
                            })
                        })
                        console.log('table_body', addonSchema[key].Specification.table_body);
                    })
                }

                estimateBreakupFormatSchema.map((feild, key) => {
                                        if (feild.name === 'base_price') {
                        counselling_details['header_amount'].map((feild, key) => {
                            estimateBreakupFormatSchema[key]['value'] = parseFloat(feild.base_price);
                            estimateBreakupFormatSchema[key]['text'] = parseFloat(feild.base_price);
                        })
                    }
                    if (feild.name === 'excludes') {
                            // estimateBreakupFormatSchema[key]['value'] = parseFloat(feild.total_estimate_amount);
                            // estimateBreakupFormatSchema[key]['text'] = parseFloat(feild.total_estimate_amount);
                            const examount = parseFloat(counselling_details['header_amount'][0] && counselling_details['header_amount'][0].excludes)
                        estimateBreakupFormatSchema[key]['value'] = examount?examount:0;
                        estimateBreakupFormatSchema[key]['text'] = examount?examount:0;
                        this.setState({ exclude_total_amount: examount?examount:0 });
                    }
                    if (feild.name === 'total_Estimate_amount') {
                        estimateBreakupFormatSchema[key]['value'] = parseFloat(counselling_details['header_amount']);
                        estimateBreakupFormatSchema[key]['text'] = parseFloat(counselling_details['header_amount']);
                    }
                    if (feild.name === 'name_of_the_fc') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['counseller_name'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['counseller_name'];
                    }
                    if (feild.name === 'attendant_name') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['attendant_name'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['attendant_name'];
                    }
                    if (feild.name === 'relation') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['patient_relation'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['patient_relation'];
                    }
                    if (feild.name === 'remarks') {
                        estimateBreakupFormatSchema[key]['value'] = counselling_details['remarks'];
                        estimateBreakupFormatSchema[key]['text'] = counselling_details['remarks'];
                    }
                    if (feild.name === 'advance_amount') {                      
                            estimateBreakupFormatSchema[key]['value'] = parseFloat(counselling_details['advance_amount']);
                            estimateBreakupFormatSchema[key]['text'] = parseFloat(counselling_details['advance_amount']);
                    }
                    
                })
                let { includesSchema } = this.state;
                if (counselling_details['includes_data'].length > 0) {
                    let includes_data = counselling_details['includes_data'];
                    includesSchema.map((subTable, key) => {
                        includes_data.map((ex_data, ex_key) => {
                            let last_id = 1;
                            if (includesSchema[key].Specification.table_body.length > 0) {
                                let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                last_id = last_element['id'];
                            }

                            let obj = {
                                "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                id: last_id + 1,
                                input_feild: [],
                                text: "Highend",
                                'key_word': 'add_more',
                                type: "text"
                            }
                            obj['feilds'].map((feild, feild_key) => {
                                obj['feilds'][feild_key]['id'] = last_id + 1;

                                if (feild.name === 'item_service') {
                                    obj['feilds'][feild_key]['value'] = ex_data.service_name;
                                    obj['feilds'][feild_key]['title'] = ex_data.service_name;
                                }
                            })
                            subTable['Specification']['table_body'].push(obj);
                        })
                    })
                    this.setState({ includes_data });

                }
                let total_estimate_amount = 0;
                counselling_details['header_amount'].map((feild, key) => {
                    total_estimate_amount = parseFloat(feild.total_estimate_amount);
                })
                if (counselling_details['excludes_data']) {
                    hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: counselling_details['excludes_data'] } })
                    optionsStore.dispatch({ type: 'options_data', 'data': [] });
                    this.setState({ excludes_datarecounselling: counselling_details['excludes_data'] });
                }
                hideInEXStore.dispatch({ type: 'NME_VIEW_DATA', data: { status: true, page: 'recounselling' } })
                hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                medicationDetailsSchema.map((feild, key) => {
                    
                    if (feild.name === 'surgery_procedure_name') {
                        medicationDetailsSchema[key]['value'] = counselling_details['surgery_procedure_id'];
                        medicationDetailsSchema[key]['text'] = counselling_details['procedure_name'];
                        if (counselling_details['surgery_procedure_id']) {
                            this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                        }
                    }

                    
                })
                this.setState({ "medicationDetailsSchema": medicationDetailsSchema, "addonSchema": addonSchema, "estimateBreakupFormatSchema": estimateBreakupFormatSchema, total_estimate_amount: total_estimate_amount, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema,fc1_total_estimate_amount: total_estimate_amount })
            }
            } break;

            case 'finanical-counselling': {
                let { PackageSchema,careManagementValue,addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, excludesSchema, includesSchema } = this.state
                Storage.remove('fc_checklist_verified');

                medicationDetailsSchema.map((feild, key) => {
                    feild.value = null;

                    // if (feild.name === 'estimated_admission_date') {
                    //     // feild.disable = false;
                    //     feild['value'] = est_date_of_admis ? moment(est_date_of_admis).format('YYYY-MM-DD') :est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):null;
                    //     feild['disable'] = est_date_of_admis ? true : est_admis_date!=='null'&& est_admis_date!==null && est_admis_date!==undefined?moment(est_admis_date).format('YYYY-MM-DD'):false;
                    // }
                    if (feild.name === 'estimated_admission_date') {
                        let {basic_info} = this.props;
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        let payload = {
                            "umr_no": basic_info.umr_no,
                            "unit_id": user_unit_id,
                            "ip_number": basic_info.ip_no || null,
                            "doctor_id": this.props.basicDetailsSchema[10].value,
                        }
                        postService('getAdmissionDetailsForCounselling', 'POST', {data:payload}).then(res => {
                            let AdmissionDetails
                            if(res.status){
                                AdmissionDetails = res.data[0];
                                const matchDoctorId = basic_info.doctor_id;
                                let careMgmtValue = AdmissionDetails.caremanagement === 'medical_department' ? '1' : '2';
                                this.setState({'doctorCode': matchDoctorId})
                                const doctorID = res.data.find((item) => item.id === matchDoctorId);
                                console.log("careMgmtValue",careMgmtValue);
                                    if(!doctorID){
                                        careManagementValue = careMgmtValue === '1' ? 1 : 2;
                                        this.setState({'careManagementValue':careManagementValue})
                                    } else {
                                        careManagementValue = doctorID.care_management === '3' ? 2 : doctorID.care_management === '2' ? 2 : 1;
                                        this.setState({'careManagementValue':careManagementValue})
                                    }
                                console.log("basic_info insurance:::",careMgmtValue);
                                feild['value'] = AdmissionDetails.estimated_admission_date ? AdmissionDetails.estimated_admission_date : null
                                feild['disable'] = AdmissionDetails.estimated_admission_date ? true : false
                            }
                            medicationDetailsSchema.map((feild, key) => {
                                if (feild.name === 'care_management') {
                                    feild['value'] = this.state.careManagementValue;
                                    feild['text'] = feild['value'] === '2' ? 'Surgical' : 'Medical';
                                    feild['disable'] = false;
                                    this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                                }
                            })
                            this.setState({medicationDetailsSchema:medicationDetailsSchema, 'admissionAdvices': AdmissionDetails});
                        });
                        let TableBody = []; 
                        additionalPackageSchema.map((subTable, key1) => {
                            TableBody = subTable.Specification.table_body;
                        });
                        // localStorage.setItem('cashPackageSchema',JSON.stringify(TableBody));
                        this.setState({'PackageSchema':TableBody});
                    }
                    if (feild.name === 'actual_admission_date') {

                    }
                    if (feild.name === 'diagnosis') {
                        feild.disable = false;
                    }
                //     if (feild.name === 'care_management') {
                //         // feild.disable = false;
                //         postService('getDoctorsforDropdown', 'GET', 'null').then(res => {
                //             if (res && res.data) {
                //                 const doctorId = basic_info.doctor_id;
                //                 const doctorMatch = res.data.find(item => item.id === doctorId)
                //                 this.setState({'doctorCode': doctorMatch})
                //                 if(doctorMatch){
                //                     careManagementValue = doctorMatch.care_management === '3' ? '2' : doctorMatch.care_management === '2' ? '2' : '1';
                //                 }
                //                 console.log("careManagementValue",careManagementValue);
                //         feild['value'] = careManagementValue;
                //         feild['text'] = feild['value'] === '2' ? 'Surgical' : 'Medical';
                //         feild['disable'] = false;
                //         this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                //     }
                // })
                //     }
                    if (feild.name === 'estimate_type') {
                        feild.visible = false;
                    }
                    if (feild.name === 'package_name') {
                        feild.visible = false;
                    }
                    if (feild.name === 'length_of_stay') {

                    }
                    if (feild.name === 'icu_stay') {

                    }
                    if (feild.name === 'room_stay') {

                    }
                    if (feild.name === 'room_opted') {

                    }
                    if (feild.name === 'room_upgrade') {

                    }
                    if (feild.name === 'room_upgrade_reason') {

                    }
                    if (feild.name === 'icu_opted') {
                        feild.visible = false;
                    }
                    if (feild.name === 'date_of_surgery') {

                    }
                    // if (feild.name === 'surgery_procedure_name') {
                    //     feild.disable = false;
                    // }
                    if (feild.name === 'surgery_procedure_amount') {

                    }
                })

                estimateBreakupFormatSchema.map((feild, key) => {
                    feild.value = null;
                    feild.text = null;
                    if (feild.name === 'base_price') {

                    }
                    if (feild.name === 'advance_amount') {
                        estimateBreakupFormatSchema[key]['disable'] = true;
                    }
                    if (feild.name === 'excludes') {

                    }
                    if (feild.name === 'total_Estimate_amount') {

                    }
                    if (feild.name === 'name_of_the_fc') {
                        estimateBreakupFormatSchema[key]['value'] = JSON.parse(Storage.get('user'));
                        estimateBreakupFormatSchema[key]['text'] = JSON.parse(Storage.get('user'));
                        feild.disable = true;
                    }
                    if (feild.name === 'attendant_name') {
                        feild.disable = false;
                    }
                    if (feild.name === 'relation') {
                        feild.disable = false;
                    }
                })

                addonSchema.map((subTable, key) => {
                    let table_name = subTable.name
                    addonSchema[key].header_amount = 0;
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                            // }

                            if (table_name === 'room_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'room_investigation_charges') {
                                addonSchema[key].Specification.add_more = true;
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'icu_investigation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'Routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_investigations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ip_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'room_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }   
                            if (table_name === 'icu_pharmacy_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_cath_pharmacy') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'drug_admin_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                            }
                            if (table_name === 'general_equipment_charges') {
                                if (feild.key_word === 'routine') {
                                    // if (sub_feild.name === 'general_highend_equipments') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'general_highend_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_charges') {

                                if (feild.key_word === 'ot_inst_disinfec') {
                                    if (sub_feild.name === 'ot_inst_disinfec') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    }

                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_hours') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'ot_equipment') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'ot_equipments') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'procedure_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'surgery_procedure_name') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    // if (sub_feild.name === 'action') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    // }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'blood_bank_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'blood_components') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'cross_consultation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'dept_for_corss_consultations') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'hospital_services') {
                                if (feild.key_word === 'mrd') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'ward_consumables') {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'seropositive') {
                                    if (sub_feild.name === 'seropositive') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'isolation_charges') {
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'room_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'icu_isolation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }

                                }
                            }
                            if (table_name === 'physiotherapy_diet_charges') {
                                if (feild.key_word === 'dietician') {
                                    if (sub_feild.name === 'dietician') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'routine') {
                                    if (sub_feild.name === 'routine') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                }
                                if (feild.key_word === 'highend') {
                                    if (sub_feild.name === 'physiotherapys') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'action') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                    }
                                }
                                if (feild.key_word === 'add_more') {
                                    addonSchema[key].Specification.table_body.splice(table_key, 1)
                                }
                            }
                            if (table_name === 'surgical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                            if (table_name === 'medical_charges') {
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                }
                            }
                        })
                    })
                })

                // additionalPackageSchema.map((subTable, key) => {
                //     let table_body = subTable.Specification.table_body;
                //     subTable.visible=false;
                //     additionalPackageSchema[key].Specification.add_more = true;
                //     // additionalPackageSchema[key].Specification.table_body.length=0;
                //     // table_body.map((feild, table_key) => {
                //     //     if (table_body.length > 0) {
                //     //         if (table_key === 0) {
                //     //             let row = feild.feilds;
                //     //             row.map((sub_feild, sub_table_key) => {
                //     //                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                //     //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                //     //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                //     //                 }
                //     //                 if (sub_feild.name === 'additional_package_name') {
                //     //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                //     //                 }
                //     //                 if (sub_feild.name === 'amount') {
                //     //                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                //     //                 }
                                    
                //     //             })
                //     //         }
                //     //         else {
                //     //             additionalPackageSchema[key].Specification.table_body.splice(table_key, 1)
                //     //         }
                //     //     }
                //     // })
                // })

                additionalPackageSchema.map((subTable, key) => {
                    console.log('TABLE_BODY::::',subTable,this.state);
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.add_more = true;
                    // additionalPackageSchema[key].Specification.table_body.length=0;
                })

                additionalProcedureSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    subTable.visible=false;
                    additionalProcedureSchema[key].Specification.add_more = true;
                    additionalProcedureSchema[key].Specification.table_body.length=0;
                    // table_body.map((feild, table_key) => {
                    //     if (table_body.length > 0) {
                    //         if (table_key === 0) {
                    //             let row = feild.feilds;
                    //             row.map((sub_feild, sub_table_key) => {
                    //                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                    //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                    //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                    //                 }
                    //                 if (sub_feild.name === 'additional_surgery_procedure_name') {
                    //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                 }
                    //                 if (sub_feild.name === 'amount') {
                    //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                 }
                    //                 if (sub_feild.name === 'action') {
                    //                     additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'text';
                    //                 }
                    //             })
                    //         }
                    //         else {
                                
                    //             additionalProcedureSchema[key].Specification.table_body.splice(table_key, 1)
                    //         }
                    //     }
                    // })
                })

                includesSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        includesSchema[key].Specification.table_body = [];
                    })
                })

                excludesSchema.map((subTable, key) => {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        excludesSchema[key].Specification.table_body = [];
                    })
                })
                hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                hideInEXStore.dispatch({ type: 'VALIDATION_NME', data:{showNMEModel:false} })
                excludesTableStore.dispatch({ type: 'options_data', 'data': [] });
                this.setState({ addonSchema: addonSchema, medicationDetailsSchema: medicationDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, includesSchema, excludesSchema }, () => {
                    console.log('additionalPackageSchema',additionalPackageSchema);
                    // this.updateDefaultEstimates()
                });
               
            } 
            break;
            default:
                this.setState({
                    medicationDetailsSchema: medicationDetailsSchema, estimateBreakupFormatSchema: estimateBreakupFormatSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema,
                    // view_mode: true 

                }, () => {

                    let { counselling_details } = this.props;
                    let { medicationDetailsSchema, addonSchema, estimateBreakupFormatSchema, additionalPackageSchema } = this.state;

                    medicationDetailsSchema.map((feild, key) => {
                        if (feild.name === 'estimated_admission_date') {
                            medicationDetailsSchema[key]['value'] = counselling_details['e_date_of_admission'];
                            medicationDetailsSchema[key]['text'] = counselling_details['e_date_of_admission'];
                            if (counselling_details['e_date_of_admission']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'actual_admission_date') {
                            medicationDetailsSchema[key]['value'] = counselling_details['a_date_of_admission'];
                            medicationDetailsSchema[key]['text'] = counselling_details['a_date_of_admission'];
                            if (counselling_details['a_date_of_admission']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }


                        if (feild.name === 'diagnosis') {
                            medicationDetailsSchema[key]['value'] = counselling_details['diagnosis'];
                            medicationDetailsSchema[key]['text'] = counselling_details['diagnosis'];
                            if (counselling_details['diagnosis']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'care_management') {
                            medicationDetailsSchema[key]['value'] = counselling_details['care_management'];
                            medicationDetailsSchema[key]['text'] = counselling_details['care_management_name'];
                            if (counselling_details['care_management']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }
                        if (feild.name === 'estimate_type') {
                            medicationDetailsSchema[key]['value'] = counselling_details['estimate_type'];
                            medicationDetailsSchema[key]['text'] = counselling_details['estimate_type_name'];
                            if (counselling_details['estimate_type']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }
                        if (feild.name === 'package_name') {
                            medicationDetailsSchema[key]['value'] = counselling_details['package_id'] || counselling_details['package_amt'] ? parseInt(counselling_details['package_amt']) : null;
                            medicationDetailsSchema[key]['text'] = counselling_details['package_name'];
                            medicationDetailsSchema[key]['length_of_stay'] = counselling_details['length_of_stay'];

                            if (counselling_details['package_id']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'length_of_stay') {
                            medicationDetailsSchema[key]['value'] = counselling_details['length_of_stay'];
                            medicationDetailsSchema[key]['text'] = counselling_details['length_of_stay'];
                            if (counselling_details['length_of_stay']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'icu_stay') {
                            medicationDetailsSchema[key]['value'] = counselling_details['icu_stay'];
                            medicationDetailsSchema[key]['text'] = counselling_details['icu_stay'];
                            if (counselling_details['icu_stay']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'room_stay') {
                            medicationDetailsSchema[key]['value'] = counselling_details['room_stay'];
                            medicationDetailsSchema[key]['text'] = counselling_details['room_stay'];
                            if (counselling_details['room_stay']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'date_of_surgery') {
                            medicationDetailsSchema[key]['value'] = counselling_details['date_of_surgery'];
                            medicationDetailsSchema[key]['text'] = counselling_details['date_of_surgery'];

                        }

                        if (feild.name === 'surgery_procedure_name') {
                            medicationDetailsSchema[key]['value'] = counselling_details['surgery_procedure_id'];
                            medicationDetailsSchema[key]['text'] = counselling_details['procedure_name'];
                            if (counselling_details['surgery_procedure_id']) {
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'room_opted') {
                            medicationDetailsSchema[key]['value'] = counselling_details['room_opted_name'];
                            medicationDetailsSchema[key]['text'] = counselling_details['room_opted_name'];
                            medicationDetailsSchema[key]['amount'] = counselling_details['room_opted_amount'];
                            medicationDetailsSchema[key]['room_id'] = counselling_details['room_opted'];

                            if (counselling_details['room_opted']) {
                                medicationDetailsSchema[key]['disable'] = false;
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                             
                            }
                        }

                        if (feild.name === 'room_upgrade') {
                            medicationDetailsSchema[key]['value'] = counselling_details['room_upgrade_name'];
                            medicationDetailsSchema[key]['text'] = counselling_details['room_upgrade_name'];
                            medicationDetailsSchema[key]['amount'] = counselling_details['room_upgrade_amount'];
                            medicationDetailsSchema[key]['room_id'] = counselling_details['room_upgrade'];

                            if (counselling_details['room_upgrade']) {
                                medicationDetailsSchema[key]['disable'] = false;
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'icu_opted') {
                            medicationDetailsSchema[key]['value'] = counselling_details['icu_opted_name'];
                            medicationDetailsSchema[key]['text'] = counselling_details['icu_opted_name'];
                            medicationDetailsSchema[key]['amount'] = counselling_details['icu_opted_amount'];
                            medicationDetailsSchema[key]['room_id'] = counselling_details['icu_opted'];

                            if (counselling_details['icu_opted']) {
                                medicationDetailsSchema[key]['disable'] = false;
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }

                        if (feild.name === 'room_upgrade_reason') {
                            medicationDetailsSchema[key]['value'] = counselling_details['room_upgrade_reason_name'];
                            medicationDetailsSchema[key]['text'] = counselling_details['room_upgrade_reason_name'];

                            if (counselling_details['room_upgrade_reason']) {
                                medicationDetailsSchema[key]['disable'] = false;
                                this.buttonClick2(medicationDetailsSchema, { "type": feild.name });
                            }
                        }
                    })

                    let { estimation, additional_packages } = counselling_details
                    if (additional_packages) {
                        additionalPackageSchema.map((data, secKey) => {
                            console.log('TABLE_BODY::::',data,this.state);
                            additional_packages.map((packages, packages_key) => {
                                // if (packages_key === 0) {
                                //     data['Specification']['table_body'].map((table_body, table_key) => {
                                //         table_body['feilds'].map((feilds, key) => {
                                //             if (feilds.name === "additional_package_name") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['package_id']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['package_name']
                                //             }
                                //             if (feilds.name === "amount") {
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = packages['amount']
                                //                 additionalPackageSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = packages['amount']
                                //             }
                                //         })
                                //     })
                                // }
                                // else {
                                    let obj = {
                                        "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? data['Specification']['add_more_feilds'] : [],
                                        id: 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    data['Specification']['table_body'].map((table_body, table_key) => {
                                        additional_packages.map((estimate, key) => {
                                            obj['feilds'].map((feild, key) => {
                                                if (feild.name === "additional_package_name") {
                                                    obj['feilds'][key]['value'] = estimate['package_id'];
                                                    obj['feilds'][key]['text'] = estimate['package_id'];
                                                }
                                                if (feild.name === "amount") {
                                                    obj['feilds'][key]['value'] = estimate['amount'];
                                                    obj['feilds'][key]['text'] = estimate['amount'];
                                                }
                                            })
                                        })
                                        data['Specification']['table_body'].push(obj);
                                    })
                                // }
                            })
                        })
                    }

                    if (estimation) {
                        addonSchema.map((subTable, key) => {
                            let service_ids = [];
                            estimation.map((estimate, estimate_key) => {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    if (estimate.header === subTable.header && feild.key_word === estimate.key_word && estimate.key_word !== 'add_more') {
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.name !== "action") {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['service']
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['service']
                                            }
                                            if (sub_feild.name === "qty") {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                            }
                                            if (sub_feild.name === "rate") {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['rate'] ? parseFloat(estimate['rate']) : 0;
                                            }
                                            if (sub_feild.name === "percentage") {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = estimate['qty'] ? parseInt(estimate['qty']) : 0;
                                            }
                                            if (sub_feild.name === "amount") {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = estimate['amount'] ? parseFloat(estimate['amount']) : 0;
                                            }
                                        })
                                    }
                                    else if (estimate.header === subTable.header && estimate.key_word === 'add_more' && !service_ids.includes(estimate.service)) {
                                        // console.log('line_item',estimate)
                                        const i_key = (addonSchema[key].Specification.table_body).length + 1;
                                        service_ids.push(estimate.service);
                                        // console.log('estimation2',estimate, i_key, (addonSchema[key].Specification.table_body).length+1)
                                        let obj = {
                                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? subTable['Specification']['add_more_feilds'] : [],
                                            id: i_key,
                                            input_feild: [],
                                            text: "Highend",
                                            'key_word': 'add_more',
                                            type: "text"
                                        }
                                        // console.log('key',i_key, obj)
                                        obj['feilds'].map((feild, key) => {
                                            obj['feilds'][key]['id'] = i_key;
                                            if (feild.name !== "qty" && feild.name !== "rate" && feild.name !== "amount" && feild.name !== "action") {
                                                obj['feilds'][key]['value'] = estimate['service'];
                                                obj['feilds'][key]['text'] = estimate['service'];
                                            }
                                            if (feild.name === "qty") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "rate") {
                                                obj['feilds'][key]['value'] = estimate['rate'];
                                                obj['feilds'][key]['text'] = estimate['rate'];
                                            }
                                            if (feild.name === "percentage") {
                                                obj['feilds'][key]['value'] = estimate['qty'];
                                                obj['feilds'][key]['text'] = estimate['qty'];
                                            }
                                            if (feild.name === "amount") {
                                                obj['feilds'][key]['value'] = estimate['amount'];
                                                obj['feilds'][key]['text'] = estimate['amount'];
                                            }
                                        })
                                        subTable['Specification']['table_body'].push(obj);
                                    }
                                })
                            })
                        })
                    }

                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild.name === 'base_price') {
                            counselling_details['header_amount'].map((feild, key) => {
                                estimateBreakupFormatSchema[key]['value'] = parseFloat(feild.base_price);
                                estimateBreakupFormatSchema[key]['text'] = parseFloat(feild.base_price);
                            })
                        }
                        if (feild.name === 'excludes') {
                            counselling_details['header_amount'].map((feild, key) => {
                                estimateBreakupFormatSchema[key]['value'] = parseFloat(feild.total_estimate_amount);
                                estimateBreakupFormatSchema[key]['text'] = parseFloat(feild.total_estimate_amount);
                            })
                        }
                        if (feild.name === 'total_Estimate_amount') {
                            estimateBreakupFormatSchema[key]['value'] = parseFloat(counselling_details['header_amount']);
                            estimateBreakupFormatSchema[key]['text'] = parseFloat(counselling_details['header_amount']);
                        }
                        if (feild.name === 'name_of_the_fc') {
                            estimateBreakupFormatSchema[key]['value'] = counselling_details['counseller_name'];
                            estimateBreakupFormatSchema[key]['text'] = counselling_details['counseller_name'];
                        }
                        if (feild.name === 'attendant_name') {
                            estimateBreakupFormatSchema[key]['value'] = counselling_details['attendant_name'];
                            estimateBreakupFormatSchema[key]['text'] = counselling_details['attendant_name'];
                        }
                        if (feild.name === 'relation') {
                            estimateBreakupFormatSchema[key]['value'] = counselling_details['patient_relation'];
                            estimateBreakupFormatSchema[key]['text'] = counselling_details['patient_relation'];
                        }
                    })

                    let total_estimate_amount = 0;
                    counselling_details['header_amount'].map((feild, key) => {
                        total_estimate_amount = parseFloat(feild.total_estimate_amount);
                        console.log('total_estimate_amounttotal_estimate_amount', total_estimate_amount );
                    })

                    // if(disabled){
                    //     medicationDetailsSchema.map((feild,key)=>{
                    //         medicationDetailsSchema[key]['disable'] = true;
                    //     })
                    //     estimateBreakupFormatSchema.map((feild,key)=>{
                    //         estimateBreakupFormatSchema[key]['disable'] = true;
                    //     })
                    //     addonSchema.map((subTable, key) => {
                    //         let table_body = subTable.Specification.table_body;
                    //         addonSchema[key].Specification.add_more = false;
                    //     })
                    //     addonSchema.map((subTable, key) => {
                    //         let table_body = subTable.Specification.table_body;
                    //         addonSchema[key].Specification.add_more = false;
                    //         table_body.map((feild, table_key) => {
                    //             let row = feild.feilds;
                    //             row.map((sub_feild, sub_table_key) => {
                    //                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true
                    //                 if (sub_feild.name === "action"){
                    //                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["element"] = 'text'
                    //                 }
                    //             })
                    //         })
                    //     })
                    // }

                    // this.setState({ "medicationDetailsSchema": medicationDetailsSchema, "addonSchema": addonSchema, "estimateBreakupFormatSchema": estimateBreakupFormatSchema, total_estimate_amount: total_estimate_amount, additionalPackageSchema: additionalPackageSchema })
                });
                break;
        }

        const {signatureSchema} = this.state;
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                signatureSchema[fei_key]["value"] = basic_info["phone_no"]
                signatureSchema[fei_key]["errors"] = []
            }
        })
        this.setState({signatureSchema})
        this.getCheckList();
        // console.log("basic_info", basic_info);
    }

    // shouldComponentUpdate (nextProps, nextState) {
    //     if(nextState.isGenerateSign !== this.state.isGenerateSign){
    //         console.log("CDU");
    //     }
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     if(prevState.isGenerateSign !== this.state.isGenerateSign){
    //         this.buttonClick_submit()
    //     }
    // }

    componentWillUnmount() {
        this.setState({
            visible: false,
            formData: [],
            'basicDetailsSchema': [],
            'medicationDetailsSchema': [],
            'estimateBreakupFormatSchema': [],
            'addonSchema': [],
            roomtypeSchema: [],
            includesSchema: JSON.parse(JSON.stringify([])),
            excludesSchema: [],
            'additionalPackageSchema': [],
            'additionalProcedureSchema': [],
            preserve_medicationDetailsSchema: [],
            preserve_estimateBreakupFormatSchema: [],
            preserve_addonSchema: [],
            exclude_slug_fordropdown:'',
            signatureSchema: [],
        });
    }

    updateDefaultEstimates(obj) {
        try {
            let { addonSchema, medicationDetailsSchema } = this.state;
            let { basic_info } = this.props;
            let { counselling_details } = this.props;

            // default Response
            // this.setState({ 'loadding': true });
            let { slug } = this.props.match.params;
            // let disabled = false;
            // const params = new URLSearchParams(this.props.location);
            const params = new URLSearchParams(this.props.location.search);
            const rid = params.get('rid');
            const cd = params.get('cd');
            if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
                slug = 'recounselling';
            }
            else if (slug === 'view-finanical-counselling') {
                slug = 'view-finanical-counselling';
            }
            else {
                slug = 'finanical-counselling';
            }

            let { surgery_procedure_name, care_management } = obj ? obj : {};
            let payload = {}
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            const unit_id =user_data ? user_data.unitid:'';
            // let {basic_info} = this.props;
            if (care_management == 1) {
                payload = {
                    // "payment_type": 1,
                    // "tariff_mapped": "TR1",
                    // "procedure_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                    // "unit_id": unit_id
                    "umr_no": basic_info.umr_no,
                    "unit_id": unit_id,
                    "ip_number": basic_info.ip_no || null,
                    "doctor_id": this.props.basicDetailsSchema[10].value,
                }
            } else {
                // payload = {
                //     "procedure_id": obj['service_id'] ? obj['service_id'] : null,
                //      // "service_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                //     //  "service_id": obj['service_id'] ?  obj['service_id']: null,
                //     "payment_type": 1,
                //     "tariff_mapped": "TR1",
                //     "unit_id": unit_id
                // }
                    payload = {
                            "umr_no": basic_info.umr_no,
                            "unit_id": unit_id,
                            "ip_number": basic_info.ip_no || null,
                            "doctor_id": this.props.basicDetailsSchema[10].value,
                        }
            }

            
            if (slug === 'finanical-counselling' || (slug === 'recounselling' && counselling_details===null) || (slug === 'recounselling' && counselling_details&&counselling_details['care_management'] !== care_management) || (slug === 'recounselling' &&counselling_details&& obj['service_id']&&counselling_details['surgery_procedure_id']!==obj['service_id'])) {
                this.setState({ 'loadding': true });
                // postService('getMasterRoutineEstimates', 'POST', { "data": payload }).then(res => {
                postService('getAdmissionDetailsForCounselling', 'POST', { "data": payload }).then(res => {
                    this.setState({ loadding: false });
                    if (res['status']) {
                        let los = parseFloat(res.data[0].room_stay) + parseFloat(res.data[0].icu_stay);
                        console.log('res:::::::', res.data[0].room_stay + res.data[0].icu_stay);
                        medicationDetailsSchema.map((feild, key) => {
                            if (feild.name === 'icu_stay') {
                                medicationDetailsSchema[key]['value'] = res.data[0].icu_stay;
                                console.log('ICU::::', this.state,res['icu_stay'])
                            }
                            if (feild.name === 'room_stay') {
                                medicationDetailsSchema[key]['value'] = res.data[0].room_stay;
                            }
                            if (feild.name === 'length_of_stay') {
                                medicationDetailsSchema[key]['value'] = los ? los : null
                            }
                            if(slug !== 'recounselling'){
                                if (feild.name === 'room_opted') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                            }
                            if(slug !== 'recounselling'){
                            if (feild.name === 'room_upgrade') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                        }
                            if(slug !== 'recounselling'){
                            if (feild.name === 'room_upgrade_reason') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                        }
                            if(slug !== 'recounselling'){
                            if (feild.name === 'icu_opted') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                        }


                        })

                        addonSchema.map((subTable, key) => {
                            let table_name = subTable.name;
                            addonSchema[key].header_amount = 0;
                            let table_body = subTable.Specification.table_body;
                            console.log('TABLEBODY:::', table_body);
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {

                                    if (feild.key_word === 'room') {
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {                                          
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = res.data[0].room_stay
                                            }

                                        })
                                    }
                                    if (feild.key_word === 'icu') {
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {                                          
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = res.data[0].icu_stay
                                            }

                                        })
                                    }
                                    
                                })
                            })
                        })


                        this.setState({ 'medicationDetailsSchema': medicationDetailsSchema, 'MasterRoutineEstimates': res }, () => {
                            this.setData(res)
                        })
                    }
                    else {
                        console.log('fail', res);
                        // Modal.error({
                        //     title: 'Unable to process',
                        //     content: 'Please try again later',
                        // });
                        let { addonSchema, medicationDetailsSchema, MasterRoutineEstimates } = this.state;

                        medicationDetailsSchema.map((feild, key) => {
                            if (feild.name === 'icu_stay') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                            if (feild.name === 'room_stay') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                            if (feild.name === 'room_opted') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                            if (feild.name === 'length_of_stay') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                            if (feild.name === 'room_upgrade') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                            if (feild.name === 'room_upgrade_reason') {
                                medicationDetailsSchema[key]['value'] = null
                            }

                            if (feild.name === 'icu_opted') {
                                medicationDetailsSchema[key]['value'] = null
                            }

                        })
                        addonSchema.map((subTable, key) => {
                            let table_name = subTable.name
                            addonSchema[key].header_amount = 0;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    // }

                                    if (table_name === 'room_charges') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (table_name === 'room_investigation_charges') {
                                        addonSchema[key].Specification.add_more = true;
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'Routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'room_highend_investigations') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            // if (sub_feild.name === 'action') {
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            // }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'icu_investigation_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'Routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'icu_highend_investigations') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            // if (sub_feild.name === 'action') {
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            // }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'ip_pharmacy_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine_drugs_implants') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'room_highend_drugs_implants') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            // if (sub_feild.name === 'action') {
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            // }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'icu_pharmacy_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine_drugs_implants') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'icu_highend_drugs_implants') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'ot_cath_pharmacy') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'general_equipment_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            // if (sub_feild.name === 'general_highend_equipments') {
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            // }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'general_highend_equipments') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'ot_charges') {

                                        if (feild.key_word === 'ot_inst_disinfec') {
                                            if (sub_feild.name === 'ot_inst_disinfec') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            }

                                        }
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'ot_hours') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'text';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'ot_equipment') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'ot_equipments') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'procedure_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'surgery_procedure_name') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            // if (sub_feild.name === 'action') {
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            // }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'blood_bank_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'blood_components') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'cross_consultation_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'dept_for_corss_consultations') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                    }
                                    if (table_name === 'hospital_services') {
                                        if (feild.key_word === 'mrd') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'ward_consumables') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'seropositive') {
                                            if (sub_feild.name === 'seropositive') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }
                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    if (table_name === 'isolation_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'room_isolation_charges') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'icu_isolation_charges') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                    }
                                    if (table_name === 'physiotherapy_diet_charges') {
                                        if (feild.key_word === 'dietician') {
                                            if (sub_feild.name === 'dietician') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'routine') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (feild.key_word === 'highend') {
                                            if (sub_feild.name === 'physiotherapys') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'action') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                            }


                                        }
                                        if (feild.key_word === 'add_more') {
                                            addonSchema[key].Specification.table_body.splice(table_key, 1)
                                        }
                                    }
                                    // if (table_name === 'surgical_charges') {
                                    //     if (sub_feild.name === 'qty') {
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    //     }
                                    //     if (sub_feild.name === 'percentage') {
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    //     }
                                    //     if (sub_feild.name === 'amount') {
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    //     }
                                    // }
                                    // if (table_name === 'medical_charges') {
                                    //     if (sub_feild.name === 'qty') {
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    //     }
                                    //     if (sub_feild.name === 'percentage') {
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    //     }
                                    //     if (sub_feild.name === 'amount') {
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                    //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    //     }
                                    // }
                                })
                            })
                        })
                        this.setState({ addonSchema: addonSchema });
                        this.total_suming();
                        // this.PrimaryConsultantRoomAmount();
                        // this.internsivistAndasstInternsivist();
                        this.setState(({ 'loadding': false, 'medicationDetailsSchema': medicationDetailsSchema, 'addonSchema': addonSchema, 'MasterRoutineEstimates': [] }), () => {
                            // this.total_suming()
                        });
                    }
                })
            }
        }
        catch (error) {
            console.log(error);
            this.setState({ 'loadding': false, 'MasterRoutineEstimates': [] });

        }


    }

    //LOS-newAPI
    updateDefaultLengthOfStay(obj) {
        try {
            let { addonSchema, medicationDetailsSchema ,doctorCode} = this.state;
            let { basic_info } = this.props;
            let { counselling_details } = this.props;

            // default Response
            // this.setState({ 'loadding': true });
            let { slug } = this.props.match.params;
            // let disabled = false;
            // const params = new URLSearchParams(this.props.location);
            const params = new URLSearchParams(this.props.location.search);
            const rid = params.get('rid');
            const cd = params.get('cd');
            if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
                slug = 'recounselling';
            }
            else if (slug === 'view-finanical-counselling') {
                slug = 'view-finanical-counselling';
            }
            else {
                slug = 'finanical-counselling';
            }

            let { surgery_procedure_name, care_management } = obj ? obj : {};
            let payload = {}
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            const unit_id =user_data ? user_data.unitid:'';
            if (care_management == 1) {
                payload = { "service_code": this.state.procedureValue, "tariff_mapped":"TR1", unit_id: unit_id,"doctor_id": doctorCode }
            } else {
                payload = payload = { "service_code": this.state.procedureValue, "tariff_mapped":"TR1", unit_id: unit_id ,"doctor_id": doctorCode }
            }


            
            if (slug === 'finanical-counselling' || (slug === 'recounselling' && counselling_details===null) || (slug === 'recounselling' && counselling_details&&counselling_details['care_management'] !== care_management) || (slug === 'recounselling' &&counselling_details&& obj['service_id']&&counselling_details['surgery_procedure_id']!==obj['service_id'])) {
                this.setState({ 'loadding': true });
                postService('getMasterEstimateTypesnew', 'POST', { "data": payload }).then(res => {
                    this.setState({ loadding: false });
                 
                    if (res['status']) {
                        if(res.data[0].package_value === 1){
                        medicationDetailsSchema.map((feild, key) => {
                            if (feild.name === 'icu_stay') {
                                medicationDetailsSchema[key]['value'] = res['icu_stay'];
                                medicationDetailsSchema[key]['disable'] = true;
                            }
                            if (feild.name === 'room_stay') {
                                medicationDetailsSchema[key]['value'] = res['room_stay'];
                                medicationDetailsSchema[key]['disable'] = true;
                            }
                            // if(feild.name === 'estimate_type'){
                            //     medicationDetailsSchema[key]['value'] = res.data[0].package_value
                            //     medicationDetailsSchema[key]['text'] = res.data[0].is_package
                            // }
                            if(slug !== 'recounselling'){
                                if (feild.name === 'room_opted') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                            }
                           
                            if (feild.name === 'length_of_stay') {
                                medicationDetailsSchema[key]['value'] = res.data[0].length_of_stay
                            }
                            if(slug !== 'recounselling'){
                            if (feild.name === 'room_upgrade') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                        }
                            if(slug !== 'recounselling'){
                            if (feild.name === 'room_upgrade_reason') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                        }
                            if(slug !== 'recounselling'){
                            if (feild.name === 'icu_opted') {
                                medicationDetailsSchema[key]['value'] = null
                            }
                        }


                        })

                            console.log('fail', res);
                        this.setState({ 'medicationDetailsSchema': medicationDetailsSchema, 'MasterRoutineEstimates': res}, () => {
                            this.setData(res)
                        })
                        }
                        else {
                            console.log('fail', res);
                            // Modal.error({
                            //     title: 'Unable to process',
                            //     content: 'Please try again later',
                            // });
                            let { addonSchema, medicationDetailsSchema, MasterRoutineEstimates } = this.state;

                            medicationDetailsSchema.map((feild, key) => {
                                if (feild.name === 'icu_stay') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                                if (feild.name === 'room_stay') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                                if (feild.name === 'room_opted') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                                if (feild.name === 'length_of_stay') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                                if (feild.name === 'room_upgrade') {
                                    medicationDetailsSchema[key]['value'] = null
                                }
                                if (feild.name === 'room_upgrade_reason') {
                                    medicationDetailsSchema[key]['value'] = null
                                }

                                if (feild.name === 'icu_opted') {
                                    medicationDetailsSchema[key]['value'] = null
                                }

                            })
                            addonSchema.map((subTable, key) => {
                                let table_name = subTable.name
                                addonSchema[key].header_amount = 0;
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }

                                        if (table_name === 'room_charges') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                        if (table_name === 'room_investigation_charges') {
                                            addonSchema[key].Specification.add_more = true;
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'Routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'room_highend_investigations') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                // if (sub_feild.name === 'action') {
                                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                // }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'icu_investigation_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'Routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'icu_highend_investigations') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                // if (sub_feild.name === 'action') {
                                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                // }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'ip_pharmacy_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine_drugs_implants') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'room_highend_drugs_implants') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                // if (sub_feild.name === 'action') {
                                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                // }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'icu_pharmacy_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine_drugs_implants') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'icu_highend_drugs_implants') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'ot_cath_pharmacy') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'general_equipment_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                // if (sub_feild.name === 'general_highend_equipments') {
                                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                // }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'general_highend_equipments') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'ot_charges') {

                                            if (feild.key_word === 'ot_inst_disinfec') {
                                                if (sub_feild.name === 'ot_inst_disinfec') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                }

                                            }
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'ot_hours') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'text';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'ot_equipment') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'ot_equipments') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'procedure_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'surgery_procedure_name') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            // if (feild.key_word === 'add_more') {
                                            //     addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            // }
                                        }
                                        if (table_name === 'blood_bank_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'blood_components') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'cross_consultation_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'dept_for_corss_consultations') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                        }
                                        if (table_name === 'hospital_services') {
                                            if (feild.key_word === 'mrd') {
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'ward_consumables') {
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'seropositive') {
                                                if (sub_feild.name === 'seropositive') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }
                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        if (table_name === 'isolation_charges') {
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'room_isolation_charges') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'icu_isolation_charges') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                        }
                                        if (table_name === 'physiotherapy_diet_charges') {
                                            if (feild.key_word === 'dietician') {
                                                if (sub_feild.name === 'dietician') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'routine') {
                                                if (sub_feild.name === 'routine') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'physiotherapys') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                if (sub_feild.name === 'action') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                                }


                                            }
                                            if (feild.key_word === 'add_more') {
                                                addonSchema[key].Specification.table_body.splice(table_key, 1)
                                            }
                                        }
                                        // if (table_name === 'surgical_charges') {
                                        //     if (sub_feild.name === 'qty') {
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        //     }
                                        //     if (sub_feild.name === 'percentage') {
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        //     }
                                        //     if (sub_feild.name === 'amount') {
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        //     }
                                        // }
                                        // if (table_name === 'medical_charges') {
                                        //     if (sub_feild.name === 'qty') {
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        //     }
                                        //     if (sub_feild.name === 'percentage') {
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        //     }
                                        //     if (sub_feild.name === 'amount') {
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        //     }
                                        // }
                                    })
                                })
                            })
                            this.setState({ addonSchema: addonSchema });
                            this.total_suming();
                            this.setState(({ 'loadding': false, 'medicationDetailsSchema': medicationDetailsSchema, 'addonSchema': addonSchema, 'MasterRoutineEstimates': [] }), () => {
                                // this.total_suming()
                            });
                        }
                    }
                })
            }
        }
        catch (error) {
            console.log(error);
            this.setState({ 'loadding': false, 'MasterRoutineEstimates': [] });

        }


    }
    //

    setData(response) {
        // console.clear();
        let { addonSchema, medicationDetailsSchema, MasterRoutineEstimates } = this.state;
        try {
            let { data } = MasterRoutineEstimates;
            let selected_room, icu_stay, room_stay = null;
            let care_management = null
            medicationDetailsSchema.map((feild, key) => {
                if (feild.name === 'icu_stay') {
                    icu_stay=medicationDetailsSchema[key]['value']  
                }
                if(feild.name === 'room_stay'){
                    room_stay=medicationDetailsSchema[key]['value'];
                }
                if (feild.name === 'room_opted') {
                    selected_room = feild['room_id']
                }
                if (feild.name === 'room_upgrade' && feild.room_id && feild.room_id !== '') {
                    selected_room = feild['room_id']
                }
                if (feild['name'] === 'icu_opted') {
                    if (icu_stay !== '' && icu_stay !== undefined && icu_stay !== null && !isNaN(icu_stay) && icu_stay !== 0) {
                        medicationDetailsSchema[key]['visible'] = true;
                        // medicationDetailsSchema[key]['disable'] =true ;
                         medicationDetailsSchema[key]['disable'] =false ;
                    }

                }
                if (feild['name'] === 'care_management') {
                    care_management = feild['value'];
                }
            })
            let los = 0;
            if (icu_stay || room_stay) {
                los = parseFloat(icu_stay) + parseFloat(room_stay);

            }
            // data.map((table_data, key) => {
                Array.isArray(data) && data.map((table_data, key) => {
                let { sub_header_id, header_id, room_data, info } = table_data;
                let current_room = room_data.find((data) => (data.id == selected_room || data.room_id == selected_room));
                addonSchema.map((subTable, key) => {
                    let { header } = subTable;
                    let table_name = subTable.name
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        let is_selected = false;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.sub_header && header === header_id && sub_header_id === sub_feild.sub_header) {
                                console.log(current_room, header, sub_feild.sub_header, header_id, sub_header_id)
                                is_selected = true;
                            }else{
                                if ((sub_feild.table === 'ot_cath_pharmacy' && care_management == 1) || (sub_feild.table === 'ot_equipment' && care_management == 1) || (sub_feild.table === 'ot_charges' && care_management == 1)) {

                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }

                                } 
                                
                            }
                            if (is_selected) {
                                if (sub_feild.tooltip === null && info !== null) {
                                   
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["tooltip"] = info;
                                    if(sub_feild.table==='ot_charges' && sub_feild.name==='routine'&& info !== null){
                                        let user_data = JSON.parse(Storage.get('user_data'));
                                        let user_unit_id = user_data.unitid;
                                        let service_id
                                        postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 9, sub_header_id: 18, tariff_mapped: 1 } }).then(res => {
                                            if (res.status && res.data.length>0) {
                                               if(info=='0.5' || info=='1'){
                                               service_id=res.data[0].id;
                                            }else{
                                                 service_id=res.data[2].id;
                                            }
                                               
                                            postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                                                if (response.status) {
                                                    if (response.data.length > 0) {
                                                        let amount,rate;
                                                        let data_value = 0;
                                
                                                        response.data.map((feild, key) => {
                                                            if (feild.room_id == selected_room) {
                                                                amount = parseFloat(feild.amount);
                                                                addonSchema.map((subTable, key) => {
                                                                    if (subTable.name === 'ot_charges') {
                                                                        let table_body = subTable.Specification.table_body;
                                                                        table_body.map((feild, table_key) => {
                                                                            let row = feild.feilds;
                                                                            if (feild.key_word === 'ot_inst_disinfec') {
                                                                                row.map((sub_feild, sub_table_key) => {
                                                                                    if (sub_feild.name === "qty") {
                                                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                                                    }
                                                                                    if (sub_feild.name === "rate") {
                                                                                        rate=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount+rate
                                                                                    }
                                                                                    if (sub_feild.name === "amount") {
                                                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount+rate
                                                                                    }
                                                                                })
                                                                            }
                                                                        })
                                                                    }
                                                                })
                                                                this.setState({ addonSchema: addonSchema });
                                                                this.total_suming();
                                                                // this.PrimaryConsultantRoomAmount();
                                                                // this.internsivistAndasstInternsivist();
                                                                // this.sumingProcedureAmounts();
                                                            }
                                                        })
                                                    }
                                                    else {
                                                        Modal.error({
                                                            title: 'Error message',
                                                            content: 'No amount for the selected room',
                                                        });
                                                    }
                                                }
                                                else {
                                                    Modal.error({
                                                        title: 'Error message',
                                                        content: 'Something went wrong',
                                                    });
                                                }
                                            })
                                        }
                                        else {
                                            Modal.error({
                                                title: 'Error message',
                                                content: 'No service available',
                                            });
                                        }
                                
                                        })
                                    }
                                }
                                if ((sub_feild.table === 'ot_cath_pharmacy' && care_management == 1) || (sub_feild.table === 'ot_equipment' && care_management == 1) || (sub_feild.table === 'ot_charges' && care_management == 1)) {

                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 0
                                    }

                                } else {
                                    if(sub_feild.table === 'ot_charges' && care_management == 2){
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 1;
                                        }  
                                    }
                                    if (sub_feild.table === 'icu_pharmacy_charges' || sub_feild.table === 'icu_investigation_charges' || (sub_feild.table==='isolation_charges' && sub_feild.row_group==='icu_isolation_charges')) {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay ? parseFloat(icu_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ? parseFloat(icu_stay) : 0;
                                        }
                                    } else if (sub_feild.table === 'room_investigation_charges' || sub_feild.table === 'ip_pharmacy_charges'|| (sub_feild.table==='isolation_charges' && sub_feild.row_group==='room_isolation_charges')) {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_stay ? parseFloat(room_stay) : 0;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = room_stay ? parseFloat(room_stay) : 0;
                                        }
                                    }
                                    else if (sub_feild.row_group === 'dietician') {
                                    
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = los;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = los;
                                        }
                                    } else {
                                        if (sub_feild.name === "qty") {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = 1;
                                        }
                                    }
                                    if (sub_feild.name === 'rate') {
                                        if (sub_feild.table === 'icu_pharmacy_charges' || sub_feild.table === 'icu_investigation_charges') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =icu_stay ? parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0 : 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ?  parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0: 0
                                        }
                                        else{
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0  
                                        }
                                    }
                                    if (sub_feild.row_group === 'dietician') {
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = current_room['amount'] ? parseFloat(current_room['amount']) * parseFloat(los) : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = current_room['amount'] ? parseFloat(current_room['amount']) * parseFloat(los) : 0
                                        }
                                    } else {
                                        if (sub_feild.name === 'amount') {
                                            if (sub_feild.table === 'icu_pharmacy_charges' || sub_feild.table === 'icu_investigation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay ? parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0 : 0
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = icu_stay ? parseFloat(current_room['amount'])? parseFloat(current_room['amount']):0 : 0
                                            }else{
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = current_room['amount'] ? parseFloat(current_room['amount']) : 0
                                            }
                                        }
                                    }
                                }

                            }
                        })
                    })
                })
            })
            this.drugaAdminCharges();
            if (icu_stay !== '' && icu_stay !== undefined && icu_stay !== null && !isNaN(icu_stay)) {
                console.log('icu_stay', icu_stay);
                // this.internsivistAndasstInternsivist(icu_stay);
                this.drugaAdminCharges();
            }
            if (room_stay !== '' && room_stay !== undefined && room_stay !== null && !isNaN(room_stay) ) {
                let qty_for_room_stay = [{ header: 1 }, { header: 2 }, { header: 4 }];
                addonSchema.map((subTable, key) => {
                    qty_for_room_stay.map((room_stays, room_stay_key) => {
                        if (subTable.header === room_stays.header) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                if (table_key === 0) {
                                    let row = feild.feilds;
                                    let rate;
                                    if (feild.key_word !== 'intensivist') {
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_stay?room_stay:0;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                console.log('Rate:::', rate);
                                            }
                                            if (sub_feild.name === 'amount') {
                                                if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(room_stay?room_stay:0) * rate;
                                                }
                                            }
                                        })
                                    }

                                }
                              
                            })
                        }
                    })
                })
                this.drugaAdminCharges();
            }

            this.setState(({ 'loadding': false, 'addonSchema': addonSchema }), () => {
                this.total_suming();
                // this.PrimaryConsultantRoomAmount();
                // this.internsivistAndasstInternsivist();
                this.drugaAdminCharges();
            });
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    cancel() {
        ;
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'add-cash':
                this
                    .props
                    .history
                    .push('/settings/cash');
                break;
        }
    }


    buttonClick(feilds, type) {
        // console.clear();
        console.log('feilds', type, feilds);

        let { estimateBreakupFormatSchema,estimateBreakupFormaterror } = this.state;
        let ele_name = '';
        let ele_val = '';
        let ele_id = 0;

        estimateBreakupFormatSchema.map((feild, key) => {
            if (feild['name'] === type.type) {
                ele_name = feild['name'];
                ele_val = feild['value'];
                ele_id = feild['id'];
            }
        })

        if (ele_name === 'name_of_the_fc') {
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'name_of_the_fc') {
                    estimateBreakupFormatSchema[key]['value'] = ele_val;
                }
            })
        }

        if (ele_name === 'attendant_name') {
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'attendant_name') {
                    estimateBreakupFormatSchema[key]['value'] = ele_val;
                }
            })
        }

        if (ele_name === 'relation') {
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'relation') {
                    estimateBreakupFormatSchema[key]['value'] = ele_val;
                }
            })
        }
        if (ele_name === 'remarks') {
            estimateBreakupFormatSchema.map((feild, key) => {
                if (feild['name'] === 'remarks') {
                    estimateBreakupFormatSchema[key]['value'] = ele_val;
                }
            })
        }
        if(estimateBreakupFormaterror.length>0){
            estimateBreakupFormaterror.map((index)=>{
                estimateBreakupFormatSchema.map((item,key) => {
            if(item['name']===ele_name && item['id']===index['id']) {
             document.getElementById("errorm"+item['name']).style.display = "none";
            }
            })
        })
        }

        this.setState((state) => ({ 'estimateBreakupFormatSchema': estimateBreakupFormatSchema }));
    }

    buttonClick1(feilds, type) {
        // console.clear();
        console.log('feilds', type);
    }

    // buttonClick2(feilds, type) {
    //     console.clear();
    //     console.log(feilds, type);
    //     let { counselling_details, basic_info  } = this.props;
    //     let {procedureValue, procedureText} = this.state;
    //     // return true;
    //     let { slug } = this.props.match.params;
    //       const params = new URLSearchParams(this.props.location.search);
    //     const rid = params.get('rid');
    //     const cd = params.get('cd');


    //     if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
    //         slug = 'recounselling';
    //         // if( cd != '' && cd !== undefined && cd !== null && !isNaN(cd)){
    //         //     disabled = true;
    //         // }
    //         if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE'])){
    //        console.log('teet')
    //         }else{
    //             slug = 'finanical-counselling'; 
    //         }
    //     }
    //     else if (slug === 'view-finanical-counselling') {
    //         slug = 'view-finanical-counselling';
    //     }
    //     else {
    //         slug = 'finanical-counselling';
    //     }
    //     const { getServicePricesById,getInsurancePackagePricesByProcedureName } = networkList;
    //     try {
    //     switch (slug) {
    //         case 'view-finanical-counselling': {
    //             let { medicationDetailsSchema } = this.state;
    //             let { counselling_details, hideing_estimatetable } = this.props

    //             let care_management = counselling_details.care_management;
    //             let estimate_type = counselling_details.estimate_type;
    //             let icu_stay = counselling_details.icu_stay;

    //             medicationDetailsSchema.map((feild, key) => {
    //                 if (feild['name'] === 'estimate_type') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                         hideing_estimatetable = 0;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                         hideing_estimatetable = 0;
    //                     }
    //                 }
    //                 if (feild['name'] === 'package_name') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                 }
    //                 if (feild['name'] === 'date_of_surgery') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                 }
    //                 if (feild['name'] === 'surgery_procedure_name') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                 }
    //                 if (feild['name'] === 'surgery_procedure_amount') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                 }
    //                 if (feild['name'] === 'icu_stay') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                     }
    //                 }


    //                 if (feild['name'] === 'room_stay') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                     }
    //                 }
    //                 if (feild['name'] === 'surgery_procedure_name') {
    //                     if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                 }

    //                 if (feild['name'] === 'package_name') {

    //                     if (parseFloat(estimate_type) === 1) {
    //                         // 1 - package, 2 - non-package
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                         hideing_estimatetable = 1;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         hideing_estimatetable = 0;
    //                     }
    //                 }
    //                 if (feild['name'] === 'icu_opted') {
    //                     if ((parseFloat(care_management) === 2) && (parseFloat(estimate_type) === 1)) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
    //                 }
    //                 if (feild['name'] === 'surgery_procedure_name') {
    //                     if ((parseFloat(care_management) === 2) && (parseFloat(estimate_type) === 1)) {    // 1 - medical, 2 - surgical
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                     }
    //                     else {
    //                         medicationDetailsSchema[key]['visible'] = true;
    //                     }
    //                 }
    //                 // if (feild['name'] === 'room_opted') {
    //                 //     medicationDetailsSchema[key]['value'] = null;
    //                 //     medicationDetailsSchema[key]['text'] = null;
    //                 //     if (parseFloat(care_management) === 1) {    // 1 - medical, 2 - surgical
    //                 //         medicationDetailsSchema[key]['disable'] = false;
    //                 //     }
    //                 //     else {
    //                 //         medicationDetailsSchema[key]['disable'] = true;
    //                 //     }
    //                 // }
    //                 // if (feild['name'] === 'room_upgrade') {
    //                 //     medicationDetailsSchema[key]['disable'] = true;
    //                 //     medicationDetailsSchema[key]['value'] = null;
    //                 //     medicationDetailsSchema[key]['text'] = null;
    //                 // }
    //                 // if (feild['name'] === 'room_upgrade_reason') {
    //                 //     medicationDetailsSchema[key]['disable'] = true;
    //                 //     medicationDetailsSchema[key]['value'] = null;
    //                 //     medicationDetailsSchema[key]['text'] = null;
    //                 // }
    //                 // if (feild['name'] === 'icu_opted') {
    //                 //     medicationDetailsSchema[key]['visible'] = false;
    //                 //     medicationDetailsSchema[key]['value'] = null;
    //                 //     medicationDetailsSchema[key]['text'] = null;
    //                 // }
    //             })
    //             this.setState({ hideing_estimatetable: hideing_estimatetable });
    //         } break;
    //         default: {
    //             let ele_name = '';
    //             let ele_val = '';
    //             let ele_id = 0;
    //             let ele_text=0;
    //             let { counselling_details, medicationDetailsSchema, addonSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, total_estimate_amount, includesSchema, excludesSchema, inc_excludes_pack_id, hideing_estimatetable, includearrya,medicationDetailserrors } = this.state;

    //             medicationDetailsSchema.map((feild, key) => {
    //                 if (feild['name'] === type.type) {
    //                     ele_name = feild['name'];
    //                     ele_val = feild['value'];
    //                     // ele_text = feild['text'] 
    //                     ele_id = feild['id'];
    //                 }
    //             })

    //             medicationDetailsSchema.map((feild, key) => {
    //                 if (ele_id === 17) {
    //                     if (feild['id'] > ele_id) {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                     }
    //                 }
    //                 // if (ele_id !== 11) {
    //                 //     if (feild['id'] > ele_id && feild['id'] !== 11 && feild['id'] !== 19 && feild['id'] !== 20 && feild['id'] !== 21 && feild['id'] !== 29 && feild['id'] !== 30) {
    //                 //         medicationDetailsSchema[key]['value'] = null;
    //                 //     }
    //                 // }
    //             })

    //             if (ele_name === 'diagnosis') {
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'diagnosis') {
    //                         medicationDetailsSchema[key]['value'] = ele_val;
    //                     }
    //                 })
    //             }

    //             if (ele_name === 'care_management') {
    //                 const { getconfigurations } = networkList;
    //                 let user_data = JSON.parse(Storage.get('user_data'));
    //                 let user_unit_id = user_data.unitid;
    //                 // configuration
    //                 postService(getconfigurations, 'GET', 'null').then(res => {
    //                     if (res.status) {
    //                         if (res.data.length > 0) {
    //                             this.setState({ configuration: res.data[0].data })
    //                             if (res.data[0].data.length > 0) {
    //                                 res.data[0].data.map((feilds, key) => {
    //                                     if (feilds.config_name === 'Cash-Physician Fees') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 18) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 1) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'amount') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                     if (feild.id === 2) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                                
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash-Asst Physician Fees') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 18) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 3) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash Consultation Charges Room') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 18  ||subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 6) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'amount') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                     if (feild.id === 6) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                                
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash Consultation Charges ICU') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 18 ||subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 7) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'amount') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                     if (feild.id === 7) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                         }
    //                         else {
    //                             Modal.error({
    //                                 title: 'Error message',
    //                                 content: 'No service available',
    //                             });
    //                         }
    //                     } 
    //                     else {
    //                         Modal.error({
    //                             title: 'Error message',
    //                             content: 'Something went wrong',
    //                         });
    //                     }
    //                 });
                    
        
                    
    //                 if (parseFloat(ele_val) === 1) {    // 1 - medical, 2 - surgical
    //                     addonSchema.map((subTable, key) => {
    //                         let table_name = subTable.name;
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             let row = feild.feilds;
    //                             row.map((sub_feild, sub_table_key) => {
    //                                 if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy' || table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges') {
    //                                     if (feild.key_word === 'routine') {
    //                                         if (sub_feild.name === 'rate') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         }
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
    //                                     if (feild.key_word === 'routine') {
    //                                         if (sub_feild.name === 'qty') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                         }
    //                                     }
    //                                 }
    //                             })
    //                         })
    //                     })
    //                     this.setState({ loadding: true });
                       
    //                     includesSchema.map((subTable, key) => {
    //                         if (includesSchema[key].Specification.table_body.length > 0) {
    //                             includesSchema[key].Specification.table_body.length = 0;
    //                         }

    //                     })
    //                     hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: [] } })
    //                     optionsStore.dispatch({ type: 'options_data', 'data': [] });
    //                     inc_excludes_pack_id.pop();
    //                     inc_excludes_pack_id.push(parseInt(0));
    //                     this.props.excludes(excludesSchema, includesSchema);
    //                     hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
    //                     hideing_estimatetable = 0;
    //                     this.setState({
    //                         includes_data: includesSchema,
    //                         includesSchema: includesSchema, inc_excludes_pack_id: inc_excludes_pack_id, hideing_estimatetable: hideing_estimatetable
    //                     });
    //                     estimateBreakupFormatSchema.map((feild, key) => {
    //                         if (feild['name'] === 'base_price') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = false;
    //                         }
    //                         if (feild['name'] === 'excludes') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = false;
    //                         }
    //                         if (feild['name'] === 'total_Estimate_amount') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = false;
    //                         }
    //                     })
    //                 }



    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'estimate_type') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['visible'] = true;
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null
    //                         }
    //                     }
    //                     if (feild['name'] === 'package_name') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['visible'] = true;
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null
    //                         }
    //                     }
    //                     if (feild['name'] === 'date_of_surgery') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['visible'] = true;
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'icu_stay') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_stay') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'surgery_procedure_name') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['visible'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'surgery_procedure_amount') {
    //                         if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_opted') {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         if (parseFloat(ele_val) === 1) {    // 1 - medical, 2 - surgical
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_upgrade') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                     }
    //                     if (feild['name'] === 'room_upgrade_reason') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
                        
    //                 })

    //                 estimateBreakupFormatSchema.map((feild, key) => {
    //                     if (feild['name'] === 'base_price') {
    //                         estimateBreakupFormatSchema[key]['value'] = null;
    //                         estimateBreakupFormatSchema[key]['disable'] = true;
    //                     }
    //                     if (feild['name'] === 'total_Estimate_amount') {
    //                         estimateBreakupFormatSchema[key]['value'] = null;
    //                         estimateBreakupFormatSchema[key]['disable'] = true;
    //                     }
    //                 })

    //                 additionalPackageSchema[0]['visible'] = false;
    //                 additionalProcedureSchema[0]['visible'] = false;

    //                 if (parseFloat(ele_val) === 1) {    // 1 - medical, 2 - surgical
    //                     addonSchema.map((subTable, key) => {
    //                         if (subTable.name === 'surgical_charges') {
    //                             addonSchema[key].visible = false;
    //                             let table_body = subTable.Specification.table_body;
    //                             let header_amount = 0;
    //                             table_body.map((feild, table_key) => {
    //                                 let row = feild.feilds;
    //                                 row.map((sub_feild, sub_table_key) => {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                 })
    //                             })
    //                         }
    //                         if (subTable.name === 'medical_charges') {
    //                             addonSchema[key].visible = true;
    //                         }
    //                         if (subTable.name === 'ot_cath_pharmacy') {
    //                             addonSchema[key].visible = false;
    //                         }
    //                         if (subTable.name === 'ot_charges') {
    //                             addonSchema[key].visible = false;
    //                         }
    //                         if (subTable.name === 'ot_equipment') {
    //                             addonSchema[key].visible = false;
    //                         }
    //                     })
    //                 }
    //                 else {
    //                     addonSchema.map((subTable, key) => {
    //                         if (subTable.name === 'surgical_charges') {
    //                             addonSchema[key].visible = true;
    //                         }
    //                         if (subTable.name === 'ot_cath_pharmacy') {
    //                             addonSchema[key].visible = true;
    //                         }
    //                         if (subTable.name === 'ot_charges') {
    //                             addonSchema[key].visible = true;
    //                         }
    //                         if (subTable.name === 'ot_equipment') {
    //                             addonSchema[key].visible = true;
    //                         }
    //                         if (subTable.name === 'medical_charges') {
    //                             addonSchema[key].visible = false;
    //                             let table_body = subTable.Specification.table_body;
    //                             table_body.map((feild, table_key) => {
    //                                 let row = feild.feilds;
    //                                 row.map((sub_feild, sub_table_key) => {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                 })
    //                             })
    //                         }
    //                     })
    //                 }

    //                 addonSchema.map((subTable, key) => {
    //                     let table_body = subTable.Specification.table_body;
    //                     table_body.map((feild, table_key) => {
    //                         let row = feild.feilds;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                             if (sub_feild.name === 'qty') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                             }
    //                             if (sub_feild.name === 'rate') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                             }
    //                             // if (sub_feild.name === 'percentage') {
    //                             //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                             //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             // }
    //                             if (sub_feild.name === 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                             }
    //                         })
    //                     })
    //                 })

    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'length_of_stay') {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                     }
    //                 })
    //                 this.setState({fc1_total_estimate_amount:0})
    //             }

    //             if (ele_name === 'estimate_type') {

    //                 let user_data = JSON.parse(Storage.get('user_data'));
    //                 let user_unit_id = user_data.unitid;
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'package_name') {
    //                         if (parseFloat(ele_val) === 1) {
    //                             let hide_estimatetable = 0   // 1 - package, 2 - non-package
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['length_of_stay'] = null;
    //                             medicationDetailsSchema[key]['visible'] = true;
    //                             hide_estimatetable = 1;
    //                             this.setState({ hideing_estimatetable: hide_estimatetable })
    //                         }
    //                         else {
    //                             let hide_estimatetable = 0
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['length_of_stay'] = null;
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             this.setState({ hideing_estimatetable: hide_estimatetable })
    //                         }
    //                     }
    //                     if (feild['name'] === 'icu_stay') {
    //                         if (parseFloat(ele_val) === 1) {
    //                             // 1 - package, 2 - non-package
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_stay') {
    //                         if (parseFloat(ele_val) === 1) {
    //                             // 1 - package, 2 - non-package
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_opted') {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['amount'] = null;
    //                         if (parseFloat(ele_val) === 1) {
    //                             // 1 - package, 2 - non-package
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_upgrade') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['amount'] = null;
    //                     }
    //                     if (feild['name'] === 'room_upgrade_reason') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
    //                     if (feild['name'] === 'surgery_procedure_name') {
    //                         if (parseFloat(ele_val) === 1) {
    //                             // 1 - package, 2 - non-package
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['text'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['visible'] = true;
    //                             medicationDetailsSchema[key]['text'] = null;
    //                         }
    //                     }
    //                     if (feild['name'] === 'surgery_procedure_amount') {
    //                         if (parseFloat(ele_val) === 1) {   // 1 - package, 2 - non-package
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['visible'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text'] = null;
    //                         }
    //                     }
    //                 })

    //                 if (parseFloat(ele_val) === 1) {    // 1 - package, 2 - non-package

    //                     addonSchema.map((subTable, key) => {
    //                         if (subTable.name === 'surgical_charges') {
    //                             addonSchema[key].visible = true;
    //                             let table_body = subTable.Specification.table_body;
    //                             let header_amount = 0;
    //                             table_body.map((feild, table_key) => {
    //                                 let row = feild.feilds;
    //                                 row.map((sub_feild, sub_table_key) => {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                 })
    //                             })
    //                         }
    //                         // if (subTable.name === 'medical_charges') {
    //                         //     addonSchema[key].visible = true;
    //                         // }
    //                     })

    //                     addonSchema.map((subTable, key) => {
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             let row = feild.feilds;
    //                             row.map((sub_feild, sub_table_key) => {
    //                                 if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                 }
    //                                 if (sub_feild.name === 'qty') {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                 }
    //                                 if (sub_feild.name === 'rate') {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                 }
    //                                 // if (sub_feild.name === 'percentage') {
    //                                 //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                 // }
    //                                 if (sub_feild.name === 'amount') {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                 }

    //                             })
    //                         })
    //                     })
    //                     addonSchema.map((subTable, key) => {
    //                         let table_name = subTable.name;
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             let row = feild.feilds;
    //                             row.map((sub_feild, sub_table_key) => {
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
    //                                     if (feild.key_word === 'routine') {
    //                                         if (sub_feild.name === 'qty') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                         }
    //                                     }
    //                                 }
    //                             })
    //                         })
    //                     })
    //                     hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
    //                     estimateBreakupFormatSchema.map((feild, key) => {
    //                         if (feild['name'] === 'base_price') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = true;
    //                         }
    //                         if (feild['name'] === 'excludes') {
    //                             //     estimateBreakupFormatSchema[key]['value'] = null;
    //                             //     estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = true;
    //                         }
    //                         if (feild['name'] === 'total_Estimate_amount') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = true;
    //                         }
    //                     })
    //                 }
    //                 else {
    //                     // hideing_estimatetable = 1;   
    //                     this.setState({ loadding: true });
    //                     let { configuration } = this.state;
    //                     if (configuration.length > 0) {
    //                         configuration.map((feilds, key) => {
    //                             if (feilds.config_name === 'Cash-Surgeon') {
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 17) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 1) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'amount') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
                                                       
    //                                                 })
    //                                             }
    //                                             if (feild.id === 2) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'percentage') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
                                                       
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                             if (feilds.config_name === 'Cash-Asst Surgeon') {
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 17) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 3) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'percentage') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                             if (feilds.config_name === 'Cash-Anaesthetist') {
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 17) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 4) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'percentage') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                             if (feilds.config_name === 'Cash-Asst Anaesthetist') {
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 17) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 5) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'percentage') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                             if (feilds.config_name === 'Cash Consultation Charges Room') {
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 18  ||subTable.header === 17) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 6) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'amount') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
                                                       
    //                                                 })
    //                                             }
    //                                             if (feild.id === 6) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'percentage') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
                                                        
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                             if (feilds.config_name === 'Cash Consultation Charges ICU') {
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 18 ||subTable.header === 17) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 7) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'amount') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
                                                       
    //                                                 })
    //                                             }
    //                                             if (feild.id === 7) {
    //                                                 let row = feild.feilds;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === 'percentage') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                         this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                         })
    //                     }
                       
    //                     addonSchema.map((subTable, key) => {
    //                         let table_name = subTable.name;
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             let row = feild.feilds;
    //                             row.map((sub_feild, sub_table_key) => {
    //                                 if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy') {
    //                                     if (feild.key_word === 'routine') {
    //                                         if (sub_feild.name === 'rate') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         }
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
    //                                     if (feild.key_word === 'routine') {
    //                                         if (sub_feild.name === 'qty') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                         }
    //                                     }
    //                                 }
    //                             })
    //                         })
    //                     })
    //                     includesSchema.map((subTable, key) => {
    //                         if (includesSchema[key].Specification.table_body.length > 0) {
    //                             includesSchema[key].Specification.table_body.length = 0;
    //                         }

    //                     })
    //                     hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: [] } })
    //                     optionsStore.dispatch({ type: 'options_data', 'data': [] });
    //                     inc_excludes_pack_id.pop();
    //                     inc_excludes_pack_id.push(parseInt(0));
    //                     hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
    //                     this.props.excludes(excludesSchema, includesSchema);
    //                     //clearing excludes data in redux store
    //                     excludesTableStore.dispatch({ type: 'options_data', 'data': [] });
    //                     this.setState({
    //                         includes_data: includesSchema,
    //                         includesSchema: includesSchema, inc_excludes_pack_id: inc_excludes_pack_id
    //                     });
    //                     estimateBreakupFormatSchema.map((feild, key) => {
    //                         if (feild['name'] === 'base_price') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = false;
    //                         }
    //                         if (feild['name'] === 'excludes') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = false;
    //                         }
    //                         if (feild['name'] === 'total_Estimate_amount') {
    //                             estimateBreakupFormatSchema[key]['value'] = null;
    //                             estimateBreakupFormatSchema[key]['disable'] = true;
    //                             estimateBreakupFormatSchema[key]['visible'] = false;
    //                         }
    //                     })
    //                 }



    //                 additionalPackageSchema[0]['visible'] = false;
    //                 additionalProcedureSchema[0]['visible'] = false;
    //                 this.setState((state) => ({ 'hideShowExcludesIncludes': true,fc1_total_estimate_amount:0 }));

    //                 addonSchema.map((subTable, key) => {
    //                     let table_body = subTable.Specification.table_body;
    //                     table_body.map((feild, table_key) => {
    //                         let row = feild.feilds;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                             if (sub_feild.name === 'qty') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                             if (sub_feild.name === 'rate') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                             // if (sub_feild.name === 'percentage') {
    //                             //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                             //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             // }
    //                             if (sub_feild.name === 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                         })
    //                     })
    //                 })
    //                 // console.log('addonSchema',addonSchema)

    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'length_of_stay') {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                     }
    //                 })

    //                 // this.total_suming();
    //             }

    //             if (ele_name === 'package_name') {
    //                 let pack_name = '';

    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'room_opted') {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['amount'] = 0;
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                     }
    //                     if (feild['name'] === 'room_upgrade') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['amount'] = null;
    //                     }
    //                     if (feild['name'] === 'room_upgrade_reason') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
    //                 })

    //                 if (ele_val !== '' && ele_val !== null && ele_val !== undefined) {
    //                     additionalPackageSchema[0]['visible'] = false;
    //                     additionalProcedureSchema[0]['visible'] = false;
    //                 }
    //                 else {
    //                     additionalPackageSchema[0]['visible'] = false;
    //                     additionalProcedureSchema[0]['visible'] = false;
    //                 }

    //                 let pack = false;
    //                 let length_of_stay = null;
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'estimate_type') {
    //                         if (parseFloat(feild['value']) === 1) { // 1 - package, 2 - non-package
    //                             pack = true;
    //                                                     }
    //                                                 }
    //                     if (feild['name'] === 'package_name') {
    //                         if(ele_val!==''){
    //                             length_of_stay = feild['length_of_stay'];
    //                             console.log('procedureText:::', procedureText);
    //                             pack_name = procedureText; 
    //                         }
    //                     else{
    //                         length_of_stay=0;
    //                     }
    //                 }
    //                 })
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'length_of_stay') {
    //                         if (pack) {
    //                             medicationDetailsSchema[key]['value'] = length_of_stay;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null;
    //                         }
    //                     }
    //                 })

    //                 estimateBreakupFormatSchema.map((feild, key) => {
    //                     if (feild['name'] === 'base_price') {
    //                         estimateBreakupFormatSchema[key]['value'] = null;
    //                     }
    //                                         })

    //                 addonSchema.map((subTable, key) => {
    //                     let table_body = subTable.Specification.table_body;
    //                     table_body.map((feild, table_key) => {
    //                         let row = feild.feilds;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                             if (sub_feild.name === 'qty') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             }
    //                             if (sub_feild.name === 'rate') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             }
    //                             if (sub_feild.name === 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             }
    //                         })
    //                     })
    //                 })

    //                 let user_data = JSON.parse(Storage.get('user_data'));
    //                 let user_unit_id = user_data.unitid;
    //                 let newData = [];
    //                 let dopulicatearray = [];

    //                 if (pack_name !== '' && pack_name !== undefined && pack_name !== null) {
    //                     this.getExcludesIncludes(parseInt(ele_val), pack_name,0);
    //                 }
    //                 this.setState((state) => ({ fc1_total_estimate_amount:0 }));
    //             }

    //             if (ele_name === 'surgery_procedure_name') {
    //                 additionalProcedureSchema[0]['visible'] = true;
    //                 let amount, room_id, room_value = 0;
    //                 let { getServicePricesById } = networkList;
    //                 let estimateTypeValue;
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     console.log("feild",feild);
    //                     if(feild['name'] === 'surgery_procedure_name'){
    //                     if (feild['value'] !== '' && feild['value'] !== null && feild['value'] !== undefined) {
    //                         console.log("feild",feild, this.state);
    //                         estimateTypeValue = feild.selected_option.is_package;
    //                         procedureValue = feild.selected_option.id;
    //                         procedureText = feild.selected_option.name;
    //                         console.log("estimateType",estimateTypeValue);
    //                         medicationDetailsSchema[key]['text'] = feild['text'];
    //                         medicationDetailsSchema[key]['value'] = feild['value'];
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                         this.setState({procedureValue : procedureValue, procedureText: procedureText})
    //                     } else {
    //                         estimateTypeValue = 0;
    //                     }
    //                 }
    //                     if (feild['name'] === 'estimate_type') {
    //                         console.log("estimateType" ,estimateTypeValue);
    //                         medicationDetailsSchema[key]['value'] = estimateTypeValue;
    //                         medicationDetailsSchema[key]['text'] = estimateTypeValue === 1 ? 'Package':'Non-Package';
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         // this.buttonClick2(medicationDetailsSchema, { "type": 'estimate_type' });
    //                         console.log('STATEVALUE:::::', this.state, ele_name);
    //                         let user_data = JSON.parse(Storage.get('user_data'));
    //                         let user_unit_id = user_data.unitid;
    //                         medicationDetailsSchema.map((feild, key) => {
    //                             if (feild['name'] === 'package_name') {
    //                                 console.log('ESTIMATE:::::', (parseFloat(ele_val)));
    //                                 if (estimateTypeValue === 1) {
    //                                     let hide_estimatetable = 0   // 1 - package, 2 - non-package
    //                                     medicationDetailsSchema[key]['disable'] = false;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                     medicationDetailsSchema[key]['length_of_stay'] = null;
    //                                     medicationDetailsSchema[key]['visible'] = false;
    //                                     hide_estimatetable = 1;
    //                                     this.setState({ hideing_estimatetable: hide_estimatetable })
    //                                 }
    //                                 else {
    //                                     console.log('ESTIMATE:::::', (parseFloat(ele_val)));
    //                                     let hide_estimatetable = 0
    //                                     medicationDetailsSchema[key]['disable'] = true;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                     medicationDetailsSchema[key]['length_of_stay'] = null;
    //                                     medicationDetailsSchema[key]['visible'] = false;
    //                                     this.setState({ hideing_estimatetable: hide_estimatetable })
    //                                 }
    //                             }
    //                             if (feild['name'] === 'icu_stay') {
    //                                 if (estimateTypeValue === 1) {
    //                                     // 1 - package, 2 - non-package
    //                                     medicationDetailsSchema[key]['disable'] = true;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                 }
    //                                 else {
    //                                     medicationDetailsSchema[key]['disable'] = false;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                 }
    //                             }
    //                             if (feild['name'] === 'room_stay') {
    //                                 if (estimateTypeValue === 1) {
    //                                     // 1 - package, 2 - non-package
    //                                     medicationDetailsSchema[key]['disable'] = true;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                 }
    //                                 else {
    //                                     medicationDetailsSchema[key]['disable'] = false;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                 }
    //                             }
    //                             if (feild['name'] === 'room_opted') {
    //                                 medicationDetailsSchema[key]['value'] = null;
    //                                 medicationDetailsSchema[key]['text'] = null;
    //                                 medicationDetailsSchema[key]['amount'] = null;
    //                                 if (estimateTypeValue === 1) {
    //                                     // 1 - package, 2 - non-package
    //                                     medicationDetailsSchema[key]['disable'] = false;
    //                                 }
    //                                 else {
    //                                     medicationDetailsSchema[key]['disable'] = false;
    //                                 }
    //                             }
    //                             if (feild['name'] === 'room_upgrade') {
    //                                 medicationDetailsSchema[key]['disable'] = true;
    //                                 medicationDetailsSchema[key]['value'] = null;
    //                                 medicationDetailsSchema[key]['text'] = null;
    //                                 medicationDetailsSchema[key]['amount'] = null;
    //                             }
    //                             if (feild['name'] === 'room_upgrade_reason') {
    //                                 medicationDetailsSchema[key]['disable'] = true;
    //                                 medicationDetailsSchema[key]['value'] = null;
    //                                 medicationDetailsSchema[key]['text'] = null;
    //                             }
    //                             if (feild['name'] === 'icu_opted') {
    //                                 medicationDetailsSchema[key]['visible'] = false;
    //                                 medicationDetailsSchema[key]['value'] = null;
    //                                 medicationDetailsSchema[key]['text'] = null;
    //                                 medicationDetailsSchema[key]['disable'] = true;
    //                             }
    //                             // if (feild['name'] === 'surgery_procedure_name') {
    //                             //     if (estimateTypeValue === '1') {
    //                             //         // 1 - package, 2 - non-package
    //                             //         medicationDetailsSchema[key]['disable'] = false;
    //                             //         medicationDetailsSchema[key]['value'] = null;
    //                             //         medicationDetailsSchema[key]['visible'] = false;
    //                             //         medicationDetailsSchema[key]['text'] = null;
    //                             //     }
    //                             //     else {
    //                             //         medicationDetailsSchema[key]['disable'] = false;
    //                             //         medicationDetailsSchema[key]['value'] = null;
    //                             //         medicationDetailsSchema[key]['visible'] = true;
    //                             //         medicationDetailsSchema[key]['text'] = null;
    //                             //     }
    //                             // }
    //                             if (feild['name'] === 'surgery_procedure_amount') {
    //                                 if (estimateTypeValue === 1) {   // 1 - package, 2 - non-package
    //                                     medicationDetailsSchema[key]['visible'] = false;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                     medicationDetailsSchema[key]['text'] = null;
    //                                 }
    //                                 else {
    //                                     medicationDetailsSchema[key]['visible'] = false;
    //                                     medicationDetailsSchema[key]['value'] = null;
    //                                     medicationDetailsSchema[key]['text'] = null;
    //                                 }
    //                             }
    //                         })
        
    //                         if (estimateTypeValue === 1) {    // 1 - package, 2 - non-package
        
    //                             addonSchema.map((subTable, key) => {
    //                                 if (subTable.name === 'surgical_charges') {
    //                                     addonSchema[key].visible = true;
    //                                     let table_body = subTable.Specification.table_body;
    //                                     let header_amount = 0;
    //                                     table_body.map((feild, table_key) => {
    //                                         let row = feild.feilds;
    //                                         row.map((sub_feild, sub_table_key) => {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                         })
    //                                     })
    //                                 }
    //                                 // if (subTable.name === 'medical_charges') {
    //                                 //     addonSchema[key].visible = true;
    //                                 // }
    //                             })
        
    //                             addonSchema.map((subTable, key) => {
    //                                 let table_body = subTable.Specification.table_body;
    //                                 table_body.map((feild, table_key) => {
    //                                     let row = feild.feilds;
    //                                     row.map((sub_feild, sub_table_key) => {
    //                                         if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         }
    //                                         if (sub_feild.name === 'qty') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         }
    //                                         if (sub_feild.name === 'rate') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         }
    //                                         // if (sub_feild.name === 'percentage') {
    //                                         //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         // }
    //                                         if (sub_feild.name === 'amount') {
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                         }
        
    //                                     })
    //                                 })
    //                             })
    //                             addonSchema.map((subTable, key) => {
    //                                 let table_name = subTable.name;
    //                                 let table_body = subTable.Specification.table_body;
    //                                 table_body.map((feild, table_key) => {
    //                                     let row = feild.feilds;
    //                                     row.map((sub_feild, sub_table_key) => {
    //                                         if (feild.key_word === 'highend') {
    //                                             if (sub_feild.name === 'qty') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                             }
    //                                         }
    //                                         if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
    //                                             if (feild.key_word === 'routine') {
    //                                                 if (sub_feild.name === 'qty') {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                                 }
    //                                             }
    //                                         }
    //                                     })
    //                                 })
    //                             })
    //                             hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
    //                             estimateBreakupFormatSchema.map((feild, key) => {
    //                                 if (feild['name'] === 'base_price') {
    //                                     estimateBreakupFormatSchema[key]['value'] = null;
    //                                     estimateBreakupFormatSchema[key]['disable'] = true;
    //                                     estimateBreakupFormatSchema[key]['visible'] = true;
    //                                 }
    //                                 if (feild['name'] === 'excludes') {
    //                                     //     estimateBreakupFormatSchema[key]['value'] = null;
    //                                     //     estimateBreakupFormatSchema[key]['disable'] = true;
    //                                     estimateBreakupFormatSchema[key]['visible'] = true;
    //                                 }
    //                                 if (feild['name'] === 'total_Estimate_amount') {
    //                                     estimateBreakupFormatSchema[key]['value'] = null;
    //                                     estimateBreakupFormatSchema[key]['disable'] = true;
    //                                     estimateBreakupFormatSchema[key]['visible'] = true;
    //                                 }
    //                             })
    //                         }
    //                         else {
    //                             // hideing_estimatetable = 1;   
    //                             this.setState({ loadding: true });
    //                             let { configuration } = this.state;
    //                             if (configuration.length > 0) {
    //                                 configuration.map((feilds, key) => {
    //                                     if (feilds.config_name === 'Cash-Surgeon') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 1) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'amount') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                     if (feild.id === 2) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash-Asst Surgeon') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 3) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash-Anaesthetist') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 4) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash-Asst Anaesthetist') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 5) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash Consultation Charges Room') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 18  ||subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 6) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'amount') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                     if (feild.id === 6) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                                
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                     if (feilds.config_name === 'Cash Consultation Charges ICU') {
    //                                         addonSchema.map((subTable, key) => {
    //                                             if (subTable.header === 18 ||subTable.header === 17) {
    //                                                 let table_body = subTable.Specification.table_body;
    //                                                 table_body.map((feild, table_key) => {
    //                                                     if (feild.id === 7) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'amount') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
                                                               
    //                                                         })
    //                                                     }
    //                                                     if (feild.id === 7) {
    //                                                         let row = feild.feilds;
    //                                                         row.map((sub_feild, sub_table_key) => {
    //                                                             if (sub_feild.name === 'percentage') {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
    //                                                                 this.setState({ addonSchema: addonSchema, loadding: false });
    //                                                             }
    //                                                         })
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
                               
    //                             addonSchema.map((subTable, key) => {
    //                                 let table_name = subTable.name;
    //                                 let table_body = subTable.Specification.table_body;
    //                                 table_body.map((feild, table_key) => {
    //                                     let row = feild.feilds;
    //                                     row.map((sub_feild, sub_table_key) => {
    //                                         if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy') {
    //                                             if (feild.key_word === 'routine') {
    //                                                 if (sub_feild.name === 'rate') {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                                 }
    //                                             }
    //                                         }
    //                                         if (feild.key_word === 'highend') {
    //                                             if (sub_feild.name === 'qty') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                             }
    //                                         }
    //                                         if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
    //                                             if (feild.key_word === 'routine') {
    //                                                 if (sub_feild.name === 'qty') {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                                 }
    //                                             }
    //                                         }
    //                                     })
    //                                 })
    //                             })
    //                             includesSchema.map((subTable, key) => {
    //                                 if (includesSchema[key].Specification.table_body.length > 0) {
    //                                     includesSchema[key].Specification.table_body.length = 0;
    //                                 }
        
    //                             })
    //                             hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: [] } })
    //                             optionsStore.dispatch({ type: 'options_data', 'data': [] });
    //                             inc_excludes_pack_id.pop();
    //                             inc_excludes_pack_id.push(parseInt(0));
    //                             hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
    //                             this.props.excludes(excludesSchema, includesSchema);
    //                             //clearing excludes data in redux store
    //                             excludesTableStore.dispatch({ type: 'options_data', 'data': [] });
    //                             this.setState({
    //                                 includes_data: includesSchema,
    //                                 includesSchema: includesSchema, inc_excludes_pack_id: inc_excludes_pack_id
    //                             });
    //                             estimateBreakupFormatSchema.map((feild, key) => {
    //                                 if (feild['name'] === 'base_price') {
    //                                     estimateBreakupFormatSchema[key]['value'] = null;
    //                                     estimateBreakupFormatSchema[key]['disable'] = true;
    //                                     estimateBreakupFormatSchema[key]['visible'] = false;
    //                                 }
    //                                 if (feild['name'] === 'excludes') {
    //                                     estimateBreakupFormatSchema[key]['value'] = null;
    //                                     estimateBreakupFormatSchema[key]['disable'] = true;
    //                                     estimateBreakupFormatSchema[key]['visible'] = false;
    //                                 }
    //                                 if (feild['name'] === 'total_Estimate_amount') {
    //                                     estimateBreakupFormatSchema[key]['value'] = null;
    //                                     estimateBreakupFormatSchema[key]['disable'] = true;
    //                                     estimateBreakupFormatSchema[key]['visible'] = false;
    //                                 }
    //                             })
    //                         }
        
        
        
    //                         additionalPackageSchema[0]['visible'] = false;
    //                         additionalProcedureSchema[0]['visible'] = false;
    //                         this.setState((state) => ({ 'hideShowExcludesIncludes': true,fc1_total_estimate_amount:0 }));
        
    //                         addonSchema.map((subTable, key) => {
    //                             let table_body = subTable.Specification.table_body;
    //                             table_body.map((feild, table_key) => {
    //                                 let row = feild.feilds;
    //                                 row.map((sub_feild, sub_table_key) => {
    //                                     if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'percentage') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     }
    //                                 })
    //                             })
    //                         })
    //                         // console.log('addonSchema',addonSchema)
        
    //                         medicationDetailsSchema.map((feild, key) => {
    //                             if (feild['name'] === 'length_of_stay') {
    //                                 medicationDetailsSchema[key]['value'] = null;
    //                             }
    //                         })
        
    //                         // this.total_suming();
    //                     }
    //                     if (feild['name'] === 'room_opted') {
    //                         room_id = feild['room_id'];
    //                         room_value = parseInt(feild['value']);
    //                     }
    //                 })
    //                 if (ele_val !== '' && ele_val !== null && ele_val !== undefined) {
    //                     additionalProcedureSchema[0]['visible'] = true;
    //                     let amount, room_id, room_value = 0;
    //                     let { getServicePricesById } = networkList;

    //                     medicationDetailsSchema.map((feild, key) => {
    //                         if (feild['name'] === 'room_opted') {
    //                             room_id = feild['room_id'];
    //                             room_value = parseInt(feild['value']);
    //                         }
    //                     })

    //                     if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
    //                         postService(getServicePricesById, 'POST', { data: { service_id: ele_val } }).then(res => {
    //                             if (res && res.data) {
    //                                 res.data.map((feild, key) => {
    //                                     // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
    //                                     amount = parseFloat(feild.amount);
    //                                     medicationDetailsSchema.map((feild, key) => {
    //                                         if (feild['name'] === 'surgery_procedure_amount') {
    //                                             feild['text'] = amount;
    //                                             feild['value'] = amount;
    //                                         }
    //                                     })
    //                                     this.setState({ medicationDetailsSchema: medicationDetailsSchema });
    //                                     // this.sumingProcedureAmounts();
    //                                     this.total_suming();
    //                                     // }
    //                                 })
    //                             }
    //                         });
    //                     }
    //                     else {
    //                         Modal.error({
    //                             title: 'Error message',
    //                             content: 'Please select room',
    //                         });
    //                     }
    //                 }
    //                 else {
    //                     additionalProcedureSchema[0]['visible'] = false;
    //                 }
    //                 //Testing//
    //                 let pack_name = '';

    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'room_opted') {
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['amount'] = 0;
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                     }
    //                     if (feild['name'] === 'room_upgrade') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['amount'] = null;
    //                     }
    //                     if (feild['name'] === 'room_upgrade_reason') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         medicationDetailsSchema[key]['visible'] = false;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         medicationDetailsSchema[key]['text'] = null;
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                     }
    //                 })

    //                 if (ele_val !== '' && ele_val !== null && ele_val !== undefined) {
    //                     additionalPackageSchema[0]['visible'] = false;
    //                     additionalProcedureSchema[0]['visible'] = false;
    //                 }
    //                 else {
    //                     additionalPackageSchema[0]['visible'] = false;
    //                     additionalProcedureSchema[0]['visible'] = false;
    //                 }

    //                 let pack = false;
    //                 let length_of_stay = null;
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'estimate_type') {
    //                         if (parseFloat(feild['value']) === 1) { // 1 - package, 2 - non-package
    //                             pack = true;
    //                                                     }
    //                                                 }
    //                     if (feild['name'] === 'surgery_procedure_name') {
    //                         if(ele_val!==''){
    //                             length_of_stay = feild['length_of_stay'];
    //                             console.log('procedureText:::', procedureText);
    //                             pack_name = procedureText; 
    //                         }
    //                     else{
    //                         length_of_stay=0;
    //                     }
    //                 }
    //                 })
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'length_of_stay') {
    //                         if (pack) {
    //                             medicationDetailsSchema[key]['value'] = length_of_stay;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['value'] = null;
    //                             medicationDetailsSchema[key]['text']=null;
    //                         }
    //                     }
    //                 })

    //                 estimateBreakupFormatSchema.map((feild, key) => {
    //                     if (feild['name'] === 'base_price') {
    //                         estimateBreakupFormatSchema[key]['value'] = null;
    //                     }
    //                                         })

    //                 addonSchema.map((subTable, key) => {
    //                     let table_body = subTable.Specification.table_body;
    //                     table_body.map((feild, table_key) => {
    //                         let row = feild.feilds;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                             }
    //                             if (sub_feild.name === 'qty') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             }
    //                             if (sub_feild.name === 'rate') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             }
    //                             if (sub_feild.name === 'amount') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                             }
    //                         })
    //                     })
    //                 })

    //                 let user_data = JSON.parse(Storage.get('user_data'));
    //                 let user_unit_id = user_data.unitid;
    //                 let newData = [];
    //                 let dopulicatearray = [];
    //                 console.log('procedureText:::', pack_name);
    //                 if (true) {
    //                     console.log('procedureText:::', pack_name);  
    //                     this.getExcludesIncludes(parseInt(ele_val), "CABG",0);
    //                 }
    //                 this.setState((state) => ({ fc1_total_estimate_amount:0 }));
    //             }

    //             if (ele_name === 'icu_stay') {
    //                 let icu_amount=0;
    //                 if (ele_val === '' || ele_val === undefined || ele_val === null || isNaN(ele_val)) {
    //                     ele_val = 0;
    //                 }
    //                 let total_stay = 0;
    //                 let pack = false;

    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'package_name') {
    //                         if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
    //                             pack = true;
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_stay') {
    //                         if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
    //                             total_stay = parseFloat(ele_val) + parseFloat(feild['value']);
    //                         }
    //                         else {
    //                             total_stay = parseFloat(ele_val);
    //                         }
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         icu_amount=parseFloat(medicationDetailsSchema[key]['amount']);
    //                         // if (ele_val !== '' && ele_val !== undefined && ele_val !== null && !isNaN(ele_val) ) {
    //                         //     medicationDetailsSchema[key]['amount']=ele_val!==0?11170:0;
    //                         // medicationDetailsSchema[key]['text']=ele_val!==0?'ICU Bed Charges':null;
    //                         // medicationDetailsSchema[key]['value']=ele_val!==0?4:null;
    //                         // medicationDetailsSchema[key]['disable'] = false;
    //                         // medicationDetailsSchema[key]['room_id']=ele_val!==0?4:null;
    //                         // }
    //                         // else {
    //                         //     medicationDetailsSchema[key]['visible'] = false;
    //                         //     medicationDetailsSchema[key]['disable'] = true;
    //                         //     medicationDetailsSchema[key]['value'] = null;
    //                         //     medicationDetailsSchema[key]['text'] = null;
    //                         // }
    //                         if(slug==='finanical-counselling'){
    //                         let user_data = JSON.parse(Storage.get('user_data'));
    //                         let user_unit_id = user_data.unitid;
    //                         try{
    //                         postService('getCashNonPackageRoomsByUnitId', 'POST', { "data": { "unit_id": user_unit_id, "payment_type":1, "tariff_id": 1, "room_type": 1 } }).then(res => {
    //                             if (res['status']) {
    //                                 if(res['data'].length>0){
    //                                     feild['value'] = res['data'][0].id;
    //                                     // feild_data['error'] = error;
    //                                     feild['amount'] = res['data'][0].amount;
    //                                     feild['room_id'] = res['data'][0].room_id;
    //                                     // feild['text'] = res['data'][0].room_name;
    //                                     icu_amount=parseFloat(res['data'][0].amount);

    //                                 } 
    //                             } else {
    //                                 Modal.error({
    //                                     title: 'Error message',
    //                                     content: `${res.message}`,
    //                                 });
    //                             }
    //                         });
    //                     }catch (error) {
    //                         console.log(error);

    //                     }
    //                     }
    //                     }
    //                 })

    //                 if (!pack) {
    //                     let qty_for_icu_stay = [
    //                         { header: 1, key: 1 },
    //                         { header: 1, key: 2 },
    //                         { header: 1, key: 3 },
    //                         { header: 3, key: 0 },
    //                         { header: 5, key: 0 },
    //                         { header: 15, key: 1 },
    //                         { header: 16, key: 0 }
    //                     ];

    //                     addonSchema.map((subTable, key) => {
    //                         qty_for_icu_stay.map((icu_stay, icu_stay_key) => {
    //                             if (subTable.header === icu_stay.header) {
    //                                 let table_body = subTable.Specification.table_body;
    //                                 table_body.map((feild, table_key) => {
    //                                     if (table_key === icu_stay.key) {
    //                                         let row = feild.feilds;
    //                                         let rate;
    //                                         let qty;
    //                                         row.map((sub_feild, sub_table_key) => {
    //                                             if (sub_feild.row_group === 'dietician') {
    //                                                 if (sub_feild.name === 'qty') {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
    //                                                     qty=total_stay;
    //                                                 }
    //                                             }else if (sub_feild.name === 'qty') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val?ele_val:0
    //                                                 qty= ele_val?ele_val:0
    //                                             }
    //                                             if (sub_feild.name === 'rate') {
    //                                                 rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                             }
    //                                             if (sub_feild.name === 'amount') {
    //                                                 if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * rate;
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                         })
    //                     })
    //                      addonSchema.map((subTable, key) => {
    //                         if (subTable.name === 'room_charges') {
    //                             let table_body = subTable.Specification.table_body;
    //                             table_body.map((feild, table_key) => {
    //                                 if (table_key === 1) {
    //                                     let row = feild.feilds;
    //                                     let qty;
    //                                     if (feild.key_word === 'icu') {
    //                                         row.map((sub_feild, sub_table_key) => {

    //                                             if (sub_feild.name === 'qty') {
    //                                                 qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                                 if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val?ele_val:0
    //                                                     qty = 0;
    //                                                 }
    //                                             }
    //                                             if (sub_feild.name === 'rate') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val!==0?icu_amount:0;
    //                                             }
    //                                             if (sub_feild.name === 'amount') {
    //                                                 if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(ele_val) * parseFloat(ele_val!==0?icu_amount:0);
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 }
    //                             })
    //                         }
    //                     })

    //                     this.drugaAdminCharges();
                        
    //                     if (total_stay != '' && !isNaN(total_stay) && total_stay != undefined && total_stay != null) {
    //                         medicationDetailsSchema.map((feild, key) => {
    //                             if (feild['name'] === 'length_of_stay') {
    //                                 medicationDetailsSchema[key]['value'] = total_stay;
    //                             }
    //                         })
    //                     }
    //                     this.internsivistAndasstInternsivist(ele_val);
    //                     this.drugaAdminCharges();
    //                 }
    //                 else {
    //                     addonSchema.map((subTable, key) => {
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             let row = feild.feilds;
    //                             row.map((sub_feild, sub_table_key) => {
    //                                 if (table_key === 1 || table_key === 2 || table_key === 3) {
    //                                    if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                 }
    //                             })
    //                         })
    //                     })

    //                     medicationDetailsSchema.map((feild, key) => {
    //                         if (feild['name'] === 'length_of_stay') {
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     })
    //                 }
    //                 this.drugaAdminCharges();
    //             }

    //             if (ele_name === 'room_stay') {
    //                 if (ele_val === '' || ele_val === undefined || ele_val === null || isNaN(ele_val)) {
    //                     ele_val = 0;
    //                 }
    //                 let total_stay = 0;
    //                 let pack = false;
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'package_name') {
    //                         if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
    //                             pack = true;
    //                         }
    //                     }
    //                     if (feild['name'] === 'icu_stay') {
    //                         if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
    //                             total_stay = parseFloat(ele_val) + parseFloat(feild['value']);
    //                         }
    //                         else {
    //                             total_stay = parseFloat(ele_val);
    //                         }
    //                     } 
    //                     // if (feild['name'] === 'room_opted') {
    //                     //     feild['value'] = null;
    //                     //     feild['text'] = null;
    //                     // }
                        
    //                 })
    //                 if (!pack) {
    //                     let qty_for_room_stay = [{ header: 1 }, { header: 2 }, { header: 4 }, { header: 6 }, { header: 8 }, { header: 9 }, { header: 10 }, { header: 11 }, { header: 12 },{ header: 15 }, { header: 16 }];

    //                     addonSchema.map((subTable, key) => {
    //                         qty_for_room_stay.map((room_stay, room_stay_key) => {
    //                             if (subTable.header === room_stay.header) {
    //                                 let table_body = subTable.Specification.table_body;
    //                                 table_body.map((feild, table_key) => {
    //                                     let row = feild.feilds;
    //                                     let rate;
    //                                     let qty
    //                                     if (table_key === 0) {
    //                                         if (feild.key_word !== 'intensivist') {
    //                                             row.map((sub_feild, sub_table_key) => {
    //                                                 if (sub_feild.table === 'general_equipment_charges' || sub_feild.table === 'ot_equipment' || sub_feild.table === 'procedure_charges' || sub_feild.table === 'blood_bank_charges' || sub_feild.table === 'ot_cath_pharmacy' || sub_feild.table === 'ot_charges') {
    //                                                     if (sub_feild.name === 'qty') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
    //                                                         qty = 1;
    //                                                     }
    //                                                 } else if (sub_feild.row_group === 'dietician') {
    //                                                     if (sub_feild.name === 'qty') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
    //                                                         qty = total_stay;
    //                                                     }

    //                                                 }
    //                                                 else {
    //                                                     if (sub_feild.name === 'qty') {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val;
    //                                                         qty = ele_val;
    //                                                     }
    //                                                 }

    //                                                 if (sub_feild.name === 'rate') {
    //                                                     rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                                 }
    //                                                 if (sub_feild.name === 'amount') {
    //                                                     if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * rate;
    //                                                     }
    //                                                 }
    //                                             })
    //                                         }

    //                                     }
    //                                     if (table_key === 1) {
    //                                         row.map((sub_feild, sub_table_key) => {
    //                                             if (sub_feild.table === 'physiotherapy_diet_charges' || sub_feild.table === 'ot_charges') {
    //                                                 if (sub_feild.name === 'qty') {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
    //                                                 }
    //                                                 if (sub_feild.name === 'rate') {
    //                                                     rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                                 }
    //                                                 if (sub_feild.name === 'amount') {
    //                                                     if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(ele_val) * rate;
    //                                                     }
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                             }
    //                         })
    //                     })
    //                     this.drugaAdminCharges();
    //                     if (total_stay != '' && !isNaN(total_stay) && total_stay != undefined && total_stay != null) {
    //                         medicationDetailsSchema.map((feild, key) => {
    //                             if (feild['name'] === 'length_of_stay') {
    //                                 medicationDetailsSchema[key]['value'] = total_stay;
    //                             }
    //                         })
    //                     }
    //                 }
    //                 else {
    //                     addonSchema.map((subTable, key) => {
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             let row = feild.feilds;
    //                             if (table_key === 0) {
    //                                 row.map((sub_feild, sub_table_key) => {
    //                                     if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                 })
    //                             }
    //                         })
    //                     })

    //                     medicationDetailsSchema.map((feild, key) => {
    //                         if (feild['name'] === 'length_of_stay') {
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     })
    //                 }
    //                 this.drugaAdminCharges();

    //             }

    //             if (ele_name === 'room_opted') {
    //                 let pack = false;
    //                 let room_amount,icu_amount;
    //                 let amount,icu_stay,room_stay;
    //                 let estimate_id=0
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name']=='estimate_type'){
    //                         estimate_id=feild.value;
    //                     }
    //                     if (feild.name === 'icu_stay') {
    //                         icu_stay=medicationDetailsSchema[key]['value']  
    //                     }
    //                     if(feild.name === 'room_stay'){
    //                         room_stay=medicationDetailsSchema[key]['value'];
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         icu_amount=parseFloat(medicationDetailsSchema[key]['amount']);
    //                         let user_data = JSON.parse(Storage.get('user_data'));
    //                         let user_unit_id = user_data.unitid;
    //                         try{
    //                         postService('getCashNonPackageRoomsByUnitId', 'POST', { "data": { "unit_id": user_unit_id, "payment_type":1, "tariff_id": 1, "room_type": 1 } }).then(res => {
    //                             if (res['status']) {
    //                                 if(res['data'].length>0){
    //                                     feild['value'] = res['data'][0].id;
    //                                     // feild_data['error'] = error;
    //                                     feild['amount'] = res['data'][0].amount;
    //                                     feild['room_id'] = res['data'][0].room_id;
    //                                     // feild['text'] = res['data'][0].room_name;
    //                                     icu_amount=parseFloat(res['data'][0].amount);
    //                                 } 
    //                             } else {
    //                                 Modal.error({
    //                                     title: 'Error message',
    //                                     content: `${res.message}`,
    //                                 });
    //                             }
    //                         });
    //                     }catch (error) {
    //                         console.log(error);

    //                     }
                            
                          
    //                     }
    //                 })
    //                 if(estimate_id==1){
    //                     additionalPackageSchema.map((subTable, key) => {
    //                         let table_body = subTable.Specification.table_body;
    //                         additionalPackageSchema[key].Specification.add_more = true;
    //                         table_body.length=0;
    //                     })
    //                     additionalPackageSchema[0]['visible'] = false;
    //                 }
    //                 if(estimate_id==1 || estimate_id==2){
    //                 additionalProcedureSchema.map((subTable, key) => {
    //                     let table_body = subTable.Specification.table_body;
    //                     additionalProcedureSchema[key].Specification.add_more = true;
    //                     table_body.length=0;
    //                 })
    //                 additionalProcedureSchema[0]['visible'] = false;
    //                 console.log('additionalProcedureSchema3',additionalProcedureSchema)
    //             }
    //                 addonSchema.map((subTable, key) => {
    //                     let table_name = subTable.name
    //                     addonSchema[key].header_amount = 0;
    //                     let table_body = subTable.Specification.table_body;
    //                     table_body.map((feild, table_key) => {
    //                         let row = feild.feilds;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
    //                             //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             // }

    //                             // if (table_name === 'room_charges') {
    //                             //     if (sub_feild.name === 'qty') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'rate') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'amount') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             // }
    //                             if (table_name === 'room_investigation_charges') {
    //                                 addonSchema[key].Specification.add_more = true;
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'Routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'qty') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'room_highend_investigations') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'icu_investigation_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'Routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'qty') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'icu_highend_investigations') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'ip_pharmacy_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine_drugs_implants') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'qty') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'room_highend_drugs_implants') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'icu_pharmacy_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine_drugs_implants') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'qty') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'icu_highend_drugs_implants') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'ot_cath_pharmacy') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'qty') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'general_equipment_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     // if (sub_feild.name === 'general_highend_equipments') {
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     // }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'general_highend_equipments') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'ot_charges') {

    //                                 if (feild.key_word === 'ot_inst_disinfec') {
    //                                     if (sub_feild.name === 'ot_inst_disinfec') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     }

    //                                 }
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'ot_hours') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'ot_equipment') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'ot_equipments') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'procedure_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'surgery_procedure_name') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'blood_bank_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'blood_components') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true ;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'cross_consultation_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'dept_for_corss_consultations') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                             }
    //                             if (table_name === 'hospital_services') {
    //                                 if (feild.key_word === 'mrd') {
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'Ward_consumables') {
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'seropositive') {
    //                                     if (sub_feild.name === 'seropositive') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             if (table_name === 'isolation_charges') {
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'room_isolation_charges') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = room_stay;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = room_stay;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'icu_isolation_charges') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = icu_stay;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = icu_stay;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                             }
    //                             if (table_name === 'physiotherapy_diet_charges') {
    //                                 if (feild.key_word === 'dietician') {
    //                                     if (sub_feild.name === 'dietician') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = icu_stay+room_stay;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = icu_stay+room_stay;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'routine') {
    //                                     if (sub_feild.name === 'routine') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                 }
    //                                 if (feild.key_word === 'highend') {
    //                                     if (sub_feild.name === 'physiotherapys') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                     }
    //                                     if (sub_feild.name === 'action') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
    //                                     }


    //                                 }
    //                                 if (feild.key_word === 'add_more') {
    //                                     addonSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             }
    //                             // if (table_name === 'intensivist') {
    //                             //     if ( feild.key_word==='asst_intensivist'){
    //                             //     // if (sub_feild.name === 'qty') {
    //                             //     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     // }
    //                             //     if (sub_feild.name === 'rate') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'amount') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             // }
    //                             // }
    //                             // if (table_name === 'surgical_charges') {
    //                             //     if (sub_feild.name === 'qty') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'percentage') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'amount') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             // }
    //                             // if (table_name === 'medical_charges') {
    //                             //     if (sub_feild.name === 'qty') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'percentage') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             //     if (sub_feild.name === 'amount') {
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                             //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                             //     }
    //                             // }
    //                         })
    //                     })
    //                 })
                   
                  
    //                 this.setState((state) => ({ addonSchema: addonSchema,additionalPackageSchema:additionalPackageSchema,additionalProcedureSchema:additionalProcedureSchema }),()=>{
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'package_name') {
    //                         if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
    //                             pack = true;
    //                             additionalPackageSchema.map((subTable, key) => {
    //                                 let table_body = subTable.Specification.table_body;
    //                                 subTable.visible=true;
    //                                 additionalPackageSchema[key].Specification.add_more = true;
    //                                 table_body.map((feild, table_key) => {
    //                                     if (table_body.length > 0) {
    //                                         let row = feild.feilds;
    //                                         row.map((sub_feild, sub_table_key) => {
    //                                             if ( sub_feild.element === 'select'  && sub_feild.value!==null && sub_feild.value!=='' && sub_feild.value!==undefined) {
    //                                                 const { getCashPackagePricesById } = networkList;
    //                                                 let user_data = JSON.parse(Storage.get('user_data'));
    //                                                 let user_unit_id = user_data.unitid;
    //                                                 let value=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'];
    //                                                 let text=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'];
    //                                                 let table=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['table'];
    //                                                 let row_group=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['row_group'];
    //                                                 let id=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['id'];
    //                                                 let room_id, room_value = 0;
    //                                                 postService(getCashPackagePricesById, 'POST', { "data": { "package_id": value, "unit_id": user_unit_id } }).then(res => {
    //                                                     if (res['status']) {
    //                                                         medicationDetailsSchema.map((feild, key) => {
    //                                                             if (feild['name'] === 'room_opted') {
    //                                                                 room_id = feild['room_id'];
    //                                                                 room_value = feild['value'];
    //                                                             }
    //                                                         })
                            
    //                                                         if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
    //                                                             res.data.map((feild, key) => {
    //                                                                 if (parseFloat(feild.room_id) === parseFloat(room_id)) {
    //                                                                     amount = feild.amount;
                            
    //                                                                     additionalPackageSchema.map((subTable, key) => {
    //                                                                         if (subTable.name === table) {
    //                                                                             let table_body = subTable.Specification.table_body;
    //                                                                             table_body.map((feild, table_key) => {
    //                                                                                 let row = feild.feilds;
    //                                                                                 row.map((sub_feild, sub_table_key) => {
    //                                                                                     if(sub_feild.name === "additional_package_name" && sub_feild.row_group ===row_group && sub_feild.id === id){
    //                                                                                         additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true;
    //                                                                                     }
    //                                                                                     if (sub_feild.name === "amount" && sub_feild.row_group === row_group && sub_feild.id === id) {
    //                                                                                         if (amount === undefined) { amount = 0; }
    //                                                                                         additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
    //                                                                                         this.setState({ additionalPackageSchema: additionalPackageSchema });
    //                                                                                         this.getExcludesIncludes(parseInt(value), text,1);
    //                                                                                         // this.getExcludesIncludes(pack_id, pack_name, id);
    //                                                                                         this.total_suming();
    //                                                                                         this.drugaAdminCharges();
    //                                                                                     }
    //                                                                                 })
    //                                                                             })
    //                                                                         }
    //                                                                     })
    //                                                                 }
    //                                                             })
    //                                                         }
    //                                                         else {
    //                                                             Modal.error({
    //                                                                 title: 'Error message',
    //                                                                 content: 'No amount for the selected room',
    //                                                             });
    //                                                         }
    //                                                     } else {
    //                                                         this.setState((state) => ({ 'selet_options': [], fetching: false }));
    //                                                         Modal.error({
    //                                                             title: 'Error message',
    //                                                             content: `${res.message}`,
    //                                                         });
    //                                                     }
    //                                                 });

    //                                             }
    //                                         });
                                           
                                               
    //                                     }
    //                                 })
    //                             })
    //                             additionalProcedureSchema.map((subTable, key) => {
    //                                 let table_body = subTable.Specification.table_body;
    //                                 subTable.visible=true;
    //                                 additionalProcedureSchema[key].Specification.add_more = true;
    //                                 table_body.map((feild, table_key) => {
    //                                     if (table_body.length > 0) {
    //                                         let row = feild.feilds;
    //                                             row.map((sub_feild, sub_table_key) => {
    //                                                 if ( sub_feild.element === 'select' && sub_feild.value!==null && sub_feild.value!==undefined  && sub_feild.value!=='') {
    //                                                 let user_data = JSON.parse(Storage.get('user_data'));
    //                                                 let user_unit_id = user_data.unitid;
    //                                                  let value=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'];
    //                                                  let text=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'];
    //                                                  let table=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['table'];
    //                                                  let row_group=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['row_group'];
    //                                                  let id=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['id'];
    //                                                  let room_id, room_value = 0;

    //                                                  medicationDetailsSchema.map((feild, key) => {
    //                                                      if (feild['name'] === 'room_opted') {
                             
    //                                                          room_id = feild['room_id'];
    //                                                          room_value = feild['value'];
    //                                                      }
    //                                                  })
    //                                                  postService(getInsurancePackagePricesByProcedureName, 'POST', { data: { "procedure_name": text, "unit_id": user_unit_id,tariff_mapped: 1,mode_of_payment:1 } }).then(res => {
    //                                                     // postService(getServicePricesById, 'POST', { data: { service_id: value } }).then(res => {
    //                                                         if (res) {
                                                               
    //                                                                 let amount = 0;
    //                                                                 if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
    //                                                                     let procedure_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
    //                                                                     amount = procedure_amount[0].package_charges;
    //                                                                     // amount = feild.amount;
                            
    //                                                                     additionalProcedureSchema.map((subTable, key) => {
    //                                                                         if (subTable.name === table) {
    //                                                                             let table_body = subTable.Specification.table_body;
    //                                                                             table_body.map((feild, table_key) => {
    //                                                                                 let row = feild.feilds;
    //                                                                                 row.map((sub_feild, sub_table_key) => {
    //                                                                                     if (sub_feild.name === "amount" && sub_feild.row_group === row_group && sub_feild.id ===id) {
    //                                                                                         additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                                                                         if (amount === undefined) { amount = 0; }
    //                                                                                         additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
    //                                                                                         this.setState({ additionalProcedureSchema: additionalProcedureSchema });
    //                                                                                         // this.sumingProcedureAmounts();
    //                                                                                         this.total_suming();
    //                                                                                     }
    //                                                                                 })
    //                                                                             })
    //                                                                         }
    //                                                                     })
    //                                                                 }
    //                                                         }
    //                                                         else {
    //                                                             Modal.error({
    //                                                                 title: 'Error message',
    //                                                                 content: 'No amount for the selected room',
    //                                                             });
    //                                                         }
    //                                                     });

    //                                                  }

    //                                             })
    //                                     }
    //                                 })
    //                             })
    //                         }
    //                     }
    //                     if(feild['name']==='surgery_procedure_name'){
    //                         if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
    //                             additionalProcedureSchema.map((subTable, key) => {
    //                                 let table_body = subTable.Specification.table_body;
    //                                 subTable.visible=true;
    //                                 additionalProcedureSchema[key].Specification.add_more = true;
    //                                 table_body.map((feild, table_key) => {
    //                                     if (table_body.length > 0) {
    //                                         let row = feild.feilds;
    //                                             row.map((sub_feild, sub_table_key) => {
    //                                                 if ( sub_feild.element === 'select' && sub_feild.value!==null) {
    //                                                     let user_data = JSON.parse(Storage.get('user_data'));
    //                                                     let user_unit_id = user_data.unitid;
    //                                                  let value=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'];
    //                                                  let text=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'];
    //                                                  let table=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['table'];
    //                                                  let row_group=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['row_group'];
    //                                                  let id=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['id'];
    //                                                  let room_id, room_value = 0;

    //                                                  medicationDetailsSchema.map((feild, key) => {
    //                                                      if (feild['name'] === 'room_opted') {
                             
    //                                                          room_id = feild['room_id'];
    //                                                          room_value = feild['value'];
    //                                                      }
    //                                                  })
    //                                                  postService(getInsurancePackagePricesByProcedureName, 'POST', { data: { "procedure_name": text, "unit_id": user_unit_id,tariff_mapped: 1,mode_of_payment:1 } }).then(res => {
    //                                                     // postService(getServicePricesById, 'POST', { data: { service_id: value } }).then(res => {
    //                                                         if (res) {
                                                                
    //                                                                 let amount = 0;
    //                                                                 if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
    //                                                                     let procedure_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
    //                                                                     amount = procedure_amount[0].package_charges;
    //                                                                     // amount = feild.amount;
                            
    //                                                                     additionalProcedureSchema.map((subTable, key) => {
    //                                                                         if (subTable.name === table) {
    //                                                                             let table_body = subTable.Specification.table_body;
    //                                                                             table_body.map((feild, table_key) => {
    //                                                                                 let row = feild.feilds;
    //                                                                                 row.map((sub_feild, sub_table_key) => {
    //                                                                                     if (sub_feild.name === "amount" && sub_feild.row_group === row_group && sub_feild.id ===id) {
    //                                                                                         additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                                                                         if (amount === undefined) { amount = 0; }
    //                                                                                         additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
    //                                                                                         this.setState({ additionalProcedureSchema: additionalProcedureSchema });
    //                                                                                         // this.sumingProcedureAmounts();
    //                                                                                         this.total_suming();
    //                                                                                     }
    //                                                                                 })
    //                                                                             })
    //                                                                         }
    //                                                                     })
    //                                                                 }
    //                                                         }
    //                                                         else {
    //                                                             Modal.error({
    //                                                                 title: 'Error message',
    //                                                                 content: 'No amount for the selected room',
    //                                                             });
    //                                                         }
    //                                                     });

    //                                                  }

    //                                             })
    //                                     }
    //                                 })
    //                             })
    //                         }
    //                     }
    //                     if (feild['name'] === 'room_opted') {
    //                         room_amount = parseFloat(medicationDetailsSchema[key]['amount']);
    //                     }
    //                     if(feild['name'] === 'icu_stay'){
    //                         icu_stay=medicationDetailsSchema[key]['value'];
    //                     }
                        
    //                     let upgrade_reason = false;
    //                     if (feild['name'] === 'room_upgrade') {
    //                         medicationDetailsSchema[key]['disable'] = false;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                         // if(medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] !== null && medicationDetailsSchema[key]['value'] !== undefined && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))){
    //                         //     upgrade_reason = true;
    //                         // }
    //                         // if (ele_val != '') {
    //                         //     medicationDetailsSchema[key]['disable'] = false;
    //                         // }
    //                         // else {
    //                         //     medicationDetailsSchema[key]['disable'] = true;
    //                         // }
    //                     }
    //                     // if (feild['name'] === 'room_upgrade_reason' && upgrade_reason === true ) {
    //                     if (feild['name'] === 'room_upgrade_reason') {
    //                         medicationDetailsSchema[key]['disable'] = true;
    //                         medicationDetailsSchema[key]['value'] = null;
    //                     }
    //                     // if (feild['name'] === 'icu_opted') {
    //                     //     icu_amount = parseFloat(medicationDetailsSchema[key]['amount']);
    //                     // }
    //                 })
    //                 if (!pack) {
    //                     addonSchema.map((subTable, key) => {
    //                         if (subTable.name === 'room_charges') {
    //                             let table_body = subTable.Specification.table_body;
    //                             table_body.map((feild, table_key) => {
    //                                 if (table_key === 0) {
    //                                     let row = feild.feilds;
    //                                     let qty;
    //                                     if (feild.key_word === 'room') {
    //                                         row.map((sub_feild, sub_table_key) => {
    //                                             if (sub_feild.name === 'qty') {
    //                                                 qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                                 if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
    //                                                     qty = 0;
    //                                                 }
    //                                             }
    //                                             if (sub_feild.name === 'rate') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_amount;
    //                                             }
    //                                             if (sub_feild.name === 'amount') {
    //                                                 if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(room_amount);
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 }
    //                             })
    //                         }
    //                         if (subTable.name === 'room_charges') {
    //                             let table_body = subTable.Specification.table_body;
    //                             table_body.map((feild, table_key) => {
    //                                 if (table_key === 1) {
    //                                     let row = feild.feilds;
    //                                     let qty;
    //                                     if (feild.key_word === 'icu') {
    //                                         row.map((sub_feild, sub_table_key) => {

    //                                             if (sub_feild.name === 'qty') {
    //                                                 qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                                 if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
    //                                                     qty = 0;
    //                                                 }
    //                                             }
    //                                             if (sub_feild.name === 'rate') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay!==0?icu_amount:0;
    //                                             }
    //                                             if (sub_feild.name === 'amount') {
    //                                                 if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(icu_stay!==0?icu_amount:0);
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 }
    //                             })
    //                         }
    //                     })
    //                 }
    //                 else {
    //                     addonSchema.map((subTable, key) => {
    //                         let table_body = subTable.Specification.table_body;
    //                         table_body.map((feild, table_key) => {
    //                             if (table_key === 0) {
    //                                 let row = feild.feilds;
    //                                 row.map((sub_feild, sub_table_key) => {
    //                                     if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
    //                                     }
    //                                     if (sub_feild.name === 'qty') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                     if (sub_feild.name === 'rate') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                     if (sub_feild.name === 'amount') {
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
    //                                     }
    //                                 })
    //                             }
    //                         })
    //                     })
    //                 }
    //                 let length_of_stay, room_id = null;
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'length_of_stay') {
    //                         length_of_stay = parseInt(feild['value']);
    //                     }
    //                     if (feild['name'] === 'room_opted') {
    //                         room_id = parseInt(feild['room_id']);
    //                     }
    //                 })
    //                 this.drugaAdminCharges();
    //                 if (length_of_stay !== 0 && length_of_stay !== '' && length_of_stay !== null && length_of_stay !== undefined) {
    //                     let user_data = JSON.parse(Storage.get('user_data'));
    //                     let user_unit_id = user_data.unitid;
    //                     postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 14, sub_header_id: 23, tariff_mapped: 1 } }).then(res => {
    //                         if (res.status) {
    //                             if (res.data.length > 1) {
    //                                 let service_id = res.data[0].id;
    //                                 if (length_of_stay > 1) {
    //                                     service_id = res.data[1].id;
    //                                 }

    //                                 postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
    //                                     if (response.status) {
    //                                         if (response.data.length > 0) {
    //                                             let amount;
    //                                             let data_value = 0;

    //                                             response.data.map((feild, key) => {
    //                                                 if (feild.room_id === room_id) {
    //                                                     amount = parseFloat(feild.amount);

    //                                                     addonSchema.map((subTable, key) => {
    //                                                         if (subTable.name === 'hospital_services') {
    //                                                             let table_body = subTable.Specification.table_body;
    //                                                             table_body.map((feild, table_key) => {
    //                                                                 // if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
    //                                                                 data_value = 1;
    //                                                                 // }
    //                                                                 let row = feild.feilds;
    //                                                                 if (feild.key_word === 'mrd') {
    //                                                                     row.map((sub_feild, sub_table_key) => {
    //                                                                         if (sub_feild.name === "qty") {
    //                                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
    //                                                                         }

    //                                                                         if (sub_feild.name === "rate") {
    //                                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
    //                                                                         }
    //                                                                         if (sub_feild.name === "amount") {
    //                                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(1);
    //                                                                         }
    //                                                                     })
    //                                                                 }
                                                                   

    //                                                             })
    //                                                         }
    //                                                     })
    //                                                     this.setState({ addonSchema: addonSchema });
    //                                                     this.total_suming();
    //                                                     // this.sumingProcedureAmounts();
    //                                                 }
    //                                             })
    //                                         }
    //                                         else {
    //                                             Modal.error({
    //                                                 title: 'Error message',
    //                                                 content: 'No amount for the selected room',
    //                                             });
    //                                         }
    //                                     }
    //                                     else {
    //                                         Modal.error({
    //                                             title: 'Error message',
    //                                             content: 'Something went wrong',
    //                                         });
    //                                     }
    //                                 })
    //                             }
    //                             else {
    //                                 Modal.error({
    //                                     title: 'Error message',
    //                                     content: 'No service available',
    //                                 });
    //                             }
    //                         }
    //                         else {
    //                             Modal.error({
    //                                 title: 'Error message',
    //                                 content: 'Something went wrong',
    //                             });
    //                         }
    //                     })

    //                     postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 14, sub_header_id: 41, tariff_mapped: 1 } }).then(res => {
    //                         if (res.status) {
    //                             if (res.data.length!==0) {
    //                                 let service_id = res.data[0].id;
    //                                 postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
    //                                     if (response.status) {
    //                                         if (response.data.length > 0) {
    //                                             let amount;
    //                                             let data_value = 0;

    //                                             response.data.map((feild, key) => {
    //                                                 if (feild.room_id === room_id) {
    //                                                     amount = parseFloat(feild.amount);
    //                                                     let total_stays
    //                                                     addonSchema.map((subTable, key) => {
    //                                                         if (subTable.name === 'hospital_services') {
    //                                                             let table_body = subTable.Specification.table_body;
    //                                                             table_body.map((feild, table_key) => {
    //                                                                 // if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
    //                                                                 data_value = 1;
    //                                                                 // }
    //                                                                 let row = feild.feilds;
                                                                   
    //                                                                 if (feild.key_word === 'ward_consumables') {
    //                                                                     row.map((sub_feild, sub_table_key) => {
    //                                                                         if (sub_feild.name === "qty") {
    //                                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = length_of_stay;
    //                                                                         }

    //                                                                         if (sub_feild.name === "rate") {
    //                                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
    //                                                                         }
    //                                                                         if (sub_feild.name === "amount") {
    //                                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(length_of_stay);
    //                                                                         }
    //                                                                     })
    //                                                                 }

    //                                                             })
    //                                                         }
    //                                                     })
    //                                                     this.setState({ addonSchema: addonSchema });
    //                                                     this.total_suming();
    //                                                     // this.sumingProcedureAmounts();
    //                                                 }
    //                                             })
    //                                         }
    //                                         else {
    //                                             Modal.error({
    //                                                 title: 'Error message',
    //                                                 content: 'No amount for the selected room',
    //                                             });
    //                                         }
    //                                     }
    //                                     else {
    //                                         Modal.error({
    //                                             title: 'Error message',
    //                                             content: 'Something went wrong',
    //                                         });
    //                                     }
    //                                 })
    //                             }
    //                             else {
    //                                 Modal.error({
    //                                     title: 'Error message',
    //                                     content: 'No service available',
    //                                 });
    //                             }
    //                         }
    //                         else {
    //                             Modal.error({
    //                                 title: 'Error message',
    //                                 content: 'Something went wrong',
    //                             });
    //                         }
    //                     })
    //                 }
    //                 else {

    //                 }
    //                 this.drugaAdminCharges();
                   
    //                     this.total_suming();
    //                     if(estimate_id==1){
    //                     additionalPackageSchema[0]['visible'] = true;
    //                     }
    //                     if(estimate_id==1 || estimate_id==2){
    //                         additionalProcedureSchema[0]['visible'] = true;
    //                     }
    //                     let This = this;
    //                     setTimeout(function () {
    //                         This.setState((state) => ({additionalPackageSchema: additionalPackageSchema,additionalProcedureSchema:additionalProcedureSchema}))
    //                         This.total_suming();
    //                                 }, 1000);
    //                 });
    //             }

                

    //             if (ele_name === 'room_upgrade') {
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     let upgrade_reason = false;
    //                     // if (feild['name'] === 'room_upgrade') {
    //                     //     if(medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] !== null && medicationDetailsSchema[key]['value'] !== undefined && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))){
    //                     //         upgrade_reason = true;
    //                     //     }
    //                     // }
    //                     // if (feild['name'] === 'room_upgrade_reason' && upgrade_reason !== true ) {
    //                     if (feild['name'] === 'room_upgrade_reason') {
    //                         if (ele_val != '') {
    //                             medicationDetailsSchema[key]['disable'] = false;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                         else {
    //                             medicationDetailsSchema[key]['disable'] = true;
    //                             medicationDetailsSchema[key]['value'] = null;
    //                         }
    //                     }
    //                 })
    //             }

    //              if(ele_name === 'icu_opted'){
    //                 let pack = false;
    //                 let icu_amount,icu_stay
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'package_name') {
    //                         if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
    //                             pack = true;
    //                         }
    //                     }
    //                     if(feild['name'] === 'icu_stay'){
    //                         icu_stay=medicationDetailsSchema[key]['value'];
    //                     }
    //                     if (feild['name'] === 'icu_opted') {
    //                         icu_amount= medicationDetailsSchema[key]['amount']

    //                     }
    //                 })
    //                 if (!pack) {
    //                     addonSchema.map((subTable, key) => {
    //                         if (subTable.name === 'room_charges') {
    //                             let table_body = subTable.Specification.table_body;
    //                             table_body.map((feild, table_key) => {
    //                                 if (table_key === 1) {
    //                                     let row = feild.feilds;
    //                                     let qty;
    //                                     if (feild.key_word === 'icu') {
    //                                         row.map((sub_feild, sub_table_key) => {

    //                                             if (sub_feild.name === 'qty') {
    //                                                 qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                                                 if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
    //                                                     qty = 0;
    //                                                 }
    //                                             }
    //                                             if (sub_feild.name === 'rate') {
    //                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_amount;
    //                                             }
    //                                             if (sub_feild.name === 'amount') {
    //                                                 if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
    //                                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(icu_amount);
    //                                                 }
    //                                             }
    //                                         })
    //                                     }
    //                                 }
    //                             })
    //                         }
    //                     })
    //                 }

    //              }
    //             if(medicationDetailserrors.length>0){
    //                 medicationDetailserrors.map((index)=>{
    //                     medicationDetailsSchema.map((item,key) => {
    //                 if(item['name']===ele_name && item['id']===index['id']) {
    //                  document.getElementById("errorm"+item['name']).style.display = "none";
    //                 }
    //                 })
    //             })
    //             }
    //             this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema, 'estimateBreakupFormatSchema': estimateBreakupFormatSchema, 'additionalPackageSchema':  JSON.parse(JSON.stringify(additionalPackageSchema)), 'additionalProcedureSchema':  JSON.parse(JSON.stringify(additionalProcedureSchema)), includearrya }), () => {
    //                 this.total_suming();
    //                 let { medicationDetailsSchema } = this.state;
    //                 let obj = {}
    //                 medicationDetailsSchema.map((feild, key) => {
    //                     if (feild['name'] === 'care_management') {
    //                         obj[feild['name']] = feild['value'];
    //                     }
    //                     if (feild['name'] === 'estimate_type') {
    //                         obj[feild['name']] = feild['value']
    //                     }
    //                     if (feild['name'] === 'surgery_procedure_name') {
    //                         obj[feild['name']] = (feild['selected_option'] && feild['selected_option']['id']) ? feild['selected_option']['id'] : null;
    //                         obj['service_id'] = feild['text']
    //                     }
    //                 })

    //                 console.log('obj', obj, ele_name)

    //                 if (ele_name === 'care_management' && obj['care_management'] && obj['care_management'] == 1) {
    //                     this.updateDefaultEstimates(obj);
    //                     this.getConstantionChagres(obj);
                        
    //                 } else {
    //                     if (ele_name === 'surgery_procedure_name' && obj['care_management'] && obj['care_management'] == 2 && obj['estimate_type'] && obj['estimate_type'] == 2 && obj['surgery_procedure_name']) {
    //                         this.updateDefaultEstimates(obj);
    //                         this.getConstantionChagres(obj);
    //                     }
    //                 }
    //                 if (ele_name === 'room_opted' || ele_name === 'room_upgrade') {
    //                     this.setData();
    //                     this.getConstantionChagres(obj);
    //                 }
    //             });
    //         } break;
    //     }
    // } catch (error) {
    //     console.log(error);
    //     this.setState({ 'loadding': false });
    // }


    // }

    buttonClick2(feilds, type) {
        // console.clear();
        console.log(feilds, type);
        let { counselling_details, basic_info  } = this.props;
        let {procedureValue, procedureText,procedureCode} = this.state;
        // return true;
        let { slug } = this.props.match.params;
          const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const cd = params.get('cd');


        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
            // if( cd != '' && cd !== undefined && cd !== null && !isNaN(cd)){
            //     disabled = true;
            // }
            if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE'])){
           console.log('teet')
            }else{
                slug = 'finanical-counselling'; 
            }
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }
        const { getServicePricesById,getInsurancePackagePricesByProcedureName } = networkList;
        try {
        switch (slug) {
            case 'view-finanical-counselling': {
                let { medicationDetailsSchema } = this.state;
                let { counselling_details, hideing_estimatetable } = this.props

                let care_management = counselling_details.care_management;
                let estimate_type = counselling_details.estimate_type;
                let icu_stay = counselling_details.icu_stay;

                medicationDetailsSchema.map((feild, key) => {
                    if (feild['name'] === 'estimate_type') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = true;
                            hideing_estimatetable = 0;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = false;
                            hideing_estimatetable = 0;
                        }
                    }
                    if (feild['name'] === 'package_name') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = true;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild['name'] === 'surgery_procedure_name') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = true;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild['name'] === 'surgery_procedure_amount') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                    }
                    if (feild['name'] === 'icu_stay') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['disable'] = true;
                        }
                        else {
                            medicationDetailsSchema[key]['disable'] = false;
                        }
                    }


                    if (feild['name'] === 'room_stay') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['disable'] = true;
                        }
                        else {
                            medicationDetailsSchema[key]['disable'] = false;
                        }
                    }
                    if (feild['name'] === 'surgery_procedure_name') {
                        if (parseFloat(care_management) === 2) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = true;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                    }

                    if (feild['name'] === 'package_name') {

                        if (parseFloat(estimate_type) === 1) {
                            // 1 - package, 2 - non-package
                            medicationDetailsSchema[key]['disable'] = false;
                            hideing_estimatetable = 1;
                        }
                        else {
                            medicationDetailsSchema[key]['disable'] = true;
                            hideing_estimatetable = 0;
                        }
                    }
                    if (feild['name'] === 'icu_opted') {
                        if ((parseFloat(care_management) === 2) && (parseFloat(estimate_type) === 1)) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = false;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = true;
                            medicationDetailsSchema[key]['disable'] = true;
                        }
                    }
                    if (feild['name'] === 'surgery_procedure_name') {
                        if ((parseFloat(care_management) === 2) && (parseFloat(estimate_type) === 1)) {    // 1 - medical, 2 - surgical
                            medicationDetailsSchema[key]['visible'] = true;
                        }
                        else {
                            medicationDetailsSchema[key]['visible'] = true;
                        }
                    }
                    // if (feild['name'] === 'room_opted') {
                    //     medicationDetailsSchema[key]['value'] = null;
                    //     medicationDetailsSchema[key]['text'] = null;
                    //     if (parseFloat(care_management) === 1) {    // 1 - medical, 2 - surgical
                    //         medicationDetailsSchema[key]['disable'] = false;
                    //     }
                    //     else {
                    //         medicationDetailsSchema[key]['disable'] = true;
                    //     }
                    // }
                    // if (feild['name'] === 'room_upgrade') {
                    //     medicationDetailsSchema[key]['disable'] = true;
                    //     medicationDetailsSchema[key]['value'] = null;
                    //     medicationDetailsSchema[key]['text'] = null;
                    // }
                    // if (feild['name'] === 'room_upgrade_reason') {
                    //     medicationDetailsSchema[key]['disable'] = true;
                    //     medicationDetailsSchema[key]['value'] = null;
                    //     medicationDetailsSchema[key]['text'] = null;
                    // }
                    // if (feild['name'] === 'icu_opted') {
                    //     medicationDetailsSchema[key]['visible'] = false;
                    //     medicationDetailsSchema[key]['value'] = null;
                    //     medicationDetailsSchema[key]['text'] = null;
                    // }
                })
                this.setState({ hideing_estimatetable: hideing_estimatetable });
            } break;
            default: {
                let ele_name = '';
                let ele_val = '';
                let ele_id = 0;
                let ele_text=0;
                let { counselling_details, medicationDetailsSchema, addonSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, total_estimate_amount, includesSchema, excludesSchema, inc_excludes_pack_id, hideing_estimatetable, includearrya,medicationDetailserrors } = this.state;

                medicationDetailsSchema.map((feild, key) => {
                    if (feild['name'] === type.type) {
                        ele_name = feild['name'];
                        ele_val = feild['value'];
                        // ele_text = feild['text'] 
                        ele_id = feild['id'];
                    }
                })

                medicationDetailsSchema.map((feild, key) => {
                    if (ele_id === 17) {
                        if (feild['id'] > ele_id) {
                            medicationDetailsSchema[key]['value'] = null;
                        }
                    }
                    // if (ele_id !== 11) {
                    //     if (feild['id'] > ele_id && feild['id'] !== 11 && feild['id'] !== 19 && feild['id'] !== 20 && feild['id'] !== 21 && feild['id'] !== 29 && feild['id'] !== 30) {
                    //         medicationDetailsSchema[key]['value'] = null;
                    //     }
                    // }
                })

                if (ele_name === 'diagnosis') {
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'diagnosis') {
                            medicationDetailsSchema[key]['value'] = ele_val;
                        }
                    })
                }

                if (ele_name === 'care_management') {
                    const { getconfigurations } = networkList;
                    let user_data = JSON.parse(Storage.get('user_data'));
                    let user_unit_id = user_data.unitid;
                    // configuration
                    postService(getconfigurations, 'GET', 'null').then(res => {
                        if (res.status) {
                            if (res.data.length > 0) {
                                this.setState({ configuration: res.data[0].data })
                                if (res.data[0].data.length > 0) {
                                    res.data[0].data.map((feilds, key) => {
                                        if (feilds.config_name === 'Cash-Physician Fees') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.header === 18) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 1) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'amount') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                        if (feild.id === 2) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    console.log('feilds.bill_tracking_percent', feilds.bill_tracking_percent);
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                                
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        if (feilds.config_name === 'Cash-Asst Physician Fees') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.header === 18) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 3) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        // if (feilds.config_name === 'Cash Consultation Charges Room') {
                                        //     addonSchema.map((subTable, key) => {
                                        //         if (subTable.header === 18  ||subTable.header === 17) {
                                        //             let table_body = subTable.Specification.table_body;
                                        //             table_body.map((feild, table_key) => {
                                        //                 if (feild.id === 6) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'amount') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                                               
                                        //                     })
                                        //                 }
                                        //                 if (feild.id === 6) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'percentage') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                                                
                                        //                     })
                                        //                 }
                                        //             })
                                        //         }
                                        //     })
                                        // }
                                        if (feilds.config_name === 'Cash Consultation Charges Room') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.id === 16) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 3) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'amount') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                        if (feild.id === 3) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    console.log('feilds.bill_tracking_percent', feilds.bill_tracking_percent);
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                                
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        // if (feilds.config_name === 'Cash Consultation Charges ICU') {
                                        //     addonSchema.map((subTable, key) => {
                                        //         if (subTable.header === 18 ||subTable.header === 17) {
                                        //             let table_body = subTable.Specification.table_body;
                                        //             table_body.map((feild, table_key) => {
                                        //                 if (feild.id === 7) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'amount') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                                               
                                        //                     })
                                        //                 }
                                        //                 if (feild.id === 7) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'percentage') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                        //                     })
                                        //                 }
                                        //             })
                                        //         }
                                        //     })
                                        // }
                                        if (feilds.config_name === 'Cash Consultation Charges ICU') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.id === 16) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 4) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'amount') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                        if (feild.id === 4) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'No service available',
                                });
                            }
                        } 
                        else {
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong',
                            });
                        }
                    });
                    
        
                    
                    if (parseFloat(ele_val) === 1) {    // 1 - medical, 2 - surgical
                        addonSchema.map((subTable, key) => {
                            let table_name = subTable.name;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy' || table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            }
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                    }
                                })
                            })
                        })
                        this.setState({ loadding: true });
                       
                        includesSchema.map((subTable, key) => {
                            if (includesSchema[key].Specification.table_body.length > 0) {
                                includesSchema[key].Specification.table_body.length = 0;
                            }

                        })
                        hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: [] } })
                        optionsStore.dispatch({ type: 'options_data', 'data': [] });
                        inc_excludes_pack_id.pop();
                        inc_excludes_pack_id.push(parseInt(0));
                        this.props.excludes(excludesSchema, includesSchema);
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                        hideing_estimatetable = 0;
                        this.setState({
                            includes_data: includesSchema,
                            includesSchema: includesSchema, inc_excludes_pack_id: inc_excludes_pack_id, hideing_estimatetable: hideing_estimatetable
                        });
                        estimateBreakupFormatSchema.map((feild, key) => {
                            if (feild['name'] === 'base_price') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = false;
                            }
                            if (feild['name'] === 'advance_amount') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = false;
                                estimateBreakupFormatSchema[key]['visible'] = true;
                            }
                            if (feild['name'] === 'excludes') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = false;
                            }
                            if (feild['name'] === 'total_Estimate_amount') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = false;
                            }
                        })
                    }



                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'estimate_type') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['visible'] = true;
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null;
                            }
                            else {
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null
                            }
                        }
                        if (feild['name'] === 'package_name') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null
                            }
                            else {
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null
                            }
                        }
                        if (feild['name'] === 'date_of_surgery') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['visible'] = true;
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null
                            }
                            else {
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null;
                            }
                        }
                        if (feild['name'] === 'icu_stay') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        }
                        if (feild['name'] === 'room_stay') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        }
                        if (feild['name'] === 'surgery_procedure_name') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['visible'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null;
                            }
                            else {
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null;
                            }
                        }
                        if (feild['name'] === 'surgery_procedure_amount') {
                            if (parseFloat(ele_val) === 2) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null
                            }
                            else {
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null
                            }
                        }
                        if (feild['name'] === 'room_opted') {
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            if (parseFloat(ele_val) === 1) {    // 1 - medical, 2 - surgical
                                medicationDetailsSchema[key]['disable'] = false;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = true;
                            }
                        }
                        if (feild['name'] === 'room_upgrade') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                        }
                        if (feild['name'] === 'room_upgrade_reason') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                        }
                        if (feild['name'] === 'icu_opted') {
                            medicationDetailsSchema[key]['visible'] = false;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['disable'] = true;
                        }
                        
                    })

                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild['name'] === 'base_price') {
                            estimateBreakupFormatSchema[key]['value'] = null;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                        if (feild['name'] === 'advance_amount') {
                            estimateBreakupFormatSchema[key]['value'] = null;
                            estimateBreakupFormatSchema[key]['disable'] = false;
                            estimateBreakupFormatSchema[key]['visible'] = true;
                        }
                        if (feild['name'] === 'total_Estimate_amount') {
                            estimateBreakupFormatSchema[key]['value'] = null;
                            estimateBreakupFormatSchema[key]['disable'] = true;
                        }
                    })

                    additionalPackageSchema[0]['visible'] = false;
                    additionalProcedureSchema[0]['visible'] = false;

                    if (parseFloat(ele_val) === 1) {    // 1 - medical, 2 - surgical
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'surgical_charges') {
                                addonSchema[key].visible = false;
                                let table_body = subTable.Specification.table_body;
                                let header_amount = 0;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                    })
                                })
                            }
                            if (subTable.name === 'medical_charges') {
                                addonSchema[key].visible = true;
                            }
                            if (subTable.name === 'ot_cath_pharmacy') {
                                addonSchema[key].visible = false;
                            }

                            if (subTable.name === 'ot_charges') {
                                addonSchema[key].visible = false;
                            }
                            if (subTable.name === 'ot_equipment') {
                                addonSchema[key].visible = false;
                            }
                        })
                    }
                    else {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'surgical_charges') {
                                addonSchema[key].visible = true;
                            }
                            if (subTable.name === 'ot_cath_pharmacy') {
                                addonSchema[key].visible = true;
                            }
                            if (subTable.name === 'ot_charges') {
                                addonSchema[key].visible = false;
                            }
                            if (subTable.name === 'ot_equipment') {
                                addonSchema[key].visible = false;
                            }
                            if (subTable.name === 'medical_charges') {
                                addonSchema[key].visible = false;
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                    })
                                })
                            }
                        })
                    }

                    addonSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                }
                                // if (sub_feild.name === 'percentage') {
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                // }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                }
                            })
                        })
                    })

                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'length_of_stay') {
                            medicationDetailsSchema[key]['value'] = null;
                        }
                    })
                    this.setState({fc1_total_estimate_amount:0, showEstimationBreakdown: false, showOtherDetails: false})
                }

                if (ele_name === 'estimate_type') {
                    let user_data = JSON.parse(Storage.get('user_data'));
                    let user_unit_id = user_data.unitid;
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'package_name') {
                            if (parseFloat(ele_val) === 1) {
                                let hide_estimatetable = 0   // 1 - package, 2 - non-package
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['length_of_stay'] = null;
                                medicationDetailsSchema[key]['visible'] = false;
                                hide_estimatetable = 1;
                                this.setState({ hideing_estimatetable: hide_estimatetable })
                            }
                            else {
                                let hide_estimatetable = 0
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['length_of_stay'] = null;
                                medicationDetailsSchema[key]['visible'] = false;
                                this.setState({ hideing_estimatetable: hide_estimatetable })
                            }
                        }
                        if (feild['name'] === 'icu_stay') {
                            if (parseFloat(ele_val) === 1) {
                                // 1 - package, 2 - non-package
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        }
                        if (feild['name'] === 'room_stay') {
                            if (parseFloat(ele_val) === 1) {
                                // 1 - package, 2 - non-package
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        }
                        if (feild['name'] === 'room_opted') {
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['amount'] = null;
                            if (parseFloat(ele_val) === 1) {
                                // 1 - package, 2 - non-package
                                medicationDetailsSchema[key]['disable'] = true;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = false;
                            }
                        }
                        if (feild['name'] === 'room_upgrade') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['amount'] = null;
                        }
                        if (feild['name'] === 'room_upgrade_reason') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                        }
                        if (feild['name'] === 'icu_opted') {
                            medicationDetailsSchema[key]['visible'] = false;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['disable'] = true;
                        }
                        if (feild['name'] === 'surgery_procedure_name') {
                            if (parseFloat(ele_val) === 1) {
                                // 1 - package, 2 - non-package
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['visible'] = true;
                                medicationDetailsSchema[key]['text'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['visible'] = true;
                                medicationDetailsSchema[key]['text'] = null;
                            }
                        }
                        if (feild['name'] === 'surgery_procedure_amount') {
                            if (parseFloat(ele_val) === 1) {   // 1 - package, 2 - non-package
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['visible'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text'] = null;
                            }
                        }
                    })

                    if (parseFloat(ele_val) === 1) {    // 1 - package, 2 - non-package

                        // addonSchema.map((subTable, key) => {
                        //     if (subTable.name === 'surgical_charges') {
                        //         addonSchema[key].visible = true;
                        //         let table_body = subTable.Specification.table_body;
                        //         let header_amount = 0;
                        //         table_body.map((feild, table_key) => {
                        //             let row = feild.feilds;
                        //             row.map((sub_feild, sub_table_key) => {
                        //                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null
                        //                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                        //             })
                        //         })
                        //     }
                        //     // if (subTable.name === 'medical_charges') {
                        //     //     addonSchema[key].visible = true;
                        //     // }
                        // })

                        addonSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                    }
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                    }
                                    if (sub_feild.name === 'rate') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                    }
                                    // if (sub_feild.name === 'percentage') {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                    // }
                                    if (sub_feild.name === 'amount') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                    }

                                })
                            })
                        })
                        addonSchema.map((subTable, key) => {
                            let table_name = subTable.name;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                    }
                                })
                            })
                        })
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
                        estimateBreakupFormatSchema.map((feild, key) => {
                            if (feild['name'] === 'base_price') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = true;
                            }
                            if (feild['name'] === 'advance_amount') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = false;
                                estimateBreakupFormatSchema[key]['visible'] = true;
                            }
                            if (feild['name'] === 'excludes') {
                                //     estimateBreakupFormatSchema[key]['value'] = null;
                                //     estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = true;
                            }
                            if (feild['name'] === 'total_Estimate_amount') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = true;
                            }
                        })
                    }
                    else {
                        // hideing_estimatetable = 1;   
                        this.setState({ loadding: true });
                        let { configuration } = this.state;
                        if (configuration.length > 0) {
                            configuration.map((feilds, key) => {
                                if (feilds.config_name === 'Cash-Surgeon') {
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.header === 17) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 1) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'amount') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                       
                                                    })
                                                }
                                                if (feild.id === 2) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'percentage') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                       
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                if (feilds.config_name === 'Cash-Asst Surgeon') {
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.header === 17) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 3) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'percentage') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                if (feilds.config_name === 'Cash-Anaesthetist') {
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.header === 17) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 4) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'percentage') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                if (feilds.config_name === 'Cash-Asst Anaesthetist') {
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.header === 17) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 5) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'percentage') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                if (feilds.config_name === 'Cash Consultation Charges Room') {
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.id === 16) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 3) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'amount') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                       
                                                    })
                                                }
                                                if (feild.id === 3) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'percentage') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                            console.log('feilds.bill_tracking_percent', feilds.bill_tracking_percent);
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                        
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                // if (feilds.config_name === 'Cash Consultation Charges ICU') {
                                //     addonSchema.map((subTable, key) => {
                                //         if (subTable.header === 18 ||subTable.header === 17) {
                                //             let table_body = subTable.Specification.table_body;
                                //             table_body.map((feild, table_key) => {
                                //                 if (feild.id === 7) {
                                //                     let row = feild.feilds;
                                //                     row.map((sub_feild, sub_table_key) => {
                                //                         if (sub_feild.name === 'amount') {
                                //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                //                         }
                                                       
                                //                     })
                                //                 }
                                //                 if (feild.id === 7) {
                                //                     let row = feild.feilds;
                                //                     row.map((sub_feild, sub_table_key) => {
                                //                         if (sub_feild.name === 'percentage') {
                                //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                //                         }
                                //                     })
                                //                 }
                                //             })
                                //         }
                                //     })
                                // }
                                if (feilds.config_name === 'Cash Consultation Charges ICU') {
                                    addonSchema.map((subTable, key) => {
                                        if (subTable.id === 16) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                if (feild.id === 4) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'amount') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                       
                                                    })
                                                }
                                                if (feild.id === 4) {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === 'percentage') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                            this.setState({ addonSchema: addonSchema, loadding: false });
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                       
                        addonSchema.map((subTable, key) => {
                            let table_name = subTable.name;
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            }
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
                                        if (feild.key_word === 'routine') {
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            }
                                        }
                                    }
                                })
                            })
                        })
                        includesSchema.map((subTable, key) => {
                            if (includesSchema[key].Specification.table_body.length > 0) {
                                includesSchema[key].Specification.table_body.length = 0;
                            }

                        })
                        hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: [] } })
                        optionsStore.dispatch({ type: 'options_data', 'data': [] });
                        inc_excludes_pack_id.pop();
                        inc_excludes_pack_id.push(parseInt(0));
                        hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                        this.props.excludes(excludesSchema, includesSchema);
                        //clearing excludes data in redux store
                        excludesTableStore.dispatch({ type: 'options_data', 'data': [] });
                        this.setState({
                            includes_data: includesSchema,
                            includesSchema: includesSchema, inc_excludes_pack_id: inc_excludes_pack_id
                        });
                        estimateBreakupFormatSchema.map((feild, key) => {
                            if (feild['name'] === 'base_price') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = false;
                            }
                            if (feild['name'] === 'advance_amount') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = false;
                                estimateBreakupFormatSchema[key]['visible'] = true;
                            }
                            if (feild['name'] === 'excludes') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = false;
                            }
                            if (feild['name'] === 'total_Estimate_amount') {
                                estimateBreakupFormatSchema[key]['value'] = null;
                                estimateBreakupFormatSchema[key]['disable'] = true;
                                estimateBreakupFormatSchema[key]['visible'] = false;
                            }
                        })
                    }



                    additionalPackageSchema[0]['visible'] = false;
                    additionalProcedureSchema[0]['visible'] = false;
                    this.setState((state) => ({ 'hideShowExcludesIncludes': true,fc1_total_estimate_amount:0 }));

                    addonSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                // if (sub_feild.name === 'percentage') {
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                // }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                            })
                        })
                    })
                    // console.log('addonSchema',addonSchema)

                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'length_of_stay') {
                            medicationDetailsSchema[key]['value'] = null;
                        }
                    })

                    // this.total_suming();
                }

                if (ele_name === 'surgery_procedure_name') {
                    additionalProcedureSchema[0]['visible'] = true;
                    let amount, room_id, room_value = 0;
                    let { getServicePricesById } = networkList;
                    let unitID = null;
                    let estimateTypeValue;
                    medicationDetailsSchema.map((feild, key) => { 
                        if(feild['name'] === 'surgery_procedure_name'){
                            if (feild['value'] !== '' && feild['value'] !== null && feild['value'] !== undefined) {
                                estimateTypeValue = feild.selected_option.is_package === null ? 2 : feild.selected_option.is_package === "Y" ? 1 : 2 ;
                                procedureText = feild.selected_option.name;
                               
                                procedureValue = feild.selected_option.service_code;
                                procedureCode = feild.selected_option.service_code;
                                unitID = feild.selected_option.unit_id;
                            
                                medicationDetailsSchema[key]['text'] = procedureText;
                                medicationDetailsSchema[key]['value'] = procedureValue;
                                medicationDetailsSchema[key]['disable'] = false;
                                this.setState({procedureValue : procedureValue, procedureText: procedureText,procedureCode: procedureCode})
                            } else {
                                estimateTypeValue = 0;
                            }
                        }
                        if (feild['name'] === 'estimate_type') {

                            medicationDetailsSchema[key]['value'] = estimateTypeValue;
                            medicationDetailsSchema[key]['text'] = estimateTypeValue === 1 ? 'Package':'Non-Package';
                            medicationDetailsSchema[key]['disable'] = true;
                            // this.buttonClick2(medicationDetailsSchema, { "type": 'estimate_type' });
                  
                            let user_data = JSON.parse(Storage.get('user_data'));
                            let user_unit_id = user_data.unitid;
                            medicationDetailsSchema.map((feild, key) => {
                                if (feild['name'] === 'package_name') {
                                    console.log('ESTIMATE:::::', (parseFloat(ele_val)));
                                    if (estimateTypeValue === 1) {
                                        let hide_estimatetable = 0   // 1 - package, 2 - non-package
                                        medicationDetailsSchema[key]['disable'] = false;
                                        medicationDetailsSchema[key]['value'] = null;
                                        medicationDetailsSchema[key]['length_of_stay'] = null;
                                        medicationDetailsSchema[key]['visible'] = false;
                                        hide_estimatetable = 1;
                                        this.setState({ hideing_estimatetable: hide_estimatetable })
                                    }
                                    else {
                                        console.log('ESTIMATE:::::', (parseFloat(ele_val)));
                                        let hide_estimatetable = 0
                                        medicationDetailsSchema[key]['disable'] = true;
                                        medicationDetailsSchema[key]['value'] = null;
                                        medicationDetailsSchema[key]['length_of_stay'] = null;
                                        medicationDetailsSchema[key]['visible'] = false;
                                        this.setState({ hideing_estimatetable: hide_estimatetable })
                                    }
                                }
                                if (feild['name'] === 'icu_stay') {
                                    if (estimateTypeValue === 1) {
                                        // 1 - package, 2 - non-package
                                        medicationDetailsSchema[key]['disable'] = true;
                                        medicationDetailsSchema[key]['value'] = null;
                                    }
                                    else {
                                        medicationDetailsSchema[key]['disable'] = false;
                                        medicationDetailsSchema[key]['value'] = null;
                                    }
                                }
                                if (feild['name'] === 'room_stay') {
                                    if (estimateTypeValue === 1) {
                                        // 1 - package, 2 - non-package
                                        medicationDetailsSchema[key]['disable'] = true;
                                        medicationDetailsSchema[key]['value'] = null;
                                    }
                                    else {
                                        medicationDetailsSchema[key]['disable'] = false;
                                        medicationDetailsSchema[key]['value'] = null;
                                    }
                                }
                                if (feild['name'] === 'room_opted') {
                                    medicationDetailsSchema[key]['value'] = null;
                                    medicationDetailsSchema[key]['text'] = null;
                                    medicationDetailsSchema[key]['amount'] = null;
                                    if (estimateTypeValue === 1) {
                                        // 1 - package, 2 - non-package
                                        medicationDetailsSchema[key]['disable'] = false;
                                    }
                                    else {
                                        medicationDetailsSchema[key]['disable'] = false;
                                    }
                                }
                                if (feild['name'] === 'room_upgrade') {
                                    medicationDetailsSchema[key]['disable'] = true;
                                    medicationDetailsSchema[key]['value'] = null;
                                    medicationDetailsSchema[key]['text'] = null;
                                    medicationDetailsSchema[key]['amount'] = null;
                                }
                                if (feild['name'] === 'room_upgrade_reason') {
                                    medicationDetailsSchema[key]['disable'] = true;
                                    medicationDetailsSchema[key]['value'] = null;
                                    medicationDetailsSchema[key]['text'] = null;
                                }
                                if (feild['name'] === 'icu_opted') {
                                    medicationDetailsSchema[key]['visible'] = false;
                                    medicationDetailsSchema[key]['value'] = null;
                                    medicationDetailsSchema[key]['text'] = null;
                                    medicationDetailsSchema[key]['disable'] = true;
                                }
                                if (feild['name'] === 'surgery_procedure_amount') {
                                    if (estimateTypeValue === 1) {   // 1 - package, 2 - non-package
                                        medicationDetailsSchema[key]['visible'] = false;
                                        medicationDetailsSchema[key]['value'] = null;
                                        medicationDetailsSchema[key]['text'] = null;
                                    }
                                    else {
                                        medicationDetailsSchema[key]['visible'] = false;
                                        medicationDetailsSchema[key]['value'] = null;
                                        medicationDetailsSchema[key]['text'] = null;
                                    }
                                }
                            })
        
                            if (estimateTypeValue === 1) {    // 1 - package, 2 - non-package
                                

                                addonSchema.map((subTable, key) => {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            }
                                            if (sub_feild.name === 'qty') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            }
                                            if (sub_feild.name === 'rate') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            }
                                            // if (sub_feild.name === 'percentage') {
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            // }
                                            if (sub_feild.name === 'amount') {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                            }
        
                                        })
                                    })
                                })
                                addonSchema.map((subTable, key) => {
                                    let table_name = subTable.name;
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy') {
                                                if (feild.key_word === 'routine') {
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    }
                                                    if (sub_feild.name === 'rate') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                                    }
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
                                                if (feild.key_word === 'routine') {
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    }
                                                }
                                            }
                                        })
                                    })
                                })
                               
                                hideInEXStore.dispatch({ type: 'hide_data', data: { hide: false } })
                                estimateBreakupFormatSchema.map((feild, key) => {
                                    if (feild['name'] === 'base_price') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                    }
                                    if (feild['name'] === 'advance_amount') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = false;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                    }
                                    if (feild['name'] === 'excludes') {
                                        //     estimateBreakupFormatSchema[key]['value'] = null;
                                        //     estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                    }
                                    if (feild['name'] === 'total_Estimate_amount') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                    }
                                })
                            }
                            else {
                                
                                // hideing_estimatetable = 1;   
                                this.setState({ loadding: true });
                                let { configuration } = this.state;
                                if (configuration.length > 0) {
                                    configuration.map((feilds, key) => {
                                        if (feilds.config_name === 'Cash-Surgeon') {
                                            addonSchema.map((subTable, key) => {
                                                console.log('subTable::::', subTable);
                                                if (subTable.header === 17) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        console.log('feild::::', feild);
                                                        if (feild.id === 1) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'amount') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                        if (feild.id === 2) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        if (feilds.config_name === 'Cash-Asst Surgeon') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.header === 17) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 3) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        if (feilds.config_name === 'Cash-Anaesthetist') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.header === 17) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 4) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        if (feilds.config_name === 'Cash-Asst Anaesthetist') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.header === 17) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 5) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        // if (feilds.config_name === 'Cash Consultation Charges Room') {
                                        //     addonSchema.map((subTable, key) => {
                                        //         if (subTable.header === 18  ||subTable.header === 17) {
                                        //             let table_body = subTable.Specification.table_body;
                                        //             table_body.map((feild, table_key) => {
                                        //                 if (feild.id === 6) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'amount') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                                               
                                        //                     })
                                        //                 }
                                        //                 if (feild.id === 6) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'percentage') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                                                
                                        //                     })
                                        //                 }
                                        //             })
                                        //         }
                                        //     })
                                        // }
                                        if (feilds.config_name === 'Cash Consultation Charges Room') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.id === 16) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 3) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'amount') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                        if (feild.id === 3) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    console.log('feilds.bill_tracking_percent', feilds.bill_tracking_percent);
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                                
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                        // if (feilds.config_name === 'Cash Consultation Charges ICU') {
                                        //     addonSchema.map((subTable, key) => {
                                        //         if (subTable.header === 18 ||subTable.header === 17) {
                                        //             let table_body = subTable.Specification.table_body;
                                        //             table_body.map((feild, table_key) => {
                                        //                 if (feild.id === 7) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'amount') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                                               
                                        //                     })
                                        //                 }
                                        //                 if (feild.id === 7) {
                                        //                     let row = feild.feilds;
                                        //                     row.map((sub_feild, sub_table_key) => {
                                        //                         if (sub_feild.name === 'percentage') {
                                        //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                        //                             this.setState({ addonSchema: addonSchema, loadding: false });
                                        //                         }
                                        //                     })
                                        //                 }
                                        //             })
                                        //         }
                                        //     })
                                        // }
                                        if (feilds.config_name === 'Cash Consultation Charges ICU') {
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.id === 16) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        if (feild.id === 4) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'amount') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                               
                                                            })
                                                        }
                                                        if (feild.id === 4) {
                                                            let row = feild.feilds;
                                                            row.map((sub_feild, sub_table_key) => {
                                                                if (sub_feild.name === 'percentage') {
                                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = feilds.bill_tracking_percent;
                                                                    this.setState({ addonSchema: addonSchema, loadding: false });
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                               
                                addonSchema.map((subTable, key) => {
                                    let table_name = subTable.name;
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        let row = feild.feilds;
                                        row.map((sub_feild, sub_table_key) => {
                                            if (table_name === 'room_investigation_charges' || table_name === 'icu_investigation_charges' || table_name === 'ip_pharmacy_charges' || table_name === 'icu_pharmacy_charges' || table_name === 'ot_cath_pharmacy') {
                                                if (feild.key_word === 'routine') {
                                                    if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                                    if (sub_feild.name === 'rate') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                                    }
                                                }
                                            }
                                            if (feild.key_word === 'highend') {
                                                if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                }
                                            }
                                            if (table_name === 'general_equipment_charges' || table_name === 'ot_equipment' || table_name === 'procedure_charges' || table_name === 'blood_bank_charges' || table_name === 'cross_consultation_charges' || table_name === 'isolation_charges') {
                                                if (feild.key_word === 'routine') {
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                                    }
                                                }
                                            }
                                        })
                                    })
                                })
                                includesSchema.map((subTable, key) => {
                                    if (includesSchema[key].Specification.table_body.length > 0) {
                                        includesSchema[key].Specification.table_body.length = 0;
                                    }
        
                                })
                                hideInEXStore.dispatch({ type: 'exclude_data_recounselling', data: { exclude_data_recounselling: [] } })
                                optionsStore.dispatch({ type: 'options_data', 'data': [] });
                                inc_excludes_pack_id.pop();
                                inc_excludes_pack_id.push(parseInt(0));
                                hideInEXStore.dispatch({ type: 'hide_data', data: { hide: true } })
                                this.props.excludes(excludesSchema, includesSchema);
                                //clearing excludes data in redux store
                                excludesTableStore.dispatch({ type: 'options_data', 'data': [] });
                                this.setState({
                                    includes_data: includesSchema,
                                    includesSchema: includesSchema, inc_excludes_pack_id: inc_excludes_pack_id,
                                    showEstimationBreakdown: false, showOtherDetails: false
                                });
                                estimateBreakupFormatSchema.map((feild, key) => {
                                    if (feild['name'] === 'base_price') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = false;
                                    }
                                    if (feild['name'] === 'advance_amount') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = false;
                                        estimateBreakupFormatSchema[key]['visible'] = true;
                                    }
                                    if (feild['name'] === 'excludes') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = false;
                                    }
                                    if (feild['name'] === 'total_Estimate_amount') {
                                        estimateBreakupFormatSchema[key]['value'] = null;
                                        estimateBreakupFormatSchema[key]['disable'] = true;
                                        estimateBreakupFormatSchema[key]['visible'] = false;
                                    }
                                })
                            }
        
        
        
                            additionalPackageSchema[0]['visible'] = false;
                            additionalProcedureSchema[0]['visible'] = false;
                            this.setState((state) => ({ 'hideShowExcludesIncludes': true,fc1_total_estimate_amount:0 }));
        
                            addonSchema.map((subTable, key) => {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                        // if (sub_feild.name === 'percentage') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        // }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                    })
                                })
                            })
                            // console.log('addonSchema',addonSchema)
        
                            medicationDetailsSchema.map((feild, key) => {
                                if (feild['name'] === 'length_of_stay') {
                                    medicationDetailsSchema[key]['value'] = null;
                                }
                            })
        
                            // this.total_suming();
                        }

                        if (feild['name'] === 'room_opted') {
                            room_id = feild['room_id'];
                            room_value = parseInt(feild['value']);
                        }
                    })
                    let pack_name = '';

                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'room_opted') {
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['amount'] = 0;
                            medicationDetailsSchema[key]['disable'] = false;
                        }
                        if (feild['name'] === 'room_upgrade') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['amount'] = null;
                        }
                        if (feild['name'] === 'room_upgrade_reason') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                        }
                        if (feild['name'] === 'icu_opted') {
                            medicationDetailsSchema[key]['visible'] = false;
                            medicationDetailsSchema[key]['value'] = null;
                            medicationDetailsSchema[key]['text'] = null;
                            medicationDetailsSchema[key]['disable'] = true;
                        }
                    })

                    if (ele_val !== '' && ele_val !== null && ele_val !== undefined) {
                        additionalPackageSchema[0]['visible'] = false;
                        additionalProcedureSchema[0]['visible'] = false;
                    }
                    else {
                        additionalPackageSchema[0]['visible'] = false;
                        additionalProcedureSchema[0]['visible'] = false;
                    }

                    let pack = false;
                    let length_of_stay = null;
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'estimate_type') {
                            if (parseFloat(feild['value']) === 1) { // 1 - package, 2 - non-package
                                pack = true;
                                                        }
                                                    }
                        if (feild['name'] === 'surgery_procedure_name') {
                            if(ele_val!==''){
                                length_of_stay = feild['length_of_stay'];
                                pack_name = procedureText; 
                            }
                        else{
                            length_of_stay=0;
                        }
                    }
                    })
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'length_of_stay') {
                            if (pack) {
                                medicationDetailsSchema[key]['value'] = length_of_stay;
                            }
                            else {
                                medicationDetailsSchema[key]['value'] = null;
                                medicationDetailsSchema[key]['text']=null;
                            }
                        }
                    })

                    estimateBreakupFormatSchema.map((feild, key) => {
                        if (feild['name'] === 'base_price') {
                            estimateBreakupFormatSchema[key]['value'] = null;
                        }
                                            })

                    addonSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                }
                                if (sub_feild.name === 'qty') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                }
                                if (sub_feild.name === 'rate') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                }
                                if (sub_feild.name === 'amount') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                }
                            })
                        })
                    })

                    let user_data = JSON.parse(Storage.get('user_data'));
                    let user_unit_id = user_data.unitid;
                    let newData = [];
                    let dopulicatearray = [];
                    if (pack_name !== '' && pack_name !== undefined && pack_name !== null) {
                    // if (true) {
                        this.getExcludesIncludes(procedureCode, pack_name,0);
                    }
                    // this.setState((state) => ({ fc1_total_estimate_amount:0 }));
                    if (ele_val !== '' && ele_val !== null && ele_val !== undefined) {
                        additionalProcedureSchema[0]['visible'] = true;
                        let amount, room_id, room_value = 0;
                        let { getServicePricesById } = networkList;

                        medicationDetailsSchema.map((feild, key) => {
                            if (feild['name'] === 'room_opted') {
                                room_id = feild['room_id'];
                                room_value = parseInt(feild['value']);
                            }
                        })

                        if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                            postService(getServicePricesById, 'POST', { data: { service_id: ele_val } }).then(res => {
                                if (res && res.data) {
                                    res.data.map((feild, key) => {
                                        // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        amount = parseFloat(feild.amount);
                                        medicationDetailsSchema.map((feild, key) => {
                                            if (feild['name'] === 'surgery_procedure_amount') {
                                                feild['text'] = amount;
                                                feild['value'] = amount;
                                            }
                                        })
                                        this.setState({ medicationDetailsSchema: medicationDetailsSchema });
                                        // this.sumingProcedureAmounts();
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                        // this.internsivistAndasstInternsivist();
                                        // }
                                    })
                                }
                            });
                        }
                        else {
                            Modal.error({
                                title: 'Error message',
                                content: 'Please select room',
                            });
                        }
                    }
                    else {
                        additionalProcedureSchema[0]['visible'] = false;
                    }
                    this.setState((state) => ({ fc1_total_estimate_amount:0 }));

                }

                if (ele_name === 'icu_stay') {
                    let icu_amount=0;
                    if (ele_val === '' || ele_val === undefined || ele_val === null || isNaN(ele_val)) {
                        ele_val = 0;
                    }
                    let total_stay = 0;
                    let pack = false;

                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'icu_opted') {
                            if(this.state.medicationDetailsSchema[10].value == 0 || this.state.medicationDetailsSchema[10].value == null){
                                medicationDetailsSchema[key]['visible'] = false;
                                // medicationDetailsSchema[key]['disable'] =true ;
                                 medicationDetailsSchema[key]['disable'] =false ;
                                 medicationDetailsSchema[key]['value'] = '';
                                 medicationDetailsSchema[key]['text'] = '';
                            } 
                            else{
                                medicationDetailsSchema[key]['visible'] = true;
                                // medicationDetailsSchema[key]['disable'] =true ;
                                 medicationDetailsSchema[key]['disable'] =false ;
                                 medicationDetailsSchema[key]['value'] = '';
                                 medicationDetailsSchema[key]['text'] = '';
                            }
                        }
                    })

                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'package_name') {
                            if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
                                pack = true;
                            }
                        }
                        if (feild['name'] === 'room_stay') {
                            if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
                                total_stay = parseFloat(ele_val) + parseFloat(feild['value']);
                            }
                            else {
                                total_stay = parseFloat(ele_val);
                            }
                        }
                        if (feild['name'] === 'icu_opted') {
                            icu_amount=parseFloat(medicationDetailsSchema[key]['amount']);
                            // if (ele_val !== '' && ele_val !== undefined && ele_val !== null && !isNaN(ele_val) ) {
                            //     medicationDetailsSchema[key]['amount']=ele_val!==0?11170:0;
                            // medicationDetailsSchema[key]['text']=ele_val!==0?'ICU Bed Charges':null;
                            // medicationDetailsSchema[key]['value']=ele_val!==0?4:null;
                            // medicationDetailsSchema[key]['disable'] = false;
                            // medicationDetailsSchema[key]['room_id']=ele_val!==0?4:null;
                            // }
                            // else {
                            //     medicationDetailsSchema[key]['visible'] = false;
                            //     medicationDetailsSchema[key]['disable'] = true;
                            //     medicationDetailsSchema[key]['value'] = null;
                            //     medicationDetailsSchema[key]['text'] = null;
                            // }
                            if(slug==='finanical-counselling'){
                            let user_data = JSON.parse(Storage.get('user_data'));
                            let user_unit_id = user_data.unitid;
                        //     try{
                        //     postService('getInsuranceNonPackageRoomsByUnitId', 'POST', { "data": { "unit_id": user_unit_id, "payment_type":1, "tariff_id": "TR1", "room_type": 1 } }).then(res => {
                        //         if (res['status']) {
                        //             if(res['data'].length>0){
                        //                 feild['value'] = res['data'][0].id;
                        //                 // feild_data['error'] = error;
                        //                 feild['amount'] = res['data'][0].amount;
                        //                 feild['room_id'] = res['data'][0].room_id;
                        //                 // feild['text'] = res['data'][0].room_name;
                        //                 icu_amount=parseFloat(res['data'][0].amount);

                        //             } 
                        //         } else {
                        //             Modal.error({
                        //                 title: 'Error message',
                        //                 content: `${res.message}`,
                        //             });
                        //         }
                        //     });
                        // }catch (error) {
                        //     console.log(error);

                        // }
                        }
                        }
                    })

                    if (!pack) {
                        let qty_for_icu_stay = [
                            { header: 1, key: 1 },
                            { header: 1, key: 2 },
                            { header: 1, key: 3 },
                            { header: 3, key: 0 },
                            { header: 5, key: 0 },
                            { header: 15, key: 1 },
                            { header: 16, key: 0 }
                        ];

                        addonSchema.map((subTable, key) => {
                            qty_for_icu_stay.map((icu_stay, icu_stay_key) => {
                                if (subTable.header === icu_stay.header) {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        if (table_key === icu_stay.key) {
                                            let row = feild.feilds;
                                            let rate;
                                            let qty;
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.row_group === 'dietician') {
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
                                                        qty=total_stay;
                                                    }
                                                }else if (sub_feild.name === 'qty') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val?ele_val:0
                                                    qty= ele_val?ele_val:0
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * rate;
                                                    }
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        })
                         addonSchema.map((subTable, key) => {
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 1) {
                                        let row = feild.feilds;
                                        let qty;
                                        if (feild.key_word === 'icu') {
                                            row.map((sub_feild, sub_table_key) => {

                                                if (sub_feild.name === 'qty') {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val?ele_val:0
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val!==0?icu_amount:0;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(ele_val) * parseFloat(ele_val!==0?icu_amount:0);
                                                    }
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })

                        this.drugaAdminCharges();
                        this.internsivistAndasstInternsivist();
                        if (total_stay != '' && !isNaN(total_stay) && total_stay != undefined && total_stay != null) {
                            medicationDetailsSchema.map((feild, key) => {
                                if (feild['name'] === 'length_of_stay') {
                                    medicationDetailsSchema[key]['value'] = total_stay;
                                }
                            })
                        }
                        console.log('ele_val', ele_val);
                        // this.internsivistAndasstInternsivist(ele_val);
                        //
                        // this.PrimaryConsultantRoomAmount();
                        if(slug==='finanical-counselling'){
                            this.avergaesData()
                        }
                        this.drugaAdminCharges();
                        // this.internsivistAndasstInternsivist();
                        // this.internsivistAndasstInternsivistTwo();
                    }
                    else {

                        
                        addonSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (table_key === 1 || table_key === 2 || table_key === 3) {
                                       if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                    }
                                })
                            })
                        })

                        medicationDetailsSchema.map((feild, key) => {
                            if (feild['name'] === 'length_of_stay') {
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        })
                        this.internsivistAndasstInternsivist();
                    }
                    this.drugaAdminCharges();
                    // this.internsivistAndasstInternsivist();
                    // this.internsivistAndasstInternsivistTwo();
                }

                if (ele_name === 'room_stay') {
                    if (ele_val === '' || ele_val === undefined || ele_val === null || isNaN(ele_val)) {
                        ele_val = 0;
                    }
                    let total_stay = 0;
                    let pack = false;
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'package_name') {
                            if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
                                pack = true;
                            }
                        }
                        if (feild['name'] === 'icu_stay') {
                            if (feild['value'] != '' && feild['value'] != null && feild['value'] != undefined && !isNaN(feild['value'])) {
                                total_stay = parseFloat(ele_val) + parseFloat(feild['value']);
                            }
                            else {
                                total_stay = parseFloat(ele_val);
                            }
                        } 
                        // if (feild['name'] === 'room_opted') {
                        //     feild['value'] = null;
                        //     feild['text'] = null;
                        // }
                        
                    })
                    if (!pack) {
                        let qty_for_room_stay = [{ header: 1 }, { header: 2 }, { header: 4 }, { header: 6 }, { header: 8 }, { header: 9 }, { header: 10 }, { header: 11 }, { header: 12 },{ header: 15 }, { header: 16 }];

                        addonSchema.map((subTable, key) => {
                            qty_for_room_stay.map((room_stay, room_stay_key) => {
                                if (subTable.header === room_stay.header) {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        let row = feild.feilds;
                                        let rate;
                                        let qty
                                        if (table_key === 0) {
                                            if (feild.key_word !== 'intensivist') {
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild.table === 'general_equipment_charges' || sub_feild.table === 'ot_equipment' || sub_feild.table === 'procedure_charges' || sub_feild.table === 'blood_bank_charges' || sub_feild.table === 'ot_cath_pharmacy' || sub_feild.table === 'ot_charges') {
                                                        if (sub_feild.name === 'qty') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                            qty = 1;
                                                        }
                                                    } else if (sub_feild.row_group === 'dietician') {
                                                        if (sub_feild.name === 'qty') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
                                                            qty = total_stay;
                                                        }

                                                    }
                                                    else {
                                                        if (sub_feild.name === 'qty') {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val;
                                                            qty = ele_val;
                                                        }
                                                    }

                                                    if (sub_feild.name === 'rate') {
                                                        rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    }
                                                    if (sub_feild.name === 'amount') {
                                                        if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * rate;
                                                        }
                                                    }
                                                })
                                            }

                                        }
                                        if (table_key === 1) {
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.table === 'physiotherapy_diet_charges' || sub_feild.table === 'ot_charges') {
                                                    if (sub_feild.name === 'qty') {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                    }
                                                    if (sub_feild.name === 'rate') {
                                                        rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    }
                                                    if (sub_feild.name === 'amount') {
                                                        if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(ele_val) * rate;
                                                        }
                                                    }
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        })
                        this.drugaAdminCharges();
                        if (total_stay != '' && !isNaN(total_stay) && total_stay != undefined && total_stay != null) {
                            medicationDetailsSchema.map((feild, key) => {
                                if (feild['name'] === 'length_of_stay') {
                                    medicationDetailsSchema[key]['value'] = total_stay;
                                }
                            })
                        }
                    }
                    else {
                        addonSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                if (table_key === 0) {
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                    })
                                }
                            })
                        })

                        medicationDetailsSchema.map((feild, key) => {
                            if (feild['name'] === 'length_of_stay') {
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        })
                    }
                    this.drugaAdminCharges();
                    if(slug==='finanical-counselling'){
                            this.avergaesData()
                    }
                }

                if (ele_name === 'room_opted') {
                    let pack = false;
                    let room_amount,icu_amount;
                    let amount,icu_stay,room_stay;
                    let estimate_id=0
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name']=='estimate_type'){
                            estimate_id=feild.value;
                        }
                        if (feild.name === 'icu_stay') {
                            icu_stay=medicationDetailsSchema[key]['value']  
                        }
                        if(feild.name === 'room_stay'){
                            room_stay=medicationDetailsSchema[key]['value'];
                        }
                        if (feild['name'] === 'icu_opted') {
                            icu_amount=parseFloat(medicationDetailsSchema[key]['amount']);
                            let user_data = JSON.parse(Storage.get('user_data'));
                            let user_unit_id = user_data.unitid;
                        //     try{
                        //     postService('getInsuranceNonPackageRoomsByUnitId', 'POST', { "data": { "unit_id": user_unit_id, "payment_type":1, "tariff_id": "TR1", "room_type": 1 } }).then(res => {
                        //         if (res['status']) {
                        //             if(res['data'].length>0){
                        //                 feild['value'] = res['data'][0].id;
                        //                 // feild_data['error'] = error;
                        //                 feild['amount'] = res['data'][0].amount;
                        //                 feild['room_id'] = res['data'][0].room_id;
                        //                 // feild['text'] = res['data'][0].room_name;
                        //                 icu_amount=parseFloat(res['data'][0].amount);
                        //             } 
                        //         } else {
                        //             Modal.error({
                        //                 title: 'Error message',
                        //                 content: `${res.message}`,
                        //             });
                        //         }
                        //     });
                        // }catch (error) {
                        //     console.log(error);

                        // }
                            
                          
                        }
                    })
                    if(estimate_id==1){
                        additionalPackageSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            additionalPackageSchema[key].Specification.add_more = true;
                            // table_body.length=0;
                        })
                        // additionalPackageSchema[0]['visible'] = true;
                    }
                    if(estimate_id==1 || estimate_id==2){
                    additionalProcedureSchema.map((subTable, key) => {
                        let table_body = subTable.Specification.table_body;
                        additionalProcedureSchema[key].Specification.add_more = true;
                        table_body.length=0;
                    })
                    additionalProcedureSchema[0]['visible'] = false;
                    console.log('additionalProcedureSchema3',additionalProcedureSchema)
                }
                    addonSchema.map((subTable, key) => {
                        let table_name = subTable.name
                        addonSchema[key].header_amount = 0;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                // if(sub_feild.element === 'input' || sub_feild.element === 'select'){
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                // }

                                // if (table_name === 'room_charges') {
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                if (table_name === 'room_investigation_charges') {
                                    addonSchema[key].Specification.add_more = true;
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'Routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        // if (sub_feild.name === 'qty') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'room_highend_investigations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'icu_investigation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'Routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        // if (sub_feild.name === 'qty') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_highend_investigations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ip_pharmacy_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        // if (sub_feild.name === 'qty') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'room_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'icu_pharmacy_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        // if (sub_feild.name === 'qty') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_cath_pharmacy') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        // if (sub_feild.name === 'qty') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_cath_highend_drugs_implants') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'general_equipment_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        // if (sub_feild.name === 'general_highend_equipments') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        // }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'general_highend_equipments') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_charges') {

                                    if (feild.key_word === 'ot_inst_disinfec') {
                                        if (sub_feild.name === 'ot_inst_disinfec') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        }

                                    }
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_hours') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'ot_equipment') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'ot_equipments') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'procedure_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'surgery_procedure_name') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        // if (sub_feild.name === 'action') {
                                        //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        // }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'blood_bank_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'blood_components') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true ;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'cross_consultation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'dept_for_corss_consultations') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                }
                                if (table_name === 'hospital_services') {
                                    if (feild.key_word === 'mrd') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'Ward_consumables') {
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'seropositive') {
                                        if (sub_feild.name === 'seropositive') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }
                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                if (table_name === 'isolation_charges') {
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'room_isolation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = room_stay;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = room_stay;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'icu_isolation_charges') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = icu_stay;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = icu_stay;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                }
                                if (table_name === 'physiotherapy_diet_charges') {
                                    if (feild.key_word === 'dietician') {
                                        if (sub_feild.name === 'dietician') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = icu_stay+room_stay;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = icu_stay+room_stay;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'routine') {
                                        if (sub_feild.name === 'routine') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['tooltip'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = 1;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = 1;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                    }
                                    if (feild.key_word === 'highend') {
                                        if (sub_feild.name === 'physiotherapys') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                        }
                                        if (sub_feild.name === 'action') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['element'] = 'action';
                                        }


                                    }
                                    if (feild.key_word === 'add_more') {
                                        addonSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                }
                                // if (table_name === 'intensivist') {
                                //     if ( feild.key_word==='asst_intensivist'){
                                //     // if (sub_feild.name === 'qty') {
                                //     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     // }
                                //     if (sub_feild.name === 'rate') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                // }
                                // if (table_name === 'surgical_charges') {
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'percentage') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                                // if (table_name === 'medical_charges') {
                                //     if (sub_feild.name === 'qty') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'percentage') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                //     if (sub_feild.name === 'amount') {
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                //         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                //     }
                                // }
                            })
                        })
                    })
                   
                  
                    this.setState((state) => ({ addonSchema: addonSchema,additionalPackageSchema:additionalPackageSchema,additionalProcedureSchema:additionalProcedureSchema }),()=>{
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'package_name') {
                            if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
                                pack = true;
                                additionalPackageSchema.map((subTable, key) => {
                                    let table_body = subTable.Specification.table_body;
                                    subTable.visible=true;
                                    additionalPackageSchema[key].Specification.add_more = true;
                                    table_body.map((feild, table_key) => {
                                        if (table_body.length > 0) {
                                            let row = feild.feilds;
                                            row.map((sub_feild, sub_table_key) => {
                                                if ( sub_feild.element === 'select'  && sub_feild.value!==null && sub_feild.value!=='' && sub_feild.value!==undefined) {
                                                    const { getCashPackagePricesById } = networkList;
                                                    let user_data = JSON.parse(Storage.get('user_data'));
                                                    let user_unit_id = user_data.unitid;
                                                    let value=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'];
                                                    let text=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'];
                                                    let table=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['table'];
                                                    let row_group=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['row_group'];
                                                    let id=  additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['id'];
                                                    let room_id, room_value = 0;
                                                    postService(getCashPackagePricesById, 'POST', { "data": { "package_id": value, "unit_id": user_unit_id, "tariff_id": "TR1"  } }).then(res => {
                                                        if (res['status']) {
                                                            medicationDetailsSchema.map((feild, key) => {
                                                                if (feild['name'] === 'room_opted') {
                                                                    room_id = feild['room_id'];
                                                                    room_value = feild['value'];
                                                                }
                                                            })
                            
                                                            if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                                                                res.data.map((feild, key) => {
                                                                    if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                                                        amount = feild.amount;
                            
                                                                        additionalPackageSchema.map((subTable, key) => {
                                                                            if (subTable.name === table) {
                                                                                let table_body = subTable.Specification.table_body;
                                                                                table_body.map((feild, table_key) => {
                                                                                    let row = feild.feilds;
                                                                                    row.map((sub_feild, sub_table_key) => {
                                                                                        if(sub_feild.name === "additional_package_name" && sub_feild.row_group ===row_group && sub_feild.id === id){
                                                                                            additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true;
                                                                                        }
                                                                                        if (sub_feild.name === "amount" && sub_feild.row_group === row_group && sub_feild.id === id) {
                                                                                            if (amount === undefined) { amount = 0; }
                                                                                            additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                                                                                            this.setState({ additionalPackageSchema: additionalPackageSchema });
                                                                                            this.getExcludesIncludes(parseInt(value), text,1);
                                                                                            // this.getExcludesIncludes(pack_id, pack_name, id);
                                                                                            this.total_suming();
                                                                                            // this.PrimaryConsultantRoomAmount();
                                                                                            this.drugaAdminCharges();
                                                                                        }
                                                                                    })
                                                                                })
                                                                            }
                                                                        })
                                                                    }
                                                                })
                                                            }
                                                            else {
                                                                Modal.error({
                                                                    title: 'Error message',
                                                                    content: 'No amount for the selected room',
                                                                });
                                                            }
                                                        } else {
                                                            this.setState((state) => ({ 'selet_options': [], fetching: false }));
                                                            Modal.error({
                                                                title: 'Error message',
                                                                content: `${res.message}`,
                                                            });
                                                        }
                                                    });

                                                }
                                            });
                                           
                                               
                                        }
                                    })
                                })
                                additionalProcedureSchema.map((subTable, key) => {
                                    let table_body = subTable.Specification.table_body;
                                    subTable.visible=true;
                                    additionalProcedureSchema[key].Specification.add_more = true;
                                    table_body.map((feild, table_key) => {
                                        if (table_body.length > 0) {
                                            let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    if ( sub_feild.element === 'select' && sub_feild.value!==null && sub_feild.value!==undefined  && sub_feild.value!=='') {
                                                    let user_data = JSON.parse(Storage.get('user_data'));
                                                    let user_unit_id = user_data.unitid;
                                                     let value=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'];
                                                     let text=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'];
                                                     let table=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['table'];
                                                     let row_group=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['row_group'];
                                                     let id=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['id'];
                                                     let room_id, room_value = 0;

                                                     medicationDetailsSchema.map((feild, key) => {
                                                         if (feild['name'] === 'room_opted') {
                             
                                                             room_id = feild['room_id'];
                                                             room_value = feild['value'];
                                                         }
                                                     })
                                                     postService(getInsurancePackagePricesByProcedureName, 'POST', { data: { "procedure_name": text, "unit_id": user_unit_id,tariff_mapped: 1,mode_of_payment:1 } }).then(res => {
                                                        // postService(getServicePricesById, 'POST', { data: { service_id: value } }).then(res => {
                                                            if (res) {
                                                               
                                                                    let amount = 0;
                                                                    if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                                                        let procedure_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                                                        amount = procedure_amount[0].package_charges;
                                                                        // amount = feild.amount;
                            
                                                                        additionalProcedureSchema.map((subTable, key) => {
                                                                            if (subTable.name === table) {
                                                                                let table_body = subTable.Specification.table_body;
                                                                                table_body.map((feild, table_key) => {
                                                                                    let row = feild.feilds;
                                                                                    row.map((sub_feild, sub_table_key) => {
                                                                                        if (sub_feild.name === "amount" && sub_feild.row_group === row_group && sub_feild.id ===id) {
                                                                                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                                                            if (amount === undefined) { amount = 0; }
                                                                                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                                                                                            this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                                                            // this.sumingProcedureAmounts();
                                                                                            this.total_suming();
                                                                                            // this.PrimaryConsultantRoomAmount();
                                                                                        }
                                                                                    })
                                                                                })
                                                                            }
                                                                        })
                                                                    }
                                                            }
                                                            else {
                                                                Modal.error({
                                                                    title: 'Error message',
                                                                    content: 'No amount for the selected room',
                                                                });
                                                            }
                                                        });

                                                     }

                                                })
                                        }
                                    })
                                })
                            }
                        }
                        if(feild['name']==='surgery_procedure_name'){
                            if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
                                additionalProcedureSchema.map((subTable, key) => {
                                    let table_body = subTable.Specification.table_body;
                                    subTable.visible=true;
                                    additionalProcedureSchema[key].Specification.add_more = true;
                                    table_body.map((feild, table_key) => {
                                        if (table_body.length > 0) {
                                            let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    if ( sub_feild.element === 'select' && sub_feild.value!==null) {
                                                        let user_data = JSON.parse(Storage.get('user_data'));
                                                        let user_unit_id = user_data.unitid;
                                                     let value=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'];
                                                     let text=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'];
                                                     let table=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['table'];
                                                     let row_group=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['row_group'];
                                                     let id=  additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['id'];
                                                     let room_id, room_value = 0;

                                                     medicationDetailsSchema.map((feild, key) => {
                                                         if (feild['name'] === 'room_opted') {
                             
                                                             room_id = feild['room_id'];
                                                             room_value = feild['value'];
                                                         }
                                                     })
                                                     postService(getInsurancePackagePricesByProcedureName, 'POST', { data: { "procedure_name": text, "unit_id": user_unit_id,tariff_mapped: 1,mode_of_payment:1 } }).then(res => {
                                                        // postService(getServicePricesById, 'POST', { data: { service_id: value } }).then(res => {
                                                            if (res) {
                                                                
                                                                    let amount = 0;
                                                                    if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                                                        let procedure_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                                                        amount = procedure_amount[0].package_charges;
                                                                        // amount = feild.amount;
                            
                                                                        additionalProcedureSchema.map((subTable, key) => {
                                                                            if (subTable.name === table) {
                                                                                let table_body = subTable.Specification.table_body;
                                                                                table_body.map((feild, table_key) => {
                                                                                    let row = feild.feilds;
                                                                                    row.map((sub_feild, sub_table_key) => {
                                                                                        if (sub_feild.name === "amount" && sub_feild.row_group === row_group && sub_feild.id ===id) {
                                                                                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                                                            if (amount === undefined) { amount = 0; }
                                                                                            additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                                                                                            this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                                                            // this.sumingProcedureAmounts();
                                                                                            this.total_suming();
                                                                                            // this.PrimaryConsultantRoomAmount();
                                                                                        }
                                                                                    })
                                                                                })
                                                                            }
                                                                        })
                                                                    }
                                                            }
                                                            else {
                                                                Modal.error({
                                                                    title: 'Error message',
                                                                    content: 'No amount for the selected room',
                                                                });
                                                            }
                                                        });

                                                     }

                                                })
                                        }
                                    })
                                })
                            }
                        }
                        if (feild['name'] === 'room_opted') {
                            room_amount = parseFloat(medicationDetailsSchema[key]['amount']);
                        }
                        if(feild['name'] === 'icu_stay'){
                            icu_stay=medicationDetailsSchema[key]['value'];
                        }
                        
                        let upgrade_reason = false;
                        if (feild['name'] === 'room_upgrade') {
                            medicationDetailsSchema[key]['disable'] = false;
                            medicationDetailsSchema[key]['value'] = null;
                            // if(medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] !== null && medicationDetailsSchema[key]['value'] !== undefined && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))){
                            //     upgrade_reason = true;
                            // }
                            // if (ele_val != '') {
                            //     medicationDetailsSchema[key]['disable'] = false;
                            // }
                            // else {
                            //     medicationDetailsSchema[key]['disable'] = true;
                            // }
                        }
                        // if (feild['name'] === 'room_upgrade_reason' && upgrade_reason === true ) {
                        if (feild['name'] === 'room_upgrade_reason') {
                            medicationDetailsSchema[key]['disable'] = true;
                            medicationDetailsSchema[key]['value'] = null;
                        }
                        // if (feild['name'] === 'icu_opted') {
                        //     icu_amount = parseFloat(medicationDetailsSchema[key]['amount']);
                        // }
                    })
                    if (!pack) {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 0) {
                                        let row = feild.feilds;
                                        let qty;
                                        if (feild.key_word === 'room') {
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.name === 'qty') {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = room_amount;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(room_amount);
                                                    }
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 1) {
                                        let row = feild.feilds;
                                        let qty;
                                        if (feild.key_word === 'icu') {
                                            row.map((sub_feild, sub_table_key) => {

                                                if (sub_feild.name === 'qty') {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_stay!==0?icu_amount:0;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(icu_stay!==0?icu_amount:0);
                                                    }
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    }
                    else {
                        addonSchema.map((subTable, key) => {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                if (table_key === 0) {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name !== 'action' && sub_feild.name !== 'qty' && sub_feild.name !== 'rate' && sub_feild.name !== 'percentage' && sub_feild.name !== 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null;
                                        }
                                        if (sub_feild.name === 'qty') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                        if (sub_feild.name === 'rate') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                        if (sub_feild.name === 'amount') {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["text"] = null
                                        }
                                    })
                                }
                            })
                        })
                    }
                    let length_of_stay, room_id = null;
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'length_of_stay') {
                            length_of_stay = parseInt(feild['value']);
                        }
                        if (feild['name'] === 'room_opted') {
                            room_id = parseInt(feild['room_id']);
                        }
                    })
                    this.drugaAdminCharges();
                    // this.PrimaryConsultantRoomAmount();
                    if(slug==='finanical-counselling'){
                            this.avergaesData()
                    }
                    // this.internsivistAndasstInternsivist();
                    // if (length_of_stay !== 0 && length_of_stay !== '' && length_of_stay !== null && length_of_stay !== undefined) {
                    //     let user_data = JSON.parse(Storage.get('user_data'));
                    //     let user_unit_id = user_data.unitid;
                    //     postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 14, sub_header_id: 23, tariff_mapped: 1 } }).then(res => {
                    //         if (res.status) {
                    //             if (res.data.length > 1) {
                    //                 let service_id = res.data[0].id;
                    //                 if (length_of_stay > 1) {
                    //                     service_id = res.data[1].id;
                    //                 }

                    //                 postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                    //                     if (response.status) {
                    //                         if (response.data.length > 0) {
                    //                             let amount;
                    //                             let data_value = 0;

                    //                             response.data.map((feild, key) => {
                    //                                 if (feild.room_id === room_id) {
                    //                                     amount = parseFloat(feild.amount);

                    //                                     addonSchema.map((subTable, key) => {
                    //                                         if (subTable.name === 'hospital_services') {
                    //                                             let table_body = subTable.Specification.table_body;
                    //                                             table_body.map((feild, table_key) => {
                    //                                                 // if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
                    //                                                 data_value = 1;
                    //                                                 // }
                    //                                                 let row = feild.feilds;
                    //                                                 if (feild.key_word === 'mrd') {
                    //                                                     row.map((sub_feild, sub_table_key) => {
                    //                                                         if (sub_feild.name === "qty") {
                    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                    //                                                         }

                    //                                                         if (sub_feild.name === "rate") {
                    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                    //                                                         }
                    //                                                         if (sub_feild.name === "amount") {
                    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(1);
                    //                                                         }
                    //                                                     })
                    //                                                 }
                                                                   

                    //                                             })
                    //                                         }
                    //                                     })
                    //                                     this.setState({ addonSchema: addonSchema });
                    //                                     this.total_suming();
                    //                                     // this.sumingProcedureAmounts();
                    //                                 }
                    //                             })
                    //                         }
                    //                         else {
                    //                             Modal.error({
                    //                                 title: 'Error message',
                    //                                 content: 'No amount for the selected room',
                    //                             });
                    //                         }
                    //                     }
                    //                     else {
                    //                         Modal.error({
                    //                             title: 'Error message',
                    //                             content: 'Something went wrong',
                    //                         });
                    //                     }
                    //                 })
                    //             }
                    //             else {
                    //                 Modal.error({
                    //                     title: 'Error message',
                    //                     content: 'No service available',
                    //                 });
                    //             }
                    //         }
                    //         else {
                    //             Modal.error({
                    //                 title: 'Error message',
                    //                 content: 'Something went wrong',
                    //             });
                    //         }
                    //     })

                    //     postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 14, sub_header_id: 41, tariff_mapped: 1 } }).then(res => {
                    //         if (res.status) {
                    //             if (res.data.length!==0) {
                    //                 let service_id = res.data[0].id;
                    //                 postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                    //                     if (response.status) {
                    //                         if (response.data.length > 0) {
                    //                             let amount;
                    //                             let data_value = 0;

                    //                             response.data.map((feild, key) => {
                    //                                 if (feild.room_id === room_id) {
                    //                                     amount = parseFloat(feild.amount);
                    //                                     let total_stays
                    //                                     addonSchema.map((subTable, key) => {
                    //                                         if (subTable.name === 'hospital_services') {
                    //                                             let table_body = subTable.Specification.table_body;
                    //                                             table_body.map((feild, table_key) => {
                    //                                                 // if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
                    //                                                 data_value = 1;
                    //                                                 // }
                    //                                                 let row = feild.feilds;
                                                                   
                    //                                                 if (feild.key_word === 'ward_consumables') {
                    //                                                     row.map((sub_feild, sub_table_key) => {
                    //                                                         if (sub_feild.name === "qty") {
                    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = length_of_stay;
                    //                                                         }

                    //                                                         if (sub_feild.name === "rate") {
                    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                    //                                                         }
                    //                                                         if (sub_feild.name === "amount") {
                    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(length_of_stay);
                    //                                                         }
                    //                                                     })
                    //                                                 }

                    //                                             })
                    //                                         }
                    //                                     })
                    //                                     this.setState({ addonSchema: addonSchema });
                    //                                     this.total_suming();
                    //                                     // this.sumingProcedureAmounts();
                    //                                 }
                    //                             })
                    //                         }
                    //                         else {
                    //                             Modal.error({
                    //                                 title: 'Error message',
                    //                                 content: 'No amount for the selected room',
                    //                             });
                    //                         }
                    //                     }
                    //                     else {
                    //                         Modal.error({
                    //                             title: 'Error message',
                    //                             content: 'Something went wrong',
                    //                         });
                    //                     }
                    //                 })
                    //             }
                    //             else {
                    //                 Modal.error({
                    //                     title: 'Error message',
                    //                     content: 'No service available',
                    //                 });
                    //             }
                    //         }
                    //         else {
                    //             Modal.error({
                    //                 title: 'Error message',
                    //                 content: 'Something went wrong',
                    //             });
                    //         }
                    //     })
                    // }
                    // else {

                    // }
                    this.drugaAdminCharges();
                   
                        this.total_suming();
                        // this.PrimaryConsultantRoomAmount();
                        if(estimate_id==1){
                        additionalPackageSchema[0]['visible'] = true;
                        }
                        if(estimate_id==1 || estimate_id==2){
                            additionalProcedureSchema[0]['visible'] = true;
                        }
                        let This = this;
                        setTimeout(function () {
                            This.setState((state) => ({additionalPackageSchema: additionalPackageSchema,additionalProcedureSchema:additionalProcedureSchema}))
                            This.total_suming();
                                    }, 1000);
                    });
                }

                

                if (ele_name === 'room_upgrade') {
                    medicationDetailsSchema.map((feild, key) => {
                        let upgrade_reason = false;
                        // if (feild['name'] === 'room_upgrade') {
                        //     if(medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] !== null && medicationDetailsSchema[key]['value'] !== undefined && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))){
                        //         upgrade_reason = true;
                        //     }
                        // }
                        // if (feild['name'] === 'room_upgrade_reason' && upgrade_reason !== true ) {
                        if (feild['name'] === 'room_upgrade_reason') {
                            if (ele_val != '') {
                                medicationDetailsSchema[key]['disable'] = false;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                            else {
                                medicationDetailsSchema[key]['disable'] = true;
                                medicationDetailsSchema[key]['value'] = null;
                            }
                        }
                    })
                }

                 if(ele_name === 'icu_opted'){
                    let pack = false;
                    let icu_amount,icu_stay
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'package_name') {
                            if (medicationDetailsSchema[key]['value'] !== '' && medicationDetailsSchema[key]['value'] != undefined && medicationDetailsSchema[key]['value'] != null && !isNaN(parseFloat(medicationDetailsSchema[key]['value']))) {
                                pack = true;
                            }
                        }
                        if(feild['name'] === 'icu_stay'){
                            icu_stay=medicationDetailsSchema[key]['value'];
                        }
                        // if (feild['name'] === 'icu_opted') {
                        //     icu_amount= medicationDetailsSchema[key]['amount']

                        // }
                        if (feild['name'] === 'icu_opted') {
                            icu_amount=parseFloat(medicationDetailsSchema[key]['amount']);
                            // if (ele_val !== '' && ele_val !== undefined && ele_val !== null && !isNaN(ele_val) ) {
                            //     medicationDetailsSchema[key]['amount']=ele_val!==0?11170:0;
                            // medicationDetailsSchema[key]['text']=ele_val!==0?'ICU Bed Charges':null;
                            // medicationDetailsSchema[key]['value']=ele_val!==0?4:null;
                            // medicationDetailsSchema[key]['disable'] = false;
                            // medicationDetailsSchema[key]['room_id']=ele_val!==0?4:null;
                            // }
                            // else {
                            //     medicationDetailsSchema[key]['visible'] = false;
                            //     medicationDetailsSchema[key]['disable'] = true;
                            //     medicationDetailsSchema[key]['value'] = null;
                            //     medicationDetailsSchema[key]['text'] = null;
                            // }
                            if(slug==='finanical-counselling'){
                            let user_data = JSON.parse(Storage.get('user_data'));
                            let user_unit_id = user_data.unitid;
                        //     try{
                        //     // postService('getCashNonPackageRoomsByUnitId', 'POST', { "data": { "unit_id": user_unit_id, "payment_type":1, "tariff_id": 1, "room_type": 1 } }).then(res => {
                        //         postService('getInsuranceNonPackageRoomsByUnitId', 'POST', { "data": { "unit_id": user_unit_id, "payment_type":1, "tariff_id": "TR1", "room_type": 1 } }).then(res => {    
                        //         if (res['status']) {
                        //             if(res['data'].length>0){
                        //                 feild['value'] = res['data'][0].id;
                        //                 // feild_data['error'] = error;
                        //                 feild['amount'] = res['data'][0].amount;
                        //                 feild['room_id'] = res['data'][0].room_id;
                        //                 // feild['text'] = res['data'][0].room_name;
                        //                 icu_amount=parseFloat(res['data'][0].amount);

                        //             } 
                        //         } else {
                        //             Modal.error({
                        //                 title: 'Error message',
                        //                 content: `${res.message}`,
                        //             });
                        //         }
                        //     });
                        // }catch (error) {
                        //     console.log(error);

                        // }
                        }
                        }
                    })
                    if (!pack) {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === 'room_charges') {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    if (table_key === 1) {
                                        let row = feild.feilds;
                                        let qty;
                                        if (feild.key_word === 'icu') {
                                            row.map((sub_feild, sub_table_key) => {

                                                if (sub_feild.name === 'qty') {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
                                                    if (qty === '' && qty === null && qty === undefined && isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === 'rate') {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = icu_amount;
                                                }
                                                if (sub_feild.name === 'amount') {
                                                    if (qty != '' && qty != undefined && qty != null && !isNaN(qty)) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(icu_amount);
                                                    }
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    }

                 }
                if(medicationDetailserrors.length>0){
                    medicationDetailserrors.map((index)=>{
                        medicationDetailsSchema.map((item,key) => {
                    if(item['name']===ele_name && item['id']===index['id']) {
                     document.getElementById("errorm"+item['name']).style.display = "none";
                    }
                    })
                })
                }
                this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema, 'estimateBreakupFormatSchema': estimateBreakupFormatSchema, 'additionalProcedureSchema':  JSON.parse(JSON.stringify(additionalProcedureSchema)), includearrya }), () => {
                    this.total_suming();
                    // this.PrimaryConsultantRoomAmount();
                    let { medicationDetailsSchema } = this.state;
                    let obj = {}
                    medicationDetailsSchema.map((feild, key) => {
                        if (feild['name'] === 'care_management') {
                            obj[feild['name']] = feild['value'];
                        }
                        if (feild['name'] === 'estimate_type') {
                            obj[feild['name']] = feild['value']
                        }
                        if (feild['name'] === 'surgery_procedure_name') {
                            obj[feild['name']] = (feild['selected_option'] && feild['selected_option']['id']) ? feild['selected_option']['id'] : null;
                            obj['service_id'] = feild['text']
                        }
                    })

                    // let Tablebody = JSON.parse(localStorage.getItem('cashPackageSchema'));
                    // console.log('TablebodyLLLL:::', Tablebody,this.state.addonSchema);
                            additionalPackageSchema.map((subTable, key) => {
                                // subTable.Specification.table_body = Tablebody;
                                let table_body = subTable.Specification.table_body;
                                table_body.map((subTable1, key1) => {
                                    let row = subTable1.feilds;
                                    let Amount = this.state.addonSchema[0].Specification.table_body[0].feilds[2].value;
                                    // console.log('total???????????????', total_estimate_amount, Amount)
                                    row.map((subTable3, key2) => {
                                        if(true){
                                            // if(subTable3.name === 'qty'){
                                            //         console.log('subTable3',procedureText);
                                            //     subTable3.value = procedureText;
                                            //     subTable3.text = procedureText;
                                            // }
                                            if (subTable3.name === 'qty') {
                                                subTable3.value = procedureText;
                                                subTable3.text = procedureText;
                                            }
                                            if(subTable3.name === 'rate'){
                                                subTable3.value = 'Package';
                                                subTable3.text = 'Package';
                                            }
                                            if(subTable3.name === 'package_amount'){
                                                
                                                subTable3.value = Amount;
                                                subTable3.text = Amount;
                                            }
                                        }
                                    });
                                });
                            });

                    // console.log('obj', obj, ele_name)

                    if (ele_name === 'care_management' && obj['care_management'] && obj['care_management'] == 1) {
                        this.updateDefaultEstimates(obj);
                        this.getConstantionChagres(obj);
                        if(slug==='finanical-counselling'){
                            this.avergaesData()
                        }
                        // this.PrimaryConsultantRoomAmount();
                        // this.internsivistAndasstInternsivist();
                        
                    } else {
                        if (ele_name === 'surgery_procedure_name' && obj['care_management'] && obj['care_management'] == 2 && obj['estimate_type'] && obj['estimate_type'] == 2 && obj['surgery_procedure_name']) {
                            this.updateDefaultEstimates(obj);
                            this.getConstantionChagres(obj);
                        }
                        if (ele_name === 'surgery_procedure_name' && obj['care_management'] && obj['care_management'] == 2 && obj['estimate_type'] && obj['estimate_type'] == 1 && obj['surgery_procedure_name']) {
                            this.updateDefaultLengthOfStay(obj);
                            // this.getConstantionChagres(obj);
                        }
                    }
                    if (ele_name === 'room_opted' || ele_name === 'room_upgrade') {
                        this.setData();
                        this.getConstantionChagres(obj);
                        if(slug==='finanical-counselling'){
                            this.avergaesData()
                        }
                        // this.PrimaryConsultantRoomAmount();
                        // this.internsivistAndasstInternsivist();
                        // let Tablebody = JSON.parse(localStorage.getItem('cashPackageSchema'));
                        // console.log('TablebodyLLLL:::', Tablebody,this.state.addonSchema[0].Specification.table_body[0].feilds[2].value);
                        //         additionalPackageSchema.map((subTable, key) => {
                        //             subTable.Specification.table_body = Tablebody;
                        //             let table_body = subTable.Specification.table_body;
                        //             table_body.map((subTable1, key1) => {
                        //                 let row = subTable1.feilds;
                        //                 let Amount = this.state.addonSchema[0].Specification.table_body[0].feilds[2].value
                        //                 row.map((subTable3, key2) => {
                        //                     if(true){
                        //                         // if(subTable3.name === 'qty'){
                        //                         //     console.log('subTable3',procedureText);
                        //                         //     subTable3.value = procedureText;
                        //                         // subTable3.text = procedureText;
                        //                         // }
                        //                         if (subTable3.name === 'qty') {
                        //                             return { ...subTable3, value: this.state.procedureText, text: this.state.procedureText };
                        //                         }
                        //                         if(subTable3.name === 'rate'){
                        //                             subTable3.value = 'Package';
                        //                             subTable3.text = 'Package';
                        //                         }
                        //                         if(subTable3.name === 'amount'){
                                                
                        //                             subTable3.value = Amount;
                        //                             subTable3.text = Amount;
                        //                         }
                        //                     }
                        //                 });
                        //             });
                        //         });
                    }
                });
            } break;
        }
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }


    }


    // internsivistAndasstInternsivist(ele_val) {
    //     try {
    //     let { addonSchema } = this.state;
    //     let user_data = JSON.parse(Storage.get('user_data'));
    //     let user_unit_id = user_data.unitid;
    //     let qty_for_icu_stay = [
    //         { header: 1, key: 1 },
    //         { header: 1, key: 2 },
    //         { header: 1, key: 3 },
    //         { header: 3, key: 0 },
    //         { header: 5, key: 0 }];

    //     addonSchema.map((subTable, key) => {
    //         qty_for_icu_stay.map((icu_stay, icu_stay_key) => {
    //             if (subTable.header === icu_stay.header) {
    //                 let table_body = subTable.Specification.table_body;
    //                 table_body.map((feild, table_key) => {
    //                     if (table_key === icu_stay.key) {
    //                         let row = feild.feilds;
    //                         let rate;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name === 'qty') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = ele_val?ele_val:0
    //                             }
    //                             if (sub_feild.name === 'rate') {
    //                                 rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                             }
    //                             if (sub_feild.name === 'amount') {
    //                                 if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(ele_val?ele_val:0) * rate;
    //                                 }
    //                             }
    //                         })
    //                     }
    //                 })
    //             }
    //         })
    //     })
    //     if(ele_val!==0){
    //         Promise.all([
    //             postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 1, sub_header_id: 3, tariff_mapped: 1 } }).then(res => res),
    //             postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 1, sub_header_id: 4, tariff_mapped: 1 } }).then(res => res)
    //         ]).then(([internsivist, asstInternsivist]) => {
    //             if (internsivist.status) {
    //                 if (internsivist.data.length > 0) {
    //                     postService('getServicePricesById', 'POST', { data: { service_id: internsivist.data[0].id } }).then(res => {
    //                         if (res['status']) {
    //                             let room_id, amount;
    //                             // medicationDetailsSchema.map((feild, key) => {
    //                             //     if (feild['name'] === 'room_opted') {
    //                             //         room_id = feild['room_id'];
    //                             //     }
    //                             // })
    
    //                             res.data.map((feild, key) => {
    //                                 if (feild.room_name === 'ICCU') {
    //                                     amount = feild.amount;
    //                                     addonSchema.map((subTable, key) => {
    //                                         if (subTable.header === 1) {
    //                                             let table_body = subTable.Specification.table_body;
    //                                             table_body.map((feild, table_key) => {
    //                                                 if (feild.id === 3) {
    //                                                     let row = feild.feilds;
    //                                                     let qty;
    //                                                     row.map((sub_feild, sub_table_key) => {
    //                                                         if (sub_feild.name === "qty") {
    //                                                             // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
    //                                                             qty = ele_val;
    
    //                                                             if (qty === '' && qty === null && qty === undefined) {
    //                                                                 qty = 0;
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
    //                                                             } else {
    //                                                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
    //                                                             }
    //                                                         }
    //                                                         if (sub_feild.name === "rate") {
    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
    //                                                         }
    //                                                         if (qty !== null && sub_feild.name === "amount") {
    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty?qty:0) * parseFloat(amount);
    //                                                         }
    //                                                     })
    //                                                 }
    //                                             })
    //                                         }
    //                                     })
    //                                     this.setState({ addonSchema: addonSchema });
    //                                     this.total_suming();
    //                                 }
    //                             })
    //                         }
    //                     })
    //                 }
    //             }
    //             if (asstInternsivist.status) {
    //                 postService('getServicePricesById', 'POST', { data: { service_id: asstInternsivist.data[0].id } }).then(res => {
    //                     if (res['status']) {
    //                         let room_id, amount;
    //                         // medicationDetailsSchema.map((feild, key) => {
    //                         //     if (feild['name'] === 'room_opted') {
    //                         //         room_id = feild['room_id'];
    //                         //     }
    //                         // })
    
    //                         res.data.map((feild, key) => {
    //                             if (feild.room_name === 'ICCU') {
    //                                 amount = feild.amount;
    
    //                                 addonSchema.map((subTable, key) => {
    //                                     if (subTable.header === 1) {
    //                                         let table_body = subTable.Specification.table_body;
    //                                         table_body.map((feild, table_key) => {
    //                                             if (feild.id === 4) {
    //                                                 let row = feild.feilds;
    //                                                 let qty;
    //                                                 row.map((sub_feild, sub_table_key) => {
    //                                                     if (sub_feild.name === "qty") {
    //                                                         // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
    //                                                         qty = ele_val;
    //                                                         if (qty === '' && qty === null && qty === undefined) {
    //                                                             qty = 0;
    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
    //                                                         } else {
    //                                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
    //                                                         }
    //                                                     }
    //                                                     if (sub_feild.name === "rate") {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
    //                                                     }
    //                                                     if (qty !== null && sub_feild.name === "amount") {
    //                                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(amount);
    //                                                     }
    //                                                 })
    //                                             }
    //                                         })
    //                                     }
    //                                 })
    //                                 this.setState({ addonSchema: addonSchema });
    //                                 this.total_suming();
    //                             }
    //                         })
    //                     }
    //                 })
    //             }
    //         })
    //     }else{
    //         addonSchema.map((subTable, key) => {
    //             if (subTable.header === 1) {
    //                 let table_body = subTable.Specification.table_body;
    //                 table_body.map((feild, table_key) => {
    //                     if (feild.id === 3) {
    //                         let row = feild.feilds;
    //                         let qty;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name === "qty") {
    //                                 // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
    //                                 qty = ele_val;

    //                                 if (qty === '' && qty === null && qty === undefined) {
    //                                     qty = 0;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
    //                                 } else {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
    //                                 }
    //                             }
                               
    //                             if (qty !== null && sub_feild.name === "amount") {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
    //                             }
    //                         })
    //                     }
    //                     if (feild.id === 4) {
    //                         let row = feild.feilds;
    //                         let qty;
    //                         row.map((sub_feild, sub_table_key) => {
    //                             if (sub_feild.name === "qty") {
    //                                 // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
    //                                 qty = ele_val;
    //                                 if (qty === '' && qty === null && qty === undefined) {
    //                                     qty = 0;
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
    //                                 } else {
    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
    //                                 }
    //                             }
                                
    //                             if (qty !== null && sub_feild.name === "amount") {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 0;
    //                             }
    //                         })
    //                     }
    //                 })
    //             }
    //         }) 
    //     }
        
        
    // } catch (error) {
    //     console.log(error);
    //     this.setState({ 'loadding': false });
    // }
    // }
    buttonClick_submit() {
        let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, preserve_addonSchema, preserve_medicationDetailsSchema, preserve_estimateBreakupFormatSchema, includes_data, includesSchema,medicationDetails, isGenerateSign, generatedLink, digital_sig_imgpath,exclude_slug_fordropdown,patient_digsign_willing } = this.state;
        let { counselling_details,basic_info } = this.props;
        console.log("counselling_details",counselling_details,basic_info)
        this.setState({ error_message: '', error_view: false });
        let estimate_data = [];
        let additional_packages = [];
        let additional_procedures = [];
        let excludes_data = [];
        let temp_obj = {}

        let care_management_name, package_text_name, estimate_name, estimated_admission_date, actual_admission_date, diagnosis, care_management, estimate_type, package_name, length_of_stay, icu_stay, room_stay, date_of_surgery, surgery_procedure_name, room_opted, room_opted_name, room_upgrade, room_upgrade_name, room_upgrade_reason, room_upgrade_reason_name, icu_opted, icu_opted_name, surgery_procedure_amount,procedure_name;

        let room_opted_amount = 0, package_amount = 0;
        let is_package = false;

        // if (generatedLink !== null && digital_sig_imgpath !== null && patient_digsign_willing === true) {
        //     this.handleCheckboxChange();
        // }
        // if (generatedLink === null && digital_sig_imgpath !== null && patient_digsign_willing === true) {
        //     this.handleCheckboxChange();
        // }

        medicationDetailsSchema.map((feild, key) => {
            
            if (feild.name === 'estimated_admission_date') {
                estimated_admission_date = feild.value;
            }
            if (feild.name === 'actual_admission_date') {
                actual_admission_date = feild.value;
            }
            if (feild.name === 'diagnosis') {
                diagnosis = feild.value;
            }
            if (feild.name === 'care_management') {
                care_management = feild.value;
                care_management_name = feild.text
            }
            if (feild.name === 'estimate_type') {
                if (parseInt(feild.value) === 1) { is_package = true }
                estimate_type = feild.value;
                estimate_name = feild.text;
            }
            if (feild.name === 'package_name') {
                package_name = feild.value;
                package_text_name = feild.text;
            }
            // if(feild.name === 'package_amount'){
            //     package_amount = feild.value;
            // }
            if (feild.name === 'length_of_stay') {
                length_of_stay = feild.value;
            }
            if (feild.name === 'icu_stay') {
                icu_stay = feild.value;
            }
            if (feild.name === 'room_stay') {
                room_stay = feild.value;
            }
            if (feild.name === 'date_of_surgery') {
                date_of_surgery = feild.value;
            }
            if (feild.name === 'room_opted') {
                room_opted = feild.room_id;
                room_opted_name = feild.text;
                if (is_package) { 
                    room_opted_amount = feild.amount;
                     package_amount = feild.amount 
                }else{
                    room_opted_amount = feild.amount;
                }
            }
            if (feild.name === 'room_upgrade') {
                room_upgrade = feild.room_id;
                room_upgrade_name = feild.text;
            }
            if (feild.name === 'room_upgrade_reason') {
                room_upgrade_reason = feild.value;
                room_upgrade_reason_name = feild.text;
            }
            if (feild.name === 'icu_opted') {
                icu_opted = feild.room_id;
                icu_opted_name = feild.text;
            }
            if (feild.name === 'surgery_procedure_name') {
                surgery_procedure_name = feild.value;
                procedure_name=feild.text
            }
            if (feild.name === 'surgery_procedure_amount') {
                surgery_procedure_amount = feild.value;
            }
        })
        // let errors = this.validateModalFeilds(diagnosis, estimated_admission_date, care_management, estimate_type, package_name, length_of_stay, room_opted, date_of_surgery)
        let mederror1=[];
       let mederror2=[];
       let mederror3=[];
        let errors1 = this.validateModalFeilds(medicationDetailsSchema);
        let errors2= this.validateModalFeilds(estimateBreakupFormatSchema);
        let errors3= this.validateModalFeilds(signatureSchema["feilds"]);
        if(errors2.length>0){
            this.setState({estimateBreakupFormaterror:errors2})
            errors2.map((item)=>{
                mederror2.push(item[false]);
            });
        }else{
            mederror2.push(true);
            this.setState({estimateBreakupFormaterror:[]})
        }
        if(errors1.length>0){
            this.setState({medicationDetailserrors:errors1})
            errors1.map((item)=>{
                mederror1.push(item[false]);
            });
        }else{
            mederror1.push(true);
            this.setState({medicationDetailserrors:[]})
        }
        if(errors3.length>0){
            errors3.map((item)=>{
                mederror3.push(item[false]);
            });
        }else{
            mederror3.push(true);
        }

        if(mederror1.includes(false)){
            document.getElementById("wizard").scrollTop=0;
        }
        if(mederror2.includes(false)){
            document.getElementById("wizard").scrollToBottom=0;
        }
        addonSchema.map((subTable, key) => {
            console.log('SUBTABLE::::', subTable);
            if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                let table_header = subTable.header;
                let table_body = subTable.Specification.table_body;
                temp_obj[table_header] = subTable.header_amount;
                table_body.map((feild, table_key) => {
                    let service, qty, rate, amount, sub_header;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    if (key_word !== 'ot_hours') {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                // if (sub_table_key === 0) {
                                //     sub_header = parseFloat(sub_feild.sub_header);
                                //     if (sub_feild.element === 'text') {
                                //         service = parseFloat(sub_feild.service);
                                //     }
                                //     else {
                                //         service = parseFloat(sub_feild.value);
                                //     }
                                // }
                                if (sub_table_key === 0) {
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    // if (sub_feild.element === 'text') {
                                    //     service = parseFloat(sub_feild.service);
                                    // }
                                    // else {
                                        service = sub_feild.value;
                                    // }
                                }
                                if (sub_table_key === 1) {
                                    qty = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }
                    else {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    // if (sub_feild.element === 'text') {
                                    //     service = parseFloat(sub_feild.service);
                                    // }
                                    // else {
                                        service = sub_feild.value;
                                    // }
                                }
                                if (sub_table_key === 1) {
                                    service = parseFloat(sub_feild.service);
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    qty = null;
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }

                    let obj = {
                        key_word: key_word,
                        header: table_header,
                        sub_header: sub_header,
                        service: service,
                        qty: qty,
                        rate: rate,
                        amount: amount
                    }

                    // if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                    // if (service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {

                        estimate_data.push(obj);
                    // }
                    // else {
                    //     if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                    //         estimate_data.push(obj);
                    //     }
                    // }
                })
            }
            else {
                if (subTable.visible) {
                    let table_header = subTable.header;
                    let table_body = subTable.Specification.table_body;
                    temp_obj[table_header] = subTable.header_amount;
                    table_body.map((feild, table_key) => {
                        let service, percentage, amount, sub_header;
                        let key_word = feild.key_word;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_table_key === 0) {
                                service = parseFloat(sub_feild.service);
                                sub_header = parseFloat(sub_feild.sub_header);
                            }
                            if (sub_table_key === 1) {
                                percentage = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 2) {
                                amount = parseFloat(sub_feild.value);
                            }
                        })
                        let obj = {
                            key_word: key_word,
                            header: table_header,
                            sub_header: sub_header,
                            service: service,
                            qty: percentage,
                            rate: null,
                            amount: amount
                        }
                        if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                            console.log('OBJ2:::', obj);
                        }
                    })
                }
            }
        })
        let in_payload = [];
        includesSchema.map((subTable, key) => {
            if (subTable.name !== '' && subTable.name !== undefined && subTable.name !== null) {
                let table_body = subTable.Specification.table_body;
                let in_data = []
                table_body.map((feild, table_key) => {
                    let service;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    let service_id, service_nam;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === 'item_service') {
                            service_id = +sub_feild.value;
                            service_nam = sub_feild.title;
                        }

                    })
                    let obj = {
                        'service_id': service_id,
                        'service_nam': service_nam
                    }
                    in_data.push(obj);
                })
                let object = {
                    'package_id': subTable.header,
                    'package_name': subTable.name,
                    'services': in_data
                }
                in_payload.push(object);
            }

        })

        console.log(in_payload);
        console.log(includes_data);
        // let duplicates_estimate_Data = [];
        // estimate_data.map((item) => {
        //     if ((item.key_word === 'add_more' && item.header === 9)) {
        //         duplicates_estimate_Data.push(item);
        //     }
        // }
        // )

        additionalPackageSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let package_id, package_name, amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                package_id = sub_feild.value;
                                package_name = sub_feild.text;
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                            // if(sub_table_key === 2){
                            //     percentage = parseFloat(sub_feild.value);
                            // }
                        }
                    })
                    
                    let obj = {
                        package_id: package_id,
                        package_name: package_name,
                        amount: amount,
                        additional_type: 1
                        // percentage : percentage
                    }
                    
                    if (package_id !== '' && package_id !== null && package_id !== undefined  && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_packages.push(obj);
                    }
                })
            }
        })

        additionalProcedureSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let procedure_id, procedure_name, amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                procedure_id = parseFloat(sub_feild.value);
                                procedure_name = sub_feild.text;
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                            // if (sub_table_key === 2) {
                            //     percentage = parseFloat(sub_feild.value);
                            // }
                        }
                    })
                    let obj = {

                        procedure_id: procedure_id,
                        procedure_name: procedure_name,
                        amount: amount,
                        additional_type: 2
                        // percentage: percentage
                    }
                    if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_procedures.push(obj);
                    }
                })
            }
        })

        if (care_management == 2) {
            if (estimate_type == 1) {
                let table_data = excludesTableStore.getState();
                table_data&&table_data.length>0 &&  table_data.map((body, key) => {
                    let obj = {
                        // "exclude_status":0,
                        "package_id": null,
                        "service_id": null,
                        "service_name": null,
                        "qty": 0,
                        "rate": 0,
                        "amount": 0
                    }

                    body['feilds'].map((feild, feild_key) => {
                        if (feild.name === 'excludes_service_id') {
                                obj = {
                                    "package_id": feild.package_id ? feild.package_id : null,
                                    "service_id": feild.value ? feild.value : null,
                                    "service_name": feild.text ?feild.text: null,
                                }
                        }

                        if (feild.name === 'qty') {
                            obj[feild.name] = feild.value?feild.value:null;
                        }
                        if (feild.name === 'rate') {
                            obj[feild.name] = feild.value?feild.value:null;

                        }
                        if (feild.name === 'amount') {
                            obj[feild.name] = feild.value?feild.value:null;
                        }
                        // }

                    })
                    excludes_data.push(obj);
                })
                if (excludes_data == null || excludes_data.length == 0) {
                    let { excludes_datarecounselling } = this.state;
                    excludes_datarecounselling && excludes_datarecounselling.length>0 && excludes_datarecounselling.map((item,index)=>{
                        item['service_id']=item.service
                    })
                    excludes_data = excludes_datarecounselling;
                }

                if (includes_data.length > 0) {
                    includes_data = includes_data;
                } else {
                    includes_data = [];
                }
            } else {
                includes_data = [];
                excludes_data = [];
            }
        } else {
            includes_data = [];
            excludes_data = [];
        }
        let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified')); 
        let rnTypeResponse = JSON.parse(Storage.get('counselling_view'));
        let payerResponse=null
        if(rnTypeResponse&&rnTypeResponse.length!==0){
            payerResponse = rnTypeResponse[0].rn_payer_response;
        } else {
            payerResponse = null;
        }
        console.log('addonSchema:::::::', this.state.addonSchema[8]['header_amount'], this.state.addonSchema)
        let data = {
           "fc_checklist_verified": patientCheckIn,
            "counselling_date": basic_info['counselling_date'],
            "token_no": basic_info['token_no'],
            "token_display_number": basic_info['token_display_number'],
            "counselling_type_id": basic_info['counselling_type_id'],
            "counsellor_id": basic_info['counsellor_id'],
            "ip_no": basic_info['ip_no'],
            "umr_no": basic_info['umr_no'],
            "patient_name": basic_info['patient_name'],
            "age": basic_info['age'],
            "gender": basic_info['gender'],
            "phone_no": basic_info['phone_no'],
            "marital_status": basic_info['marital_status'],
            "doctor_id": basic_info['doctor_id'],
            "speciality_id": basic_info['speciality_id'],
            "address": basic_info['address'],
            "payment_type": basic_info['payment_type'],
            "comments_data": basic_info['comments_data'],
            "service_id": parseInt(basic_info['service_id']),
            "form_id": basic_info['form_id'],
            "payment_change_reason": basic_info['payment_change_reason'],
            // "whatsapp_phno":basic_info['whatsapp_number'],
            // "token_display_number": 'token',

            "doctor_name": basic_info['doctor_name'],
            "speciality_name": basic_info['speciality_name'],
            "counselling_type_name": basic_info['counselling_type_name'],
            "payment_name": basic_info['payment_name'],
            "care_management_name": care_management_name,
            "estimate_name": estimate_name,
            "package_text_name": package_text_name,
            "package_amt":room_opted_amount,
            "package_id":package_name,

            "estimated_admission_date": estimated_admission_date,
            "actual_admission_date": actual_admission_date,
            "diagnosis": diagnosis,
            "care_management": care_management,
            "estimate_type": estimate_type,
            "package_name": package_name,
            "package_amount": package_amount,
            "length_of_stay": length_of_stay,
            "icu_stay": icu_stay,
            "room_stay": room_stay,
            "date_of_surgery": date_of_surgery,
            "surgery_procedure_name": surgery_procedure_name,
            "room_opted": room_opted,
            "room_opted_name": room_opted_name,
            "room_opted_amount": room_opted_amount,
            "room_upgrade": room_upgrade,
            "room_upgrade_name": room_upgrade_name,
            "room_upgrade_reason": room_upgrade_reason,
            "room_upgrade_reason_name": room_upgrade_reason_name,
            "icu_opted": icu_opted,
            "icu_opted_name": icu_opted_name,
            "surgery_procedure_amount": surgery_procedure_amount,

            "additional_packages": additional_packages,
            "additional_procedures": additional_procedures,

            "excludes_data": excludes_data,
            "includes_data": in_payload,
            // "includes_data": includes_data,
            "base_price": estimateBreakupFormatSchema[0]['value'],
            "excludes": estimateBreakupFormatSchema[1]['value'],
            "total_Estimate_amount": estimateBreakupFormatSchema[2]['value']?estimateBreakupFormatSchema[2]['value']:total_estimate_amount,
            "name_of_the_fc": estimateBreakupFormatSchema[3]['value'],
            "attendant_name": estimateBreakupFormatSchema[4]['value'],
            "patient_relation": estimateBreakupFormatSchema[5]['value'],
            "patient_attender_signature": null,
            "counsellor_signature": null,
            "covid_status":basic_info['covid_status']?basic_info['covid_status']:null,
            "procedure_name":procedure_name,
            'rn_payer_response': payerResponse || null,
            'advance_amount': estimateBreakupFormatSchema[7]['value'],
            // "header_amount": {
            //     "room_charges": addonSchema[0]['header_amount'],
            //     "room_investigation_charges": addonSchema[1]['header_amount'],
            //     "icu_investigation_charges": addonSchema[2]['header_amount'],
            //     "ip_pharmacy_charges": addonSchema[3]['header_amount'],
            //     "icu_pharmacy_charges": addonSchema[4]['header_amount'],
            //     "ot_cath_pharmacy": addonSchema[5]['header_amount'],
            //     "drug_admin_charges": addonSchema[6]['header_amount'],
            //     "general_equipment_charges": addonSchema[7]['header_amount'],
            //     "ot_charges": addonSchema[8]['header_amount'],
            //     "ot_equipment": addonSchema[9]['header_amount'],
            //     "procedure_charges": addonSchema[10]['header_amount'],
            //     "blood_bank_charges": addonSchema[11]['header_amount'],
            //     "cross_consultation_charges": addonSchema[13]['header_amount'],
            //     "hospital_services": addonSchema[13]['header_amount'],
            //     "isolation_charges": addonSchema[14]['header_amount'],
            //     "physiotherapy_diet_charges": addonSchema[15]['header_amount'],
            //     "surgical_charges": addonSchema[17]['header_amount'],
            //     "medical_charges": addonSchema[18]['header_amount']
            // },
            "header_amount": {
                "room_charges": addonSchema[0]['header_amount'],
                "room_investigation_charges": addonSchema[1]['header_amount'],
                "icu_investigation_charges": addonSchema[2]['header_amount'],
                "ip_pharmacy_charges": addonSchema[3]['header_amount'],
                "ot_cath_pharmacy": addonSchema[4]['header_amount'],
                "procedure_charges": addonSchema[5]['header_amount'],
                // "physiotherapy_diet_charges": addonSchema[7]['header_amount'],
                "blood_bank_charges": addonSchema[7]['header_amount'],
                "consultation_charges": addonSchema[8]['header_amount'],
                "surgical_charges": addonSchema[9]['header_amount'],
                "medical_charges": addonSchema[10]['header_amount']
            },
            "estimation": estimate_data,
            "isGenerateSign": isGenerateSign,
            "generatedLink": generatedLink,
        };

        console.log('payload',data)
        console.log('errors3',errors3)

        // if ((!mederror1.includes(false)) && 
        // (!mederror2.includes(false)) && 
        // (!mederror3.includes(false) && 
        // (digital_sig_imgpath))) {
        //     if(exclude_slug_fordropdown ==='finanical-counselling' && (data.fc_checklist_verified === 'no' || data.fc_checklist_verified === null)){
        //         Modal.error({
        //             title: 'Error message',
        //             content: 'Please verify the FC checklist',
        //             onOk: function () {
        //                 window.scrollTo(0, 0);
        //             },
        //             }); 
        //     }else{
        //         this.setState({ 'preview_data': data, 'preview_modal': true,'preview_PatientCheckin_model':true });
        //         console.log("document.getElementById(id)",document.getElementById('previewcash'))
        //         return
        //     }
        // }
        // else if(!mederror1.includes(false) && !mederror2.includes(false) && !mederror3.includes(false) && generatedLink && !digital_sig_imgpath && !patient_digsign_willing){
        //     console.log('generatedLink', digital_sig_imgpath);
        //     Modal.error({
        //         title: 'Unable to process',
        //         content: 'Please Add Digital Signature',
        //     });
        // } 
        // else if(!mederror1.includes(false) && !mederror2.includes(false) && !mederror3.includes(false) && !generatedLink){
        //     Modal.error({
        //         title: 'Unable to process',
        //         content: 'Please Send Link For Digital Signature',
        //     });
        // }
        //////
       
        // if (
        //     !mederror1.includes(false) &&
        //     !mederror2.includes(false) &&
        //     !mederror3.includes(false) 
        // ) {
        //     if (generatedLink) {
        //         if (digital_sig_imgpath !== null || patient_digsign_willing !== false) {
        //             if (exclude_slug_fordropdown === 'finanical-counselling' && (data.fc_checklist_verified === 'no' || data.fc_checklist_verified === null)) {
        //                 Modal.error({
        //                     title: 'Error message',
        //                     content: 'Please verify the FC checklist',
        //                     onOk: function () {
        //                         window.scrollTo(0, 0);
        //                     },
        //                 });
        //             } else {
        //                 // Proceed to the next step
        //                 this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
        //                 console.log("document.getElementById(id)", document.getElementById('previewcash'));
        //             }
        //         } else {
        //             Modal.error({
        //                 title: 'Unable to process',
        //                 content: 'Please Add Digital Signature/Patient unwilling',
        //             });
        //         }
        //     } else {
        //         Modal.error({
        //             title: 'Unable to process',
        //             content: 'Please Send Link For Digital Signature',
        //         });
        //     }
        // } else {
        //     // Modal.error({
        //     //     title: 'Unable to process',
        //     //     content: 'Oops something went wrong',
        //     // });
        // }



        // if (
        //     !mederror1.includes(false) &&
        //     !mederror2.includes(false) &&
        //     !mederror3.includes(false)
        // ) {
        //     if (exclude_slug_fordropdown === 'finanical-counselling' && (data.fc_checklist_verified === 'no' || data.fc_checklist_verified === null)) {
        //         Modal.error({
        //             title: 'Error message',
        //             content: 'Please verify the FC checklist',
        //             onOk: function () {
        //                 window.scrollTo(0, 0);
        //             },
        //         });
        //     }  else if (digital_sig_imgpath !== null && patient_digsign_willing !== true) {
        //         // Proceed to the next step
        //         this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
        //         console.log("document.getElementById(id)", document.getElementById('previewcash'));
        //     } else if (digital_sig_imgpath === null && patient_digsign_willing !== false) {
        //         // Proceed to the next step
        //         this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
        //         console.log("document.getElementById(id)", document.getElementById('previewcash'));
        //     } else if (generatedLink === null && digital_sig_imgpath === null && patient_digsign_willing !== true) {
        //         Modal.error({
        //             title: 'Unable to process',
        //             content: 'Please Add Digital Signature/Patient unwilling',
        //         });
        //     }
        // } else {
        //                   Modal.error({
        //                 title: 'Unable to process',
        //                 content: 'Please Add Digital Signature',
        //             });
        // }

        
        // if (
        //     !mederror1.includes(false) &&
        //     // !mederror2.includes(false)
        //     !mederror3.includes(false)
        // )
        if (true)
         {
            if (exclude_slug_fordropdown === 'finanical-counselling' && (data.fc_checklist_verified === 'no' || data.fc_checklist_verified === null)) {
                Modal.error({
                    title: 'Error message',
                    content: 'Please verify the FC checklist',
                    onOk: function () {
                        window.scrollTo(0, 0);
                    },
                });
            } 
            else{
                this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            }
            // else if (generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing !== true) {
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please Add Digital Signature or check Patient unwilling/unavailable Checkbox',
            //     });
            // } 
            // else if (generatedLink !== null && digital_sig_imgpath !== null && (patient_digsign_willing === true ||  patient_digsign_willing === "yes")) {
            //     console.log('patient_digsign_willing', patient_digsign_willing);
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please uncheck Patient unwilling',
            //     });
            // } 
            // else if (digital_sig_imgpath !== null && patient_digsign_willing !== true) {
            //     this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            //     console.log("document.getElementById(id)", document.getElementById('previewcash'));
            // } else if (digital_sig_imgpath === null && patient_digsign_willing !== false) {
            //     this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            //     console.log("document.getElementById(id)", document.getElementById('previewcash'));
            // } 
            // else if (generatedLink === null && digital_sig_imgpath !== null && patient_digsign_willing !== false) {
            //     this.setState({ 'preview_data': data, 'preview_modal': true, 'preview_PatientCheckin_model': true });
            //     console.log("document.getElementById(id)", document.getElementById('previewcash'));
            // }
            // else if (generatedLink === null && digital_sig_imgpath === null && patient_digsign_willing !== true) {
            //     Modal.error({
            //         title: 'Unable to process',
            //         content: 'Please Send Digital Signature or Check Patient unwilling/unavailable',
            //     });
            // }
        } 
    }

    preview_submit() {
        // this.final_submit()
        // this.setState({signatureModal: true});
        let generatedLink = this.generateLink()
        this.setState({signatureModal: true, generatedLink})

        // const {signatureSchema, } = this.state;
        // confirm({
        //     title: 'Do you need patient digital signature ?',
        //     icon: <ExclamationCircleFilled />,
        //     content: 
        //         <div className="row">
        //             {signatureSchema.map((feild, fei_key) => {
        //                 if(feild["name"] === "phonenumber"){
        //                     return (
        //                         <div>
        //                             <label className="data-label w-100 mb-1 pt-2">{feild["title"]}</label>
        //                             <Input value={feild["value"]} maxLength={10} onChange={(e) => this.onChange(e)} />
        //                         </div>
        //                     )
        //                 }
        //             })}
        //         </div>,
        //     onOk: () => this.onChangeGenerateSign("yes"),
        //     onCancel: () => this.onChangeGenerateSign("no"),
        //     okText: 'Yes',
        //     cancelText: 'No',
        //     zIndex: 2000,
        // });
    }

    final_submit() {
        try {
        this.setState({ loadding: true,finalSubmit:true }); 
        let { procedureText,procedureCode,procedureValue,addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, preserve_addonSchema, preserve_medicationDetailsSchema, preserve_estimateBreakupFormatSchema, includes_data, includesSchema,medicationDetails, isGenerateSign, generatedLink, signatureSchema, } = this.state;
        let { counselling_details,basic_info } = this.props;
        console.log("counselling_details",counselling_details,basic_info['phone_no'], this.props, this.state.preview_data.phone_no);
        // let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema } = this.state;
        this.setState({ error_message: '', error_view: false });
        let estimate_data = [];
        let additional_packages = [];
        let additional_procedures = [];
        let excludes_data = [];
        let temp_obj = {}

        let care_management_name, estimate_name, estimated_admission_date, actual_admission_date, diagnosis, care_management, estimate_type, package_name, length_of_stay, icu_stay, room_stay, date_of_surgery, surgery_procedure_name, room_opted, room_opted_name, room_upgrade, room_upgrade_name, room_upgrade_reason, room_upgrade_reason_name, icu_opted, icu_opted_name, surgery_procedure_amount;

        let room_opted_amount = 0, package_amount = 0;
        let is_package = false;

        medicationDetailsSchema.map((feild, key) => {
            
            if (feild.name === 'estimated_admission_date') {
                estimated_admission_date = feild.value;
            }
            if (feild.name === 'actual_admission_date') {
                actual_admission_date = feild.value;
            }
            if (feild.name === 'diagnosis') {
                diagnosis = feild.value;
            }
            if (feild.name === 'care_management') {
                care_management = feild.value;
                care_management_name = feild.text
            }
            if (feild.name === 'estimate_type') {
                if (parseInt(feild.value) === 1) { is_package = true }
                estimate_type = feild.value;
                estimate_name = feild.text;
            }
            if (feild.name === 'package_name') {
                package_name = feild.value;
            }
            // if(feild.name === 'package_amount'){
            //     package_amount = feild.value;
            // }
            if (feild.name === 'length_of_stay') {
                length_of_stay = feild.value;
            }
            if (feild.name === 'icu_stay') {
                icu_stay = feild.value;
            }
            if (feild.name === 'room_stay') {
                room_stay = feild.value;
            }
            if (feild.name === 'date_of_surgery') {
                date_of_surgery = feild.value;
            }
            if (feild.name === 'room_opted') {
                room_opted = feild.room_id;
                room_opted_name = feild.text;
                if (is_package) { room_opted_amount = feild.amount;
                     package_amount = feild.amount
                     }else{
                        room_opted_amount = feild.amount; 
                     }
            }
            if (feild.name === 'room_upgrade') {
                room_upgrade = feild.room_id;
                room_upgrade_name = feild.text;
            }
            if (feild.name === 'room_upgrade_reason') {
                room_upgrade_reason = feild.value;
                room_upgrade_reason_name = feild.text;
            }
            if (feild.name === 'icu_opted') {
                icu_opted = feild.room_id;
                icu_opted_name = feild.text;
            }
            if (feild.name === 'surgery_procedure_name') {
                surgery_procedure_name = feild.value;
            }
            if (feild.name === 'surgery_procedure_amount') {
                surgery_procedure_amount = feild.value;
            }
        })

        // let errors = this.validateModalFeilds(diagnosis, estimated_admission_date, care_management, estimate_type, package_name, length_of_stay, room_opted, date_of_surgery)
        let mederror1=[];
        let errors1 = this.validateModalFeilds(medicationDetailsSchema);
        if(errors1.length>0){
            this.setState({medicationDetailserrors:errors1})
            errors1.map((item)=>{
                mederror1.push(item[false]);
            });
        }else{
            mederror1.push(true);
            this.setState({medicationDetailserrors:[]})
        }

        if(mederror1.includes(false)){
            document.getElementById("wizard").scrollTop=0;
        }
        addonSchema.map((subTable, key) => {
            if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                let table_header = subTable.header;
                let table_body = subTable.Specification.table_body;
                temp_obj[table_header] = subTable.header_amount;
                table_body.map((feild, table_key) => {
                    let service, qty, rate, amount, sub_header;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    if (key_word !== 'ot_hours') {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    // if (sub_feild.element === 'text') {
                                    //     service = parseFloat(sub_feild.service);
                                    // }
                                    // else {
                                        service = sub_feild.value;
                                    // }
                                }
                                if (sub_table_key === 1) {
                                    qty = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }
                    else {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') 
                                {
                                if (sub_table_key === 0) {
                                            sub_header = parseFloat(sub_feild.sub_header);
                                            // if (sub_feild.element === 'text') {
                                            //     service = parseFloat(sub_feild.service);
                                            // }
                                            // else {
                                                service = sub_feild.value;
                                            // }
                                        }
                                if (sub_table_key === 1) {
                                    service = parseFloat(sub_feild.service);
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    qty = null;
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }

                    let obj = {
                        key_word: key_word,
                        header: table_header,
                        sub_header: sub_header,
                        service: service,
                        qty: qty,
                        rate: rate,
                        amount: amount
                    }

                    // if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                    // if (service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {

                        estimate_data.push(obj);
                        console.log('OBJJJJ::', obj, this.state);
                    // }
                    // else {
                    //     if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                    //         estimate_data.push(obj);
                    //     }
                    // }
                })
            }
            else {
                if (subTable.visible) {
                    let table_header = subTable.header;
                    let table_body = subTable.Specification.table_body;
                    temp_obj[table_header] = subTable.header_amount;
                    table_body.map((feild, table_key) => {
                        let service, percentage, amount, sub_header;
                        let key_word = feild.key_word;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_table_key === 0) {
                                service = parseFloat(sub_feild.service);
                                sub_header = parseFloat(sub_feild.sub_header);
                            }
                            if (sub_table_key === 1) {
                                percentage = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 2) {
                                amount = parseFloat(sub_feild.value);
                            }
                        })
                        let obj = {
                            key_word: key_word,
                            header: table_header,
                            sub_header: sub_header,
                            service: service,
                            qty: percentage,
                            rate: null,
                            amount: amount
                        }
                        if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                            console.log('OBJJJJ2::', obj, this.state);
                        }
                    })
                }
            }
        })
        let in_payload = [];
        includesSchema.map((subTable, key) => {
            if (subTable.name !== '' && subTable.name !== undefined && subTable.name !== null) {
                let table_body = subTable.Specification.table_body;
                let in_data = []
                table_body.map((feild, table_key) => {
                    let service;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    let service_id, service_nam;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === 'item_service') {
                            service_id = +sub_feild.value;
                            service_nam = sub_feild.title;
                        }

                    })
                    let obj = {
                        'service_id': service_id,
                        'service_nam': service_nam
                    }
                    in_data.push(obj);
                 
                })
                let object = {
                    'package_id': subTable.header,
                    'package_name': subTable.name,
                    'services': in_data
                }
                in_payload.push(object);

            }

        })
        console.log('in_payload', in_payload);
        // let duplicates_estimate_Data = [];
        // estimate_data.map((item) => {
        //     if ((item.key_word === 'add_more' && item.header === 9)) {
        //         duplicates_estimate_Data.push(item);
        //     }
        // }
        // )

        additionalPackageSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let package_id, amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                package_id = sub_feild.value;
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                            // if(sub_table_key === 2){
                            //     percentage = parseFloat(sub_feild.value);
                            // }
                        }
                    })
                    let obj = {
                        package_id: package_id,
                        amount: amount,
                        additional_type: 1
                        // percentage : percentage
                    }

                    if (package_id !== '' && package_id !== null && package_id !== undefined && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_packages.push(obj);
                    }
                })
            }
        })

        additionalProcedureSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let procedure_id, amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                procedure_id = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                            // if (sub_table_key === 2) {
                            //     percentage = parseFloat(sub_feild.value);
                            // }
                        }
                    })
                    let obj = {

                        procedure_id: procedure_id,
                        amount: amount,
                        additional_type: 2
                        // percentage: percentage
                    }
                    if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_procedures.push(obj);
                    }
                })
            }
        })

        if (care_management == 2) {
            if (estimate_type == 1) {
                let table_data = excludesTableStore.getState();

                table_data  &&table_data.length>0 &&  table_data.map((body, key) => {
                    let obj = {
                        "package_id": null,
                        "service_id": null,
                        "service_name": null,
                        "qty": 0,
                        "rate": 0,
                        "amount": 0
                    }

                    body['feilds'].map((feild, feild_key) => {

                        if (feild.name === 'excludes_service_id') {
                                obj = {
                                    "package_id": feild.package_id ? feild.package_id : null,
                                    "service_id": feild.value ? feild.value : null,
                                    "service_name": feild.text ?feild.text: null,
                                }
                        }

                        if (feild.name === 'qty') {
                            obj[feild.name] = feild.value;
                        }
                        if (feild.name === 'rate') {
                            obj[feild.name] = feild.value;

                        }
                        if (feild.name === 'amount') {
                            obj[feild.name] = feild.value;
                        }

                    })
                    excludes_data.push(obj);
                })
                if (excludes_data == null || excludes_data.length == 0) {
                    let { excludes_datarecounselling } = this.state;
                    excludes_datarecounselling && excludes_datarecounselling.length>0 && excludes_datarecounselling.map((item,index)=>{
                        item['service_id']=item.service
                    })
                    excludes_data = excludes_datarecounselling;
                }

                if (includes_data.length > 0) {
                    includes_data = includes_data;
                } else {
                    includes_data = [];
                }
            } else {
                includes_data = [];
                excludes_data = [];
            }
        } else {
            includes_data = [];
            excludes_data = [];
        }
        let patient_Willing = this.state.patient_digsign_willing;
        let patient_willing = patient_Willing === true ? 'yes' : 'no';
        let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified'));
        let rnTypeResponse = JSON.parse(Storage.get('counselling_view'));
        let counsellerName = JSON.parse(Storage.get('user_data'));
        let payerResponse=null
        if(rnTypeResponse&&rnTypeResponse.length!==0){
            payerResponse = rnTypeResponse[0].rn_payer_response;
        } else {
            payerResponse = null;
        }

        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let data = {
            "patient_unwilling": patient_willing,
            "fc_checklist_verified": patientCheckIn,
            "counselling_date": basic_info['counselling_date'],
            "token_no": basic_info['token_no'],
            "token_display_number": basic_info['token_display_number'],
            "counselling_type_id": basic_info['counselling_type_id'],
            "counsellor_id": basic_info['counsellor_id'],
            "ip_no": basic_info['ip_no'],
            "umr_no": basic_info['umr_no'],
            "patient_name": basic_info['patient_name'],
            "age": basic_info['age'],
            "gender": basic_info['gender'],
            "phone_no": basic_info['phone_no'],
            "marital_status": basic_info['marital_status'],
            "doctor_id": basic_info['doctor_id'],
            "speciality_id": basic_info['speciality_id'],
            "address": basic_info['address'],
            "payment_type": basic_info['payment_type'],
            "comments_data": basic_info['comments_data'],
            "service_id": parseInt(basic_info['service_id']),
            "form_id": basic_info['form_id'],
            "payment_change_reason": basic_info['payment_change_reason'],
            'package_id':package_name,
            "token_is_icu":basic_info['token_is_icu'],
            "token_doctor_id":basic_info['token_doctor_id'],
            "token_doctor_name":basic_info['token_doctor_name'],
            "token_doctor_speciality":basic_info['token_doctor_speciality'],
            // "whatsapp_phno":basic_info['whatsapp_number'],
            // "token_display_number": 'token',

            "doctor_name": basic_info['doctor_name'],
            "speciality_name": basic_info['speciality_name'],
            "counselling_type_name": basic_info['counselling_type_name'],
            "payment_name": basic_info['payment_name'],
            "care_management_name": care_management_name,
            "estimate_name": estimate_name,

            "estimated_admission_date": estimated_admission_date,
            "actual_admission_date": actual_admission_date,
            "diagnosis": diagnosis,
            "care_management": care_management,
            "estimate_type": estimate_type,
            "package_name": package_name,
            "package_amount": package_amount,
            "length_of_stay": length_of_stay,
            "icu_stay": icu_stay,
            "room_stay": room_stay,
            "date_of_surgery": date_of_surgery,
            // "surgery_procedure_name": surgery_procedure_name,
            "surgery_procedure_name": procedureValue ? procedureValue : medicationDetailsSchema[4]['value'],
            "surgery_procedure_id": procedureValue ? procedureValue : medicationDetailsSchema[4]['value'],
            "tariff_mapped": 'TR1',
            "unit_id": user_unit_id,
            "room_opted": room_opted,
            "room_opted_name": room_opted_name,
            "room_opted_amount": room_opted_amount,
            "room_upgrade": room_upgrade,
            "room_upgrade_name": room_upgrade_name,
            "room_upgrade_reason": room_upgrade_reason,
            "room_upgrade_reason_name": room_upgrade_reason_name,
            "icu_opted": icu_opted,
            "icu_opted_name": icu_opted_name,
            "surgery_procedure_amount": surgery_procedure_amount,

            "additional_packages": additional_packages,
            "additional_procedures": additional_procedures,

            "excludes_data": excludes_data,
            "includes_data": in_payload,
            // "includes_data": includes_data,
            "base_price": estimateBreakupFormatSchema[0]['value'],
            "excludes": estimateBreakupFormatSchema[1]['value'],
            "total_Estimate_amount": estimateBreakupFormatSchema[2]['value'],
            "name_of_the_fc": estimateBreakupFormatSchema[3]['value'],
            "attendant_name": estimateBreakupFormatSchema[4]['value'],
            "patient_relation": estimateBreakupFormatSchema[5]['value'],
            "patient_attender_signature": null,
            "counsellor_signature": null,
            "covid_status":basic_info['covid_status']?basic_info['covid_status']:null,
            "remarks":estimateBreakupFormatSchema[6].value,
            'rn_payer_response': payerResponse || null,
            'advance_amount': estimateBreakupFormatSchema[7]['value'],
            // "header_amount": {
            //     "room_charges": addonSchema[0]['header_amount'],
            //     "room_investigation_charges": addonSchema[1]['header_amount'],
            //     "icu_investigation_charges": addonSchema[2]['header_amount'],
            //     "ip_pharmacy_charges": addonSchema[3]['header_amount'],
            //     "icu_pharmacy_charges": addonSchema[4]['header_amount'],
            //     "ot_cath_pharmacy": addonSchema[5]['header_amount'],
            //     "drug_admin_charges": addonSchema[6]['header_amount'],
            //     "general_equipment_charges": addonSchema[7]['header_amount'],
            //     "ot_charges": addonSchema[8]['header_amount'],
            //     "ot_equipment": addonSchema[9]['header_amount'],
            //     "procedure_charges": addonSchema[10]['header_amount'],
            //     "blood_bank_charges": addonSchema[11]['header_amount'],
            //     "cross_consultation_charges": addonSchema[12]['header_amount'],
            //     "hospital_services": addonSchema[13]['header_amount'],
            //     "isolation_charges": addonSchema[14]['header_amount'],
            //     "physiotherapy_diet_charges": addonSchema[15]['header_amount'],
            //     "surgical_charges": addonSchema[16]['header_amount'],
            //     "medical_charges": addonSchema[17]['header_amount']
            // },
            // "header_amount": {
            //     "room_charges": addonSchema[0]['header_amount'],
            //     "room_investigation_charges": addonSchema[1]['header_amount'],
            //     "icu_investigation_charges": addonSchema[2]['header_amount'],
            //     "ip_pharmacy_charges": addonSchema[3]['header_amount'],
            //     "ot_cath_pharmacy": addonSchema[4]['header_amount'],
            //     "procedure_charges": addonSchema[5]['header_amount'],
            //     "blood_bank_charges": addonSchema[7]['header_amount'],
            //     "ins_consultation_charges": addonSchema[8]['header_amount'],
            //     "surgical_charges": addonSchema[8]['header_amount'],
            //     "medical_charges": addonSchema[9]['header_amount']
                
            // },
            "header_amount": {
                "room_charges": addonSchema[0]['header_amount'],
                "room_investigation_charges": addonSchema[1]['header_amount'],
                "icu_investigation_charges": addonSchema[2]['header_amount'],
                "ip_pharmacy_charges": addonSchema[3]['header_amount'],
                "ot_cath_pharmacy": addonSchema[4]['header_amount'],
                "procedure_charges": addonSchema[5]['header_amount'],
                // "physiotherapy_diet_charges": addonSchema[7]['header_amount'],
                "blood_bank_charges": addonSchema[7]['header_amount'],
                "consultation_charges": addonSchema[8]['header_amount'],
                "surgical_charges": addonSchema[9]['header_amount'],
                "medical_charges": addonSchema[10]['header_amount']
            },
            "estimation": estimate_data,

            "is_digital_sig_required": isGenerateSign,
            "digital_sig_number": basic_info['phone_no'],
            "digital_sig_weblink": patient_willing === 'yes' || null ? 'no' : 'yes',
            "counseller_name": counsellerName.username,
        };
        // if ((!mederror1.includes(false))) {
        //     try {
        //         if (data.fc_checklist_verified === 'No') {
        //             Modal.error({
        //               title: 'Error message',
        //               content: 'Please verify the FC checklist',
        //               onOk: function () {
        //                 window.scrollTo(0, 0);
        //               },
        //             });
        //           } else{
        //             this.setState({ 'preview_data': data, 'preview_modal': true });
        //         }

        //     }
        //     catch(error){

        //     }
        // }
        let digiSignPhone;
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                digiSignPhone = feild["value"]
                data["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] :  basic_info['phone_no']
            }
        })

        // console.log('final_submit payload',data)
        // return

        if (!mederror1.includes(false)) {
            // return
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "create Financial Councelling - Request",
                    "date": new Date(),
                    "meta": data
                }
            }
            userTrackService(Userlogobj);  
            localStorage.removeItem('est_admis_date') 
            postService('getconfigurations', 'GET', 'null').then(res => {
                if (res.status) {
                    if (res.data.length > 0) {
                        if (res.data[0].data.length > 0) {
                            res.data[0].data.map((feilds, key) => {
                                if (feilds.config_name === 'Print Waiting Time') {
                                 localStorage.setItem('printTimeWait',feilds.bill_tracking_percent);
                                }
                            })
                        }
                    }
                    else {
                        Modal.error({
                            title: 'Error message',
                            content: 'No service available',
                        });
                    }
                } 
                else {
                    Modal.error({
                        title: 'Error message',
                        content: 'Something went wrong',
                    });
                }
            });   

            postService('createFinancialCouncelling', 'POST', { "data": data }).then(res => {
                if (res['status']) {
                    localStorage.removeItem('completed_counselling_date');
                    const UserlogobjRes = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "create Financial Councelling - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                    Storage.store('current_print', res.data);
                    Storage.store('CounID', res.data.counselling_id)
                    let counselling_id=res.data.counselling_id
                    let user_data = JSON.parse(localStorage.getItem('user_data'));
                    const unit_id =user_data ? user_data.unitid:'';
                    let payload={
                        "umr_no": basic_info['umr_no'],
                        "unit_id": unit_id,
                        "comment": estimateBreakupFormatSchema[6].value,
                        "comment_from": "counselling form",
                        "call_log": false,
                        "call_log_eda": null,
                        "call_back_date": null,
                        "call_log_surgery_date": null,
                        "call_log_category": null,
                        "call_log_ip_no": null,
                        "call_log_reason": null,
                        "admission_id": "",
                        "doctor_id": basic_info['token_doctor_id'],
                        "is_iccu": null,
                        "ip_no": basic_info['ip_no']
                    }

                    postService('addCounsellorComments', 'POST', { 'data': payload }).then(res => {
                        if (res.status) {
                            userTrackService(UserlogobjRes);
                            this.setState({preview_modal:false,preview_PatientCheckin_model:false });
                            let This=this
                                    const id = `previewcash`;
                                    const input = document.getElementById(id);
                                    let doctor_cd = this.state.preview_data.doctor_id;
                                    console.log("input=======",this.state.preview_data.doctor_id);
                                    if(input !==null && input !=='' && input !==undefined) {
                                        console.log("input12212++++++++++",input)
                                        html2PDF(input, {   
                                            image: { type: 'png', quality: 0.20 },
                                            jsPDF: { format: 'a4', },
                                            html2canvas: {
                                                scrollX: 0,
                                                scrollY: -window.scrollY,
                                                useCORS: true,
                                            },
                                            imageType: 'image/jpeg',
                                            output: './images/generate.pdf',
                                            success: function(pdf) {
                                                const blob = pdf.output('blob');
                                                // const blob2 = pdf.output('blob');
                                                const form_data = new FormData();
                                                console.log("input++++++++++",input)
                                                form_data.append('upfile', blob);
                                                form_data.append("umr", basic_info['umr_no']);
                                                // form_data.append("phone_no",basic_info['phone_no']);
                                                form_data.append("counselling_id", counselling_id);
                                                form_data.append("doctor_name", basic_info['doctor_name']);
                                                form_data.append("patient_name",basic_info['patient_name']);
                                                form_data.append("counselling_date",basic_info['counselling_date']);
                                                form_data.append("speciality_id", basic_info['speciality_id']);
                                                form_data.append("doctor_cd", doctor_cd);
                                                form_data.append("is_digital_sig_required", isGenerateSign);
                                                form_data.append("phone_no", digiSignPhone);
                                                form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                                                formDataPostService('fileUploadforFinancialCounselling', 'POST', form_data).then(res => {
                                                    if (res.status) {
                                                    localStorage.setItem('completed_counselling_date',moment());
                                                    console.log("input+-+-+-+-",);    
                                                    This.props.next();
                                                        This.setState({ loadding: false });
                                                        console.log("input!!!!!!!!");
                                                        // Modal.success({
                                                        //     title: `success`,
                                                        //     content: `${res.message}`,
                                                        //     zIndex: '1022'
                                                        // });
                                                }
                                            });
                                                // pdf.save(this.output);
                                            }
                                        });
                                    } 
                                     
                                    }
                                });
                              localStorage.removeItem('fc_checklist_verified');  
                    }   

                else {
                        this.setState({ loadding: false});
                        let that=this
                        localStorage.setItem('completed_counselling_date',moment());
                        Storage.store('current_print', res.data);
                        Modal.warning({
                            title: 'Unable to process',
                            content: res.message?res.message:'Oops! something went wrong. Please,try again later',
                            zIndex:'1035',
                            onOk() {
                                that.props.next();
                                    }
                        });
                }
            })

            
            
        } 
    }catch (error) {
            Modal.error({
                title: 'Error message',
                content: 'Oops! something went wrong. Please,try again later'
            });
        }
    }

    validateModalFeilds(formFeilds) {
        console.log("validateModalFeilds formFeilds", formFeilds);
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'input' || feild['element'] === 'select' || feild['element'] === 'Select2multiple' || feild['element'] === 'datepicker')) {
                formFeilds[key]['errors'] = [];
                if (!feild.disable && feild.visible) {
                        feild
                        .rules
                        .map((rule, rkey) => {
                            if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                              
                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                let obj={
                                    id:feild['id'],
                                    false:false
                                }
                                errors.push(obj);
                            }
                            else {
                                console.log('no', feild['name'], feild['value'])
                                if(feild['name'] === "phonenumber"){
                                    let isvalid = this.validateMobileNumber(feild['value'])
                                    if(!isvalid){
                                        formFeilds[key]['errors'].push({ 'message': "Please Enter Valid Phone Number" });
                                        let obj={
                                            id:feild['id'],
                                            false:false
                                        }
                                        errors.push(obj);
                                    }else{
                                        formFeilds[key]['errors'] = [];
                                        errors.push(true);
                                    }
                                }else{
                                    formFeilds[key]['errors'] = [];
                                    errors.push(true);
                                }
                            }
                        })
                   
                }
            }
        })

        this.setState((state) => ({ formFeilds: formFeilds }));
        return errors;
    }
   

    buttonClick_save() {
        this.props.next()
    }

    buttonClick_cancel() {
        this.props.back()
    }

    addCash(feilds) {

    }

    feildChange1(ele) {
        // console.clear();
        console.log(ele);
    }

    feildChange(ele) {

        let { medicationDetailsSchema, addonSchema } = this.state;

        let ele_name = ele['name'];
        let ele_val = ele['value'];
        let ele_id = ele['id'];
        // console.clear();
        console.log(ele)


        // this.setState((state) => ({ 'medicationDetailsSchema': medicationDetailsSchema }));

        if (ele['name'] === 'roomtypes') {
            let arr = [];
            let val = ele['value'];
            if (val == 'Single') {
                arr = ['https://www.kevinmd.com/blog/wp-content/uploads/shutterstock_48561808.jpg', 'https://aanchhospital.com/themes/images/PG5A1642.jpg', 'https://suneeldhand.com/wp-content/uploads/2014/02/Hospital-bed1-566x675.jpg', 'https://i.pinimg.com/originals/7b/04/86/7b0486ca7b6a0aca916bf5e05121be26.jpg', 'https://vizag.apollohospitals.com/wp-content/uploads/2016/05/Single-room.jpg']
            }
            if (val === 'Deluxe') {
                arr = ['https://medanta.org/wp-content/uploads/2017/04/SuDR1.jpg', 'https://www.jaslokhospital.net/Content/PhotoGallery/Suite-Deluxe.jpg']
            }
            if (val === 'Suite') {
                arr = ['https://5.imimg.com/data5/OD/QW/GLADMIN-9027984/treatment-executive-suite-room-500x500.png', 'https://cih.com.sg/wp-content/uploads/2018/02/4-1.jpg', 'https://meitra.com/wp-content/themes/meitra-hospital/images/Presidential-Suite.jpg']
            }
            if (val === 'General') {
                arr = ['https://3.imimg.com/data3/YT/HI/MY-9780834/1-500x500.jpg', 'https://yashodahospitalbijapur.in/wp-content/uploads/2018/07/general-ward.jpg', 'https://firstwesternhospital.healthcare/wp-content/uploads/2015/03/First-Western-Hospital-Koh-Phanagn-clinic-General-ward.jpg']
            }
            this.setState((state) => ({ 'rooms': arr }));
        }
    }

    next() {
        this.carousel.next();
    }
    previous() {
        this.carousel.prev();
    }

    handleChange(data) {
        console.log('DTAAAAA:::', data);
        let { slug } = this.props.match.params;
        try {
        let { addonSchema, additionalPackageSchema, medicationDetailsSchema, additionalProcedureSchema } = this.state;
        let { counselling_details } = this.props;
        const { getServicePricesById ,getInsurancePackagePricesByProcedureName} = networkList;
        let amount, room_id, room_value = 0;

        if (Array.isArray(data)) {
            addonSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                // if (subTable.name === 'ot_charges') {
                //     let procedure_amount = 0;
                //     medicationDetailsSchema.map((feild, key) => {
                //         if (feild['name'] === 'surgery_procedure_amount') {
                //             let amount = parseFloat(medicationDetailsSchema[key]['value'])
                //             if (amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                //                 procedure_amount = parseFloat(medicationDetailsSchema[key]['value']);
                //             }
                //         }
                //     })

                //     additionalProcedureSchema.map((subTable, key) => {
                //         if (subTable.visible) {
                //             let table_body = subTable.Specification.table_body;
                //             table_body.map((feild, table_key) => {
                //                 let row = feild.feilds;
                //                 row.map((sub_feild, sub_table_key) => {
                //                     if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                //                         // procedure_amount = parseFloat(procedure_amount) + parseFloat(sub_feild.value);
                //                     }
                //                 })
                //             })
                //         }
                //     })
                //     data[0].feilds.map((feilds, table_keys) => {
                //         if (feilds.id > 2) {
                //             if (feilds.name === "qty") {
                //                 data[0].feilds[table_keys]["value"] = 1;
                //             }
                //             if (feilds.name === "rate") {
                //                 // data[0].feilds[table_keys]["value"] = procedure_amount;
                //                 data[0].feilds[table_keys]["value"] = null;
                //             }
                //             if (feilds.name === "amount") {
                //                 // data[0].feilds[table_keys]["value"] = procedure_amount;
                //                 data[0].feilds[table_keys]["value"] = null;
                //             }
                //         }
                //     })
                //     // if (subTable.name === 'ot_charges') {
                //         let table_body = subTable.Specification.table_body;
                //         addonSchema[key].Specification.table_body = table_body.concat(data);
                //     // }

                // }
                // else {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    addonSchema[key].Specification.table_body = table_body.concat(data);
                }
                // }
            })

            additionalPackageSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    additionalPackageSchema[key].Specification.table_body = table_body.concat(data);
                }
            })

            additionalProcedureSchema.map((subTable, key) => {
                let table_name = data[0].feilds[0].table;
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    additionalProcedureSchema[key].Specification.table_body = table_body.concat(data);
                }
            })
        }
        else {
            if (data.table === 'ot_charges') {
                const params = new URLSearchParams(this.props.location.search);
                const rid = params.get('rid');
                if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
                    slug = 'recounselling';
                    if(counselling_details && moment(counselling_details['counselling_date']).isAfter(counselling_details['VERSION_UPDATED_DATE'])){
                        console.log('teet')
                         }else{
                             slug = 'finanical-counselling'; 
                         }
                }
                if (slug == 'view-finanical-counselling' || slug == 'recounselling') {
                    if (data.service_id !== '' && data.service_id !== undefined) {
                        const serviceId = data.service_id;
                        let serviceidforestimation = 0;
                        let otHoursAmount = 0;
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id } }).then(res => {
                            if (res) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        room_id = feild['room_id'];
                                    }
                                })
                                res.data.map((feild, key) => {
                                    console.log(res.data)
                                    // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        counselling_details['estimation'].map((feild, key) => {
                                            if (feild['key_word'] == 'ot_hours') {
                                                otHoursAmount = feild['rate'];
                                                serviceidforestimation = feild['service'];
                                            }
                                        });
                                        if (serviceidforestimation === serviceId) {
                                            amount = feild.amount;
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["service"] = data.service_id
                                                            }
                                                            if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1
                                                                // data.service_id
                                                            }
                                                            if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = otHoursAmount;
                                                            }
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = otHoursAmount;
                                                            }

                                                        })

                                                    })
                                                }
                                            })
                                            this.setState({ addonSchema: addonSchema });
                                            this.total_suming();
                                        } else {
                                            amount = feild.amount;
                                            addonSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["service"] = data.service_id
                                                            }
                                                            if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1
                                                                // data.service_id
                                                            }
                                                            if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount;
                                                            }
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount;
                                                            }

                                                        })

                                                    })
                                                }
                                            })
                                            this.setState({ addonSchema: addonSchema });
                                            this.total_suming();
                                        }

                                    // }
                                })
                            }
                        });
                            this.otInstDisinfecAmounts(data);
                    } else {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                                        }
                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                    })
                                })
                            }
                        })
                        this.setState({ addonSchema: addonSchema });
                        this.total_suming();
                    }
                } else {
                    if (data.service_id !== '' && data.service_id !== undefined) {
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id } }).then(res => {
                            if (res) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        room_id = feild['room_id'];
                                    }
                                })
                                res.data.map((feild, key) => {
                                    console.log(res.data)
                                    // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        amount = feild.amount;
                                        addonSchema.map((subTable, key) => {
                                            if (subTable.name === data.table) {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name !== "qty" && sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["service"] = data.service_id
                                                        }
                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1
                                                            // data.service_id
                                                        }
                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                        this.setState({ addonSchema: addonSchema });
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                    // }
                                })
                            }
                        });
                        // if(data.id==3){
                            this.otInstDisinfecAmounts(data);
                        // }
                    } else {
                        addonSchema.map((subTable, key) => {
                            if (subTable.name === data.table) {
                                let table_body = subTable.Specification.table_body;
                                table_body.map((feild, table_key) => {
                                    let row = feild.feilds;
                                    let rate, qty = null;
                                    row.map((sub_feild, sub_table_key) => {
                                        if (data.name === "qty") {
                                            if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                                if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                                }
                                                if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    rate = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                    if (rate === '' && rate === null && rate === undefined) {
                                                        rate = 0;
                                                    }
                                                }
                                                if (rate !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(rate) * parseFloat(data.value);
                                                }
                                            }
                                        }
                                        if (data.name === "rate") {
                                            if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                                if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                                    if (qty === '' && qty === null && qty === undefined) {
                                                        qty = 0;
                                                    }
                                                }
                                                if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                                }
                                                if (qty !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(data.value);
                                                }
                                            }
                                        }
                                    })
                                })
                            }
                        })
                        this.setState({ addonSchema: addonSchema });
                        this.total_suming();
                        // this.PrimaryConsultantRoomAmount();
                    }
                }
            }
            else {
                if (data.element === 'input') {
                    // if (data.table === 'surgical_charges' || data.table === 'medical_charges') {
                    //     addonSchema.map((subTable, key) => {
                    //         if (subTable.name === data.table) {
                    //             let table_body = subTable.Specification.table_body;
                    //             table_body.map((feild, table_key) => {
                    //                 let row = feild.feilds;
                    //                 row.map((sub_feild, sub_table_key) => {
                    //                     if (sub_feild.name === "percentage" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                    //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                    //                     }
                    //                     if(sub_feild.name==='amount'&& sub_feild.row_group === data.row && sub_feild.id === data.id){
                    //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=data.value
                    //                     }
                    //                 })
                    //             })
                    //         }
                    //     })
                    // }
                    
                    if(data.tableName === 'additional_surgery_procedure_name'|| data.name==='amount'){
                    let room_id, room_value = 0;

                        medicationDetailsSchema.map((feild, key) => {
                            if (feild['name'] === 'room_opted') {

                                room_id = feild['room_id'];
                                room_value = feild['value'];
                            }
                        })
                        if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                    additionalProcedureSchema.map((subTable, key) => {
                        if (subTable.name === data.table) {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                        additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        if (amount === undefined) { amount = 0; }
                                        additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(data.value);
                                        this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                        // this.sumingProcedureAmounts();
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                    }
                                })
                            })
                        }
                    })
                }
            }
            // else if (data.name === 'cash_room_highend_implants'){
            //     let user_data = JSON.parse(Storage.get('user_data'));
            //     let user_unit_id = user_data.unitid;
            //     addonSchema.map((subTable, key) => {
            //         if (subTable.name === data.table) {
            //             let table_body = subTable.Specification.table_body;
            //             table_body.map((feild, table_key) => {
            //                 let row = feild.feilds;
            //                 let qty = 1;
            //                 row.map((sub_feild, sub_table_key) => {
            //                     if (sub_feild.name === "cash_room_highend_implants") {
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
            //                     }
            //                     if (sub_feild.name === "rate") {
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
            //                     }
            //                     if (sub_feild.name === "qty") {
            //                         if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
            //                         }
            //                         else {
            //                             qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
            //                         }
            //                     }
            //                     if (sub_feild.name === "amount") {
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
            //                     }
            //                 })
            //             })
            //         }
            //     })
            //     this.setState({ addonSchema: addonSchema });
            //     this.total_suming();
            //     this.PrimaryConsultantRoomAmount();
            //     this.drugaAdminCharges();
            // } 
            // else if(data.keyword === 'add_more'){
            //     console.log("data.name", data.name);
            //     let header_amount = 0;
            //     addonSchema.map((subTable, key) => {
            //         if (subTable.name === data.table) {
            //             let HeaderAmount = subTable.header_amount;
            //             let table_body = subTable.Specification.table_body;
            //             table_body.map((feild, table_key) => {
            //                 let row = feild.feilds;
            //                 let qty = 0;
            //                 let implantCharges = 0;
            //                 row.map((sub_feild, sub_table_key) => {
            //                     if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
            //                         if(sub_feild.name === 'cash_room_implants'){
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
            //                         }
            //                         if (sub_feild.name === "qty") {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
            //                             qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
            //                         }
            //                         if (sub_feild.name === "rate") {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
            //                             implantCharges = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
            //                         }
            //                         if (sub_feild.name === "amount") {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * implantCharges;
            //                             // header_amount = parseInt(qty) * parseInt(implantCharges);
            //                         }
            //                     }
            //                 })
            //             })
            //         }
            //     })
            //     this.setState({ addonSchema: addonSchema });
            //     this.total_suming();
            // }
            else if(data.name === 'ins_room_highend_implants' && data.keyword === 'implant'){
                console.log("data.name", data.name);
                let header_amount = 0;
                addonSchema.map((subTable, key) => {
                    if (subTable.name === data.table) {
                        let HeaderAmount = subTable.header_amount;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            let qty = 0;
                            let implantCharges = 0;
                            row.map((sub_feild, sub_table_key) => {
                                if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
                                    if(sub_feild.name === 'ins_room_highend_implants'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                                    }
                                    if (sub_feild.name === "qty") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        implantCharges = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * implantCharges;
                                        // header_amount = parseInt(qty) * parseInt(implantCharges);
                                    }
                                }
                            })
                        })
                    }
                })
                this.setState({ addonSchema: addonSchema });
                this.total_suming();
            } else if(data.name === 'ins_room_implants' && data.keyword === 'add_more'){
                console.log("data.name", data.name);
                let header_amount = 0;
                addonSchema.map((subTable, key) => {
                    if (subTable.name === data.table) {
                        let HeaderAmount = subTable.header_amount;
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            let qty = 0;
                            let implantCharges = 0;
                            row.map((sub_feild, sub_table_key) => {
                                if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
                                    if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' ){
                                        if(sub_feild.name === 'ins_room_implants' && sub_feild.id === data.id){
                                            // if(sub_feild.name === 'ins_room_implants'){
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                                            } 
                                    }else if(slug === 'recounselling'){
                                        if(sub_feild.name === 'ins_room_implants'){
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                                        } 
                                    }
                                    // if(sub_feild.name === 'ins_room_implants' && sub_feild.id === data.id){
                                    // // if(sub_feild.name === 'ins_room_implants'){
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                                    // }                                    
                                    if (sub_feild.name === "qty") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        implantCharges = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * implantCharges;
                                        // header_amount = parseInt(qty) * parseInt(implantCharges);
                                    }
                                }
                            })
                        })
                    }
                })
                this.setState({ addonSchema: addonSchema });
                this.total_suming();
            }
            else {
                addonSchema.map((subTable, key) => {
                    if (subTable.name === data.table) {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            let rate, qty = null;
                            row.map((sub_feild, sub_table_key) => {
                                if (data.name === "qty") {
                                    if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            rate = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                            if (rate === '' && rate === null && rate === undefined) {
                                                rate = 0;
                                            }
                                        }
                                        if (rate !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(rate) * parseFloat(data.value);
                                        }
                                    }
                                }
                                if (data.name === "rate") {
                                    if (data.value !== "" && data.value !== null && data.value !== undefined) {
                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                            if (qty === '' && qty === null && qty === undefined) {
                                                qty = 0;
                                            }
                                        }
                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value
                                        }
                                        if (qty !== null && sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(qty) * parseFloat(data.value);
                                        }
                                    }
                                }
                            })
                        })
                    }
                })
            }
                }
                else {
                    let qty = 1;

                    if (data.name === 'additional_package_name') {
                        const { getCashPackagePricesById } = networkList;
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        let pack_id = data.value;
                        let pack_name = data.text;
                        let id = data.id;
                        let WardName =  this.state.medicationDetailsSchema[12].ward_groupname;
                        postService('getServicePricesById', 'POST', { "data": { "package_id": data.equservicecd, "unit_id": user_unit_id, tariff_id:'TR1', form_type: 1,service_type: 'APKG', ward_name: WardName}}).then(res => {
                            if (res['status']) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        room_id = feild['room_id'];
                                        room_value = feild['value'];
                                    }
                                })
                                if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                                        // if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                            let Package_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id));
                                            amount = parseFloat(data.packageAmount);
                                            let pkg = data.packageName === 'Y' ? 'Package' : 'Non-Package';
                                            additionalPackageSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if(sub_feild.name === "additional_package_name" && sub_feild.row_group === data.row && sub_feild.id === data.id){
                                                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true;
                                                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =  data.equservicecd;
                                                            }
                                                            // if(sub_feild.name === "is_package"){
                                                            //     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=pkg;
                                                            // }
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                if (amount === undefined) { amount = 0; }
                                                                additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(res.data[0].amount);
                                                                this.setState({ additionalPackageSchema: additionalPackageSchema });
                                                                
                                                                this.getExcludesIncludes(data.equservicecd, pack_name,1);
                                                                // this.getExcludesIncludes(pack_id, pack_name, id);
                                                                this.total_suming();
                                                                // this.PrimaryConsultantRoomAmount();
                                                                this.drugaAdminCharges();
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        // }
                                }
                                else {
                                    Modal.error({
                                        title: 'Error message',
                                        content: 'No amount for the selected room',
                                    });
                                }
                            }else  if (!res.data || res.data.length === 0) {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'No data available for the selected room',
                                });
                            }else{
                                additionalPackageSchema.map((subTable, key) => {
                                    if (subTable.name === data.table) {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            let row = feild.feilds;
                                            row.map((sub_feild, sub_table_key) => {
                                                if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                    additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true;
                                                    this.setState({ additionalPackageSchema: additionalPackageSchema });
                                                    this.getExcludesIncludes(data.equservicecd, pack_name,1);
                                                    this.total_suming();
                                                    // this.PrimaryConsultantRoomAmount();
                                                    this.drugaAdminCharges();
                                                }
                                            })
                                        })
                                    }
                                })
                            } 
                        });
                    }
                    else if (data.name === 'additional_surgery_procedure_name') {
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                            postService(getInsurancePackagePricesByProcedureName, 'POST', { "data": { "procedure_name": data.text, "unit_id": user_unit_id,tariff_mapped: 1,mode_of_payment:1 } }).then(res => {
                                if (res['status']) {
                                    medicationDetailsSchema.map((feild, key) => {
                                        if (feild['name'] === 'room_opted') {
            
                                            room_id = feild['room_id'];
                                            room_value = feild['value'];
                                        }
                                    })
                                    if (room_value !== 0 && room_value !== '' && room_value !== null && room_value !== undefined) {
                                        let amount = 0;
                                        if(res.data.some(feild=>parseFloat(feild.room_id)===parseFloat(room_id))){
                                            let procedure_amount=res.data.filter(item=>parseFloat(item.room_id)===parseFloat(room_id)) 
                                            amount = procedure_amount[0].package_charges;
                                            additionalProcedureSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                                if (amount === undefined) { amount = 0; }
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount);
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=true;
                                                                this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                                this.total_suming();
                                                                // this.PrimaryConsultantRoomAmount();
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        }else{
                                            additionalProcedureSchema.map((subTable, key) => {
                                                if (subTable.name === data.table) {
                                                    let table_body = subTable.Specification.table_body;
                                                    table_body.map((feild, table_key) => {
                                                        let row = feild.feilds;
                                                        row.map((sub_feild, sub_table_key) => {
                                                            if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                                additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=false;
                                                                this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                                this.total_suming();
                                                                // this.PrimaryConsultantRoomAmount();
                                                            }
                                                        })
                                                    })
                                                }
                                            })
                                        }
                                }
                                else {
                                    // Modal.error({
                                    //     title: 'Error message',
                                    //     content: 'Please select room',
                                    // });
                                }
                                }
                                else{
                                    additionalProcedureSchema.map((subTable, key) => {
                                        if (subTable.name === data.table) {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                                        additionalProcedureSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"]=false;
                                                        this.setState({ additionalProcedureSchema: additionalProcedureSchema });
                                                        this.total_suming();
                                                        // this.PrimaryConsultantRoomAmount();
                                                    }
                                                })
                                            })
                                        }
                                    })
                                }
                            });
                    }
                    else if (data.name === 'ot_cath_highend_drugs_implants'){
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        console.log('DATAAA::::', medicationDetailsSchema);
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id, "unit_id": user_unit_id, tariff_id: 'TR1'} }).then(res => {
                            if (res.status) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        console.log('DATAAA::::', room_id, feild['room_id']);
                                        room_id = feild['room_id'];
                                    }
                                })

                                res.data.map((feild, key) => {
                                    if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        amount = feild.amount;
                                        addonSchema.map((subTable, key) => {
                                            if (subTable.name === data.table) {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                            }
                                                            else {
                                                                qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                                            }
                                                        }
                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                        this.setState({ addonSchema: addonSchema });
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                        this.drugaAdminCharges();
                                    }
                                })
                            } else {

                            }
                        });
                    }
                    else if (data.name === 'room_highend_drugs_implants'){
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        console.log('DATAAA::::', medicationDetailsSchema);
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id, "unit_id": user_unit_id, tariff_id: 'TR1', service_type: 'PH'} }).then(res => {
                            if (res.status) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        console.log('DATAAA::::', room_id, feild['room_id']);
                                        room_id = feild['room_id'];
                                    }
                                })

                                res.data.map((feild, key) => {
                                    // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        amount = feild.amount;
                                        addonSchema.map((subTable, key) => {
                                            if (subTable.name === data.table) {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                            }
                                                            else {
                                                                qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                                            }
                                                        }
                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                        this.setState({ addonSchema: addonSchema });
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                        this.drugaAdminCharges();
                                    // }
                                })
                            } else {

                            }
                        });
                    }
                    else if(data.name === 'icu_highend_investigations' || data.name === 'surgery_procedure_name'){
                        console.log("data.name", data);
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;

                        postService(getServicePricesById, 'POST', { data: { service_id: data.sub_data.service_code, tariff_id: 'TR1', room_type:0, payment_type: 2, unit_id: user_unit_id, service_type: 'PC' } }).then((res) => {
                            if (res.data && res.data.length > 0) {
                                let amount = res.data[0].amount || 0;
                                addonSchema.map((subTable, key) => {
                                    if (subTable.name === data.table) {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            let row = feild.feilds;
                                            row.map((sub_feild, sub_table_key) => {
                                                if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
                                                    // if(sub_feild.name === "ispackage"){
                                                    //     console.log("data.name isPackage",isPackage);
                                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = isPackage
                                                    // }
                                                    if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;

                                                        }
                                                        else {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                        }
                                                    }
                                                    if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                    }
                                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * 1;
                                                    }
                                                }
                                            })
                                        })
                                    }
                                })
                                this.setState({ addonSchema: addonSchema });
                                this.total_suming();
                                // this.insurance_total();
                            } else {
                                let amount = 0;
                                addonSchema.map((subTable, key) => {
                                    if (subTable.name === data.table) {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            let row = feild.feilds;
                                            row.map((sub_feild, sub_table_key) => {
                                                if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
                                                    if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;

                                                        }
                                                        else {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                        }
                                                    }
                                                    if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                    }
                                                    if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * 1;
                                                    }
                                                }
                                            })
                                        })
                                    }
                                })
                                this.setState({ addonSchema: addonSchema });
                                this.total_suming();
                                this.insurance_total();
                            }
                        });
                    // } else if(data.name === 'ins_medical_record_charges'){              
                    //     console.log("data.name", data);
                    //     postService(getServicePricesById, 'POST', { data: { service_id: 'RNS0120', tariff_id: this.state.tariff_mapped, room_type:0, payment_type: 2, unit_id: user_unit_id,  } }).then((res) => {
                    //         if (res.status) {
                    //             let amount = res.data ? res.data[0].amount : 0;
                    //             addonSchema.map((subTable, key) => {
                    //                 // if (subTable.name === data.table) {
                    //                     let table_body = subTable.Specification.table_body;
                    //                     table_body.map((feild, table_key) => {
                    //                         let row = feild.feilds;
                    //                         row.map((sub_feild, sub_table_key) => {
                    //                             if (sub_feild.name === "qty") {
                    //                                 if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;

                    //                                 }
                    //                                 else {
                    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                                     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                    //                                 }
                    //                             }
                    //                             if (sub_feild.name === "rate") {
                    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                    //                             }
                    //                             if (sub_feild.name === "amount") {
                    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * 1;
                    //                             }
                    //                         })
                    //                     })
                    //                 // }
                    //             })
                    //             this.setState({ addonSchema: addonSchema });
                    //             this.total_suming();
                    //             this.insurance_total();
                    //         }
                    //     });
                    }
                    else if (data.table=== 'ot_cath_pharmacy' || data.name === 'ins_physiotherapy_charges' || data.name === 'room_highend_investigations'){
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        console.log('DATAAA::::', medicationDetailsSchema);
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id, "unit_id": user_unit_id, tariff_id: 'TR1', type: 'ocp'} }).then(res => {
                            if (res.status) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        console.log('DATAAA::::', room_id, feild['room_id']);
                                        room_id = feild['room_id'];
                                    }
                                })

                                res.data.map((feild, key) => {
                                    // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                                        amount = feild.amount;
                                        addonSchema.map((subTable, key) => {
                                            if (subTable.name === data.table) {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                            }
                                                            else {
                                                                qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                                            }
                                                        }
                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                        this.setState({ addonSchema: addonSchema });
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                        this.drugaAdminCharges();
                                    // }
                                })
                            } else {

                            }
                        });
                    }
                    // else if (data.name === 'room_highend_implants'){
                    //     let user_data = JSON.parse(Storage.get('user_data'));
                    //     let user_unit_id = user_data.unitid;
                    //     console.log('DATAAA::::', medicationDetailsSchema);
                    //     postService(getServicePricesById, 'POST', { data: { service_id: data.service_id, "unit_id": user_unit_id, tariff_id: 'TR1', service_type: 'IMP'} }).then(res => {
                    //         if (res.status) {
                    //             medicationDetailsSchema.map((feild, key) => {
                    //                 if (feild['name'] === 'room_opted') {
                    //                     console.log('DATAAA::::', room_id, feild['room_id']);
                    //                     room_id = feild['room_id'];
                    //                 }
                    //             })

                    //             res.data.map((feild, key) => {
                    //                 // if (parseFloat(feild.room_id) === parseFloat(room_id)) {
                    //                     amount = feild.amount;
                    //                     addonSchema.map((subTable, key) => {
                    //                         if (subTable.name === data.table) {
                    //                             let table_body = subTable.Specification.table_body;
                    //                             table_body.map((feild, table_key) => {
                    //                                 let row = feild.feilds;
                    //                                 row.map((sub_feild, sub_table_key) => {
                    //                                     if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                    //                                     }
                    //                                     if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                    //                                         if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                    //                                         }
                    //                                         else {
                    //                                             qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                    //                                         }
                    //                                     }
                    //                                     if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                    //                                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
                    //                                     }
                    //                                 })
                    //                             })
                    //                         }
                    //                     })
                    //                     this.setState({ addonSchema: addonSchema });
                    //                     this.total_suming();
                    //                     this.PrimaryConsultantRoomAmount();
                    //                     this.drugaAdminCharges();
                    //                 // }
                    //             })
                    //         } else {

                    //         }
                    //     });
                    // }
                    // else if(data.name === 'cash_room_highend_implants' && data.keyword === 'implant'){
                    //     console.log("data.name", data.name);
                    //     let header_amount = 0;
                    //     addonSchema.map((subTable, key) => {
                    //         if (subTable.name === data.table) {
                    //             let HeaderAmount = subTable.header_amount;
                    //             let table_body = subTable.Specification.table_body;
                    //             table_body.map((feild, table_key) => {
                    //                 let row = feild.feilds;
                    //                 let qty = 0;
                    //                 let implantCharges = 0;
                    //                 row.map((sub_feild, sub_table_key) => {
                    //                     if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
                    //                         if(sub_feild.name === 'cash_room_highend_implants'){
                    //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = data.value;
                    //                         }
                    //                         if (sub_feild.name === "qty") {
                    //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                             qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                    //                         }
                    //                         if (sub_feild.name === "rate") {
                    //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                    //                             implantCharges = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                    //                         }
                    //                         if (sub_feild.name === "amount") {
                    //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * implantCharges;
                    //                             // header_amount = parseInt(qty) * parseInt(implantCharges);
                    //                         }
                    //                     }
                    //                 })
                    //             })
                    //         }
                    //     })
                    //     this.setState({ addonSchema: addonSchema });
                    //     this.total_suming();
                    // }
                    else {
                        let user_data = JSON.parse(Storage.get('user_data'));
                        let user_unit_id = user_data.unitid;
                        console.log('DATAAA::::', medicationDetailsSchema);
                        postService(getServicePricesById, 'POST', { data: { service_id: data.service_id, "unit_id": user_unit_id, tariff_id: 'TR1'} }).then(res => {
                            console.log('INVes', res);
                            if (res.status) {
                                medicationDetailsSchema.map((feild, key) => {
                                    if (feild['name'] === 'room_opted') {
                                        room_id = feild['room_id'];
                                    }
                                })

                                res.data.map((feild, key) => {
                                    console.log('FEILD:::', feild)
                                    // if (parseFloat(feild.room_id) === 1) {
                                        amount = feild.amount;

                                        addonSchema.map((subTable, key) => {
                                            if (subTable.name === data.table) {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        if (sub_feild.name === "rate" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                                        }
                                                        if (sub_feild.name === "qty" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                            }
                                                            else {
                                                                qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                                            }
                                                        }
                                                        if (sub_feild.name === "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * parseFloat(qty);
                                                        }
                                                    })
                                                })
                                            }
                                        })
                                        this.setState({ addonSchema: addonSchema });
                                        this.total_suming();
                                        // this.PrimaryConsultantRoomAmount();
                                        this.drugaAdminCharges();
                                    // }
                                })
                            } else {

                            }
                        });
                    }
                }
            }
        }

        this.setState({ addonSchema: addonSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema });
        this.total_suming();
        // this.PrimaryConsultantRoomAmount();
        this.drugaAdminCharges();
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }
    otInstDisinfecAmounts(data) {
        try {
        let { medicationDetailsSchema, addonSchema, additionalProcedureSchema } = this.state;
        let procedure_amount,ot_inst_disinfec = 0;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let service_id;
        let  room_id = null;
        medicationDetailsSchema.map((feild, key) => {
            if (feild['name'] === 'room_opted') {
                room_id = parseInt(feild['room_id']);
            }
        })
        addonSchema.map((subTable, key) => {
            if (subTable.name === 'ot_charges') {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    if (feild.key_word === 'highend' || feild.key_word==='add_more' ) {
                        row.map((sub_feild, sub_table_key) => {
                            if ( sub_feild.name!=='ot_hours'&& sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                            if (sub_feild.name === "qty") {
                                ot_inst_disinfec=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["charges"];
                            }
                        }
                           
                        })
                    }

                })
            }
        })
        addonSchema.map((subTable, key) => {
            if (subTable.name === 'ot_charges') {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    let rates=0;
                    if (feild.key_word === 'ot_inst_disinfec') {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "qty") {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                            }
                            if (sub_feild.name === "rate") {
                                rates=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.abs(rates-ot_inst_disinfec)
                            }
                            if (sub_feild.name === "amount") {
                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.abs(rates-ot_inst_disinfec)
                            }
                        })
                    }
                  

                })
            }
        })
        this.setState({ addonSchema: addonSchema });
        this.total_suming();

        postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 9, sub_header_id: 18, tariff_mapped: 1 } }).then(res => {
            if (res.status && res.data.length>0) {
               if(data.text=='OT - 1 HOUR' || data.text=='OT - 1/2 HOUR'){
               service_id=res.data[0].id;
            }else{
                 service_id=res.data[2].id;
            }
            postService('getServicePricesById', 'POST', { data: { service_id: service_id } }).then(response => {
                if (response.status) {
                    if (response.data.length > 0) {
                        let amount,rate;
                        let data_value = 0;

                        response.data.map((feild, key) => {
                            if (feild.room_id === room_id) {
                                amount = parseFloat(feild.amount);
                                addonSchema.map((subTable, key) => {
                                    if (subTable.name === 'ot_charges') {
                                        let table_body = subTable.Specification.table_body;
                                        table_body.map((feild, table_key) => {
                                            let row = feild.feilds;

                                            if (feild.key_word === 'ot_inst_disinfec') {
                                                row.map((sub_feild, sub_table_key) => {
                                                    if (sub_feild.name === "qty") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                    }
                                                    if (sub_feild.name === "rate") {
                                                        rate=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.abs(amount+rate)
                                                    }
                                                    if (sub_feild.name === "amount") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Math.abs(amount+rate)
                                                    }
                                                })
                                            }
                                            if (feild.key_word === 'highend' || feild.key_word === 'add_more') {
                                                row.map((sub_feild, sub_table_key) => {
                                                    if ( sub_feild.name!=='ot_hours'&& sub_feild.name !== "rate" && sub_feild.name !== "amount" && sub_feild.row_group === data.row && sub_feild.id === data.id) {
                                                    if (sub_feild.name === "qty") {
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["charges"]=amount;
                                                    }
                                                }
                                                   
                                                })
                                            }
                                            

                                        })
                                    }
                                })
                                this.setState({ addonSchema: addonSchema });
                                this.total_suming();
                                // this.sumingProcedureAmounts();
                            }
                        })
                    }
                    else {
                        Modal.error({
                            title: 'Error message',
                            content: 'No amount for the selected room',
                        });
                    }
                }
                else {
                    Modal.error({
                        title: 'Error message',
                        content: 'Something went wrong',
                    });
                }
            })
        }
        else {
            Modal.error({
                title: 'Error message',
                content: 'No service available',
            });
        }

        })
        

        this.setState({ addonSchema: addonSchema });
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }
    }

    // getExcludesIncludes(pack_id, pack_name,intial) {
    //     try {
    //         let { counselling_details } = this.props;
    //     let { inc_excludes_pack_id, inc_excludes_packages_ids, includesSchema, excludesSchema, tariff_mapped ,packages_IN_EX,additionalPackageSchema,exclude_slug_fordropdown} = this.state;
    //     let user_data = JSON.parse(Storage.get('user_data'));
    //     let user_unit_id = user_data.unitid;
    //     let newData = [];
       
    //             let { exculude_options } = this.state;
    //             if(intial===0){
    //                 if(packages_IN_EX){
    //                     if((pack_id)){
    //                         console.log('PACK:::', pack_id);
    //                         inc_excludes_packages_ids.length=0;
    //                         packages_IN_EX.length=0;
    //                         includesSchema.map((subTable, key) => {
    //                             subTable['title'] = '';
    //                             subTable['name'] = '';
    //                             if (includesSchema[key].id === 1) {
    //                                 if (includesSchema[key].Specification.table_body.length > 0) {
    //                                     includesSchema[key].Specification.table_body.length = 0;
    //                                 }
    //                             } else {
    //                                 includesSchema.splice(1, includesSchema.length)
    //                             }
    //                         })

    //                          additionalPackageSchema.map((subTable, key) => {
    //                             let table_body = subTable.Specification.table_body;
    //                             subTable.visible=false;
    //                             // additionalPackageSchema[key].Specification.add_more = true;
    //                             table_body.map((feild, table_key) => {
    //                                 additionalPackageSchema[key].Specification.table_body.length=0;
    //                                 if (table_body.length > 0) {
    //                                     let row = feild.feilds;
    //                             row.map((sub_feild, sub_table_key) => {
    //                                 if (sub_feild.element === 'input' || sub_feild.element === 'select') {
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                 }
    //                                 if (sub_feild.name === 'additional_package_name') {
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                 }
    //                                 if (sub_feild.name === 'amount') {
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
    //                                     additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
    //                                 }
    //                             })
    //                                         additionalPackageSchema[key].Specification.table_body.splice(table_key, 1)
    //                                 }
    //                             })
    //                         })
    //                         this.setState({ includesSchema,exludesconcatdata:[],additionalPackageSchema });
    //                         optionsStore.dispatch({ type: 'options_data', 'data': [] });
    //                         if (Array.isArray(inc_excludes_packages_ids)?!inc_excludes_packages_ids.includes(pack_id):inc_excludes_packages_ids!==pack_id) {
    //                             inc_excludes_packages_ids.push(parseInt(pack_id));
    //                             let obj={
    //                                 'pack_id':pack_id,
    //                                 'pack_name':pack_name
    //                             }
    //                             packages_IN_EX.push(obj);
    //                             console.log(packages_IN_EX);
    //                             console.log('PACK:::', pack_id,packages_IN_EX);
    //                             Promise.all([
    //                                 postService('getMasterIncludesDropDown', 'POST', {"data":{package_id: 'CTH0060', package_name: pack_name,unit_id: user_unit_id,"payment_type":1,"tariff_mapped":"TR1"}}).then(res => res),
    //                                 postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [this.state.procedureValue], package_name: [pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1",status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
    //                             ]).then(([includesResponse, excludesResponse]) => {
    //                                 if (includesResponse && includesResponse.status) {
    //                                     if (includesResponse.data.length > 0) {
    //                                         let includes_data = includesResponse.data;
    //                                         console.log('PACK:::', includes_data);
    //                                         includesSchema.map((subTable, key) => {
    //                                             includes_data.map((ex_data, ex_key) => {
    //                                                 let last_id = 1;
    //                                                 if (includesSchema[key].Specification.table_body.length > 0) {
    //                                                     let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
    //                                                     last_id = last_element['id'];
    //                                                 }
            
    //                                                 let obj = {
    //                                                     "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
    //                                                     id: last_id + 1,
    //                                                     input_feild: [],
    //                                                     text: "Highend",
    //                                                     'key_word': 'add_more',
    //                                                     type: "text"
    //                                                 }
    //                                                 obj['feilds'].map((feild, feild_key) => {
    //                                                     obj['feilds'][feild_key]['id'] = last_id + 1;
            
    //                                                     if (feild.name === 'item_service') {
    //                                                         obj['feilds'][feild_key]['value'] = ex_data.service;
    //                                                         obj['feilds'][feild_key]['title'] = ex_data.service;
    //                                                     }
    //                                                     if(feild.name==='item_package'){
    //                                                         obj['feilds'][feild_key]['value'] = pack_name;
    //                                                         obj['feilds'][feild_key]['title'] = pack_name;
    //                                                     }
    //                                                 })
    //                                                 subTable['Specification']['table_body'].push(obj);
    //                                             })
    //                                         })
    //                                         includesResponse.data.map((item, key) => {
    //                                             newData.push({
    //                                                 "package_id": parseInt(pack_id),
    //                                                 'service_id': item['id'],
    //                                                 'service_nam': item['service'],
    //                                                 "qty": 0,
    //                                                 "rate": 5,
    //                                                 "amount": 5,
            
    //                                             })
            
    //                                         });
    //                                     }
    //                                 }
    //                                 if (excludesResponse && excludesResponse.status) {
    //                                     if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
    //                                         let excludes_data = excludesResponse.data;
    //                                         console.log('excludes_data', excludes_data);
    //                                         excludes_data.map((ex_data, key) => {
    //                                             excludes_data[key]['package_id'] = pack_id;
    //                                             excludes_data[key]['package_name'] = pack_name;
    //                                             excludes_data[key]['unit_id'] = user_unit_id;
    //                                             excludes_data[key]['payment_type'] = 1;
    //                                             excludes_data[key]['tariff_mapped'] = 1;
    //                                             excludes_data[key]['service_name'] = ex_data.service+' - '+pack_name;
    //                                         })
                                          
    //                                         let new_exculude_options =  exculude_options.concat(excludes_data);
    //                                         const exludesconcat =this.state.exludesconcatdata;
    //                                        let exludesconcatdata=exludesconcat.concat(excludes_data);
    //                                        console.log(exludesconcatdata);
        
    //                                         this.setState({exludesconcatdata})
    //                                         optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
    //                                         hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })
    //                                         // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
        
                                            
           
    //                                     }
    //                                 }
    //                             })
    //                             this.setState({
    //                                 inc_excludes_pack_id: inc_excludes_pack_id,
    //                                 includes_data: newData,
    //                                 includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options,additionalPackageSchema
    //                             });
    //                             // console.log('exculude_options',exludesconcatdata);
    //                             this.total_suming();
    //                         } 
                       
    //                     }else{
    //                         if(packages_IN_EX){
    //                             let last_id
    //                             packages_IN_EX.map((item,key)=>{
    //                                 if(item['pack_name']===pack_name){
    //                                     const index = inc_excludes_packages_ids.indexOf(item['pack_id']);
    //                                      last_id=item['pack_id'];
    //                                 if (index > -1) {
    //                                     inc_excludes_packages_ids.splice(index, 1);
    //                                     packages_IN_EX.splice(index, 1);
            
    //                                     includesSchema.map((subTable, key) => {
    //                                         subTable['title'] = '';
    //                                         subTable['name'] = '';
    //                                         if (includesSchema[key].id === 1) {
    //                                             if (includesSchema[key].Specification.table_body.length > 0) {
    //                                                 includesSchema[key].Specification.table_body.length = 0;
    //                                             }
    //                                         } else {
    //                                             includesSchema.splice(1, includesSchema.length)
    //                                         }
    //                                     })
    //                                     packages_IN_EX.length=0;
    //                                     this.setState({ includesSchema,exludesconcatdata:[] });
    //                                     optionsStore.dispatch({ type: 'options_data', 'data': [] });
    //                                 }
                                    
    //                                 }
    //                             });
    //                             let table_data = excludesTableStore.getState();
       
    //                             table_data.map((body, key) => {
    //                                 // body['feilds'].map((feild, feild_key) => {
    //                                     if (body['feilds'][0].name === 'excludes_service_id') {
    //                                         let { selected_option } = body['feilds'][0];
    //                                         if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
    //                                             table_data.splice(key, 1);
    //                                             excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
    //                                             hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:table_data, page: 'finanical-counselling' } })
    //                                         }
    //                                     }
                        
    //                                 // })
                        
    //                             })
    //                             table_data.map((body, key) => {
    //                                 // body['feilds'].map((feild, feild_key) => {
    //                                     if (body['feilds'][0].name === 'excludes_service_id') {
    //                                         let { selected_option } = body['feilds'][0];
    //                                         if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
    //                                             table_data.splice(key, 1);
    //                                             excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
    //                                             hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:table_data, page: 'finanical-counselling' } })
                                                
                                                 
    //                                         }
    //                                     }
                        
    //                                 // })
                        
    //                             })
                        
    //                             packages_IN_EX.length=0;
    //                         }
    //                         if(packages_IN_EX){
    //                             packages_IN_EX.map((ele,key)=>{
    //                                 Promise.all([
    //                                     postService('getMasterIncludesDropDown', 'POST', { data: { package_id: ele.pack_id, package_name: ele.pack_name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: 1 } }).then(res => res),
    //                                     postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [ele.pack_id], package_name: [ele.pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: 1,status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
    //                                 ]).then(([includesResponse, excludesResponse]) => {
    //                                     if (includesResponse && includesResponse.status) {
    //                                         if (includesResponse.data.length > 0) {
    //                                             let includes_data = includesResponse.data;
    //                                             includesSchema.map((subTable, key) => {
    //                                                 includes_data.map((ex_data, ex_key) => {
    //                                                     let last_id = 1;
    //                                                     if (includesSchema[key].Specification.table_body.length > 0) {
    //                                                         let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
    //                                                         last_id = last_element['id'];
    //                                                     }
                
    //                                                     let obj = {
    //                                                         "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
    //                                                         id: last_id + 1,
    //                                                         input_feild: [],
    //                                                         text: "Highend",
    //                                                         'key_word': 'add_more',
    //                                                         type: "text"
    //                                                     }
    //                                                     obj['feilds'].map((feild, feild_key) => {
    //                                                         obj['feilds'][feild_key]['id'] = last_id + 1;
                
    //                                                         if (feild.name === 'item_service') {
    //                                                             obj['feilds'][feild_key]['value'] = ex_data.service;
    //                                                             obj['feilds'][feild_key]['title'] = ex_data.service;
    //                                                         }
    //                                                         if(feild.name==='item_package'){
    //                                                             obj['feilds'][feild_key]['value'] = ele.pack_name;
    //                                                             obj['feilds'][feild_key]['title'] = ele.pack_name;
    //                                                         }
    //                                                     })
    //                                                     subTable['Specification']['table_body'].push(obj);
    //                                                 })
    //                                             })
    //                                             includesResponse.data.map((item, key) => {
    //                                                 newData.push({
    //                                                     "package_id": parseInt(pack_id),
    //                                                     'service_id': item['id'],
    //                                                     'service_nam': item['service'],
    //                                                     "qty": 0,
    //                                                     "rate": 5,
    //                                                     "amount": 5,
                
    //                                                 })
                
    //                                             });
    //                                         }
    //                                     }
    //                                     if (excludesResponse && excludesResponse.status) {
    //                                         if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
    //                                             let excludes_data = excludesResponse.data;
    //                                             console.log('excludes_data', excludes_data);
    //                                             excludes_data.map((ex_data, key) => {
    //                                                 excludes_data[key]['package_id'] = ele.pack_id;
    //                                                 excludes_data[key]['package_name'] = ele.pack_name;
    //                                                 excludes_data[key]['unit_id'] = user_unit_id;
    //                                                 excludes_data[key]['payment_type'] = 1;
    //                                                 excludes_data[key]['tariff_mapped'] = 1;
    //                                                 excludes_data[key]['service_name'] = ex_data.service+' - '+ele.pack_name;
    //                                             })
                                                
    //                                             let new_exculude_options =  exculude_options.concat(excludes_data);
    //                                             const exludesconcat =this.state.exludesconcatdata;
    //                                             let exludesconcatdata=exludesconcat.concat(excludes_data);
    //                                             console.log(exludesconcatdata);
            
    //                                             this.setState({exludesconcatdata})
    //                                             optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
    //                                             hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })

    //                                             // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
            
                                                
                
    //                                         }
    //                                     }
    //                                 })
    //                                 this.setState({
    //                                     inc_excludes_pack_id: inc_excludes_pack_id,
    //                                     includes_data: newData,
    //                                     includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options,packages_IN_EX
    //                                 });
    //                                 // console.log('exculude_options',exludesconcatdata);
    //                                 this.total_suming();
                                
    //                             });
    //                         }
    //                     } 
    //                 }

    //             }else{
    //                 if(!isNaN(pack_id)){
    //                     if (Array.isArray(inc_excludes_packages_ids)?!inc_excludes_packages_ids.includes(pack_id):inc_excludes_packages_ids!==pack_id) {
    //                         inc_excludes_packages_ids.push(parseInt(pack_id));
    //                         let obj={
    //                             'pack_id':pack_id,
    //                             'pack_name':pack_name
    //                         }
    //                         packages_IN_EX.push(obj);
    //                         console.log(packages_IN_EX);
    //                         Promise.all([
    //                             postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: 1 } }).then(res => res),
    //                             postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: 1,status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
    //                         ]).then(([includesResponse, excludesResponse]) => {
    //                             if (includesResponse && includesResponse.status) {
    //                                 if (includesResponse.data.length > 0) {
    //                                     let includes_data = includesResponse.data;
    //                                     includesSchema.map((subTable, key) => {
    //                                         includes_data.map((ex_data, ex_key) => {
    //                                             let last_id = 1;
    //                                             if (includesSchema[key].Specification.table_body.length > 0) {
    //                                                 let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
    //                                                 last_id = last_element['id'];
    //                                             }
        
    //                                             let obj = {
    //                                                 "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
    //                                                 id: last_id + 1,
    //                                                 input_feild: [],
    //                                                 text: "Highend",
    //                                                 'key_word': 'add_more',
    //                                                 type: "text"
    //                                             }
    //                                             obj['feilds'].map((feild, feild_key) => {
    //                                                 obj['feilds'][feild_key]['id'] = last_id + 1;
        
    //                                                 if (feild.name === 'item_service') {
    //                                                     obj['feilds'][feild_key]['value'] = ex_data.service;
    //                                                     obj['feilds'][feild_key]['title'] = ex_data.service;
    //                                                 }
    //                                                 if(feild.name==='item_package'){
    //                                                     obj['feilds'][feild_key]['value'] = pack_name;
    //                                                     obj['feilds'][feild_key]['title'] = pack_name;
    //                                                 }
    //                                             })
    //                                             subTable['Specification']['table_body'].push(obj);
    //                                         })
    //                                     })
    //                                     includesResponse.data.map((item, key) => {
    //                                         newData.push({
    //                                             "package_id": parseInt(pack_id),
    //                                             'service_id': item['id'],
    //                                             'service_nam': item['service'],
    //                                             "qty": 0,
    //                                             "rate": 5,
    //                                             "amount": 5,
        
    //                                         })
        
    //                                     });
    //                                 }
    //                             }
    //                             if (excludesResponse && excludesResponse.status) {
    //                                 if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
    //                                     let excludes_data = excludesResponse.data;
    //                                     console.log('excludes_data', excludes_data);
    //                                     excludes_data.map((ex_data, key) => {
    //                                         excludes_data[key]['package_id'] = pack_id;
    //                                         excludes_data[key]['package_name'] = pack_name;
    //                                         excludes_data[key]['unit_id'] = user_unit_id;
    //                                         excludes_data[key]['payment_type'] = 1;
    //                                         excludes_data[key]['tariff_mapped'] = 1;
    //                                         excludes_data[key]['service_name'] = ex_data.service+' - '+pack_name;
    //                                     })
                                      
    //                                     let new_exculude_options =  exculude_options.concat(excludes_data);
    //                                     const exludesconcat =this.state.exludesconcatdata;
    //                                    let exludesconcatdata=exludesconcat.concat(excludes_data);
    //                                    console.log(exludesconcatdata);
    
    //                                     this.setState({exludesconcatdata})
    //                                     optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
    //                                     hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })
    //                                     // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
    
                                        
       
    //                                 }
    //                             }
    //                         })
    //                         this.setState({
    //                             inc_excludes_pack_id: inc_excludes_pack_id,
    //                             includes_data: newData,
    //                             includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options
    //                         });
    //                         // console.log('exculude_options',exludesconcatdata);
    //                         this.total_suming();
    //                     } 
                   
    //                 } 
    //             }
                
    //         } catch (error) {
    //             console.log(error);
    //             this.setState({ 'loadding': false });
    //         }      
                    
                    
                    



    // }
    getExcludesIncludes(pack_id, pack_name,intial) {
        try {
            let { counselling_details } = this.props;
        let { inc_excludes_pack_id, inc_excludes_packages_ids, includesSchema, excludesSchema, tariff_mapped ,packages_IN_EX,additionalPackageSchema,exclude_slug_fordropdown} = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let newData = [];
       
                let { exculude_options } = this.state;
                if(intial===0){
                    if(packages_IN_EX){
                        if((pack_id)){
                            inc_excludes_packages_ids.length=0;
                            packages_IN_EX.length=0;
                            includesSchema.map((subTable, key) => {
                                subTable['title'] = '';
                                subTable['name'] = '';
                                if (includesSchema[key].id === 1) {
                                    if (includesSchema[key].Specification.table_body.length > 0) {
                                        includesSchema[key].Specification.table_body.length = 0;
                                    }
                                } else {
                                    includesSchema.splice(1, includesSchema.length)
                                }
                            })

                             additionalPackageSchema.map((subTable, key) => {
                                let table_body = subTable.Specification.table_body;
                                subTable.visible=false;
                                // additionalPackageSchema[key].Specification.add_more = true;
                                table_body.map((feild, table_key) => {
                                    // additionalPackageSchema[key].Specification.table_body.length=0;
                                    if (table_body.length > 0) {
                                        let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.element === 'input' || sub_feild.element === 'select') {
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'additional_package_name') {
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                    if (sub_feild.name === 'amount') {
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = true;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                                        additionalPackageSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                                    }
                                })
                                            // additionalPackageSchema[key].Specification.table_body.splice(table_key, 1)
                                    }
                                })
                            })
                            this.setState({ includesSchema,exludesconcatdata:[],additionalPackageSchema });
                            optionsStore.dispatch({ type: 'options_data', 'data': [] });
                            if (Array.isArray(inc_excludes_packages_ids)?!inc_excludes_packages_ids.includes(pack_id):inc_excludes_packages_ids!==pack_id) {
                                inc_excludes_packages_ids.push(parseInt(pack_id));
                                let obj={
                                    'pack_id':pack_id,
                                    'pack_name':pack_name
                                }
                                packages_IN_EX.push(obj);
                                Promise.all([
                                    postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" } }).then(res => res),
                                    postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1",status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
                                ]).then(([includesResponse, excludesResponse]) => {
                                    if (includesResponse && includesResponse.status) {
                                        if (includesResponse.data.length > 0) {
                                            let includes_data = includesResponse.data;
                                            includesSchema.map((subTable, key) => {
                                                includes_data.map((ex_data, ex_key) => {
                                                    let last_id = 1;
                                                    if (includesSchema[key].Specification.table_body.length > 0) {
                                                        let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                        last_id = last_element['id'];
                                                    }
            
                                                    let obj = {
                                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                        id: last_id + 1,
                                                        input_feild: [],
                                                        text: "Highend",
                                                        'key_word': 'add_more',
                                                        type: "text"
                                                    }
                                                    let totalAmount = 0;
                                                    obj['feilds'].map((feild, feild_key) => {
                                                        obj['feilds'][feild_key]['id'] = last_id + 1;
            
                                                        // if (feild.name === 'item_service') {
                                                        //     obj['feilds'][feild_key]['value'] = ex_data.service;
                                                        //     obj['feilds'][feild_key]['title'] = ex_data.service;
                                                        // }
                                                        // if(feild.name==='quantity'){
                                                        //     obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                        //     obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                        // }
                                                        // if(feild.name==='rate'){
                                                        //     obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                        //     obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                        // }
                                                        // if(feild.name==='amount'){
                                                        //     obj['feilds'][feild_key]['value'] = ex_data.qty*ex_data.rate;
                                                        //     obj['feilds'][feild_key]['title'] = ex_data.qty*ex_data.rate;
                                                        // }
                                                        if (feild.name === 'servicetype') {
                                                            obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                            obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                        }
                                                        if (feild.name === 'servicegroup') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                            obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                        }
                                                        if (feild.name === 'item_service') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.service;
                                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                                        }
                                                        if (feild.name === 'item_package') {
                                                            obj['feilds'][feild_key]['value'] = pack_name;
                                                            obj['feilds'][feild_key]['title'] = pack_name;
                                                        }
                                                        if (feild.name === 'item_qty') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                            obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                        }
                                                        if (feild.name === 'item_rate') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                            obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                        }if (feild.name === 'item_amount') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                            obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                        }if (feild.name === 'equservicecd') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                            obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                        }
                                                        if (feild.name === 'isactive') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                            obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                        }
                                                        if (feild.name === 'ward_name') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                            obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                        }
                                                        if (feild.name === 'level1_desc') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                            obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                        }
                                                    })
                                                    subTable['Specification']['table_body'].push(obj);
                                                    
                                                })
                                            })
                                            includesResponse.data.map((item, key) => {
                                                newData.push({
                                                    "package_id": (pack_id),
                                                    'service_id': item['id'],
                                                    'service_nam': item['service'],
                                                    "qty": 0,
                                                    "rate": 5,
                                                    "amount": 5,
            
                                                })
            
                                            });
                                        }
                                    }
                                    if (excludesResponse && excludesResponse.status) {
                                        if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                            let excludes_data = excludesResponse.data;
                                            console.log('excludes_data', excludes_data);
                                            // excludes_data.map((ex_data, key) => {
                                            //     excludes_data[key]['package_id'] = pack_id;
                                            //     excludes_data[key]['package_name'] = pack_name;
                                            //     excludes_data[key]['unit_id'] = user_unit_id;
                                            //     excludes_data[key]['payment_type'] = 1;
                                            //     excludes_data[key]['tariff_mapped'] = 1;
                                            //     excludes_data[key]['service_name'] = ex_data.service+' - '+pack_name;
                                            // })
                                            excludesSchema.map((subTable, key) => {
                                                excludes_data.map((ex_data, ex_key) => {
                                                    let last_id = 1;
                                                    if (excludesSchema[key].Specification.table_body.length > 0) {
                                                        let last_element = excludesSchema[key].Specification.table_body[excludesSchema[key].Specification.table_body.length - 1];
                                                        last_id = last_element['id'];
                                                    }
            
                                                    let obj = {
                                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                        id: last_id + 1,
                                                        input_feild: [],
                                                        text: "Highend",
                                                        'key_word': 'add_more',
                                                        type: "text"
                                                    }
                                                    let totalAmount = 0;
                                                    obj['feilds'].map((feild, feild_key) => {
                                                        obj['feilds'][feild_key]['id'] = last_id + 1;
            
                                                        if (feild.name === 'servicetype') {
                                                            obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                            obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                        }
                                                        if (feild.name === 'servicegroup') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                            obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                        }
                                                        if (feild.name === 'excludes_service_id') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.service;
                                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                                        }
                                                        if (feild.name === 'item_package') {
                                                            obj['feilds'][feild_key]['value'] = pack_name;
                                                            obj['feilds'][feild_key]['title'] = pack_name;
                                                        }
                                                        if (feild.name === 'qty') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                            obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                        }
                                                        if (feild.name === 'rate') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                            obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                        }
                                                        if (feild.name === 'amount') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                            obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                        }
                                                        if (feild.name === 'equservicecd') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                            obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                        }
                                                        if (feild.name === 'isactive') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                            obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                        }
                                                        if (feild.name === 'ward_name') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                            obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                        }
                                                        if (feild.name === 'level1_desc') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                            obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                        }
                                                    })
                                                    subTable['Specification']['table_body'].push(obj);
                                                    
                                                })
                                            })
                                        //     let new_exculude_options =  exculude_options.concat(includesResponse);
                                        //     const exludesconcat =this.state.exludesconcatdata;
                                        //    let exludesconcatdata=exludesconcat.concat(excludes_data);
                                        //    console.log(exludesconcatdata);
        
                                        //     this.setState({exludesconcatdata})
                                        //     optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                        //     hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })
                                            // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
        
                                            
           
                                        }
                                    }
                                })
                                this.setState({
                                    inc_excludes_pack_id: inc_excludes_pack_id,
                                    includes_data: newData,
                                    includesSchema: includesSchema, excludesSchema: excludesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options,additionalPackageSchema,
                                    isLoading: false
                                });
                                // console.log('exculude_options',exludesconcatdata);
                                this.total_suming();
                            } 
                       
                        }else{
                            if(packages_IN_EX){
                                let last_id
                                packages_IN_EX.map((item,key)=>{
                                    if(item['pack_name']===pack_name){
                                        const index = inc_excludes_packages_ids.indexOf(item['pack_id']);
                                         last_id=item['pack_id'];
                                    if (index > -1) {
                                        inc_excludes_packages_ids.splice(index, 1);
                                        packages_IN_EX.splice(index, 1);
            
                                        includesSchema.map((subTable, key) => {
                                            subTable['title'] = '';
                                            subTable['name'] = '';
                                            if (includesSchema[key].id === 1) {
                                                if (includesSchema[key].Specification.table_body.length > 0) {
                                                    includesSchema[key].Specification.table_body.length = 0;
                                                }
                                            } else {
                                                includesSchema.splice(1, includesSchema.length)
                                            }
                                        })
                                        packages_IN_EX.length=0;
                                        this.setState({ includesSchema,exludesconcatdata:[] });
                                        optionsStore.dispatch({ type: 'options_data', 'data': [] });
                                    }
                                    
                                    }
                                });
                                let table_data = excludesTableStore.getState();
       
                                table_data.map((body, key) => {
                                    // body['feilds'].map((feild, feild_key) => {
                                        if (body['feilds'][0].name === 'excludes_service_id') {
                                            let { selected_option } = body['feilds'][0];
                                            if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                                                table_data.splice(key, 1);
                                                excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                                                hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:table_data, page: 'finanical-counselling' } })
                                            }
                                        }
                        
                                    // })
                        
                                })
                                table_data.map((body, key) => {
                                    // body['feilds'].map((feild, feild_key) => {
                                        if (body['feilds'][0].name === 'excludes_service_id') {
                                            let { selected_option } = body['feilds'][0];
                                            if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                                                table_data.splice(key, 1);
                                                excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                                                hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:table_data, page: 'finanical-counselling' } })
                                                
                                                 
                                            }
                                        }
                        
                                    // })
                        
                                })
                        
                                packages_IN_EX.length=0;
                            }
                            if(packages_IN_EX){
                                packages_IN_EX.map((ele,key)=>{
                                    Promise.all([
                                        postService('getMasterIncludesDropDown', 'POST', { data: { package_id: ele.pack_id, package_name: ele.pack_name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" } }).then(res => res),
                                        postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [ele.pack_id], package_name: [ele.pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1",status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
                                    ]).then(([includesResponse, excludesResponse]) => {
                                        if (includesResponse && includesResponse.status) {
                                            if (includesResponse.data.length > 0) {
                                                let includes_data = includesResponse.data;
                                                includesSchema.map((subTable, key) => {
                                                    includes_data.map((ex_data, ex_key) => {
                                                        let last_id = 1;
                                                        if (includesSchema[key].Specification.table_body.length > 0) {
                                                            let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                            last_id = last_element['id'];
                                                        }
                
                                                        let obj = {
                                                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                            id: last_id + 1,
                                                            input_feild: [],
                                                            text: "Highend",
                                                            'key_word': 'add_more',
                                                            type: "text"
                                                        }
                                                        obj['feilds'].map((feild, feild_key) => {
                                                            obj['feilds'][feild_key]['id'] = last_id + 1;
                
                                                            // if (feild.name === 'item_service') {
                                                            //     obj['feilds'][feild_key]['value'] = ex_data.service;
                                                            //     obj['feilds'][feild_key]['title'] = ex_data.service;
                                                            // }
                                                            // if(feild.name==='item_package'){
                                                            //     obj['feilds'][feild_key]['value'] = ele.pack_name;
                                                            //     obj['feilds'][feild_key]['title'] = ele.pack_name;
                                                            // }
                                                            if (feild.name === 'servicetype') {
                                                                // obj['feilds'][feild_key]['value'] = ex_data.servicetype === 'I' ? 'Investigations' : ex_data.servicetype === 'PF' ? 'Professional' : 'Services';
                                                                // obj['feilds'][feild_key]['title'] = ex_data.servicetype === 'I' ? 'Investigations' : ex_data.servicetype === 'PF' ? 'Professional' : 'Services';
                                                                obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                                obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                            }
                                                            if (feild.name === 'servicegroup') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                                obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                            }
                                                            if (feild.name === 'item_service') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.service;
                                                                obj['feilds'][feild_key]['title'] = ex_data.service;
                                                            }
                                                            if (feild.name === 'item_package') {
                                                                obj['feilds'][feild_key]['value'] = pack_name;
                                                                obj['feilds'][feild_key]['title'] = pack_name;
                                                            }
                                                            if (feild.name === 'item_qty') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                                obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                            }
                                                            if (feild.name === 'item_rate') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                                obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                            }if (feild.name === 'item_amount') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                                obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                            }if (feild.name === 'equservicecd') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                                obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                            }
                                                            if (feild.name === 'isactive') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                                obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                            }
                                                            if (feild.name === 'ward_name') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                                obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                            }
                                                            if (feild.name === 'level1_desc') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                                obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                            }
                                                        })
                                                        subTable['Specification']['table_body'].push(obj);
                                                    })
                                                })
                                                includesResponse.data.map((item, key) => {
                                                    newData.push({
                                                        "package_id": (pack_id),
                                                        'service_id': item['id'],
                                                        'service_nam': item['service'],
                                                        "qty": 0,
                                                        "rate": 5,
                                                        "amount": 5,
                
                                                    })
                
                                                });
                                            }
                                        }
                                        if (excludesResponse && excludesResponse.status) {
                                            if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                                let excludes_data = excludesResponse.data;
                                                console.log('excludes_data', excludes_data);
                                                // excludes_data.map((ex_data, key) => {
                                                //     excludes_data[key]['package_id'] = ele.pack_id;
                                                //     excludes_data[key]['package_name'] = ele.pack_name;
                                                //     excludes_data[key]['unit_id'] = user_unit_id;
                                                //     excludes_data[key]['payment_type'] = 1;
                                                //     excludes_data[key]['tariff_mapped'] = 1;
                                                //     excludes_data[key]['service_name'] = ex_data.service+' - '+ele.pack_name;
                                                // })
                                                excludesSchema.map((subTable, key) => {
                                                    excludes_data.map((ex_data, ex_key) => {
                                                        let last_id = 1;
                                                        if (excludesSchema[key].Specification.table_body.length > 0) {
                                                            let last_element = excludesSchema[key].Specification.table_body[excludesSchema[key].Specification.table_body.length - 1];
                                                            last_id = last_element['id'];
                                                        }
                
                                                        let obj = {
                                                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                            id: last_id + 1,
                                                            input_feild: [],
                                                            text: "Highend",
                                                            'key_word': 'add_more',
                                                            type: "text"
                                                        }
                                                        let totalAmount = 0;
                                                        obj['feilds'].map((feild, feild_key) => {
                                                            obj['feilds'][feild_key]['id'] = last_id + 1;
                
                                                            if (feild.name === 'servicetype') {
                                                                obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                                obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                            }
                                                            if (feild.name === 'servicegroup') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                                obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                            }
                                                            if (feild.name === 'excludes_service_id') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.service;
                                                                obj['feilds'][feild_key]['title'] = ex_data.service;
                                                            }
                                                            if (feild.name === 'item_package') {
                                                                obj['feilds'][feild_key]['value'] = pack_name;
                                                                obj['feilds'][feild_key]['title'] = pack_name;
                                                            }
                                                            if (feild.name === 'qty') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                                obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                            }
                                                            if (feild.name === 'rate') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                                obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                            }
                                                            if (feild.name === 'amount') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                                obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                            }
                                                            if (feild.name === 'equservicecd') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                                obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                            }
                                                            if (feild.name === 'isactive') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                                obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                            }
                                                            if (feild.name === 'ward_name') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                                obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                            }
                                                            if (feild.name === 'level1_desc') {
                                                                obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                                obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                            }
                                                        })
                                                        subTable['Specification']['table_body'].push(obj);
                                                        
                                                    })
                                                })
                                                
                                                let new_exculude_options =  exculude_options.concat(excludes_data);
                                                const exludesconcat =this.state.exludesconcatdata;
                                                let exludesconcatdata=exludesconcat.concat(excludes_data);
                                                console.log(exludesconcatdata);
            
                                                this.setState({exludesconcatdata})
                                                optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                                hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })

                                                // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
            
                                                
                
                                            }
                                        }
                                    })
                                    this.setState({
                                        inc_excludes_pack_id: inc_excludes_pack_id,
                                        includes_data: newData,
                                        includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options,packages_IN_EX
                                    });
                                    // console.log('exculude_options',exludesconcatdata);
                                    this.total_suming();
                                
                                });
                            }
                        } 
                    }
                    else{
                        if((pack_id)){
                            if (Array.isArray(inc_excludes_packages_ids)?!inc_excludes_packages_ids.includes(pack_id):inc_excludes_packages_ids!==pack_id) {
                                inc_excludes_packages_ids.push(parseInt(pack_id));
                                let obj={
                                    'pack_id':pack_id,
                                    'pack_name':pack_name
                                }
                                packages_IN_EX.push(obj);
                                console.log(packages_IN_EX);
                                Promise.all([
                                    postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" } }).then(res => res),
                                    postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1",status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
                                ]).then(([includesResponse, excludesResponse]) => {
                                    if (includesResponse && includesResponse.status) {
                                        if (includesResponse.data.length > 0) {
                                            let includes_data = includesResponse.data;
                                            includesSchema.map((subTable, key) => {
                                                includes_data.map((ex_data, ex_key) => {
                                                    let last_id = 1;
                                                    if (includesSchema[key].Specification.table_body.length > 0) {
                                                        let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                        last_id = last_element['id'];
                                                    }
            
                                                    let obj = {
                                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                        id: last_id + 1,
                                                        input_feild: [],
                                                        text: "Highend",
                                                        'key_word': 'add_more',
                                                        type: "text"
                                                    }
                                                    obj['feilds'].map((feild, feild_key) => {
                                                        obj['feilds'][feild_key]['id'] = last_id + 1;
            
                                                        // if (feild.name === 'item_service') {
                                                        //     obj['feilds'][feild_key]['value'] = ex_data.service;
                                                        //     obj['feilds'][feild_key]['title'] = ex_data.service;
                                                        // }
                                                        // if(feild.name==='item_package'){
                                                        //     obj['feilds'][feild_key]['value'] = pack_name;
                                                        //     obj['feilds'][feild_key]['title'] = pack_name;
                                                        // }
                                                        if (feild.name === 'servicetype') {
                                                            obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                            obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                        }
                                                        if (feild.name === 'servicegroup') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                            obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                        }
                                                        if (feild.name === 'item_service') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.service;
                                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                                        }
                                                        if (feild.name === 'item_package') {
                                                            obj['feilds'][feild_key]['value'] = pack_name;
                                                            obj['feilds'][feild_key]['title'] = pack_name;
                                                        }
                                                        if (feild.name === 'item_qty') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                            obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                        }
                                                        if (feild.name === 'item_rate') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                            obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                        }if (feild.name === 'item_amount') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                            obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                        }if (feild.name === 'equservicecd') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                            obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                        }
                                                        if (feild.name === 'isactive') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                            obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                        }
                                                        if (feild.name === 'ward_name') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                            obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                        }
                                                        if (feild.name === 'level1_desc') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                            obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                        }
                                                    })
                                                    subTable['Specification']['table_body'].push(obj);
                                                })
                                            })
                                            includesResponse.data.map((item, key) => {
                                                newData.push({
                                                    "package_id": (pack_id),
                                                    'service_id': item['id'],
                                                    'service_nam': item['service'],
                                                    "qty": 0,
                                                    "rate": 5,
                                                    "amount": 5,
            
                                                })
            
                                            });
                                        }
                                    }
                                    if (excludesResponse && excludesResponse.status) {
                                        if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                            let excludes_data = excludesResponse.data;
                                            console.log('excludes_data', excludes_data);
                                            // excludes_data.map((ex_data, key) => {
                                            //     excludes_data[key]['package_id'] = pack_id;
                                            //     excludes_data[key]['package_name'] = pack_name;
                                            //     excludes_data[key]['unit_id'] = user_unit_id;
                                            //     excludes_data[key]['payment_type'] = 1;
                                            //     excludes_data[key]['tariff_mapped'] = 1;
                                            //     excludes_data[key]['service_name'] = ex_data.service+' - '+pack_name;
                                            // })
                                            excludesSchema.map((subTable, key) => {
                                                excludes_data.map((ex_data, ex_key) => {
                                                    let last_id = 1;
                                                    if (excludesSchema[key].Specification.table_body.length > 0) {
                                                        let last_element = excludesSchema[key].Specification.table_body[excludesSchema[key].Specification.table_body.length - 1];
                                                        last_id = last_element['id'];
                                                    }
            
                                                    let obj = {
                                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                        id: last_id + 1,
                                                        input_feild: [],
                                                        text: "Highend",
                                                        'key_word': 'add_more',
                                                        type: "text"
                                                    }
                                                    let totalAmount = 0;
                                                    obj['feilds'].map((feild, feild_key) => {
                                                        obj['feilds'][feild_key]['id'] = last_id + 1;
            
                                                        if (feild.name === 'servicetype') {
                                                            obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                            obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                        }
                                                        if (feild.name === 'servicegroup') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                            obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                        }
                                                        if (feild.name === 'excludes_service_id') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.service;
                                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                                        }
                                                        if (feild.name === 'item_package') {
                                                            obj['feilds'][feild_key]['value'] = pack_name;
                                                            obj['feilds'][feild_key]['title'] = pack_name;
                                                        }
                                                        if (feild.name === 'qty') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                            obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                        }
                                                        if (feild.name === 'rate') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                            obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                        }
                                                        if (feild.name === 'amount') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                            obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                        }
                                                        if (feild.name === 'equservicecd') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                            obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                        }
                                                        if (feild.name === 'isactive') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                            obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                        }
                                                        if (feild.name === 'ward_name') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                            obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                        }
                                                        if (feild.name === 'level1_desc') {
                                                            obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                            obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                        }
                                                    })
                                                    subTable['Specification']['table_body'].push(obj);
                                                    
                                                })
                                            })
                                          
                                            let new_exculude_options =  exculude_options.concat(excludes_data);
                                            const exludesconcat =this.state.exludesconcatdata;
                                           let exludesconcatdata=exludesconcat.concat(excludes_data);
                                           console.log(exludesconcatdata);
        
                                            this.setState({exludesconcatdata})
                                            optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                            hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })
                                            // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
        
                                            
           
                                        }
                                    }
                                })
                                this.setState({
                                    inc_excludes_pack_id: inc_excludes_pack_id,
                                    includes_data: newData,
                                    includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options
                                });
                                // console.log('exculude_options',exludesconcatdata);
                                this.total_suming();
                            } 
                       
                        }
                    }
                }else{
                    if((pack_id)){
                        if (Array.isArray(inc_excludes_packages_ids)?!inc_excludes_packages_ids.includes(pack_id):inc_excludes_packages_ids!==pack_id) {
                            inc_excludes_packages_ids.push(parseInt(pack_id));
                            let obj={
                                'pack_id':pack_id,
                                'pack_name':pack_name
                            }
                            packages_IN_EX.push(obj);
                            console.log(packages_IN_EX);
                            Promise.all([
                                postService('getMasterIncludesDropDown', 'POST', { data: { package_id: pack_id, package_name: pack_name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" } }).then(res => res),
                                postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [pack_id], package_name: [pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1",status:exclude_slug_fordropdown==='view-finanical-counselling'?0:1 } }).then(res => res)
                            ]).then(([includesResponse, excludesResponse]) => {
                                if (includesResponse && includesResponse.status) {
                                    if (includesResponse.data.length > 0) {
                                        let includes_data = includesResponse.data;
                                        includesSchema.map((subTable, key) => {
                                            includes_data.map((ex_data, ex_key) => {
                                                let last_id = 1;
                                                if (includesSchema[key].Specification.table_body.length > 0) {
                                                    let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                    last_id = last_element['id'];
                                                }
        
                                                let obj = {
                                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                    id: last_id + 1,
                                                    input_feild: [],
                                                    text: "Highend",
                                                    'key_word': 'add_more',
                                                    type: "text"
                                                }
                                                obj['feilds'].map((feild, feild_key) => {
                                                    obj['feilds'][feild_key]['id'] = last_id + 1;
        
                                                    // if (feild.name === 'item_service') {
                                                    //     obj['feilds'][feild_key]['value'] = ex_data.service;
                                                    //     obj['feilds'][feild_key]['title'] = ex_data.service;
                                                    // }
                                                    // if(feild.name==='item_package'){
                                                    //     obj['feilds'][feild_key]['value'] = pack_name;
                                                    //     obj['feilds'][feild_key]['title'] = pack_name;
                                                    // }
                                                    if (feild.name === 'servicetype') {
                                                        obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                        obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                    }
                                                    if (feild.name === 'servicegroup') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                        obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                    }
                                                    if (feild.name === 'item_service') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.service;
                                                        obj['feilds'][feild_key]['title'] = ex_data.service;
                                                    }
                                                    if (feild.name === 'item_package') {
                                                        obj['feilds'][feild_key]['value'] = pack_name;
                                                        obj['feilds'][feild_key]['title'] = pack_name;
                                                    }
                                                    if (feild.name === 'item_qty') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                        obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                    }
                                                    if (feild.name === 'item_rate') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                        obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                    }if (feild.name === 'item_amount') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                        obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                    }if (feild.name === 'equservicecd') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                        obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                    }
                                                    if (feild.name === 'isactive') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                        obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                    }
                                                    if (feild.name === 'ward_name') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                        obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                    }
                                                    if (feild.name === 'level1_desc') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                        obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                    }
                                                })
                                                subTable['Specification']['table_body'].push(obj);
                                            })
                                        })
                                        includesResponse.data.map((item, key) => {
                                            newData.push({
                                                "package_id": (pack_id),
                                                'service_id': item['id'],
                                                'service_nam': item['service'],
                                                "qty": 0,
                                                "rate": 5,
                                                "amount": 5,
        
                                            })
        
                                        });
                                    }
                                }
                                if (excludesResponse && excludesResponse.status) {
                                    if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                        let excludes_data = excludesResponse.data;
                                        console.log('excludes_data', excludes_data);
                                        // excludes_data.map((ex_data, key) => {
                                        //     excludes_data[key]['package_id'] = pack_id;
                                        //     excludes_data[key]['package_name'] = pack_name;
                                        //     excludes_data[key]['unit_id'] = user_unit_id;
                                        //     excludes_data[key]['payment_type'] = 1;
                                        //     excludes_data[key]['tariff_mapped'] = 1;
                                        //     excludes_data[key]['service_name'] = ex_data.service+' - '+pack_name;
                                        // })
                                        excludesSchema.map((subTable, key) => {
                                            excludes_data.map((ex_data, ex_key) => {
                                                let last_id = 1;
                                                if (excludesSchema[key].Specification.table_body.length > 0) {
                                                    let last_element = excludesSchema[key].Specification.table_body[excludesSchema[key].Specification.table_body.length - 1];
                                                    last_id = last_element['id'];
                                                }
        
                                                let obj = {
                                                    "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                    id: last_id + 1,
                                                    input_feild: [],
                                                    text: "Highend",
                                                    'key_word': 'add_more',
                                                    type: "text"
                                                }
                                                let totalAmount = 0;
                                                obj['feilds'].map((feild, feild_key) => {
                                                    obj['feilds'][feild_key]['id'] = last_id + 1;
        
                                                    if (feild.name === 'servicetype') {
                                                        obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                        obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                    }
                                                    if (feild.name === 'servicegroup') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                        obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                    }
                                                    if (feild.name === 'excludes_service_id') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.service;
                                                        obj['feilds'][feild_key]['title'] = ex_data.service;
                                                    }
                                                    if (feild.name === 'item_package') {
                                                        obj['feilds'][feild_key]['value'] = pack_name;
                                                        obj['feilds'][feild_key]['title'] = pack_name;
                                                    }
                                                    if (feild.name === 'qty') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                        obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                    }
                                                    if (feild.name === 'rate') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                        obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                    }
                                                    if (feild.name === 'amount') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                        obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                    }
                                                    if (feild.name === 'equservicecd') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                        obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                    }
                                                    if (feild.name === 'isactive') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                        obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                    }
                                                    if (feild.name === 'ward_name') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                        obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                    }
                                                    if (feild.name === 'level1_desc') {
                                                        obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                        obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                    }
                                                })
                                                subTable['Specification']['table_body'].push(obj);
                                                
                                            })
                                        })
                                      
                                        let new_exculude_options =  exculude_options.concat(excludes_data);
                                        const exludesconcat =this.state.exludesconcatdata;
                                       let exludesconcatdata=exludesconcat.concat(excludes_data);
                                       console.log(exludesconcatdata);
    
                                        this.setState({exludesconcatdata})
                                        optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                        hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })
                                        // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
    
                                        
       
                                    }
                                }
                            })
                            this.setState({
                                inc_excludes_pack_id: inc_excludes_pack_id,
                                includes_data: newData,
                                includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options
                            });
                            // console.log('exculude_options',exludesconcatdata);
                            this.total_suming();
                        } 
                   
                    } 
                }
                
            } catch (error) {
                console.log(error);
                this.setState({ 'loadding': false });
            }      
                    
                    
                    



    }
   
    drugaAdminCharges() {
        try {
        let { addonSchema, medicationDetailsSchema, configuration } = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let care_management = null;
        let data_value = 0;
        let drug_admin_charges_total_amount = 0;

        medicationDetailsSchema.map((feild, key) => {

            if (feild['name'] === 'care_management') {
                care_management = feild['value'];
            }
        })
        addonSchema.map((subTable, key) => {
            if (subTable.name === 'icu_pharmacy_charges' || subTable.name === 'ip_pharmacy_charges' || subTable.name === 'ot_cath_pharmacy') {
                if (care_management == 1 && subTable.name === 'ot_cath_pharmacy') {
                    subTable['header_amount'] = 0;
                }
                if (subTable.header_amount !== 0) {
                    drug_admin_charges_total_amount = drug_admin_charges_total_amount + subTable.header_amount;
                }
                // addonSchema[key]['header_amount'] = header_amount;
            }
        })
        let drug_admin_charges = 0;
        if (drug_admin_charges_total_amount !== 0) {
            let percentage = 0;
            if (configuration.length > 0) {
                configuration.map((feild, key) => {
                    if (feild.config_name === 'Drug admin charges') {
                        percentage = feild.bill_tracking_percent;
                    }
                })
                drug_admin_charges = Math.round((drug_admin_charges_total_amount * parseFloat(percentage)) / 100);
                if (drug_admin_charges !== 0) {
                    addonSchema.map((subTable, key) => {
                        if (subTable.name === 'drug_admin_charges') {
                            let table_body = subTable.Specification.table_body;
                            table_body.map((feild, table_key) => {
                                // if (data.value !== '' && data.value !== null && data.value !== undefined && !isNaN(parseFloat(data.value))) {
                                //     data_value = data.value;
                                // }
                                let row = feild.feilds;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === "qty") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = drug_admin_charges

                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(drug_admin_charges) * parseFloat(1);
                                    }
                                })
                            })
                        }
                    })
                    this.setState({ addonSchema: addonSchema });
                    this.total_suming();
                }
            }
        }
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }      
        
    }

    deleteRow(data) {
        try {
        let { addonSchema, additionalPackageSchema, additionalProcedureSchema, inc_excludes_packages_ids,packages_IN_EX, exculude_options,inc_excludes_pack_id ,includesSchema,exclude_slug_fordropdown } = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let table_name = data[0].feilds[0].table;
        let last_id = data[0].feilds[0].id;
        let newData = [];
        let ot_inst_disinfec=0;
        if (Array.isArray(data)) {
            addonSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            addonSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })
        if(table_name==='ot_charges'){
            ot_inst_disinfec= data[0].feilds[1].charges;
            addonSchema.map((subTable, key) => {
                if (subTable.name === 'ot_charges') {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        let rates=0;
                        if (feild.key_word === 'ot_inst_disinfec') {
                            row.map((sub_feild, sub_table_key) => {
                               
                                if (sub_feild.name === "rate") {
                                    rates=addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = rates-ot_inst_disinfec
                                }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = rates-ot_inst_disinfec
                                }
                            })
                        }
                    

                    })
                }
            })
            this.total_suming();
        }
           

          
            additionalPackageSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            let { feilds } = feild
                            // try {
                                feilds.map((input_data) => {
                                    console.log('inc_excludes_packages_ids', input_data, excludesTableStore.getState(), optionsStore.getState());
                                    if (input_data['name'] === 'additional_package_name') {
                                        if(packages_IN_EX){
                                            packages_IN_EX.map((item,key)=>{
                                                if(item['pack_id']===input_data['value']){
                                                    const index = inc_excludes_packages_ids.indexOf(item['pack_id']);
                                                if (index > -1) {
                                                    inc_excludes_packages_ids.splice(index, 1);
                                                    packages_IN_EX.splice(index, 1);
                        
                                                    includesSchema.map((subTable, key) => {
                                                        subTable['title'] = '';
                                                        subTable['name'] = '';
                                                        if (includesSchema[key].id === 1) {
                                                            if (includesSchema[key].Specification.table_body.length > 0) {
                                                                includesSchema[key].Specification.table_body.length = 0;
                                                            }
                                                        } else {
                                                            includesSchema.splice(1, includesSchema.length)
                                                        }
                                                    })
                                                    this.setState({ includesSchema,exludesconcatdata:[] });
                                                    optionsStore.dispatch({ type: 'options_data', 'data': [] });
                        
                                                    
                        
                                                }
                                                   
                                                }
                                            });
                                        }
                                            if(packages_IN_EX){
                                                packages_IN_EX.map((ele,key)=>{
                                                    Promise.all([
                                                        // postService('getMasterIncludesDropDown', 'POST', {"data":{package_id: "CTH0060", package_name: "CABG","unit_id":"UN0","payment_type":1,"tariff_mapped":"TR1"}}).then(res => res),
                                                        // postService('getMasterIncludesDropDown', 'POST', { data: { package_id: [ele.pack_id], package_name: [ele.pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" } }).then(res => res),
                                                        // postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [ele.pack_id], package_name: [ele.pack_name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1",status:exclude_slug_fordropdown === 'view-finanical-counselling'?0:1 } }).then(res => res)
                                                    ]).then(([includesResponse, excludesResponse]) => {
                                                        if (includesResponse && includesResponse.status) {
                                                            if (includesResponse.data.length > 0) {
                                                                let includes_data = includesResponse.data;
                                                                includesSchema.map((subTable, key) => {
                                                                    includes_data.map((ex_data, ex_key) => {
                                                                        let last_id = 1;
                                                                        if (includesSchema[key].Specification.table_body.length > 0) {
                                                                            let last_element = includesSchema[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                                                            last_id = last_element['id'];
                                                                        }
                                
                                                                        let obj = {
                                                                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                                            id: last_id + 1,
                                                                            input_feild: [],
                                                                            text: "Highend",
                                                                            'key_word': 'add_more',
                                                                            type: "text"
                                                                        }
                                                                        obj['feilds'].map((feild, feild_key) => {
                                                                            obj['feilds'][feild_key]['id'] = last_id + 1;
                                
                                                                            // if (feild.name === 'item_service') {
                                                                            //     obj['feilds'][feild_key]['value'] = ex_data.service;
                                                                            //     obj['feilds'][feild_key]['title'] = ex_data.service;
                                                                            // }
                                                                            // if(feild.name==='item_package'){
                                                                            //     obj['feilds'][feild_key]['value'] = ele.pack_name;
                                                                            //     obj['feilds'][feild_key]['title'] = ele.pack_name;
                                                                            // }
                                                                            if (feild.name === 'servicetype') {
                                                                                obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                                                obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                                            }
                                                                            if (feild.name === 'servicegroup') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                                                obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                                            }
                                                                            if (feild.name === 'item_service') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.service;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.service;
                                                                            }
                                                                            if (feild.name === 'item_package') {
                                                                                obj['feilds'][feild_key]['value'] = ele.pack_name;
                                                                                obj['feilds'][feild_key]['title'] = ele.pack_name;
                                                                            }
                                                                            if (feild.name === 'item_qty') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                                            }
                                                                            if (feild.name === 'item_rate') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                                            }if (feild.name === 'item_amount') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                                            }if (feild.name === 'equservicecd') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                                            }
                                                                            if (feild.name === 'isactive') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                                            }
                                                                            if (feild.name === 'ward_name') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                                            }
                                                                            if (feild.name === 'level1_desc') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                                            }
                                                                        })
                                                                        subTable['Specification']['table_body'].push(obj);
                                                                    })
                                                                })
                                                                includesResponse.data.map((item, key) => {
                                                                    newData.push({
                                                                        "package_id": parseInt(ele.pack_id),
                                                                        'service_id': item['id'],
                                                                        'service_nam': item['service'],
                                                                        "qty": 0,
                                                                        "rate": 5,
                                                                        "amount": 5,
                                
                                                                    })
                                
                                                                });
                                                            }
                                                        }
                                                        if (excludesResponse && excludesResponse.status) {
                                                            if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                                                                let excludes_data = excludesResponse.data;
                                                                console.log('excludes_data', excludes_data);
                                                                // excludes_data.map((ex_data, key) => {
                                                                //     excludes_data[key]['package_id'] = ele.pack_id;
                                                                //     excludes_data[key]['package_name'] = ele.pack_name;
                                                                //     excludes_data[key]['unit_id'] = user_unit_id;
                                                                //     excludes_data[key]['payment_type'] = 1;
                                                                //     excludes_data[key]['tariff_mapped'] = 1;
                                                                //     excludes_data[key]['service_name'] = ex_data.service+' - '+ele.pack_name;
                                                                // })
                                                                excludesSchema.map((subTable, key) => {
                                                                    excludes_data.map((ex_data, ex_key) => {
                                                                        let last_id = 1;
                                                                        if (excludesSchema[key].Specification.table_body.length > 0) {
                                                                            let last_element = excludesSchema[key].Specification.table_body[excludesSchema[key].Specification.table_body.length - 1];
                                                                            last_id = last_element['id'];
                                                                        }
                                
                                                                        let obj = {
                                                                            "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                                                            id: last_id + 1,
                                                                            input_feild: [],
                                                                            text: "Highend",
                                                                            'key_word': 'add_more',
                                                                            type: "text"
                                                                        }
                                                                        let totalAmount = 0;
                                                                        obj['feilds'].map((feild, feild_key) => {
                                                                            obj['feilds'][feild_key]['id'] = last_id + 1;
                                
                                                                            if (feild.name === 'servicetype') {
                                                                                obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                                                                obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                                                            }
                                                                            if (feild.name === 'servicegroup') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                                                                obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                                                            }
                                                                            if (feild.name === 'excludes_service_id') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.service;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.service;
                                                                            }
                                                                            if (feild.name === 'item_package') {
                                                                                obj['feilds'][feild_key]['value'] = ele.pack_name;
                                                                                obj['feilds'][feild_key]['title'] = ele.pack_name;
                                                                            }
                                                                            if (feild.name === 'qty') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.qty;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.qty;
                                                                            }
                                                                            if (feild.name === 'rate') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.rate;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.rate;
                                                                            }
                                                                            if (feild.name === 'amount') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.amount;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.amount;
                                                                            }
                                                                            if (feild.name === 'equservicecd') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                                                            }
                                                                            if (feild.name === 'isactive') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                                                            }
                                                                            if (feild.name === 'ward_name') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                                                            }
                                                                            if (feild.name === 'level1_desc') {
                                                                                obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                                                                obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                                                            }
                                                                        })
                                                                        subTable['Specification']['table_body'].push(obj);
                                                                        
                                                                    })
                                                                })
                                                              
                                                                let new_exculude_options =  exculude_options.concat(excludes_data);
                                                                const exludesconcat =this.state.exludesconcatdata;
                                                               let exludesconcatdata=exludesconcat.concat(excludes_data);
                                                               console.log(exludesconcatdata);
                            
                                                                this.setState({exludesconcatdata})
                                                                optionsStore.dispatch({ type: 'options_data', 'data': exludesconcatdata });
                                                                hideInEXStore.dispatch({ type: 'exclude_data', data: { excludesData:exludesconcatdata, page: 'finanical-counselling' } })
                                                                // optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });
                            
                                                                
                               
                                                            }
                                                        }
                                                    })
                                                    this.setState({
                                                        inc_excludes_pack_id: inc_excludes_pack_id,
                                                        includes_data: newData,
                                                        includesSchema: includesSchema, inc_excludes_packages_ids: inc_excludes_packages_ids,exculude_options,packages_IN_EX
                                                    });
                                                    // console.log('exculude_options',exludesconcatdata);
                                                    this.total_suming();
                                                
                                                });
                                            }
                                        this.updateExcludesTable(input_data['value'], data[0].id);
                                        let new_option_array = []
                                        let options_data = optionsStore.getState();
                                        options_data.map((data) => {
                                            if (data['package_id'] !== input_data['value']) {
                                                new_option_array.push(data)
                                            }
                                        })
                                        optionsStore.dispatch({ type: 'options_data', 'data': new_option_array });
                                    }
                                })
                            // } catch (error) {
                            //     console.log(error);
                            // }

                            console.log('inc_excludes_packages_ids', feild, last_id);



                            additionalPackageSchema[key].Specification.table_body.splice(table_key, 1);

                        }
                    })
                }
            })

            additionalProcedureSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            additionalProcedureSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })
        }

        // this.total_suming();
        // this.setState({ addonSchema: addonSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema });

        this.setState({ 'inc_excludes_packages_ids': inc_excludes_packages_ids, addonSchema: addonSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema }, () => {
            // this.sumingProcedureAmounts();
            this.total_suming();
            this.drugaAdminCharges();
        })
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }   
    }

    updateExcludesTable(last_id, id) {
        try {
        let { includearrya, inc_excludes_pack_id, includesSchema,exclude_slug_fordropdown } = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let user_unit_id = user_data.unitid;
        let newData = [];
        let dopulicatearray = [];
        if (includearrya) {
            const index = includearrya.map(item => item.id).indexOf(id + 1);
            if (index > -1) {
                includearrya.splice(index, 1);
                includesSchema.map((subTable, key) => {
                    subTable['title'] = '';
                    subTable['name'] = '';
                    if (includesSchema[key].id === 1) {
                        if (includesSchema[key].Specification.table_body.length > 0) {
                            includesSchema[key].Specification.table_body.length = 0;
                        }
                    } else {
                        includesSchema.splice(1, includesSchema.length)
                    }
                })
                this.setState({ includesSchema });
            }
        }
        if (includearrya.length > 0) {
            includearrya.map((data, key) => {
                Promise.all([
                    postService('getMasterIncludesDropDown', 'POST', { data: { package_id: data.package_id, package_name: data.name, unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" } }).then(res => res),
                    postService('getMasterExcludesDropDown', 'POST', { data: { package_id: [data.package_id], package_name: [data.name], unit_id: user_unit_id, payment_type: 1, tariff_mapped: "TR1" ,status:exclude_slug_fordropdown === 'view-finanical-counselling'?0:1} }).then(res => res)
                ]).then(([includesResponse, excludesResponse]) => {
                    if (includesResponse && includesResponse.status) {
                        if (includesResponse.data.length > 0) {
                            let includes_data = includesResponse.data;
                            dopulicatearray = JSON.parse(JSON.stringify(includesSchema));
                            dopulicatearray.map((subTable, key) => {
                                if (dopulicatearray[key].id === 1) {
                                    if (dopulicatearray[key].Specification.table_body.length > 0) {
                                        dopulicatearray[key].Specification.table_body.length = 0;
                                    }
                                } else {
                                    dopulicatearray.splice(1, dopulicatearray.length)
                                }
                            })
                            dopulicatearray.map((subTable, key) => {
                                subTable['id'] = key + 2;
                                subTable['header'] = data.package_id;
                                subTable['title'] = data.name;
                                subTable['name'] = data.name;
                                includes_data.map((ex_data, ex_key) => {
                                    let last_id = 1;
                                    if (dopulicatearray[key].Specification.table_body.length > 0) {
                                        let last_element = dopulicatearray[key].Specification.table_body[includesSchema[key].Specification.table_body.length - 1];
                                        last_id = last_element ? last_element['id'] : 0;
                                    }
                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                        id: last_id + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    obj['feilds'].map((feild, feild_key) => {
                                        obj['feilds'][feild_key]['id'] = last_id + 1;

                                        // if (feild.name === 'item_service') {
                                        //     obj['feilds'][feild_key]['value'] = ex_data.id;
                                        //     obj['feilds'][feild_key]['title'] = ex_data.service;
                                        // }
                                        if (feild.name === 'servicetype') {
                                            obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                            obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                        }
                                        if (feild.name === 'servicegroup') {
                                            obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                            obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                        }
                                        if (feild.name === 'item_service') {
                                            obj['feilds'][feild_key]['value'] = ex_data.service;
                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                        }
                                        if (feild.name === 'item_package') {
                                            obj['feilds'][feild_key]['value'] = data.name;
                                            obj['feilds'][feild_key]['title'] = data.name;
                                        }
                                        if (feild.name === 'item_qty') {
                                            obj['feilds'][feild_key]['value'] = ex_data.qty;
                                            obj['feilds'][feild_key]['title'] = ex_data.qty;
                                        }
                                        if (feild.name === 'item_rate') {
                                            obj['feilds'][feild_key]['value'] = ex_data.rate;
                                            obj['feilds'][feild_key]['title'] = ex_data.rate;
                                        }if (feild.name === 'item_amount') {
                                            obj['feilds'][feild_key]['value'] = ex_data.amount;
                                            obj['feilds'][feild_key]['title'] = ex_data.amount;
                                        }if (feild.name === 'equservicecd') {
                                            obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                            obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                        }
                                        if (feild.name === 'isactive') {
                                            obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                            obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                        }
                                        if (feild.name === 'ward_name') {
                                            obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                            obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                        }
                                        if (feild.name === 'level1_desc') {
                                            obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                            obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                        }
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                })
                                includesSchema.push(subTable);
                                console.log(includesSchema)
                            })
                        }

                        includesResponse.data.map((item, key) => {
                            newData.push({
                                "package_id": parseInt(data.package_id),
                                'service_id': item['id'],
                                'service_nam': item['service'],
                                "qty": 0,
                                "rate": 5,
                                "amount": 5,

                            })

                        });
                    }


                    if (excludesResponse && excludesResponse.status) {
                        let table_data = excludesTableStore.getState();
                        table_data.map((body, key) => {
                            body['feilds'].map((feild, feild_key) => {
                                if (feild.name === 'excludes_service_id') {
                                    let { selected_option } = feild;
                                    if (selected_option && selected_option['package_id']) {
                                        table_data.splice(0, table_data.length);
                                        excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                                    }
                                }

                            })

                        })
                        if (excludesResponse.data.length > 0 && Array.isArray(excludesResponse.data)) {
                            let excludes_data = excludesResponse.data;
                            console.log('excludes_data', excludes_data);
                            // excludes_data.map((ex_data, key) => {
                            //     excludes_data[key]['package_id'] = data.package_id;
                            //     excludes_data[key]['unit_id'] = user_unit_id;
                            //     excludes_data[key]['payment_type'] = 1;
                            //     excludes_data[key]['tariff_mapped'] = 1;
                            // })
                            excludesSchema.map((subTable, key) => {
                                excludes_data.map((ex_data, ex_key) => {
                                    let last_id = 1;
                                    if (excludesSchema[key].Specification.table_body.length > 0) {
                                        let last_element = excludesSchema[key].Specification.table_body[excludesSchema[key].Specification.table_body.length - 1];
                                        last_id = last_element['id'];
                                    }

                                    let obj = {
                                        "feilds": (subTable['Specification'] && subTable['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(subTable['Specification']['add_more_feilds'])) : [],
                                        id: last_id + 1,
                                        input_feild: [],
                                        text: "Highend",
                                        'key_word': 'add_more',
                                        type: "text"
                                    }
                                    let totalAmount = 0;
                                    obj['feilds'].map((feild, feild_key) => {
                                        obj['feilds'][feild_key]['id'] = last_id + 1;

                                        if (feild.name === 'servicetype') {
                                            obj['feilds'][feild_key]['value'] = serviceTypes[ex_data.servicetype];
                                            obj['feilds'][feild_key]['title'] = serviceTypes[ex_data.servicetype];
                                        }
                                        if (feild.name === 'servicegroup') {
                                            obj['feilds'][feild_key]['value'] = ex_data.servicegroupdesc
                                            obj['feilds'][feild_key]['title'] = ex_data.servicegroupdesc
                                        }
                                        if (feild.name === 'excludes_service_id') {
                                            obj['feilds'][feild_key]['value'] = ex_data.service;
                                            obj['feilds'][feild_key]['title'] = ex_data.service;
                                        }
                                        if (feild.name === 'item_package') {
                                            obj['feilds'][feild_key]['value'] = data.name;
                                            obj['feilds'][feild_key]['title'] = data.name;
                                        }
                                        if (feild.name === 'qty') {
                                            obj['feilds'][feild_key]['value'] = ex_data.qty;
                                            obj['feilds'][feild_key]['title'] = ex_data.qty;
                                        }
                                        if (feild.name === 'rate') {
                                            obj['feilds'][feild_key]['value'] = ex_data.rate;
                                            obj['feilds'][feild_key]['title'] = ex_data.rate;
                                        }
                                        if (feild.name === 'amount') {
                                            obj['feilds'][feild_key]['value'] = ex_data.amount;
                                            obj['feilds'][feild_key]['title'] = ex_data.amount;
                                        }
                                        if (feild.name === 'equservicecd') {
                                            obj['feilds'][feild_key]['value'] = ex_data.equservicecd;
                                            obj['feilds'][feild_key]['title'] = ex_data.equservicecd;
                                        }
                                        if (feild.name === 'isactive') {
                                            obj['feilds'][feild_key]['value'] = ex_data.isactive;
                                            obj['feilds'][feild_key]['title'] = ex_data.isactive;
                                        }
                                        if (feild.name === 'ward_name') {
                                            obj['feilds'][feild_key]['value'] = ex_data.ward_name;
                                            obj['feilds'][feild_key]['title'] = ex_data.ward_name;
                                        }
                                        if (feild.name === 'level1_desc') {
                                            obj['feilds'][feild_key]['value'] = ex_data.itemleveldesc;
                                            obj['feilds'][feild_key]['title'] = ex_data.itemleveldesc;
                                        }
                                    })
                                    subTable['Specification']['table_body'].push(obj);
                                    
                                })
                            })
                            let { exculude_options } = this.state;
                            let new_exculude_options = exculude_options.concat(excludes_data);
                            optionsStore.dispatch({ type: 'options_data', 'data': new_exculude_options });

                        }
                    }
                    // this.total_suming();
                    this.props.excludes(excludesSchema, includesSchema)

                })
            })
            console.log(includesSchema)
            this.setState({
                inc_excludes_pack_id: inc_excludes_pack_id, includes_data: newData,
                includesSchema: includesSchema
            });
        }


        let table_data = excludesTableStore.getState();
       
        table_data.map((body, key) => {
            // body['feilds'].map((feild, feild_key) => {
                if (body['feilds'][0].name === 'excludes_service_id') {
                    let { selected_option } = body['feilds'][0];
                    if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                        table_data.splice(key, 1);
                        excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                    }
                }

            // })

        })
        table_data.map((body, key) => {
            // body['feilds'].map((feild, feild_key) => {
                if (body['feilds'][0].name === 'excludes_service_id') {
                    let { selected_option } = body['feilds'][0];
                    if (selected_option && selected_option['package_id'] && selected_option['package_id'] === last_id) {
                        table_data.splice(key, 1);
                        excludesUpdateTableStore.dispatch({ type: 'options_data', 'data': table_data });
                    }
                }

            // })

        })

        console.log('inc_excludes_packages_ids', excludesTableStore.getState())

        // excludesTableStore,excludesUpdateTableStore
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }  

    }

    total_suming() {
        try {
        let { addonSchema, estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, medicationDetailsSchema, view_details, excludesSchema, hideing_estimatetable ,exclude_total_amount, total_estimate_amount,fc1_total_estimate_amount,consutations, HeaderAmounts,estimateTypeValue} = this.state;
        let amount = 0;
        let surgical_charges_and_medical_charges = 0;
        let additional_packages_amount = 0;
        let additional_procedures_amount = 0;
        let base_percentage_amount = 0;
        let surgeon_charges = 0;
        let  surgeon_charges_=0
        let room_amount = 0;
        let surgery_procedure_amount = 0;
        let pack = false;
        let excludes_amount = 0;
        let { counselling_details } = this.props;
        let { slug } = this.props.match.params;
        let intensivist_and_asstintensivist = 0;
        let total_amount = 0;
        let room_stay=0;
        let icu_stay=0;
        let room_id=0;
        let cross_consultation_room = 0;
        let cross_consultation_icu = 0;
        let finalIntestivisit = 0;
        let anaesthetist_charges = 0;
        if (slug === 'view-finanical-counselling') {
            if (counselling_details['header_amount'].length > 0) {
                counselling_details['header_amount'].map((feild, key) => {
                    if (feild.excludes !== '' && feild.excludes !== null & feild.excludes !== undefined) {
                        excludes_amount = feild.excludes;
                    }

                })
            }
        }
        if (excludes_amount === 0) {
            let table_data = excludesTableStore.getState();
            if(table_data.length>0){
                table_data.map((body, key) => {
                    body['feilds'].map((feild, feild_key) => {
                        if (feild.name === 'amount') {
                                excludes_amount = parseFloat(excludes_amount) + parseFloat(feild.value?feild.value:0);
                        }
                    })
                })
            }
        }

        medicationDetailsSchema.map((feild, key) => {
            if (feild['name'] === 'room_opted') {
                if (medicationDetailsSchema[key]['amount'] != '' && medicationDetailsSchema[key]['amount'] !== null && medicationDetailsSchema[key]['amount'] !== undefined) {
                    room_amount = parseFloat(medicationDetailsSchema[key]['amount']);
                    room_id=parseFloat(medicationDetailsSchema[key]['room_id'])?parseFloat(medicationDetailsSchema[key]['room_id']):parseFloat(medicationDetailsSchema[key]['room_id']);
                }
            }
            if (feild['name'] === 'icu_stay') {
                icu_stay=medicationDetailsSchema[key]['value']?parseFloat(medicationDetailsSchema[key]['value']):0;
            }
            if (feild['name'] === 'room_stay') {
                room_stay=medicationDetailsSchema[key]['value']?parseFloat(medicationDetailsSchema[key]['value']):0;
        }
            if (feild['name'] === 'package_name') {
                if (parseFloat(feild.value) !== null && feild.value !== null && parseFloat(feild.value) !== '' && parseFloat(feild.value) !== undefined) {
                    pack = true;
                }
                else {
                    pack = false;
                }
            }
            if (feild['name'] === 'surgery_procedure_amount') {
                if (parseFloat(feild.value) !== null && parseFloat(feild.value) !== '' && parseFloat(feild.value) !== undefined && !isNaN(parseFloat(feild.value))) {
                    surgery_procedure_amount = parseFloat(medicationDetailsSchema[key]['value']);
                }
            }
        })


        addonSchema.map((subTable, key) => {
            if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                let table_body = subTable.Specification.table_body;
                let header_amount = 0;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    if (feild.key_word === 'intensivist' || feild.key_word === 'asst_intensivist') {

                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                intensivist_and_asstintensivist = parseFloat(intensivist_and_asstintensivist) + parseFloat(sub_feild.value);
                            }


                        })
                    } else {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                header_amount = parseFloat(header_amount) + parseFloat(sub_feild.value);
                            }


                        })

                    }

                })
                addonSchema[key]['header_amount'] = header_amount;
            }
        })

        addonSchema.map((subTable, key) => {
            if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                let table_body = subTable.Specification.table_body;
                let header_amount = 0;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                            amount = parseFloat(amount) + parseFloat(sub_feild.value);
                            header_amount = parseFloat(header_amount) + parseFloat(sub_feild.value);
                            this.setState({'HeaderAmounts':amount});
                        }
                    })
                })
                addonSchema[key]['header_amount'] = header_amount;
            }
        })

        additionalPackageSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                            additional_packages_amount = parseFloat(additional_packages_amount) + parseFloat(sub_feild.value);
                        }
                    })
                })
            }
        })

        additionalProcedureSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === "amount" && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                            additional_procedures_amount = parseFloat(additional_procedures_amount) + parseFloat(sub_feild.value);
                        }
                    })
                })
            }
        })

        // if(estimateTypeValue === 2 || estimateTypeValue === null){
            addonSchema.map((subTable, key) => {
                if(hideing_estimatetable === 1){
                    if (subTable.name === 'room_charges') {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.name === 'qty'){
                                    sub_feild.value = 0
                                }
                                if(sub_feild.name === 'rate'){
                                    sub_feild.value = 0
                                }
                                if(sub_feild.name === 'amount'){
                                    sub_feild.value = 0
                                }
                            });
                        });
                    }
                }
                if (subTable.name === 'ins_consultation_charges') {
                    if (subTable.visible) {
                        let table_body = subTable.Specification.table_body;
                        let header_amount = 0;
                        let anaesthetist_amount = 0;
                        let HeaderAmount = subTable.header_amount;
                        let Value;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            if (feild.id === 3 && feild.key_word === 'cross_consultation_room' || feild.id === 4 && feild.key_word === 'cross_consultation_icu') {
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'percentage') {
                                    
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                            let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(HeaderAmounts);
                                            cross_consultation_room = Math.floor(total_charges * ((sub_feild.value) / 100));       
                                    }                        
                                    if (sub_feild.name === "rate") {
                                        if(sub_feild.value === '' || sub_feild.value === null || sub_feild.value === undefined || !isNaN(parseFloat(sub_feild.value))){
                                            Value = sub_feild.text;
                                        } else {
                                            Value = cross_consultation_room;
                                        }
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = hideing_estimatetable !== 1 ? Value: 0;
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = hideing_estimatetable !== 1 ? Value: 0;
                                        header_amount = parseFloat(header_amount) + parseFloat(Value);
                                    }
                                })
                            } 
                            // if (feild.id === 4 && feild.key_word === 'cross_consultation_icu') {
                            //     row.map((sub_feild, sub_table_key) => {
                            //         if (sub_feild.name === 'percentage') {
                            //             let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(HeaderAmounts);
                            //             cross_consultation_icu = Math.floor(total_charges * ((sub_feild.value) / 100));
                            //         }
                            //         if (sub_feild.name === "rate") {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = hideing_estimatetable !== 1 ? cross_consultation_room - 7 : 0;
                            //         }
                            //         if (sub_feild.name === "amount") {
                            //             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = hideing_estimatetable !== 1 ? cross_consultation_room - 7 : 0;
                            //             header_amount = parseFloat(header_amount) + parseFloat(cross_consultation_icu);
                            //         }
                            //     })
                            // }                             
                            
                        }) 
                            }
                }
            });
        // }

        addonSchema.map((subTable, key) => {
            if (subTable.name === 'surgical_charges') {
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    let header_amount = 0;
                    let anaesthetist_amount = 0;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        if(hideing_estimatetable === 1){
                            if (feild.key_word === 'add_more') {
                                let qty = 1;
                                let additional_surgeon = 0;
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'percentage') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                    }
                                    // if (sub_feild.name === "rate") {
                                    //     additional_surgeon = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                    // }
                                    if (sub_feild.name === "rate") {
                                        additional_surgeon = parseFloat(
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                        ) || 0;
                                    }
                                    // if (sub_feild.name === "amount") {
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(additional_surgeon);
                                    //     header_amount = parseFloat(header_amount) + (qty * parseFloat(additional_surgeon));
                                    //     amount = parseFloat(amount) + (qty * parseFloat(additional_surgeon));
                                    // }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * additional_surgeon;
                                        header_amount = parseFloat(header_amount) + (qty * additional_surgeon);
                                        amount = parseFloat(amount) + (qty * additional_surgeon);
                                    }
                                })
                            } 
                        }
                        else{
                        if (feild.id === 2 && feild.key_word === 'surgeon_fees') {
                            // if(estimateTypeValue === 2 || estimateTypeValue === null){
                                row.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'percentage') {
                                        if(sub_feild.value){
                                            let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(amount);
                                            surgeon_charges = Math.round(total_charges * ((sub_feild.value) / 100));
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                        }
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = surgeon_charges;
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = surgeon_charges;
                                        header_amount = parseFloat(header_amount) + parseFloat(surgeon_charges);
                                        amount = parseFloat(amount) + parseFloat(surgeon_charges);
                                    }
                                })
                            // }
                        } else if (feild.key_word === 'add_more') {
                            let qty = 1;
                            let additional_surgeon = 0;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                }
                                // if (sub_feild.name === "rate") {
                                //     additional_surgeon = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                // }
                                if (sub_feild.name === "rate") {
                                    additional_surgeon = parseFloat(
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                    ) || 0;
                                }
                                // if (sub_feild.name === "amount") {
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(additional_surgeon);
                                //     header_amount = parseFloat(header_amount) + (qty * parseFloat(additional_surgeon));
                                //     amount = parseFloat(amount) + (qty * parseFloat(additional_surgeon));
                                // }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * additional_surgeon;
                                    header_amount = parseFloat(header_amount) + (qty * additional_surgeon);
                                    amount = parseFloat(amount) + (qty * additional_surgeon);
                                }
                            })
                        } else if (feild.id === 3 && feild.key_word === 'asst_surgeon') {
                            let asst_surgeon_charges = 0
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.name === 'asst_surgeon'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === 'percentage') {
                                    asst_surgeon_charges = Math.round(surgeon_charges * ((sub_feild.value) / 100));
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === "rate") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = asst_surgeon_charges;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = asst_surgeon_charges;
                                    header_amount = parseFloat(header_amount) + parseFloat(asst_surgeon_charges);
                                    amount = parseFloat(amount) + parseFloat(asst_surgeon_charges);
                                }
                            })
                        } else if (feild.id === 4 && feild.key_word === 'anaesthetist') {
                            
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.name === 'anaesthetist'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === 'percentage') {
                                    anaesthetist_charges = Math.round(surgeon_charges * ((sub_feild.value) / 100));
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === "rate") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = anaesthetist_charges;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = anaesthetist_charges;
                                    header_amount = parseFloat(header_amount) + parseFloat(anaesthetist_charges);
                                    amount = parseFloat(amount) + parseFloat(anaesthetist_charges);
                                }
                            })
                        } else {
                            let total_surgeon_extra_charges = 0;
                            let this_value;
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.name === 'asst_anaesthetist'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === 'percentage') {
                                    this_value = sub_feild.value
                                    total_surgeon_extra_charges = Math.round(anaesthetist_charges * ((sub_feild.value) / 100));
                                    if (sub_feild.id === 5) {
                                        anaesthetist_amount = total_surgeon_extra_charges;
                                    }
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                }
                                if (sub_feild.name === "rate") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_surgeon_extra_charges;
                                }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_surgeon_extra_charges;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true;
                                    header_amount = parseFloat(header_amount) + parseFloat(total_surgeon_extra_charges);
                                    amount = parseFloat(amount) + parseFloat(total_surgeon_extra_charges);
                                }
                            })
                        }
                    }
                    })
                    addonSchema[key]['header_amount'] = header_amount;
                }
            }
            if(subTable.name === 'medical_charges'){
                if (subTable.visible) {
                    let table_body = subTable.Specification.table_body;
                    let total_physician_charges = 0;
                    let header_amount = 0;
                    let anaesthetist_amount = 0;
                    let qty = 1;
                    table_body.map((feild, table_key) => {
                        let row = feild.feilds;
                        if(feild.id === 2 && feild.key_word === 'physician_fees'){
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === 'percentage' && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                    // sub_feild.value = sub_feild.value
                                    let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(amount);
                                    total_physician_charges = Math.round(total_charges * (sub_feild.value / 100));
                                }
                                if (sub_feild.name === "rate") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_physician_charges;
                                }
                                if (sub_feild.name === "amount") {
                                    // total_physician_charges= addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]!==null?addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]:0;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=total_physician_charges;
                                    header_amount = parseFloat(header_amount) + parseFloat(total_physician_charges);
                                    amount = parseFloat(amount) + parseFloat(total_physician_charges);
                                }
                            })
                        } else if (feild.key_word === 'add_more') {
                            let additional_physician = 0
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === 'percentage') {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                    // qty = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                }
                                if (sub_feild.name === "rate") {
                                    additional_physician = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]) || 0;
                                }
                                // if (sub_feild.name === "amount") {
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(additional_physician);
                                //     header_amount = parseFloat(header_amount) + (qty * parseFloat(additional_physician));
                                //     amount = parseFloat(amount) + (qty * parseFloat(additional_physician));
                                // }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(additional_physician);
                                    header_amount = parseFloat(header_amount) + (qty * parseFloat(additional_physician));
                                    amount = parseFloat(amount) + (qty * parseFloat(additional_physician));
                                }
                            })
                        } else if(feild.id === 3 && feild.key_word === 'asst_physician_fees'){
                            let total_aastphysician_charges = 0;
                            row.map((sub_feild, sub_table_key) => {
                                if (sub_feild.name === 'percentage' && parseFloat(sub_feild.value) !== null && parseFloat(sub_feild.value) !== '' && parseFloat(sub_feild.value) !== undefined && !isNaN(parseFloat(sub_feild.value))) {
                                    let total_charges = parseFloat(additional_packages_amount) + parseFloat(room_amount) + parseFloat(amount);
                                    total_aastphysician_charges = Math.round(total_physician_charges * (sub_feild.value / 100));
                                }
                                if (sub_feild.name === "rate") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_aastphysician_charges;
                                }
                                if (sub_feild.name === "amount") {
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["visible"] = true
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]=total_aastphysician_charges;
                                    header_amount = parseFloat(header_amount) + parseFloat(total_aastphysician_charges);
                                    amount = parseFloat(amount) + parseFloat(total_aastphysician_charges);
                                }
                            })
                        }
                    })
                    addonSchema[key]['header_amount'] = header_amount;
                }
            }
        });

        estimateBreakupFormatSchema.map((feild, key) => {
            if (feild['name'] === 'base_price') {
                if (parseFloat(additional_packages_amount) !== null && parseFloat(additional_packages_amount) !== '' && parseFloat(additional_packages_amount) !== undefined && !isNaN(parseFloat(additional_packages_amount)) && parseFloat(additional_procedures_amount) !== null && parseFloat(additional_procedures_amount) !== '' && parseFloat(additional_procedures_amount) !== undefined && !isNaN(parseFloat(additional_procedures_amount)) && parseFloat(room_amount) !== null && parseFloat(room_amount) !== '' && parseFloat(room_amount) !== undefined && !isNaN(parseFloat(room_amount))) {
                    estimateBreakupFormatSchema[key]['value'] = parseFloat(additional_packages_amount) +parseFloat(room_amount)+ parseFloat(additional_procedures_amount);
                }
                else {
                    estimateBreakupFormatSchema[key]['value'] = 0;
                }
            }
            if (feild['name'] === 'excludes') {
                if (isNaN(excludes_amount)) {
                    excludes_amount = 0;
                    estimateBreakupFormatSchema[key]['value'] = parseFloat(excludes_amount) ? parseFloat(excludes_amount) : parseFloat(exclude_total_amount);
                    this.setState({ exclude_total_amount: excludes_amount ? excludes_amount : exclude_total_amount });
                } else {
                    estimateBreakupFormatSchema[key]['value'] = parseFloat(excludes_amount) ? parseFloat(excludes_amount) : parseFloat(exclude_total_amount);
                    excludes_amount=parseFloat(excludes_amount) ? parseFloat(excludes_amount) : parseFloat(exclude_total_amount)
                }
            }
            if (feild['name'] === 'total_Estimate_amount') {
                if (parseFloat(additional_packages_amount) !== null && parseFloat(additional_packages_amount) !== '' && parseFloat(additional_packages_amount) !== undefined && !isNaN(parseFloat(additional_packages_amount)) && parseFloat(additional_procedures_amount) !== null && parseFloat(additional_procedures_amount) !== '' && parseFloat(additional_procedures_amount) !== undefined && parseFloat(room_amount) !== null && parseFloat(room_amount) !== '' && parseFloat(room_amount) !== undefined && !isNaN(parseFloat(room_amount)) && parseFloat(amount) !== null && parseFloat(amount) !== '' && parseFloat(amount) !== undefined && !isNaN(parseFloat(amount))) {
                    if (hideing_estimatetable === 1) {
                        estimateBreakupFormatSchema[key]['value'] =  parseFloat(amount)+ parseFloat(room_amount) + parseFloat(surgical_charges_and_medical_charges) + parseFloat(additional_procedures_amount) + parseFloat(additional_packages_amount);
                        total_amount =parseFloat(amount) + parseFloat(room_amount) + parseFloat(surgical_charges_and_medical_charges) + parseFloat(additional_procedures_amount)  + parseFloat(additional_packages_amount);
                        console.log('AMOUTN::::', amount,room_amount, surgical_charges_and_medical_charges);
                        if(total_amount!==0 && total_amount!=='0' && slug === 'view-finanical-counselling'){
                            fc1_total_estimate_amount=total_estimate_amount;
                            console.log('TOTAL_AMOUNT', fc1_total_estimate_amount);
                        }
                    } else {
                        estimateBreakupFormatSchema[key]['value'] =  parseFloat(amount) + parseFloat(surgical_charges_and_medical_charges) + parseFloat(additional_procedures_amount);
                        total_amount =parseFloat(amount) + parseFloat(surgical_charges_and_medical_charges) + parseFloat(additional_procedures_amount);
                        console.log('TOOOOOOTAL:', amount,room_amount, surgical_charges_and_medical_charges)
                        if(total_amount!==0 && total_amount!=='0' && slug === 'view-finanical-counselling'){
                            fc1_total_estimate_amount=total_estimate_amount;
                            console.log('TOTAL_AMOUNTS', fc1_total_estimate_amount);
                        }
                    }
                }
                else {
                    estimateBreakupFormatSchema[key]['value'] = 0;
                    total_amount = 0;
                    fc1_total_estimate_amount=0;
                }
            }
            if (feild['name'] === 'advance_amount') {
                // if(slug === 'finanical-counselling' && this.props.basic_info.counselling_type_name !== 'Recounselling'){
                    console.log('CHEKCING::', this.props,this.state);
                if (
                    !isNaN(parseFloat(room_amount))
                ) {
                    let percentage = hideing_estimatetable === 1 ? 1.0 : 0.8;
                    let calculatedAmount = total_amount 
                        ? (percentage * parseFloat(total_amount)) 
                        : (percentage * parseFloat(fc1_total_estimate_amount));
                    estimateBreakupFormatSchema[key]['value'] = this.roundAmount(parseFloat(calculatedAmount.toFixed(2)));
                } else {
                    estimateBreakupFormatSchema[key]['value'] = 0;
                }
            // }
            }
            
        })

        this.setState({ addonSchema: addonSchema, total_estimate_amount: total_amount, estimateBreakupFormatSchema: estimateBreakupFormatSchema,fc1_total_estimate_amount });
    } catch (error) {
        console.log(error);
        this.setState({ 'loadding': false });
    }  
    }

     getConstantionChagres (obj){
        let {basic_info} =this.props
        let { surgery_procedure_name, care_management } = obj ? obj : {};
        let user_data = JSON.parse(localStorage.getItem('user_data'));
        const unit_id =user_data ? user_data.unitid:'';
                      let  payload = {
                            "payment_type": 1,
                            "tariff_mapped": 1,
                            "procedure_id": basic_info['speciality_name'] ? basic_info['speciality_name'] : null,
                            "unit_id": unit_id
                        }
                    try {
                        postService('getMasterconsutations', 'POST', {data:payload}).then(res => {
                            if (res) {
                                if (res.status) {
                                    if (res.data.length > 0) {
                                        this.setState({ consutations: res.data })
                                    }
                                    else {
                                        Modal.error({
                                            title: 'Error message',
                                            content: 'No service available',
                                        });
                                    }
                                } 
                            }
                        });
                    } catch (error) {
                        Modal.error({
                            title: 'Error message',
                            content: 'Oops! something went wrong. Please,try again later'
                        });
                    }
     }
    
    generateLink() {
        let { basic_info, } = this.props;
        // console.log("generateLink", basic_info);
        const currentTime = new Date();
        const expirationTime = new Date(currentTime.getTime() + 60000*5); // 5 minute expiration
    
        const year = expirationTime.getFullYear();
        const month = ('0' + (expirationTime.getMonth() + 1)).slice(-2);
        const day = ('0' + expirationTime.getDate()).slice(-2);
        const hours = ('0' + expirationTime.getHours()).slice(-2);
        const minutes = ('0' + expirationTime.getMinutes()).slice(-2);
    
        // const generatedLink = `https://example.com/${year}-${month}-${day}-${hours}-${minutes}`;
        // const generatedLink = `${base_url}digital-signature/${basic_info["token_no"]}`;
        let { ui_base_url } = networkList;
        const generatedLink = `${ui_base_url}/digital-signature/${basic_info["token_no"]}`;

        // const querystring = require('querystring');
        // // const original_link = 'https://www.example.com/page?param1=value1&param2=value2';
        // const original_link = `http://localhost/digital-signature?token=${basic_info["token_no"]}`;
        // const encoded_link = encodeURIComponent(original_link);
        // console.log("encoded_link", encoded_link);

        return generatedLink;
    }

    sendLink() {
        let {digital_sig_imgpath, patient_digsign_willing,enableCheckBox} = this.state;
        let generatedLink = this.generateLink();
                // Set a timeout to enable the second section after 2 minutes (120,000 milliseconds)
        setTimeout(() => {
            this.setState({ enableCheckBox: true });
        }, 120000); // 2 minutes in milliseconds
        if (generatedLink !== null && patient_digsign_willing === true) {
            this.handleCheckboxChange();
        }
        this.setState({signatureModal: false, generatedLink, isGenerateSign: "yes", digital_sig_imgpath: null, patient_digsign_willing: false}, () => this.api_sendLink())
    
        // API to send whatsapp and refresh API to get signature if signed
    }

    api_sendLink() {
        // let {basic_info} = this.props
        // // let {generatedLink, signatureSchema,preview_data } = this.state
        // let { signatureSchema,preview_data,addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, preserve_addonSchema, preserve_medicationDetailsSchema, preserve_estimateBreakupFormatSchema, includes_data, includesSchema,medicationDetails, isGenerateSign, generatedLink, digital_sig_imgpath,exclude_slug_fordropdown } = this.state;
        // let care_management_name, package_text_name, estimate_name, estimated_admission_date, actual_admission_date, diagnosis, care_management, estimate_type, package_name, length_of_stay, icu_stay, room_stay, date_of_surgery, surgery_procedure_name, room_opted, room_opted_name, room_upgrade, room_upgrade_name, room_upgrade_reason, room_upgrade_reason_name, icu_opted, icu_opted_name, surgery_procedure_amount,procedure_name;
        // let room_opted_amount = 0, package_amount = 0;
        // let estimate_data = [];
        // let excludes_data = [];
        // let temp_obj = {}
        // let additional_packages = [];
        // let additional_procedures = [];

        // addonSchema.map((subTable, key) => {
        //     if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
        //         let table_header = subTable.header;
        //         let table_body = subTable.Specification.table_body;
        //         temp_obj[table_header] = subTable.header_amount;
        //         table_body.map((feild, table_key) => {
        //             let service, qty, rate, amount, sub_header;
        //             let key_word = feild.key_word;
        //             let row = feild.feilds;
        //             if (key_word !== 'ot_hours') {
        //                 row.map((sub_feild, sub_table_key) => {
        //                     if (sub_feild.name !== 'action') {
        //                         if (sub_table_key === 0) {
        //                             sub_header = parseFloat(sub_feild.sub_header);
        //                             if (sub_feild.element === 'text') {
        //                                 service = parseFloat(sub_feild.service);
        //                             }
        //                             else {
        //                                 service = parseFloat(sub_feild.value);
        //                             }
        //                         }
        //                         if (sub_table_key === 1) {
        //                             qty = parseFloat(sub_feild.value);
        //                         }
        //                         if (sub_table_key === 2) {
        //                             rate = parseFloat(sub_feild.value);
        //                         }
        //                         if (sub_table_key === 3) {
        //                             amount = parseFloat(sub_feild.value);
        //                         }
        //                     }
        //                 })
        //             }
        //             else {
        //                 row.map((sub_feild, sub_table_key) => {
        //                     if (sub_feild.name !== 'action') {
        //                         if (sub_table_key === 1) {
        //                             service = parseFloat(sub_feild.service);
        //                             sub_header = parseFloat(sub_feild.sub_header);
        //                             qty = null;
        //                         }
        //                         if (sub_table_key === 2) {
        //                             rate = parseFloat(sub_feild.value);
        //                         }
        //                         if (sub_table_key === 3) {
        //                             amount = parseFloat(sub_feild.value);
        //                         }
        //                     }
        //                 })
        //             }

        //             let obj = {
        //                 key_word: key_word,
        //                 header: table_header,
        //                 sub_header: sub_header,
        //                 service: service,
        //                 qty: qty,
        //                 rate: rate,
        //                 amount: amount
        //             }

        //             // if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
        //             if (service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {

        //                 estimate_data.push(obj);
        //             }
        //             // else {
        //             //     if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
        //             //         estimate_data.push(obj);
        //             //     }
        //             // }
        //         })
        //     }
        //     else {
        //         if (subTable.visible) {
        //             let table_header = subTable.header;
        //             let table_body = subTable.Specification.table_body;
        //             temp_obj[table_header] = subTable.header_amount;
        //             table_body.map((feild, table_key) => {
        //                 let service, percentage, amount, sub_header;
        //                 let key_word = feild.key_word;
        //                 let row = feild.feilds;
        //                 row.map((sub_feild, sub_table_key) => {
        //                     if (sub_table_key === 0) {
        //                         service = parseFloat(sub_feild.service);
        //                         sub_header = parseFloat(sub_feild.sub_header);
        //                     }
        //                     if (sub_table_key === 1) {
        //                         percentage = parseFloat(sub_feild.value);
        //                     }
        //                     if (sub_table_key === 2) {
        //                         amount = parseFloat(sub_feild.value);
        //                     }
        //                 })
        //                 let obj = {
        //                     key_word: key_word,
        //                     header: table_header,
        //                     sub_header: sub_header,
        //                     service: service,
        //                     qty: percentage,
        //                     rate: null,
        //                     amount: amount
        //                 }
        //                 if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
        //                     estimate_data.push(obj);
        //                 }
        //             })
        //         }
        //     }
        // })
        // additionalPackageSchema.map((subTable, key) => {
        //     if (subTable.visible) {
        //         let table_body = subTable.Specification.table_body;
        //         table_body.map((feild, table_key) => {
        //             let package_id, amount, percentage;
        //             let row = feild.feilds;
        //             row.map((sub_feild, sub_table_key) => {
        //                 if (sub_feild.name !== 'action') {
        //                     if (sub_table_key === 0) {
        //                         package_id = parseFloat(sub_feild.value);
        //                     }
        //                     if (sub_table_key === 1) {
        //                         amount = parseFloat(sub_feild.value);
        //                     }
        //                     // if(sub_table_key === 2){
        //                     //     percentage = parseFloat(sub_feild.value);
        //                     // }
        //                 }
        //             })
        //             let obj = {
        //                 package_id: package_id,
        //                 amount: amount,
        //                 additional_type: 1
        //                 // percentage : percentage
        //             }

        //             if (package_id !== '' && package_id !== null && package_id !== undefined && !isNaN(package_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
        //                 additional_packages.push(obj);
        //             }
        //         })
        //     }
        // })

        // additionalProcedureSchema.map((subTable, key) => {
        //     if (subTable.visible) {
        //         let table_body = subTable.Specification.table_body;
        //         table_body.map((feild, table_key) => {
        //             let procedure_id, amount, percentage;
        //             let row = feild.feilds;
        //             row.map((sub_feild, sub_table_key) => {
        //                 if (sub_feild.name !== 'action') {
        //                     if (sub_table_key === 0) {
        //                         procedure_id = parseFloat(sub_feild.value);
        //                     }
        //                     if (sub_table_key === 1) {
        //                         amount = parseFloat(sub_feild.value);
        //                     }
        //                     // if (sub_table_key === 2) {
        //                     //     percentage = parseFloat(sub_feild.value);
        //                     // }
        //                 }
        //             })
        //             let obj = {

        //                 procedure_id: procedure_id,
        //                 amount: amount,
        //                 additional_type: 2
        //                 // percentage: percentage
        //             }
        //             if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
        //                 additional_procedures.push(obj);
        //             }
        //         })
        //     }
        // })
        // let in_payload = [];
        // includesSchema.map((subTable, key) => {
        //     if (subTable.name !== '' && subTable.name !== undefined && subTable.name !== null) {
        //         let table_body = subTable.Specification.table_body;
        //         let in_data = []
        //         table_body.map((feild, table_key) => {
        //             let service;
        //             let key_word = feild.key_word;
        //             let row = feild.feilds;
        //             let service_id, service_nam;
        //             row.map((sub_feild, sub_table_key) => {
        //                 if (sub_feild.name === 'item_service') {
        //                     service_id = +sub_feild.value;
        //                     service_nam = sub_feild.title;
        //                 }

        //             })
        //             let obj = {
        //                 'service_id': service_id,
        //                 'service_nam': service_nam
        //             }
        //             in_data.push(obj);
        //         })
        //         let object = {
        //             'package_id': subTable.header,
        //             'package_name': subTable.name,
        //             'services': in_data
        //         }
        //         in_payload.push(object);
        //     }

        // })

        let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, preserve_addonSchema, preserve_medicationDetailsSchema, preserve_estimateBreakupFormatSchema, includes_data, includesSchema,medicationDetails, isGenerateSign, generatedLink, digital_sig_imgpath,exclude_slug_fordropdown,patient_digsign_willing } = this.state;
        let { counselling_details,basic_info } = this.props;
        console.log("counselling_details",counselling_details,basic_info)
        this.setState({ error_message: '', error_view: false });
        let estimate_data = [];
        let additional_packages = [];
        let additional_procedures = [];
        let excludes_data = [];
        let temp_obj = {}

        let care_management_name, package_text_name, estimate_name, estimated_admission_date, actual_admission_date, diagnosis, care_management, estimate_type, package_name, length_of_stay, icu_stay, room_stay, date_of_surgery, surgery_procedure_name, room_opted, room_opted_name, room_upgrade, room_upgrade_name, room_upgrade_reason, room_upgrade_reason_name, icu_opted, icu_opted_name, surgery_procedure_amount,procedure_name;

        let room_opted_amount = 0, package_amount = 0;
        let is_package = false;

        medicationDetailsSchema.map((feild, key) => {
            
            if (feild.name === 'estimated_admission_date') {
                estimated_admission_date = feild.value;
            }
            if (feild.name === 'actual_admission_date') {
                actual_admission_date = feild.value;
            }
            if (feild.name === 'diagnosis') {
                diagnosis = feild.value;
            }
            if (feild.name === 'care_management') {
                care_management = feild.value;
                care_management_name = feild.text
            }
            if (feild.name === 'estimate_type') {
                if (parseInt(feild.value) === 1) { is_package = true }
                estimate_type = feild.value;
                estimate_name = feild.text;
            }
            if (feild.name === 'package_name') {
                package_name = feild.value;
                package_text_name = feild.text;
            }
            // if(feild.name === 'package_amount'){
            //     package_amount = feild.value;
            // }
            if (feild.name === 'length_of_stay') {
                length_of_stay = feild.value;
            }
            if (feild.name === 'icu_stay') {
                icu_stay = feild.value;
            }
            if (feild.name === 'room_stay') {
                room_stay = feild.value;
            }
            if (feild.name === 'date_of_surgery') {
                date_of_surgery = feild.value;
            }
            if (feild.name === 'room_opted') {
                room_opted = feild.room_id;
                room_opted_name = feild.text;
                if (is_package) { 
                    room_opted_amount = feild.amount;
                     package_amount = feild.amount 
                }else{
                    room_opted_amount = feild.amount;
                }
            }
            if (feild.name === 'room_upgrade') {
                room_upgrade = feild.room_id;
                room_upgrade_name = feild.text;
            }
            if (feild.name === 'room_upgrade_reason') {
                room_upgrade_reason = feild.value;
                room_upgrade_reason_name = feild.text;
            }
            if (feild.name === 'icu_opted') {
                icu_opted = feild.room_id;
                icu_opted_name = feild.text;
            }
            if (feild.name === 'surgery_procedure_name') {
                surgery_procedure_name = feild.value;
                procedure_name=feild.text
            }
            if (feild.name === 'surgery_procedure_amount') {
                surgery_procedure_amount = feild.value;
            }
        })
        // let errors = this.validateModalFeilds(diagnosis, estimated_admission_date, care_management, estimate_type, package_name, length_of_stay, room_opted, date_of_surgery)
        let mederror1=[];
        let mederror2=[];
        let mederror3=[];
        let errors1 = this.validateModalFeilds(medicationDetailsSchema);
        let errors2= this.validateModalFeilds(estimateBreakupFormatSchema);
        let errors3= this.validateModalFeilds(signatureSchema["feilds"]);
        if(errors2.length>0){
            this.setState({estimateBreakupFormaterror:errors2})
            errors2.map((item)=>{
                mederror2.push(item[false]);
            });
        }else{
            mederror2.push(true);
            this.setState({estimateBreakupFormaterror:[]})
        }
        if(errors1.length>0){
            this.setState({medicationDetailserrors:errors1})
            errors1.map((item)=>{
                mederror1.push(item[false]);
            });
        }else{
            mederror1.push(true);
            this.setState({medicationDetailserrors:[]})
        }
        if(errors3.length>0){
            errors3.map((item)=>{
                mederror3.push(item[false]);
            });
        }else{
            mederror3.push(true);
        }

        if(mederror1.includes(false)){
            document.getElementById("wizard").scrollTop=0;
        }
        if(mederror2.includes(false)){
            document.getElementById("wizard").scrollToBottom=0;
        }
        addonSchema.map((subTable, key) => {
            if (subTable.name !== 'surgical_charges' && subTable.name !== 'medical_charges') {
                let table_header = subTable.header;
                let table_body = subTable.Specification.table_body;
                temp_obj[table_header] = subTable.header_amount;
                table_body.map((feild, table_key) => {
                    let service, qty, rate, amount, sub_header;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    if (key_word !== 'ot_hours') {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 0) {
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    if (sub_feild.element === 'text') {
                                        service = parseFloat(sub_feild.service);
                                    }
                                    else {
                                        service = parseFloat(sub_feild.value);
                                    }
                                }
                                if (sub_table_key === 1) {
                                    qty = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }
                    else {
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_feild.name !== 'action') {
                                if (sub_table_key === 1) {
                                    service = parseFloat(sub_feild.service);
                                    sub_header = parseFloat(sub_feild.sub_header);
                                    qty = null;
                                }
                                if (sub_table_key === 2) {
                                    rate = parseFloat(sub_feild.value);
                                }
                                if (sub_table_key === 3) {
                                    amount = parseFloat(sub_feild.value);
                                }
                            }
                        })
                    }

                    let obj = {
                        key_word: key_word,
                        header: table_header,
                        sub_header: sub_header,
                        service: service,
                        qty: qty,
                        rate: rate,
                        amount: amount
                    }

                    // if (key_word !== 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                    if (service !== '' && service !== null && service !== undefined && !isNaN(service) && qty !== '' && qty !== null && qty !== undefined && !isNaN(qty) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {

                        estimate_data.push(obj);
                    }
                    // else {
                    //     if (key_word === 'ot_hours' && service !== '' && service !== null && service !== undefined && !isNaN(service) && rate !== '' && rate !== null && rate !== undefined && !isNaN(rate) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                    //         estimate_data.push(obj);
                    //     }
                    // }
                })
            }
            else {
                if (subTable.visible) {
                    let table_header = subTable.header;
                    let table_body = subTable.Specification.table_body;
                    temp_obj[table_header] = subTable.header_amount;
                    table_body.map((feild, table_key) => {
                        let service, percentage, amount, sub_header;
                        let key_word = feild.key_word;
                        let row = feild.feilds;
                        row.map((sub_feild, sub_table_key) => {
                            if (sub_table_key === 0) {
                                service = parseFloat(sub_feild.service);
                                sub_header = parseFloat(sub_feild.sub_header);
                            }
                            if (sub_table_key === 1) {
                                percentage = parseFloat(sub_feild.value);
                            }
                            if (sub_table_key === 2) {
                                amount = parseFloat(sub_feild.value);
                            }
                        })
                        let obj = {
                            key_word: key_word,
                            header: table_header,
                            sub_header: sub_header,
                            service: service,
                            qty: percentage,
                            rate: null,
                            amount: amount
                        }
                        if (service !== '' && service !== null && service !== undefined && !isNaN(service) && percentage !== '' && percentage !== null && percentage !== undefined && !isNaN(percentage) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                            estimate_data.push(obj);
                        }
                    })
                }
            }
        })
        let in_payload = [];
        includesSchema.map((subTable, key) => {
            if (subTable.name !== '' && subTable.name !== undefined && subTable.name !== null) {
                let table_body = subTable.Specification.table_body;
                let in_data = []
                table_body.map((feild, table_key) => {
                    let service;
                    let key_word = feild.key_word;
                    let row = feild.feilds;
                    let service_id, service_nam;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name === 'item_service') {
                            service_id = +sub_feild.value;
                            service_nam = sub_feild.title;
                        }

                    })
                    let obj = {
                        'service_id': service_id,
                        'service_nam': service_nam
                    }
                    in_data.push(obj);
                })
                let object = {
                    'package_id': subTable.header,
                    'package_name': subTable.name,
                    'services': in_data
                }
                in_payload.push(object);
            }

        })

        console.log(in_payload)
        console.log(includes_data);
        // let duplicates_estimate_Data = [];
        // estimate_data.map((item) => {
        //     if ((item.key_word === 'add_more' && item.header === 9)) {
        //         duplicates_estimate_Data.push(item);
        //     }
        // }
        // )

        additionalPackageSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let package_id, package_name, amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                package_id = parseFloat(sub_feild.value);
                                package_name = sub_feild.text;
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                            // if(sub_table_key === 2){
                            //     percentage = parseFloat(sub_feild.value);
                            // }
                        }
                    })
                    let obj = {
                        package_id: package_id,
                        package_name: package_name,
                        amount: amount,
                        additional_type: 1
                        // percentage : percentage
                    }

                    if (package_id !== '' && package_id !== null && package_id !== undefined && !isNaN(package_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_packages.push(obj);
                    }
                })
            }
        })

        additionalProcedureSchema.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let procedure_id, procedure_name, amount, percentage;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'action') {
                            if (sub_table_key === 0) {
                                procedure_id = parseFloat(sub_feild.value);
                                procedure_name = sub_feild.text;
                            }
                            if (sub_table_key === 1) {
                                amount = parseFloat(sub_feild.value);
                            }
                            // if (sub_table_key === 2) {
                            //     percentage = parseFloat(sub_feild.value);
                            // }
                        }
                    })
                    let obj = {

                        procedure_id: procedure_id,
                        procedure_name: procedure_name,
                        amount: amount,
                        additional_type: 2
                        // percentage: percentage
                    }
                    if (procedure_id !== '' && procedure_id !== null && procedure_id !== undefined && !isNaN(procedure_id) && amount !== '' && amount !== null && amount !== undefined && !isNaN(amount)) {
                        additional_procedures.push(obj);
                    }
                })
            }
        })

        if (care_management == 2) {
            if (estimate_type == 1) {
                let table_data = excludesTableStore.getState();
                table_data&&table_data.length>0 &&  table_data.map((body, key) => {
                    let obj = {
                        // "exclude_status":0,
                        "package_id": null,
                        "service_id": null,
                        "service_name": null,
                        "qty": 0,
                        "rate": 0,
                        "amount": 0
                    }

                    body['feilds'].map((feild, feild_key) => {
                        if (feild.name === 'excludes_service_id') {
                                obj = {
                                    "package_id": feild.package_id ? feild.package_id : null,
                                    "service_id": feild.value ? feild.value : null,
                                    "service_name": feild.text ?feild.text: null,
                                }
                        }

                        if (feild.name === 'qty') {
                            obj[feild.name] = feild.value?feild.value:null;
                        }
                        if (feild.name === 'rate') {
                            obj[feild.name] = feild.value?feild.value:null;

                        }
                        if (feild.name === 'amount') {
                            obj[feild.name] = feild.value?feild.value:null;
                        }
                        // }

                    })
                    excludes_data.push(obj);
                })
                if (excludes_data == null || excludes_data.length == 0) {
                    let { excludes_datarecounselling } = this.state;
                    excludes_datarecounselling && excludes_datarecounselling.length>0 && excludes_datarecounselling.map((item,index)=>{
                        item['service_id']=item.service
                    })
                    excludes_data = excludes_datarecounselling;
                }

                if (includes_data.length > 0) {
                    includes_data = includes_data;
                } else {
                    includes_data = [];
                }
            } else {
                includes_data = [];
                excludes_data = [];
            }
        } else {
            includes_data = [];
            excludes_data = [];
        }
        let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified'));
        let rnTypeResponse = JSON.parse(Storage.get('counselling_view'));
        let payerResponse=null
        if(rnTypeResponse&&rnTypeResponse.length!==0){
            payerResponse = rnTypeResponse[0].rn_payer_response;
        } else {
            payerResponse = null;
        }
        let data = {
            "fc_checklist_verified": patientCheckIn,
             "counselling_date": basic_info['counselling_date'],
             "token_no": basic_info['token_no'],
             "token_display_number": basic_info['token_display_number'],
             "counselling_type_id": basic_info['counselling_type_id'],
             "counsellor_id": basic_info['counsellor_id'],
             "ip_no": basic_info['ip_no'],
             "umr_no": basic_info['umr_no'],
             "patient_name": basic_info['patient_name'],
             "age": basic_info['age'],
             "gender": basic_info['gender'],
             "phone_no": basic_info['phone_no'],
             "marital_status": basic_info['marital_status'],
             "doctor_id": basic_info['doctor_id'],
             "speciality_id": basic_info['speciality_id'],
             "address": basic_info['address'],
             "payment_type": basic_info['payment_type'],
             "comments_data": basic_info['comments_data'],
             "service_id": parseInt(basic_info['service_id']),
             "form_id": basic_info['form_id'],
             "payment_change_reason": basic_info['payment_change_reason'],
             // "whatsapp_phno":basic_info['whatsapp_number'],
             // "token_display_number": 'token',
 
             "doctor_name": basic_info['doctor_name'],
             "speciality_name": basic_info['speciality_name'],
             "counselling_type_name": basic_info['counselling_type_name'],
             "payment_name": basic_info['payment_name'],
             "care_management_name": care_management_name,
             "estimate_name": estimate_name,
             "package_text_name": package_text_name,
             "package_amt":room_opted_amount,
             "package_id":package_name,
 
             "estimated_admission_date": estimated_admission_date,
             "actual_admission_date": actual_admission_date,
             "diagnosis": diagnosis,
             "care_management": care_management,
             "estimate_type": estimate_type,
             "package_name": package_name,
             "package_amount": package_amount,
             "length_of_stay": length_of_stay,
             "icu_stay": icu_stay,
             "room_stay": room_stay,
             "date_of_surgery": date_of_surgery,
             "surgery_procedure_name": surgery_procedure_name,
             "room_opted": room_opted,
             "room_opted_name": room_opted_name,
             "room_opted_amount": room_opted_amount,
             "room_upgrade": room_upgrade,
             "room_upgrade_name": room_upgrade_name,
             "room_upgrade_reason": room_upgrade_reason,
             "room_upgrade_reason_name": room_upgrade_reason_name,
             "icu_opted": icu_opted,
             "icu_opted_name": icu_opted_name,
             "surgery_procedure_amount": surgery_procedure_amount,
 
             "additional_packages": additional_packages,
             "additional_procedures": additional_procedures,
 
             "excludes_data": excludes_data,
             "includes_data": in_payload,
             // "includes_data": includes_data,
             "base_price": estimateBreakupFormatSchema[0]['value'],
             "excludes": estimateBreakupFormatSchema[1]['value'],
             "total_Estimate_amount": estimateBreakupFormatSchema[2]['value']?estimateBreakupFormatSchema[2]['value']:total_estimate_amount,
             "name_of_the_fc": estimateBreakupFormatSchema[3]['value'],
             "attendant_name": estimateBreakupFormatSchema[4]['value'],
             "patient_relation": estimateBreakupFormatSchema[5]['value'],
             "patient_attender_signature": null,
             "counsellor_signature": null,
             "covid_status":basic_info['covid_status']?basic_info['covid_status']:null,
             "procedure_name":procedure_name,
             'rn_payer_response': payerResponse || null,
 
             "header_amount": {
                 "room_charges": addonSchema[0]['header_amount'],
                 "room_investigation_charges": addonSchema[1]['header_amount'],
                 "icu_investigation_charges": addonSchema[2]['header_amount'],
                 "ip_pharmacy_charges": addonSchema[3]['header_amount'],
                 "icu_pharmacy_charges": addonSchema[4]['header_amount'],
                 "ot_cath_pharmacy": addonSchema[5]['header_amount'],
                 "drug_admin_charges": addonSchema[6]['header_amount'],
                 "general_equipment_charges": addonSchema[7]['header_amount'],
                 "ot_charges": addonSchema[8]['header_amount'],
                 "ot_equipment": addonSchema[9]['header_amount'],
                 "procedure_charges": addonSchema[10]['header_amount'],
                 "blood_bank_charges": addonSchema[11]['header_amount'],
                 "cross_consultation_charges": addonSchema[12]['header_amount'],
                 "hospital_services": addonSchema[13]['header_amount'],
                 "isolation_charges": addonSchema[14]['header_amount'],
                 "physiotherapy_diet_charges": addonSchema[15]['header_amount'],
                 "surgical_charges": addonSchema[16]['header_amount'],
                 "medical_charges": addonSchema[17]['header_amount']
             },
             "estimation": estimate_data,
             "isGenerateSign": isGenerateSign,
             "generatedLink": generatedLink,
         };
         let estimationPreview = JSON.stringify(data);
         console.log('Preview_Cash_View', estimationPreview);
        let obj = {
            "patient_name": basic_info['patient_name'],
            "phone_no": basic_info['phone_no'],
            "digital_sig_number": basic_info['phone_no'],
            "digital_sig_weblink": generatedLink,
            "token_id": basic_info['token_no'],
            "preview_data": estimationPreview,
        }
        // signatureSchema.map((feild, fei_key) => {
        //     if(feild["name"] === "phonenumber"){
        //         obj["digital_sig_number"] = feild["value"]
        //     }
        // })
        // console.log("api_sendLink obj", obj);
        // return
        postService(sendDigitalSignLink, "POST", {data: obj}).then(res => {
            if(res.status){
                Modal.success({
                    title: 'Success message',
                    content: res.message ? res.message : 'Sent Link Successfully',
                });
            }else{
                Modal.success({
                    title: 'Error message',
                    content: res.message ? res.message : '',
                }); 
            }
        })
    }
    getDigitalSign = (type) => {
        let {basic_info} = this.props
        let {generatedLink, signatureSchema, digital_sig_imgpath, patient_digsign_willing} = this.state;
                let obj = {
            "patient_name": basic_info['patient_name'],
            "phone_no": basic_info['phone_no'],
            "digital_sig_number": basic_info['phone_no'],
            "digital_sig_weblink": generatedLink,
            "token_id": basic_info['token_no'],
        }
        console.log('Checked', obj);
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                obj["digital_sig_number"] = feild["value"]
            }
        })
        // console.log("getDigitalSign obj", obj);
        // return
        postService(getDigitalSignInfoByToken, "POST", {data: obj}).then(res => {
            if(res.status){
                if(res.data && res.data.length){
                    if(type === "refresh"){
                        if (generatedLink !== null && digital_sig_imgpath === null && patient_digsign_willing === true) {
                            this.handleCheckboxChange();
                        }
                        this.setState({digital_sig_imgpath: res.data[0]["digital_sig_imgpath"]})
                    }else if(type === "preview"){
                        this.setState({digital_sig_imgpath: res.data[0]["digital_sig_imgpath"], patient_digsign_willing: res.data[0]["patient_digsign_willing"] === 'yes'}, () => this.buttonClick_submit())
                    }
                }
            }
        })
          
    }

    onChange = (event) => {
        // console.log("test change", event.target.value);
        const {signatureSchema} = this.state;
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                signatureSchema[fei_key]["value"] = event.target.value ? event.target.value : null
                signatureSchema[fei_key]["errors"] = []
            }
        })
        this.setState({signatureSchema})
    }

    previewAttachments = (file) => {
        this.setState({isPreviewAttachments: true, previewFile: file})
    }

    validateMobileNumber = (number) => {
        const mobilePattern = /^\d{10}$/; // Matches a 10-digit number
        
        return mobilePattern.test(number);
    };

    onChangeGenerateSign = (event) => {
        let {preview_data, generatedLink, signatureSchema,} = this.state
        // console.log("onChangeGenerateSign", event);
        // this.setState({isGenerateSign: event.target.value})
        // this.setState({isGenerateSign: event}, () => this.final_submit())
        let errors = [];
        signatureSchema.map((feild, key) => {
            if (feild['name'] === 'phonenumber') {
                signatureSchema[key]['errors'] = [];
                feild.rules.map((rule, rkey) => {
                    if (feild['value'] === null || feild['value'] === "") {
                        signatureSchema[key]['errors'].push({ 'message': rule.message });
                        errors.push(false);
                    }else {
                        signatureSchema[key]['errors'] = [];
                        let isvalid = this.validateMobileNumber(feild['value'])
                        if(!isvalid){
                            errors.push(false);
                            signatureSchema[key]['errors'].push({ 'message': "Please Enter Valid Phone Number" });
                        }
                    }
                })
            }
        })
        if(!errors.includes(false)){
            // if(event === 'yes'){
            //     let This = this;
            //     preview_data["isGenerateSign"] = event
            //     preview_data["generatedLink"] = generatedLink
        
            //     this.setState({isGenerateSign: event,preview_modal:false, preview_data: preview_data, loadding: true, signatureModal:false})
            //     setTimeout(function () {
            //         This.setState((state) => ({ isGenerateSign: event,preview_modal:true, }), () => This.final_submit())
            //     }, 100);
            // }else {
            //     this.setState({isGenerateSign: event, signatureModal: false}, () => this.final_submit())
            // }

            this.setState({isGenerateSign: event, signatureModal: false}, () => this.final_submit())
        }
        this.setState((state) => ({ signatureSchema: signatureSchema }));
    }

    getCheckList () {
        console.log("here");
        try {
          let user_data;
          if (
            localStorage.getItem('user_data') !== null &&
            localStorage.getItem('user_data') !== undefined &&
            localStorage.getItem('user_data') !== ''
          ) {
            user_data = JSON.parse(localStorage.getItem('user_data'));
          }
          postService('getFCChecklist', 'POST', {
            data: { unit_id: user_data['unitid'] ? user_data['unitid'] : '' }
          })
            .then(res => {
              if (res.status) {
                this.setState({ tableData: res.data[0].data });
              } else {
                this.setState({ tableData: [], fetching: false });
              }
            })
            .catch(error => {
              console.log(error);
              this.setState({ fetching: false });
            });
        } catch (error) {
          console.log(error);
          this.setState({ fetching: false });
        }
      };



handleCheckboxChange = () => {
    let { basic_info } = this.props;
    console.log('check', basic_info);
    const { patient_digsign_willing, signatureSchema} = this.state;
    console.log('check2', patient_digsign_willing);
    const patientWilling = patient_digsign_willing ? 'no' : 'yes';
  
this.setState(
    { patient_digsign_willing: !patient_digsign_willing, errorMessage: '', otpSent: false},
    () => {
      postService('getPatientWilling', 'POST', {
        data: { "token_id": basic_info['token_no'],
             "patient_digsign_willing": patientWilling,
             //"umr":'MRSE2425023763',
           }
      })
        .then((response) => {
            if(patientWilling === 'yes'){
            let This=this
            const id = `previewcash`;
            const input = document.getElementById(id);
            let digiSignPhone;
                signatureSchema.forEach((field, fei_key) => {
                    if (field.name === "phonenumber") {
                        digiSignPhone = field.value;
                    }
                });
            console.log("input=======",this.state.preview_data, this.props);
            let speciality_id = this.state.preview_data.speciality_id;
            if(input !==null && input !=='' && input !==undefined) {
                console.log("input12212++++++++++",input)
                html2PDF(input, {   
                    image: { type: 'png', quality: 0.20 },
                    jsPDF: { format: 'a4', },
                    html2canvas: {
                        scrollX: 0,
                        scrollY: -window.scrollY,
                        useCORS: true,
                    },
                    imageType: 'image/jpeg',
                    output: './images/generate.pdf',
                    success: function(pdf) {
                        const blob = pdf.output('blob');
                        // const blob2 = pdf.output('blob');
                        const form_data = new FormData();
                        console.log("input++++++++++",input)
                        form_data.append('upfile', blob);
                        form_data.append("umr", basic_info['umr_no']);
                        // form_data.append("phone_no",basic_info['phone_no']);
                        //form_data.append("counselling_id", counselling_id);
                        form_data.append("doctor_name", basic_info['doctor_name']);
                        form_data.append("patient_name",basic_info['patient_name']);
                        //form_data.append("counselling_date",basic_info['counselling_date']);
                        form_data.append("speciality_id", speciality_id);
                        //form_data.append("is_digital_sig_required", isGenerateSign);
                        form_data.append("phone_no", digiSignPhone);
                        form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                        formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
                            if (res.status) {
                            localStorage.setItem('completed_counselling_date',moment());
                            console.log("input+-+-+-+-",);    
                            //This.props.next();
                                This.setState({ loadding: false});
                                console.log("input!!!!!!!!");
                                // Modal.success({
                                //     title: `success`,
                                //     content: `${res.message}`,
                                //     zIndex: '1022'
                                // });
                        }
                    });
                        // pdf.save(this.output);
                    }
                });
            }
        }
          // Handle the response from the POST request
          console.log('POST request successful', response);
          // Add further code to handle the response data
        })
        .catch((error) => {
          // Handle any errors that occur during the POST request
          console.error('POST request error', error);
        });
  
      if (!patient_digsign_willing) {
        this.setState({ otp: Array(this.props.length).fill('') });
      }
    }
  );
  
  };

  roundAmount(amount) {

    if (amount < 50) {
      return Math.floor(amount / 100) * 100;
    } else {
      return Math.round(amount / 100) * 100;
    }
  }

  ///////
handleChangeOTP = (index, value) => {
    const newOTP = [...this.state.otp];
    console.log('OTP::::::', newOTP);
    newOTP[index] = value;
    this.setState({ otp: newOTP, errorMessage: ''}, () =>{
        this.handleValidate();
    });
  };

handleValidate = () => {
    try {
        let { counselling_details,basic_info } = this.props;
        let { signatureSchema } = this.state;
        const encryptedOtp = localStorage.getItem('encryptedOtp');
        if (!encryptedOtp) {
            console.error('Encrypted OTP not found in localStorage');
            return;
        }
        const userEnteredOtp = this.state.otp.join("");
        console.log(userEnteredOtp.length);
        let isOtpCorrect = bcrypt.compareSync(userEnteredOtp, encryptedOtp);
        if (isOtpCorrect) {
            let ID = localStorage.getItem('otpid');
                    let payload = {
            "token_id": this.props.basic_info.token_no,
            "umr": this.props.basic_info.umr_no,
            "resId": ID,
            "create_date": moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        };
            postService('generateOTP', 'POST', { "data": payload }).then(res => {
                if (res.status) {
                    let createdDate = res.created_date;
                    console.log('createdDate:::', createdDate);
                    Modal.success({
                        title: 'Success message',
                        content: 'OTP Validated Successfully.'
                    })
                    this.setState({ errorMessage: '',showButtons: true, showInputFeilds: false, showLinks: true, patient_validate: true, createdDate});
                             let This=this
                const id = `previewcash`;
                const input = document.getElementById(id);
                let digiSignPhone;
        signatureSchema.map((feild, fei_key) => {
            if(feild["name"] === "phonenumber"){
                digiSignPhone = feild["value"]
                // data["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] : null
            }
        })
                console.log("input=======", this.state, this.props);
                let speciality_id = this.state.preview_data.speciality_id;
                if(input !==null && input !=='' && input !==undefined) {
                    console.log("input12212++++++++++",input)
                    html2PDF(input, {   
                        image: { type: 'png', quality: 0.20 },
                        jsPDF: { format: 'a4', },
                        html2canvas: {
                            scrollX: 0,
                            scrollY: -window.scrollY,
                            useCORS: true,
                        },
                        imageType: 'image/jpeg',
                        output: './images/generate.pdf',
                        success: function(pdf) {
                            const blob = pdf.output('blob');
                            // const blob2 = pdf.output('blob');
                            const form_data = new FormData();
                            console.log("input++++++++++",input)
                            form_data.append('upfile', blob);
                            form_data.append("umr", basic_info['umr_no']);
                            // form_data.append("phone_no",basic_info['phone_no']);
                            //form_data.append("counselling_id", counselling_id);
                            form_data.append("doctor_name", basic_info['doctor_name']);
                            form_data.append("patient_name",basic_info['patient_name']);
                            //form_data.append("counselling_date",basic_info['counselling_date']);
                            form_data.append("speciality_id", speciality_id);
                            //form_data.append("is_digital_sig_required", isGenerateSign);
                            form_data.append("phone_no", digiSignPhone);
                            form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

                            formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
                                if (res.status) {
                                localStorage.setItem('completed_counselling_date',moment());
                                console.log("input+-+-+-+-",);    
                                //This.props.next();
                                    This.setState({ loadding: false });
                                    console.log("input!!!!!!!!");
                                    // Modal.success({
                                    //     title: `success`,
                                    //     content: `${res.message}`,
                                    //     zIndex: '1022'
                                    // });
                            }
                        });
                            // pdf.save(this.output);
                        }
                    });
                }
                    localStorage.removeItem('encryptedOtp');
                    localStorage.removeItem('otpid');
                } else {
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
        } else {
            if(!isOtpCorrect){
                this.setState({ errorMessage: 'Invalid OTP. Please try again.', showButtons: false});
            console.log("OTP is incorrect");
            }else{
                this.setState({ errorMessage: '', showButtons: false});
                console.log("OTP is incorrect");
            }
           
        }
    } catch (error) {
        console.log(error);
    }
};

getOtp = () => {
    try {
        this.setState({ loading: true });
        let { counselling_details,basic_info } = this.props;
        let { addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, preserve_addonSchema, preserve_medicationDetailsSchema, preserve_estimateBreakupFormatSchema, includes_data, includesSchema,medicationDetails, isGenerateSign, generatedLink, signatureSchema, } = this.state;
        console.log('PROPSSSS::::::', this.props.basic_info);
        // let currentDateTime = new Date().toLocaleString()
        let payload = {
            "token_id": this.props.basic_info.token_no,
            "umr": this.props.basic_info.umr_no,
            "ip_no": this.props.basic_info.ip_no,
            "phone_number": this.props.basic_info.phone_no,
            "resId": null,
            // "create_date": moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        };
        postService('generateOTP', 'POST', { "data": payload }).then(res => {
            if (res.status) {
                console.log('Response:', res);
                localStorage.setItem('encryptedOtp', res.encryptedOtp);
                localStorage.setItem('otpid', res.patientOTPforValidationRes.insertedId);
                this.setState({showInputFeilds: true, otpLink: true, loading: false, otpSent: true});
                Modal.success({
                    title: 'Success message',
                    content: 'OTP Send Successfully.'
                })
        //         let This=this
        //         const id = `previewcash`;
        //         const input = document.getElementById(id);
        //         let digiSignPhone;
        // signatureSchema.map((feild, fei_key) => {
        //     if(feild["name"] === "phonenumber"){
        //         digiSignPhone = feild["value"]
        //         // data["digital_sig_number"] = isGenerateSign === 'yes' ? feild["value"] : null
        //     }
        // })
        //         console.log("input=======",input);
        //         if(input !==null && input !=='' && input !==undefined) {
        //             console.log("input12212++++++++++",input)
        //             html2PDF(input, {   
        //                 image: { type: 'png', quality: 0.20 },
        //                 jsPDF: { format: 'a4', },
        //                 html2canvas: {
        //                     scrollX: 0,
        //                     scrollY: -window.scrollY,
        //                     useCORS: true,
        //                 },
        //                 imageType: 'image/jpeg',
        //                 output: './images/generate.pdf',
        //                 success: function(pdf) {
        //                     const blob = pdf.output('blob');
        //                     // const blob2 = pdf.output('blob');
        //                     const form_data = new FormData();
        //                     console.log("input++++++++++",input)
        //                     form_data.append('upfile', blob);
        //                     form_data.append("umr", basic_info['umr_no']);
        //                     // form_data.append("phone_no",basic_info['phone_no']);
        //                     //form_data.append("counselling_id", counselling_id);
        //                     form_data.append("doctor_name", basic_info['doctor_name']);
        //                     form_data.append("patient_name",basic_info['patient_name']);
        //                     //form_data.append("counselling_date",basic_info['counselling_date']);
        //                     //form_data.append("speciality_id", basic_info['speciality_id']);
        //                     //form_data.append("is_digital_sig_required", isGenerateSign);
        //                     form_data.append("phone_no", digiSignPhone);
        //                     form_data.append('counsellorName',JSON.parse(localStorage.getItem('user')))

        //                     formDataPostService('CounsellingDocumentsendtopatient', 'POST', form_data).then(res => {
        //                         if (res.status) {
        //                         localStorage.setItem('completed_counselling_date',moment());
        //                         console.log("input+-+-+-+-",);    
        //                         //This.props.next();
        //                             This.setState({ loadding: false });
        //                             console.log("input!!!!!!!!");
        //                             // Modal.success({
        //                             //     title: `success`,
        //                             //     content: `${res.message}`,
        //                             //     zIndex: '1022'
        //                             // });
        //                     }
        //                 });
        //                     // pdf.save(this.output);
        //                 }
        //             });
        //         }
                // Enable checkbox after 2 minutes
                // setTimeout(() => {
                //     this.setState({ checkboxDisabled: true });
                // }, 12000);
                this.timeoutId = setTimeout(() => {
                    this.setState({ checkboxDisabled: true });
                }, 60000);
            } else {
                Modal.error({
                    title: 'Error message',
                    content: `${res.message}`,
                });
            }
        });
    } catch (error) {
        console.log(error);
    }
};

cancelOperation = () => {
    if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null; // Reset the timeout ID
    }
    this.setState({
        preview_modal: false,
        preview_PatientCheckin_model: false,
        errorMessage: '',
        otp: Array(this.props.length).fill(''),
        showInputFeilds: false,
        showButtons: false,
        patient_digsign_willing: false,
        showLinks: false,
        otpLink: false,
        otpSent: false,
        patient_validate: false,
        checkboxDisabled: false
    });
};
       
//hiding the estimate table
toggleEstimateTable = () => {
    this.setState(prevState => ({
        hideing_estimatetable_break_down: !prevState.hideing_estimatetable_break_down
    }));
};

admissionDetails = () => {
    this.setState({
        activeKey: []
    })
}

handleCollapseChange = (key) => {
    this.setState({
        activeKey:key, 
    })
}

handleCollapseChange2 = (key) => {
    this.setState({activeKey2: key});
}

handleCollapseChange3 = (index) => {
    this.setState((prevState) => {
        const isActive = prevState.activeKey3.includes(index);
        return {
            activeKey3: isActive 
                ? prevState.activeKey3.filter(key => key !== index) // Remove if already active
                : [...prevState.activeKey3, index] // Add if not active
        };
    });
}

handleCollapseChange4 = (key) => {
    this.setState({activeKey5: key});
}

admissionDetailsNextButton = () => {
    let { slug } = this.props.match.params;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        if (rid != '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
            slug = 'recounselling';
        }
        else if (slug === 'view-finanical-counselling') {
            slug = 'view-finanical-counselling';
        }
        else {
            slug = 'finanical-counselling';
        }
    let {medicationDetailsSchema,showEstimationBreakdown,hideing_estimatetable} = this.state;
    let mederror1=[];
    let mederror2=[];
    let mederror3=[];
    let errors1 = this.validateModalFeilds(medicationDetailsSchema);
    if(errors1.length>0){
        this.setState({medicationDetailserrors:errors1})
        errors1.map((item)=>{
            mederror1.push(item[false]);
        });
    }else{
        mederror1.push(true);
        this.setState({medicationDetailserrors:[]})
    }
    if(slug === 'finanical-counselling' || slug === 'recounselling'){
        if(medicationDetailsSchema[3].value === 1 || medicationDetailsSchema[3].value === '1' || medicationDetailsSchema[3].value === 'Medical'){
            if(medicationDetailsSchema[0].value === null || medicationDetailsSchema[3].value === null || medicationDetailsSchema[9].value === null ||
                 (medicationDetailsSchema[10].value === null || medicationDetailsSchema[10].value === undefined)
                  || medicationDetailsSchema[12].value === null ||
                   ((medicationDetailsSchema[15].value === null || medicationDetailsSchema[15].value === '') && medicationDetailsSchema[10].value >=1)
                    || (medicationDetailsSchema[13].value !== null && medicationDetailsSchema[14].value === null) || medicationDetailsSchema[11].value === null){
                return true;
            }
        } else if(hideing_estimatetable === 1) {
            if(medicationDetailsSchema[0].value === null || medicationDetailsSchema[3].value === null || medicationDetailsSchema[4].value === null || medicationDetailsSchema[6].value === null || medicationDetailsSchema[9].value === null || medicationDetailsSchema[12].value === null || (medicationDetailsSchema[13].value !== null && medicationDetailsSchema[14].value === null)){
                return true;
            }
        }else{
             if(medicationDetailsSchema[0].value === null || medicationDetailsSchema[3].value === null || medicationDetailsSchema[4].value === null || medicationDetailsSchema[6].value === null || medicationDetailsSchema[9].value === null || (medicationDetailsSchema[10].value === null || medicationDetailsSchema[10].value === undefined) || medicationDetailsSchema[12].value === null || (medicationDetailsSchema[13].value !== null && medicationDetailsSchema[14].value === null) || ((medicationDetailsSchema[15].value === null || medicationDetailsSchema[15].value === '') && medicationDetailsSchema[10].value >=1)){
                return true;
            }
        }
        this.setState({activeKey: [], activeKey2: ['1'], showEstimationBreakdown: true,});
    } else {
        this.setState({activeKey: [], activeKey2: ['1'], showEstimationBreakdown: true,});
    }
    // this.total_suming();
}

othersDetailsNextButton = () => {
    let {medicationDetailsSchema,showEstimationBreakdown} = this.state;
    let mederror1=[];
    let mederror2=[];
    let mederror3=[];
    let errors1 = this.validateModalFeilds(medicationDetailsSchema);
    if(errors1.length>0){
        this.setState({medicationDetailserrors:errors1})
        errors1.map((item)=>{
            mederror1.push(item[false]);
        });
    }else{
        mederror1.push(true);
        this.setState({medicationDetailserrors:[]})
    }
    if(medicationDetailsSchema[3].value === 1 || medicationDetailsSchema[3].value === '1' || medicationDetailsSchema[3].value === 'Medical'){
        if(medicationDetailsSchema[0].value === null || medicationDetailsSchema[3].value === null || medicationDetailsSchema[9].value === null || medicationDetailsSchema[12].value === null || medicationDetailsSchema[15].value === null || (medicationDetailsSchema[13].value !== null && medicationDetailsSchema[14].value === null)){
            return true;
        }
    } else {
        if(medicationDetailsSchema[0].value === null || medicationDetailsSchema[3].value === null || medicationDetailsSchema[4].value === null || medicationDetailsSchema[6].value === null || medicationDetailsSchema[9].value === null|| medicationDetailsSchema[12].value === null || (medicationDetailsSchema[13].value !== null && medicationDetailsSchema[14].value === null)){
            return true;
        }
    }
    this.setState({activeKey: [], activeKey2: ['1'], showEstimationBreakdown: true,})
}

estimateBreakDownNextButton = () => {
    this.setState({activeKey2: [], activeKey5: ['1'], showOtherDetails: true})
}

//new_consultations_fee_adding

internsivistAndasstInternsivist(ele_val) {
    console.log("this.props", ele_val);
    try {
    let { addonSchema ,InsuranceDetailsSchema,medicationDetailsSchema} = this.state;
    let {counselling_details}=this.props;
    let { slug } = this.props.match.params;
    let user_data = JSON.parse(Storage.get('user_data'));
    let user_unit_id = user_data.unitid;
    let qty_for_icu_stay = [
        { header: 1, key: 1 },
        { header: 1, key: 2 },
        { header: 1, key: 3 },
        { header: 3, key: 0 },
        { header: 5, key: 0 },
        { header: 15, key: 1 },
        { header: 16, key: 0 }];

        let icu_stay = 0;
        let total_stay = 0;
    // addonSchema.map((subTable, key) => {
    //     qty_for_icu_stay.map((icu_stay, icu_stay_key) => {
    //         if (subTable.header === icu_stay.header) {
    //             let table_body = subTable.Specification.table_body;
    //             table_body.map((feild, table_key) => {
    //                 if (table_key === icu_stay.key) {
    //                     let row = feild.feilds;
    //                     let rate;
    //                     let qty;
    //                     row.map((sub_feild, sub_table_key) => {
    //                         console.log('ADDONSCHEMAAAAA', sub_feild)
    //                         if (sub_feild.row_group === 'dietician') {
    //                             if (sub_feild.name === 'qty') {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = total_stay;
    //                                 qty=total_stay;
    //                             }
                                

    //                         }else if (sub_feild.name === 'qty') {
    //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = !isNaN(ele_val) ? ele_val : 0;
    //                             qty=ele_val;
    //                         }
    //                         if (sub_feild.name === 'rate') {
    //                             rate = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]);
    //                         }
    //                         if (sub_feild.name === 'amount') {
    //                             if (rate != '' && rate != undefined && rate != null && !isNaN(rate)) {
    //                                 addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty*rate;
    //                             }
    //                         }
    //                     })
    //                 }
    //             })
    //         }
    //     })
    // })

    postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 1, sub_header_id: 3, tariff_mapped: "TR1" } }).then(res => {
        if(res.status){
            postService('getServicePricesById', 'POST', { data: { service_id: res.data[0].id, tariff_id: 'TR1', room_type:0, payment_type: 2, unit_id: user_unit_id, payment_type_9:1 } }).then(res => {
                let Intensivistamount = res.data[0].amount;
                console.log('INNNTTT', this.state);
                addonSchema.map((subfeild1, key) => {
                    let table_body = subfeild1.Specification.table_body;
                    let header_amount = 0;
                    table_body.map((subfeilds2, table_key) => {
                        let subFeilds = subfeilds2.feilds;
                        let qty;
                        subFeilds.map((subfeilds3, sub_table_key) => {
                            if (subfeilds3.row_group === 'intensivist') {
                                if (subfeilds3.name === "qty") {
                                    // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                    qty = this.state.medicationDetailsSchema[10].value;

                                    if (qty === '' && qty === null && qty === undefined) {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    } else {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                    }
                                }
                                if(subfeilds3.name === 'rate'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Intensivistamount ? Intensivistamount : 0
                                };
                                if(subfeilds3.name === 'amount'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * (parseFloat(Intensivistamount) ? parseFloat(Intensivistamount) : 0);
                                    header_amount = parseFloat(header_amount) + (qty * parseFloat(Intensivistamount));
                                    console.log('INTENSIVISTAMOUNT222', header_amount);
                                };
                            };
                        });
                    });
                    addonSchema[key]['header_amount'] = header_amount;
                    this.total_suming();
                });
            });
        };
    });
    postService('getServicesByHeaderId', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 1, sub_header_id: 4, tariff_mapped: "TR1" } }).then(res => {
        if(res.status){
            postService('getServicePricesById', 'POST', { data: { service_id: res.data[0].id, tariff_id: 'TR1', room_type:0, payment_type: 2, unit_id: user_unit_id, payment_type_9:1 } }).then(res => {
                let Intensivistamount = res.data[0].amount;
                addonSchema.map((subfeild1, key) => {
                    let table_body = subfeild1.Specification.table_body;
                    let header_amount = 0;
                    table_body.map((subfeilds2, table_key) => {
                        let subFeilds = subfeilds2.feilds;
                        let qty;
                        subFeilds.map((subfeilds3, sub_table_key) => {
                            if (subfeilds3.row_group === 'asst_intensivist') {
                                if (subfeilds3.name === "qty") {
                                    // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                    qty = this.state.medicationDetailsSchema[10].value;

                                    if (qty === '' && qty === null && qty === undefined) {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    } else {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                    }
                                }
                                if(subfeilds3.name === 'rate'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = Intensivistamount ? Intensivistamount : 0
                                };
                                if(subfeilds3.name === 'amount'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * (parseFloat(Intensivistamount) ? parseFloat(Intensivistamount) : 0);
                                    header_amount = parseFloat(header_amount) + (qty * parseFloat(Intensivistamount));
                                    console.log('HEADER_AMOUNT', header_amount);
                                };
                            };
                        });
                    });
                    addonSchema[key]['header_amount'] = header_amount;
                    this.total_suming();
                });
            });
        };
    // this.total_suming();
    });

    // this.total_suming();
    this.setState({addonSchema: addonSchema})
    // this.insurance_total();
} catch (error) {
    console.log(error);
    this.setState({ 'loadding': false });
}
}


PrimaryConsultantRoomAmount = async() => {
    let { basicDetailsSchema, medicationDetailsSchema, estimateBreakupFormatSchema, addonSchema, roomtypeSchema, includesSchema, excludesSchema, additionalPackageSchema, additionalProcedureSchema, signatureSchema, } = this.state;
    let { counselling_details, basic_info, } = this.props;
    console.log('STATE:::::', this.props.basic_info.token_doctor_id, this.state.medicationDetailsSchema[12].ward_groupname)
    let user_data = JSON.parse(Storage.get('user_data'));
    let user_unit_id = user_data.unitid;
    let WardName = this.state.medicationDetailsSchema[12].ward_groupname ? this.state.medicationDetailsSchema[12].ward_groupname : this.state.medicationDetailsSchema[12].wardgroupname;
    let doctorCode = this.props.basic_info.token_doctor_id;
    let { slug } = this.props.match.params;
    // let wardGroupName = basicSumInsuredSchema[5].data[0];
    console.log('WardName', WardName, this.state);
    if(WardName){
        await postService('getServicesByHeaderId', 'POST', { data: { tariff_mapped: "TR1", room_type:0, payment_type: 1, unit_id: user_unit_id, header_id: 16, sub_header_id: 34, doctor_id: doctorCode, ward_groupname: WardName } }).then(res => {
            let PrimaryConsultantRoomamount;
            if(res.data && res.data.length > 0){
                PrimaryConsultantRoomamount = res.data[0].amount; 
            }
            let header_amount = 0;
            // addonSchema.map((subfeild1, key) => {
            //     let table_body = subfeild1.Specification.table_body;
            //     table_body.map((subfeilds2, table_key) => {
            //         let subFeilds = subfeilds2.feilds;
            //         let qty = 1;
            //         subFeilds.map((subfeilds3, sub_table_key) => {
            //             if(PrimaryConsultantRoomamount !== null){
            //                 if (subfeilds3.row_group === 'primary_consultation_room') {
            //                     if (subfeilds3.name === "qty") {
            //                         if (qty === '' && qty === null && qty === undefined) {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
            //                         } else {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
            //                         }
            //                     }
            //                     // if(subfeilds3.name === 'rate'){
            //                     //     addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = PrimaryConsultantRoomamount
            //                     //     // addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =
            //                     //     // 1000;
            //                     // };
            //                     // if(subfeilds3.name === 'amount'){
            //                     //     // addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1 * 1000;
            //                     //     // header_amount = parseFloat(header_amount) + (qty * parseFloat(PrimaryConsultantRoomamount));
            //                     // };
            //                     if (subfeilds3.name === "rate" ) {
            //                         PrimaryConsultantRoomamount = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
            //                     }
            //                     if (subfeilds3.name === "amount") {
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1*parseFloat(PrimaryConsultantRoomamount);
            //                         console.log('PrimaryConsultantRoomamount::', PrimaryConsultantRoomamount);
            //                         header_amount = parseFloat(header_amount) + (1*parseFloat(PrimaryConsultantRoomamount));
            //                     }
            //                 };
            //             }
            //         });
            //     });
            //     // addonSchema[key]['header_amount'] = header_amount;
            // });
            addonSchema.map((subfeild1, key) => {
                let table_body = subfeild1.Specification.table_body;
                table_body.map((subfeilds2, table_key) => {
                    let subFeilds = subfeilds2.feilds;
                    let qty = 1;
                    subFeilds.map((subfeilds3, sub_table_key) => {
                        if(PrimaryConsultantRoomamount !== null){
                            if (subfeilds3.row_group === 'primary_consultation_room') {
                                if(slug === 'finanical-counselling' || slug === 'view-finanical-counselling' || slug === 'recounselling'){
                                    if (subfeilds3.name === "qty") {
                                        if (qty === '' && qty === null && qty === undefined) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                        }
                                    }
                                    if(subfeilds3.name === 'rate'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = PrimaryConsultantRoomamount
                                    };
                                    if(subfeilds3.name === 'amount'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1 * parseFloat(PrimaryConsultantRoomamount);
                                    };
                                }
                            };
                        } else {
                            if (subfeilds3.row_group === 'primary_consultation_room') {
                                if (subfeilds3.name === "qty") {
                                    if (qty === '' && qty === null && qty === undefined) {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    } else {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                    }
                                }
                                if(subfeilds3.name === 'rate'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false 
                                    PrimaryConsultantRoomamount = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                };
                                if(subfeilds3.name === 'amount'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1 * parseFloat(PrimaryConsultantRoomamount);
                                };
                            };
                        }
                    });
                });
            });

        }); 
        await postService('getServicesByHeaderId', 'POST', { data: { tariff_mapped: "TR1", room_type:0, payment_type: 1, unit_id: user_unit_id, header_id: 16, sub_header_id: 35, doctor_id: doctorCode, ward_groupname: WardName } }).then(res => {
            let PrimaryConsultantICUamount;
            if(res.data && res.data.length > 0){
                PrimaryConsultantICUamount = res.data[0].amount; 
            }
            let header_amount = 0;
            // addonSchema.map((subfeild1, key) => {
            //     let table_body = subfeild1.Specification.table_body;
            //     table_body.map((subfeilds2, table_key) => {
            //         let subFeilds = subfeilds2.feilds;
            //         let qty = 2;
            //         subFeilds.map((subfeilds3, sub_table_key) => {
            //             if(PrimaryConsultantICUamount !== null){
            //                 if (subfeilds3.row_group === 'primary_consultation_icu') {
            //                     if (subfeilds3.name === "qty") {
            //                         // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
            //                         // qty = ele_val;

            //                         if (qty === '' && qty === null && qty === undefined) {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
            //                         } else {
            //                             addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 2;
            //                         }
            //                     }
            //                     if(subfeilds3.name === 'rate'){
            //                         // addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = PrimaryConsultantICUamount
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =
            //                         1000;
            //                     };
            //                     if(subfeilds3.name === 'amount'){
            //                         addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 2 * 1000;
            //                         // header_amount = parseFloat(header_amount) + (qty * parseFloat(PrimaryConsultantICUamount));
            //                     };
            //                 };
            //             }
            //         });
            //     });
            //     // addonSchema[key]['header_amount'] = header_amount;
            // });
            addonSchema.map((subfeild1, key) => {
                let table_body = subfeild1.Specification.table_body;
                table_body.map((subfeilds2, table_key) => {
                    let subFeilds = subfeilds2.feilds;
                    let qty = 2;
                    subFeilds.map((subfeilds3, sub_table_key) => {
                        if(PrimaryConsultantICUamount !== null){
                            if (subfeilds3.row_group === 'primary_consultation_icu') {
                                if (subfeilds3.name === "qty") {
                                    if (qty === '' && qty === null && qty === undefined) {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    } else {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 2;
                                    }
                                }
                                if(subfeilds3.name === 'rate'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = PrimaryConsultantICUamount
                                };
                                if(subfeilds3.name === 'amount'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 2 * parseFloat(PrimaryConsultantICUamount);
                                };
                            };
                        } else {
                            if (subfeilds3.row_group === 'primary_consultation_icu') {
                                if (subfeilds3.name === "qty") {
                                    if (qty === '' && qty === null && qty === undefined) {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                    } else {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                    }
                                }
                                if(subfeilds3.name === 'rate'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false
                                    PrimaryConsultantICUamount = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                };
                                if(subfeilds3.name === 'amount'){
                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(PrimaryConsultantICUamount);
                                };
                            };
                        }
                    });
                });
            });

        });
    }
}


avergaesData = async() => {
    let { addonSchema,hideing_estimatetable, medicationDetailsSchema,estimateBreakupFormatSchema, additionalPackageSchema, additionalProcedureSchema, InsuranceDetailsSchema, basicSumInsuredSchema, view_details, ailmentSchema, nmePopupSchema, inital_package_amount, nme_total_amount, exclude_total_amount, fc1_total_estimate_amount, total_estimate_amount,Insu_Physician_Fees_ICU,consutations, doctorCode, estimateTypeValue } = this.state;
    let {counselling_details, basic_info}=this.props;
    let doctor_cd = this.props.basic_info.token_doctor_id 
    console.log('counselling_details:::', counselling_details, this.state, this.props.basic_info.token_doctor_id);
    let { slug } = this.props.match.params;
    let user_data = JSON.parse(Storage.get('user_data'));
    let user_unit_id = user_data.unitid;
    console.log('AVVVV', this.state.procedureCode);
    postService('getAveragesData', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 14, sub_header_id: 22, tariff_mapped: "TR1", doctor_id:  this.props.basicDetailsSchema[10].value, length_of_Stay: (this.state.medicationDetailsSchema[5].value === 1 || this.state.medicationDetailsSchema[5].value === '1') ? null : this.state.medicationDetailsSchema[9].value, "care_management":this.state.medicationDetailsSchema[3].value, "surgery_code": this.state.procedureCode? this.state.procedureCode: null} }).then(res => {
        if(res.status){
            // postService('getServicePricesById', 'POST', { data: { service_id: res.data[0].id, tariff_id: 'TR1', room_type:0, payment_type: 2, unit_id: user_unit_id, payment_type_9:1 } }).then(res => {
                let FNBamount = res.data[0].average_fnb_amount;
                let BloodBankamount = res.data[0].average_bloodbank_amount;
                let investigationsAmount = res.data[0].average_inv_amount;
                let seviceCharges = res.data[0].average_service_amount;
                let procedureCharges = res.data[0].average_procedure_amount;
                let pharmacyCharges = res.data[0].average_pharmacy_amount;
                addonSchema.map((subfeild1, key) => {
                    let table_body = subfeild1.Specification.table_body;
                    if(subfeild1.name === 'icu_investigation_charges'){
                        let header_amount = 0;
                        table_body.map((subfeilds2, table_key) => {
                            let subFeilds = subfeilds2.feilds;
                            let qty;
                            subFeilds.map((subfeilds3, sub_table_key) => {
                                if (subfeilds3.row_group === 'routine') {
                                    if (subfeilds3.name === "qty") {
                                        // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                        qty = 1;

                                        if (qty === '' && qty === null && qty === undefined) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if(subfeilds3.name === 'rate'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = seviceCharges
                                    };
                                    if(subfeilds3.name === 'amount'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(seviceCharges);
                                        header_amount = parseFloat(header_amount) + (qty * parseFloat(seviceCharges));
                                    };
                                };
                            });
                        });
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                        if(subfeild1.name === 'blood_bank_charges'){
                        let header_amount = 0
                        table_body.map((subfeilds2, table_key) => {
                            let subFeilds = subfeilds2.feilds;
                            let qty;
                            if(subfeilds2.key_word === 'add_more'){
                                let qty = 1;
                                let additionalPrimaryConsultant = null
                                subFeilds.map((sub_feild, sub_table_key) => {
                                    if (sub_feild.name === 'qty') {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = false;
                                        additionalPrimaryConsultant = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"];
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(additionalPrimaryConsultant);
                                        header_amount = parseFloat(header_amount) + parseFloat(additionalPrimaryConsultant);
                                        // amount = parseFloat(amount) + parseFloat(additionalPrimaryConsultant);
                                    }
                                })
                            } else {
                                subFeilds.map((subfeilds3, sub_table_key) => {
                                        if (subfeilds3.row_group === 'bloodbank_charges') {
                                        if (subfeilds3.name === "qty") {
                                            // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                            qty = 1;
    
                                            if (qty === '' && qty === null && qty === undefined) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            } else {
                                                    addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                            }
                                        }
                                        if(subfeilds3.name === 'rate'){
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = BloodBankamount
                                        };
                                        if(subfeilds3.name === 'amount'){
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(BloodBankamount);
                                            console.log("qty * parseFloat(BloodBankamount);",qty * parseFloat(BloodBankamount));
                                            const finalamount = addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"]
                                            header_amount = parseFloat(header_amount) + finalamount;
                                        };
                                    } else if (subfeilds3.row_group === 'fnb_charges') {
                                        if (subfeilds3.name === "qty") {
                                            // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                            qty = 1;
    
                                            if (qty === '' && qty === null && qty === undefined) {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                            } else {
                                                addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                            }
                                        }
                                        if(subfeilds3.name === 'rate'){
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = FNBamount
                                        };
                                        if(subfeilds3.name === 'amount'){
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(FNBamount);
                                            header_amount = parseFloat(header_amount) + (qty * parseFloat(FNBamount));
                                        };
                                    }
                                });
                            }
                        });
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                    if(subfeild1.name === 'room_investigation_charges'){
                        let header_amount = 0;
                        table_body.map((subfeilds2, table_key) => {
                            let subFeilds = subfeilds2.feilds;
                            let qty;
                            subFeilds.map((subfeilds3, sub_table_key) => {
                                if (subfeilds3.row_group === 'routine') {
                                    if (subfeilds3.name === "qty") {
                                        // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                        qty = 1;

                                        if (qty === '' && qty === null && qty === undefined) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if(subfeilds3.name === 'rate'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = investigationsAmount
                                    };
                                    if(subfeilds3.name === 'amount'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(investigationsAmount);
                                        header_amount = parseFloat(header_amount) + (qty * parseFloat(investigationsAmount));
                                    };
                                };
                            });
                        });
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                    if(subfeild1.name === 'ip_pharmacy_charges'){
                        let header_amount = 0;
                        table_body.map((subfeilds2, table_key) => {
                            let subFeilds = subfeilds2.feilds;
                            let qty;
                            subFeilds.map((subfeilds3, sub_table_key) => {
                                if (subfeilds3.row_group === 'routine') {
                                    if (subfeilds3.name === "qty") {
                                        // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                        qty = 1;

                                        if (qty === '' && qty === null && qty === undefined) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if(subfeilds3.name === 'rate'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = pharmacyCharges
                                    };
                                    if(subfeilds3.name === 'amount'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(pharmacyCharges);
                                        header_amount = parseFloat(header_amount) + (qty * parseFloat(pharmacyCharges));
                                    };
                                };
                            });
                        });
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                    if(subfeild1.name === 'procedure_charges'){
                        let header_amount = 0;
                        table_body.map((subfeilds2, table_key) => {
                            let subFeilds = subfeilds2.feilds;
                            let qty;
                            subFeilds.map((subfeilds3, sub_table_key) => {
                                if (subfeilds3.row_group === 'routine') {
                                    if (subfeilds3.name === "qty") {
                                        // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                        qty = 1;

                                        if (qty === '' && qty === null && qty === undefined) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if(subfeilds3.name === 'rate'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = procedureCharges
                                    };
                                    if(subfeilds3.name === 'amount'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty * parseFloat(procedureCharges);
                                        header_amount = parseFloat(header_amount) + (qty * parseFloat(procedureCharges));
                                    };
                                };
                            });
                        });
                        addonSchema[key]['header_amount'] = header_amount;
                    }
                });
            // });
        };
    });
    postService('getDMOCharges', 'POST', { data: { payment_type: 1, unit_id: user_unit_id, header_id: 16, sub_header_id: 7, tariff_mapped: "TR1"} }).then(res => {
        if(res.status){
            let DMOCharges = res.data[0].amount;
            addonSchema.map((subfeild1, key) => {
                let table_body = subfeild1.Specification.table_body;
                if(subfeild1.name === 'ins_consultation_charges'){
                    let header_amount = 0;
                    table_body.map((subfeilds2, table_key) => {
                        let subFeilds = subfeilds2.feilds;
                        let qty;
                        subFeilds.map((subfeilds3, sub_table_key) => {
                            if (subfeilds3.row_group === 'dmo_charges') {
                                if (subfeilds3.name === "qty") {
                                    // qty = parseFloat(addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"])
                                    qty = this.state.medicationDetailsSchema[11].value;

                                        if (qty === '' && qty === null && qty === undefined) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = null;
                                        } else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if(subfeilds3.name === 'rate'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = hideing_estimatetable !== 1 ? DMOCharges : 0;
                                    };
                                    if(subfeilds3.name === 'amount'){
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] =  hideing_estimatetable !== 1 ? (qty * parseFloat(DMOCharges)) : 0;
                                    };
                                };
                            });
                        });
                        addonSchema[key]['header_amount'] = header_amount;
                        this.total_suming();
                    }
                });
            };
        });
        postService('getServicePricesById', 'POST', { data: { service_id: 'RNS0120', tariff_id: 'TR1', room_type:0, payment_type: 1, unit_id: user_unit_id, service_type: 'PC' } }).then((res) => {
            if (res.status) {
                let amount = res.data ? res.data[0].amount : 0;
                addonSchema.map((subTable, key) => {
                    // if (subTable.name === data.table) {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.row_group === 'medical_record_charges'){
                                    if (sub_feild.name === "qty") {
                                        if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
    
                                        }
                                        else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = 1;
                                        }
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * 1;
                                    }
                                }
                            })
                        })
                    // }
                })
                this.setState({ addonSchema: addonSchema });
                this.total_suming();
            }
        });
        postService('getServicePricesById', 'POST', { data: { service_id: 'HSP5013', tariff_id: 'TR1', room_type:0, payment_type: 1, unit_id: user_unit_id, service_type: 'PC' } }).then((res) => {
            if (res.status) {
                let amount = res.data ? res.data[0].amount : 0;
                addonSchema.map((subTable, key) => {
                    // if (subTable.name === data.table) {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            let qty = this.state.medicationDetailsSchema[9].value;
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.row_group === 'ward_consumables'){
                                    if (sub_feild.name === "qty") {
                                        if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
    
                                        }
                                        else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * qty;
                                    }
                                }
                            })
                        })
                    // }
                })
                this.setState({ addonSchema: addonSchema });
                this.total_suming();
            }
        });
        postService('getServicePricesById', 'POST', { data: { service_id: 'DIE0001', tariff_id: 'TR1', room_type:0, payment_type: 1, unit_id: user_unit_id, service_type: 'PC' } }).then((res) => {
            if (res.status) {
                let amount = res.data ? res.data[0].amount : 0;
                addonSchema.map((subTable, key) => {
                    // if (subTable.name === data.table) {
                        let table_body = subTable.Specification.table_body;
                        table_body.map((feild, table_key) => {
                            let row = feild.feilds;
                            let qty = 1;
                            row.map((sub_feild, sub_table_key) => {
                                if(sub_feild.row_group === 'diet_consulation_charges'){
                                    if (sub_feild.name === "qty") {
                                        if (sub_feild.value === '' || sub_feild.value === undefined || sub_feild.value === null) {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
    
                                        }
                                        else {
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['disable'] = false;
                                            addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = qty;
                                        }
                                    }
                                    if (sub_feild.name === "rate") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = amount
                                    }
                                    if (sub_feild.name === "amount") {
                                        addonSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["value"] = parseFloat(amount) * qty;
                                    }
                                }
                            })
                        })
                    // }
                })
                this.setState({ addonSchema: addonSchema });
                this.total_suming();
            }
        });
    }
    
    handleCollapseChange6 = (key) => {
    this.setState({activeKey6: key });
}

deleteRow1(data,index) {
    try {
    let { addonSchema, additionalPackageSchema, additionalProcedureSchema, ailmentSchema, packages_IN_EX, inc_excludes_packages_ids, includesSchema, exculude_options, inc_excludes_pack_id,slugforexcludedropdown, excludesSchema } = this.state;
    let {counselling_details}=this.props
    let user_data = JSON.parse(Storage.get('user_data'));
    let user_unit_id = user_data.unitid;
    let table_name = data[0].feilds[0].table;
    let last_id = data[0].feilds[0].id;
    let newData = [];
    let ot_inst_disinfec=0;
    if (Array.isArray(data)) {
        console.log("line 14348",data, index);
        addonSchema.map((subTable, key) => {
            if (subTable.name === table_name) {
                let table_body = subTable.Specification.table_body;
                // table_body.map((feild, table_key) => {
                //     if (table_key !==0 || table_key !== '0') {
                //         // addonSchema[key].Specification.table_body.splice(table_key, 1);
                //         let row = feild.feilds;
                //         row.map((feild1,keys) => {
                //             feild1.value = '';
                //         });
                //     }
                // })
            }
        })
    }
    this.setState({ addonSchema: addonSchema, additionalPackageSchema: additionalPackageSchema, additionalProcedureSchema: additionalProcedureSchema, ailmentSchema: ailmentSchema }, () => {
        this.total_suming();
        // this.highestPackage(data)
    })
} catch (error) {
    console.log(error);
    this.setState({ 'loadding': false });
}
}

    render() {
        let { hideing_estimatetable_break_down,tableData,addonSchema, medicationDetailsSchema, estimateBreakupFormatSchema, view_mode, img, img2, total_estimate_amount, additionalPackageSchema, additionalProcedureSchema, view_details, error_view, error_message, hideing_estimatetable, preview_data, preview_modal,preview_PatientCheckin_model,fc1_total_estimate_amount, signatureModal, signatureSchema, isPreviewAttachments, previewFile, isGenerateSign, generatedLink, digital_sig_imgpath,chechlistData, isChecked, patient_digsign_willing,enableCheckBox, patient_validate, checkboxDisabled,estimateTypeValue} = this.state;
        let { slug } = this.props.match.params;
        let { basicDetailsSchema } = this.props;
        
        let { data } = this.state
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        console.log('SATTEL:::::::', this.state);
        let visibleCounter = 0;
        //
        const totalAmount = total_estimate_amount !== 0 
    ? total_estimate_amount 
    : fc1_total_estimate_amount;
    // Calculate -10% and +10%
    const lowerBound = hideing_estimatetable === 1 ? totalAmount : (totalAmount * 0.9); // 90% of the total amount
    const upperBound = totalAmount * 1.1; // 110% of the total amount

    // Format the values
    const formattedLowerBound = dollarIndianLocale.format(this.roundAmount(lowerBound));
    const formattedUpperBound = dollarIndianLocale.format(this.roundAmount(upperBound));

    // Display the estimated range
    const estimatedRange = `${formattedLowerBound} - ${formattedUpperBound}`;
        return (
            <div>
                <Spin spinning={this.state.loadding}>
                    <div className="card mx-5 mb-0 mt-0">
                    <Collapse
                    activeKey={this.state.activeKey}
                    onChange={this.handleCollapseChange}
                    expandIconPosition="end" // Optional: controls where the expand icon appears
                >
                    <Collapse.Panel header={(<h1 className="text-capitalize text-heading mb-0" style={{fontSize: '25px'}}>Admission Details</h1>)} key="1">
                        <div className="mx-4 mb-5 mt-4">
                            
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={medicationDetailsSchema} buttonClick={this.buttonClick2.bind(this)} />
                        </div>
                        <div className="row justify-content-center mt-4">
                            <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.admissionDetailsNextButton}>Next</button>
                        </div>
                    </Collapse.Panel>
                </Collapse>
                    </div>
                    {/* {hideing_estimatetable !== 1 ? */}
                    <React.Fragment>
                        <div className="card mx-5 mb-0 mt-0">
                        {this.state.showEstimationBreakdown && (
                            <Collapse activeKey={this.state.activeKey2} onChange={this.handleCollapseChange2} expandIconPosition="end">
                                <Collapse.Panel header={(<h1 className="text-capitalize text-heading mb-0" style={{fontSize: '25px'}}>Estimation Breakdown Charges</h1>)} key="1">
                                {hideing_estimatetable === 1 ? 
                                    <Collapse activeKey={this.state.activeKey6} onChange={this.handleCollapseChange6}  expandIconPosition="end">
                                        <Collapse.Panel header={(<h4 className="data-label w-50" style={{ fontSize: 20, color:'black' }}>Add Additional Package</h4>)} key="1">
                                            <div className="financial-table table-responsive">
                                                {additionalPackageSchema.map((feild, key) => {
                                                    if (true) {
                                                        return (<React.Fragment key={key}>
                                                            <div className="d-inline-flex pl-5 w-100">
                                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                                            </div>
                                                            <div className="financial-table table-responsive">
                                                                <Tableantd form_table={'additional_packages'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                            </div>
                                                        </React.Fragment>)
                                                    }
                                                })}
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>
                                    : null
                            }
                            <br></br>
                                <table className="table table-hover table-bordered" style={{marginRight:'2%'}} ref={this.activeKey2Ref}>
                                    <thead style={{ backgroundColor: '#87979f', textAlign: 'center', color:'white', border: '3px solid #dee2e6',fontWeight: 500, }}>
                                        <tr>
                                            <td style={{ width: '5%' }}>S.No</td>
                                            <td style={{ width: '30%' }}>Service Name</td>
                                            <td style={{ width: '20%' }}>Quantity</td>
                                            <td style={{ width: '20%' }}>Rate (Rs.)</td>
                                            <td style={{ width: '19%' }}>Amount (Rs.)</td>
                                            <td style={{ width: '15%' }}>Action</td>
                                        </tr>
                                    </thead>
                                </table>
                            {/* {hideing_estimatetable === 1 ? 
                                    <Collapse activeKey={this.state.activeKey6} onChange={this.handleCollapseChange6}  expandIconPosition="end">
                                        <Collapse.Panel header={(<h4 className="data-label w-50" style={{ fontSize: 20, color:'black' }}>Add Additional Package</h4>)} key="1">
                                            <div className="financial-table table-responsive">
                                                {additionalPackageSchema.map((feild, key) => {
                                                    if (true) {
                                                        return (<React.Fragment key={key}>
                                                            <div className="d-inline-flex pl-5 w-100">
                                                                <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                                            </div>
                                                            <div className="financial-table table-responsive">
                                                                <Tableantd form_table={'additional_packages'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                            </div>
                                                        </React.Fragment>)
                                                    }
                                                })}
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>
                                    : null
                            }         */}
                                {addonSchema.map((feild, index) => {
                                    if (feild.visible) {
                                        visibleCounter++
                                        const isActive = this.state.activeKey3.includes(index);
                                        return (<React.Fragment key={index}>
                                            <Collapse activeKey={isActive ? [index.toString()] : []} onChange={() => this.handleCollapseChange3(index)} expandIconPosition="end">
                                                <Collapse.Panel key={index.toString()} header={(
                                                        <div className="d-inline-flex w-100">
                                                            <h4 className="data-label w-50" style={{ fontSize: 20 }}>{visibleCounter} . {feild.title}</h4>
                                                            <h4 className="data-label w-50 text-right mr-3" style={{ fontSize: 20 }}>
                                                                Rs. {dollarIndianLocale.format(this.roundAmount(feild.header_amount))}
                                                            </h4>
                                                        </div>
                                                    )}>
                                             
                                                <div className="financial-table table-responsive">
                                                    {/* <Tableantd {...this.props} {...this.state} table_data={feild.Specification} index={visibleCounter} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)}  /> */}
                                                    <Tableantd {...this.props} {...this.state} table_data={feild.Specification} index={visibleCounter} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} deleteLineItem1={this.deleteRow1.bind(this)} />
                                                </div>
                                            
                                                </Collapse.Panel>
                                            </Collapse>
                                        </React.Fragment>)
                                    }
                                })}
                                <div className="row justify-content-center mt-4">
                                                    <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.estimateBreakDownNextButton}>Next</button>
                                </div>
                                </Collapse.Panel>
                                </Collapse>
                                )}
                                <div className="clearfix px-5 total_estimate p-2">
                                    <h4 className="float-left sizeDcress">Total Estimation</h4>
                                    {console.log('fc1_total_estimate_amount:::::', total_estimate_amount, fc1_total_estimate_amount)}
                                    {/* <h4 className="float-right sizeDcress">Rs. {total_estimate_amount !== 0 ? dollarIndianLocale.format(this.roundAmount(total_estimate_amount)) : dollarIndianLocale.format(this.roundAmount(fc1_total_estimate_amount))}</h4> */}
                                    <h4 className="float-right sizeDcress">Rs. {estimatedRange}</h4>
                                </div>
                            {/* </div> */}
                        </div>
                        </React.Fragment>
                        {/* :<React.Fragment>
                        <div className="card mx-5 mb-5 mt-0">
                        <div className="financial-table table-responsive mt-5 p-2">
                        <div className="clearfix px-5 total_estimate">
                        <h4 className="float-left sizeDcress">Total Estimation2</h4>
                        <h4 className="float-right sizeDcress">Rs. {total_estimate_amount!==0?dollarIndianLocale.format(this.roundAmount(total_estimate_amount)):dollarIndianLocale.format(this.roundAmount(fc1_total_estimate_amount))}</h4>
                        </div>
                        </div>
                        </div>
                        </React.Fragment>
                    } */}
                    {/* <div className="card py-3 m-5">
                        <div className="row mx-4">
                            {signatureSchema.map((feild, fei_key) => {
                                if(feild["name"] === "phonenumber"){
                                    return (
                                        <>
                                            <div className='col-3 p-0'>
                                                <label className="data-label w-100 mb-1">{feild["title"]}</label>
                                                <Input value={feild["value"]} maxLength={10} onChange={this.onChange.bind(this)} />
                                                {feild.errors.map((error, eKey) => {
                                                    return (<small key={eKey} className="text-danger">{error.message}</small>);
                                                })}
                                            </div>
                                            <div className='col-9 text-right'>
                                                {feild["value"] 
                                                    ?  <label onClick={this.sendLink.bind(this)} style={{cursor:"pointer"}} className="text-success py-4">Click here to digitally sign the copy & Link will be shared to whatsapp with 15min validity.</label>
                                                    :  <label className="py-4">Click here to digitally sign the copy & Link will be shared to whatsapp with 15min validity.</label>
                                                }
                                            </div>
                                        </>
                                    )
                                }
                            })}
                            <div className='row mx-1'>
                                {generatedLink && <label className="data-label mb-1 pt-2">Signature </label>} 
                                {digital_sig_imgpath 
                                    ? <img className='preview_img' alt='sign' src={`${base_url}${digital_sig_imgpath}`}></img>
                                    : generatedLink && <i class="fas fa-redo-alt text-success pt-2 mt-1" style={{cursor:"pointer"}} onClick={() => this.getDigitalSign("refresh")} />
                                }
                            </div>
                        </div>
                    </div> */}
                    <div className="card mx-5 mb-5 mt-0">
                    {this.state.showOtherDetails && (
                    <Collapse activeKey={this.state.activeKey5} onChange={this.handleCollapseChange4} expandIconPosition="end">
                    <Collapse.Panel header={(<h1 className="text-capitalize text-heading mb-0" style={{fontSize: '25px'}}>Other Details</h1>)} key="1">
                        <div className="mx-4">
                            <Formcomponent className="row" {...this.props} {...this.state} feilds={estimateBreakupFormatSchema} buttonClick={this.buttonClick.bind(this)} />
                        </div>
                        <div className="mx-4 pt-4 mt-1">
                        </div>
                        {/* </Collapse.Panel>
                        </Collapse> */}
                        {error_view && <div className="row justify-content-center mt-4">
                            <p className="text-danger text-capitalize">{error_message}</p>
                        </div>}
                        {/* {this.state.generatedLink && <a className='mx-3' href={this.state.generatedLink} target="_blank">Generated Link</a>} */}
                        <div className="row justify-content-center mt-4">
                            {/* <button className="btn btn-primary px-5 mx-2" onClick={this.buttonClick_sign.bind(this)}>Signature</button> */}
                            <button className="btn btn-danger btn-next px-5 mx-2" onClick={this.buttonClick_cancel.bind(this)}>Back</button>
                            {/* <button className="btn btn-danger  text-capitalize" onClick={this.buttonClick_cancel.bind(this)}>Back</button> */}
                            {/* {view_details == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.buttonClick_submit.bind(this)}>Preview</button>} */}
                            {/* {view_details == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={() => this.getDigitalSign("preview")}>Preview</button>} */}
                            {view_details == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={() => this.buttonClick_submit()}>Preview</button>}
                            
                            {view_details && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.buttonClick_save.bind(this)}>Next</button>}
                            {/* patient Sign */}
                    <Modal
                        title="Patient/Attendant  Signature"
                        centered
                        visible={this.state.signModalVisible}
                        onOk={() => this.signsuccess()}
                        onCancel={() => this.signModal(false)}
                        width={1000}
                        zIndex={1012}
                    >
                        <React.Fragment>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-100 h-100"></img>
                        </React.Fragment>
                    </Modal>

                    {/* fc Sign */}
                    <Modal
                        title="Counsellor Signature"
                        centered
                        visible={this.state.signModal2Visible}
                        onOk={() => this.sign2success()}
                        onCancel={() => this.sign2Modal(false)}
                        width={1000}
                        zIndex={1012}
                    >

                        <React.Fragment>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/9/98/Asa_S._Bushnell_%28Governor%29_signature.jpg" className="w-100 h-100"></img>
                        </React.Fragment>
                    </Modal>
                    {/* <Modal centered visible={this.state.preview_modal} footer={null} width='100%' zIndex={1021} destroyOnClose={true}> */}
                    <Modal centered visible={this.state.preview_modal} footer={null} width='100%' destroyOnClose={true} >
                                    {/* <Cash_preview  cash_preview_data={preview_data} digital_sig_imgpath={digital_sig_imgpath} new_state_value={new_state_value}/> */}
                                    <Cash_preview 
                                        cash_preview_data={preview_data} 
                                        digital_sig_imgpath={digital_sig_imgpath} 
                                        new_state_value={patient_validate}
                                        created_date={this.state.createdDate} 
                                    />
                                    <div className="fc-patient-copy">
                                        {/* <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                            <button className="btn d-print-none btn-success text-capitalize" onClick={()=>{this.final_submit()}} disabled={this.state.finalSubmit}>Submit</button>
                                            <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false})}>cancel</button>
                                        </div> */}
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn" style={{display: 'flex'}}>
                                            {/* <label style={{cursor:"pointer"}} className="text-success py-4" onClick={() =>this.getOtp()}>Click here to get OTP & OTP will be shared to whatsapp with 15min validity.</label> */}
                                            {this.state.showLinks ? null : (
                                                <div>
                                                    {this.state.patient_digsign_willing === true ? null : (
                                                    // <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={() => this.getOtp()}>
                                                    //     Click here to send the OTP. The OTP will be sent to your registered mobile number.
                                                    // </label>
                                                    <>
                                                        {this.state.otpSent ? (
                                                            <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={this.getOtp}>
                                                            Click here to Resend OTP.
                                                        </label>
                                                        ) : (
                                                            <label style={{ cursor: "pointer" }} className="text-success py-4" onClick={this.getOtp}>
                                                                Click here to get the OTP. The OTP will be sent to your registered mobile number
                                                            </label>
                                                        )}
                                                    </>

                                                    )}
                                                    {checkboxDisabled && (
                                                    <label className="text-success py-4" style={{ marginLeft: '102px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.patient_digsign_willing}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                    <span style={{ marginLeft: '2px' }}>patient was unwilling or unavailable to receive the OTP.</span>
                                                    </label>
                                                    )}
                                                </div>
                                                )}
                                            {/* {this.state.patient_digsign_willing === true ? null : (
                                            <label style={{cursor:"pointer"}} className="text-success py-4" onClick={() => this.getOtp()}>Click here to get OTP & OTP will be shared to whatsapp with 15min validity.</label>
                                            )}

                                            <label className="text-success py-4" style={{ marginLeft: '102px' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state.patient_digsign_willing}
                                                                            onChange={this.handleCheckboxChange}
                                                                        />
                                                                        <span style={{ marginLeft: '2px' }}>patient was unwilling/unavailable to sign on digital estimate link</span>
                                                                    </label> */}
                                        </div>
                                        {(this.state.patient_digsign_willing === true || this.state.otpLink === true) ? null : (
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                                                                        <button className="btn d-print-none btn-next text-capitalize ml-3" 
                                            onClick={() => this.cancelOperation()}>cancel</button>
                                            {/* <button className="btn d-print-none btn-next text-capitalize ml-3" 
                                            onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false, otpLink: false, patient_digsign_willing: false,otpSent :false, patient_validate: false,checkboxDisabled: false})} >cancel</button> */}
                                        </div>
                                        )}
                                        {this.state.showInputFeilds && (
                                            <>
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn"> 
                                        {this.state.patient_digsign_willing === true ? null : (
                                        <>
                                        {this.state.otp.map((digit, index) => (
                                            <Input
                                                key={index}
                                                placeholder='Enter OTP'
                                                style={{ width: '140px', marginLeft: '16px', textAlign:'center'}}
                                                maxLength={6}
                                                value={digit}
                                                onChange={(e) => this.handleChangeOTP(index, e.target.value)}
                                                onKeyPress={(e) => {
                                                    // Allow only numeric values
                                                    const pattern = /^[0-9\b]+$/;
                                                    if (!pattern.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        ))}
                                        </>
                                        )}
                                            {/* <button className="btn d-print-none btn-success text-capitalize" disabled={this.state.finalSubmit} onClick={() =>this.handleValidate()}>validate</button> */}
                                        </div>
                                        {this.state.errorMessage && (
                                            <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn" style={{ color: 'red', marginTop: '10px' }}>
                                                {this.state.errorMessage}
                                            </div>
                                        )}
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                        {this.state.patient_digsign_willing === true ? null : (
                                                                                        <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.cancelOperation()}>cancel</button>
                                            // <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false,otpLink: false, patient_digsign_willing: false, otpSent :false, patient_validate: false,checkboxDisabled: false})} >cancel</button>
                                        )}
                                        </div>
                                        </>
                                        )}
                                        {/* <div className="row justify-content-center p-4 pt-1 m-0 estimate-print-btn">
                                            <button className="btn d-print-none btn-success text-capitalize" disabled={this.state.finalSubmit}>validate</button>
                                        </div> */}
                                        {(this.state.showButtons || this.state.patient_digsign_willing) && (
                                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                                            <button className="btn d-print-none btn-success text-capitalize" onClick={()=>{this.final_submit()}} disabled={this.state.finalSubmit}>Submit</button>
                                            <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.cancelOperation()}>cancel</button>
                                            {/* <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({preview_modal: false,preview_PatientCheckin_model:false, errorMessage: '', otp: Array(this.props.length).fill(''), showInputFeilds: false, showButtons: false, patient_digsign_willing: false, showLinks: false,otpLink: false, patient_digsign_willing: false, otpSent :false, patient_validate: false,checkboxDisabled: false})} >cancel</button> */}
                                        </div>
                                        )}
                                    </div>
                            </Modal>
                            {/* <Modal  footer={null} width='100%' zIndex={1021} destroyOnClose={true}> */}
                                
                                {/* <button className="btn d-print-none btn-success text-capitalize" onClick={()=>{this.preview_submit()}} disabled={this.state.finalSubmit}>Submit</button> */}
                            {/* </Modal> */}
                            {/* Signature modal (to generate link)*/}
                            <Modal
                                // title="Generate and share link for signature"
                                title=""
                                centered
                                visible={signatureModal}
                                zIndex={2000}
                                footer={null}
                                bodyStyle={{padding: "30px 50px", backgroundColor:"white"}}
                            >
                                <React.Fragment>
                                    <div className="row">
                                        <label className=''>Do you need patient digital signature ?</label>
                                    </div>
                                    <div className="row my-4">
                                        {signatureSchema && signatureSchema.map((feild, fei_key) => {
                                            if(feild["name"] === "phonenumber"){
                                                return (
                                                    <div className=''>
                                                        <label className="data-label w-500 mr-3">{feild["title"]}</label>
                                                        <Input type='number' value={feild["value"]} style={{width: "50%"}} maxLength={10} onChange={(e) => this.onChange(e)} />
                                                        {feild.errors.map((error, eKey) => {
                                                            return (<small key={eKey} className="text-danger">{error.message}</small>);
                                                        })}
                                                    </div>
                                                )
                                            }

                                        })}
                                    </div>
                                    <div className="col-12 text-center">
                                        <button className="btn btn-success px-3 mr-2" onClick={() => this.onChangeGenerateSign("yes")}>Yes</button>
                                        <button className="btn btn-next px-3 mx-2" onClick={() => this.onChangeGenerateSign("no")}>No</button>
                                    </div>
                                    {/* <div className="row mx-4">
                                        {
                                            signatureSchema.map((feild, fei_key) => {
                                                if(feild["name"] === "phonenumber"){
                                                    return (
                                                        <div className='col-3 p-0'>
                                                            <label className="data-label w-100 mb-1 pt-2">{feild["title"]}</label>
                                                            <Input value={feild["value"]} maxLength={10} onChange={this.onChange.bind(this)} />
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                        <div className='col-3'>
                                            <Radio.Group
                                                buttonStyle="solid"
                                                value={isGenerateSign}
                                                onChange={this.onChangeGenerateSign}
                                            >
                                                <Radio.Button value="yes">Yes</Radio.Button>
                                                <Radio.Button value="no">No</Radio.Button>
                                            </Radio.Group>
                                        </div>
                                    </div> */}

                                    {/* <div className="card m-5">
                                        <div className="row m-4">
                                                <label>Do you want to generate digital signature</label>
                                                <Radio.Group
                                                    className='mx-5'
                                                    buttonStyle="solid"
                                                    value={isGenerateSign}
                                                    onChange={this.onChangeGenerateSign}
                                                >
                                                    <Radio.Button value="yes">Yes</Radio.Button>
                                                    <Radio.Button value="no">No</Radio.Button>
                                                </Radio.Group>
                                        </div>
                                        {isGenerateSign === 'yes' &&  <div className="row mx-4">
                                            {
                                                signatureSchema.map((feild, fei_key) => {
                                                    if(feild["name"] === "phonenumber"){
                                                        return (
                                                            <div className='col-3 p-0'>
                                                                <label className="data-label w-100 mb-1 pt-2">{feild["title"]}</label>
                                                                <Input value={feild["value"]} maxLength={10} onChange={this.onChange.bind(this)} />
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                            <div className='col-9 my-4 py-2 text-right'>
                                                <button className="btn btn-primary px-5" onClick={this.sendLink.bind(this)}>Generate Digital Signature</button>
                                            </div>
                                        </div>}
                                    </div> */}
                                </React.Fragment>
                            </Modal>
                            <Modal visible={isPreviewAttachments} title="" 
                                footer={<div className="row m-0">
                                    <div className="col-12 mx-auto text-center">
                                        <button className="btn btn-light mr-3" onClick={() => this.setState({isPreviewAttachments:false})}><i className="far fa-times-circle btn-icon"></i>Close</button>
                                    </div>
                                </div>}
                                onCancel={()=>this.setState({isPreviewAttachments:false})}>
                                <img 
                                    alt=""
                                    style={{ width: "100%" }}
                                    src={base_url + previewFile}
                                />
                            </Modal> 
                        </div>
                        </Collapse.Panel>
                        </Collapse>
                    )}
                    </div>
                </Spin>
            </div>
        )
    }
}
export default New_add_cash_form;